window.theme = window.theme || {};
window.slate = window.slate || {};

/* ================ VENDORS ================ */
/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);

/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!function(a,b,c){var d=window.matchMedia;"undefined"!=typeof module&&module.exports?module.exports=c(d):"function"==typeof define&&define.amd?define(function(){return b[a]=c(d)}):b[a]=c(d)}("enquire",this,function(a){"use strict";function b(a,b){var c,d=0,e=a.length;for(d;e>d&&(c=b(a[d],d),c!==!1);d++);}function c(a){return"[object Array]"===Object.prototype.toString.apply(a)}function d(a){return"function"==typeof a}function e(a){this.options=a,!a.deferSetup&&this.setup()}function f(b,c){this.query=b,this.isUnconditional=c,this.handlers=[],this.mql=a(b);var d=this;this.listener=function(a){d.mql=a,d.assess()},this.mql.addListener(this.listener)}function g(){if(!a)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!a("only all").matches}return e.prototype={setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},f.prototype={addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var c=this.handlers;b(c,function(b,d){return b.equals(a)?(b.destroy(),!c.splice(d,1)):void 0})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){b(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";b(this.handlers,function(b){b[a]()})}},g.prototype={register:function(a,e,g){var h=this.queries,i=g&&this.browserIsIncapable;return h[a]||(h[a]=new f(a,i)),d(e)&&(e={match:e}),c(e)||(e=[e]),b(e,function(b){d(b)&&(b={match:b}),h[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},new g});

/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
!function(e){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};e.zoom=function(t,n,i,o){var r,s,a,l,u,c,d,p=e(t),f=p.css("position"),h=e(n);return t.style.position=/(absolute|fixed)/.test(f)?f:"relative",t.style.overflow="hidden",i.style.width=i.style.height="",e(i).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:i.width*o,height:i.height*o,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){s=p.outerWidth(),r=p.outerHeight(),n===t?(l=s,a=r):(l=h.outerWidth(),a=h.outerHeight()),u=(i.width-s)/l,c=(i.height-r)/a,d=h.offset()},move:function(e){var t=e.pageX-d.left,n=e.pageY-d.top;n=Math.max(Math.min(n,a),0),t=Math.max(Math.min(t,l),0),i.style.left=t*-u+"px",i.style.top=n*-c+"px"}}},e.fn.zoom=function(n){return this.each(function(){var i=e.extend({},t,n||{}),o=i.target&&e(i.target)[0]||this,r=this,s=e(r),a=document.createElement("img"),l=e(a),u="mousemove.zoom",c=!1,d=!1;if(!i.url){var p=r.querySelector("img");if(p&&(i.url=p.getAttribute("data-src")||p.currentSrc||p.src),!i.url)return}s.one("zoom.destroy",function(e,t){s.off(".zoom"),o.style.position=e,o.style.overflow=t,a.onload=null,l.remove()}.bind(this,o.style.position,o.style.overflow)),a.onload=function(){function t(t){p.init(),p.move(t),l.stop().fadeTo(e.support.opacity?i.duration:0,1,!!e.isFunction(i.onZoomIn)&&i.onZoomIn.call(a))}function n(){l.stop().fadeTo(i.duration,0,!!e.isFunction(i.onZoomOut)&&i.onZoomOut.call(a))}var p=e.zoom(o,r,a,i.magnify);"grab"===i.on?s.on("mousedown.zoom",function(i){1===i.which&&(e(document).one("mouseup.zoom",function(){n(),e(document).off(u,p.move)}),t(i),e(document).on(u,p.move),i.preventDefault())}):"click"===i.on?s.on("click.zoom",function(i){return c?void 0:(c=!0,t(i),e(document).on(u,p.move),e(document).one("click.zoom",function(){n(),c=!1,e(document).off(u,p.move)}),!1)}):"toggle"===i.on?s.on("click.zoom",function(e){c?n():t(e),c=!c}):"mouseover"===i.on&&(p.init(),s.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(u,p.move)),i.touch&&s.on("touchstart.zoom",function(e){e.preventDefault(),d?(d=!1,n()):(d=!0,t(e.originalEvent.touches[0]||e.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(e){e.preventDefault(),p.move(e.originalEvent.touches[0]||e.originalEvent.changedTouches[0])}).on("touchend.zoom",function(e){e.preventDefault(),d&&(d=!1,n())}),e.isFunction(i.callback)&&i.callback.call(a)},a.setAttribute("role","presentation"),a.alt="",a.src=i.url})},e.fn.zoom.defaults=t}(window.jQuery),function(){function e(e,t){for(var n=-1,i=t.length,o=e.length;++n<i;)e[o+n]=t[n];return e}function t(e,t,n){for(var i=-1,o=e.length;++i<o;){var r=e[i],s=t(r);if(null!=s&&(a===le?s===s:n(s,a)))var a=s,l=r}return l}function n(e,t,n){var i;return n(e,function(e,n,o){return t(e,n,o)?(i=e,!1):void 0}),i}function i(e,t,n,i,o){return o(e,function(e,o,r){n=i?(i=!1,e):t(n,e,o,r)}),n}function o(e,t){return T(t,function(t){return e[t]})}function r(e){return e&&e.Object===Object?e:null}function s(e){return fe[e]}function a(e){var t=!1;if(null!=e&&"function"!=typeof e.toString)try{t=!!(e+"")}catch(e){}return t}function l(e,t){return e="number"==typeof e||pe.test(e)?+e:-1,e>-1&&0==e%1&&(null==t?9007199254740991:t)>e}function u(e){if(Z(e)&&!Re(e)){if(e instanceof c)return e;if(Se.call(e,"__wrapped__")){var t=new c(e.__wrapped__,e.__chain__);return t.__actions__=A(e.__actions__),t}}return new c(e)}function c(e,t){this.__wrapped__=e,this.__actions__=[],this.__chain__=!!t}function d(e,t,n,i){var o;return(o=e===le)||(o=Te[n],o=(e===o||e!==e&&o!==o)&&!Se.call(i,n)),o?t:e}function p(e){return J(e)?De(e):{}}function f(e,t,n){if("function"!=typeof e)throw new TypeError("Expected a function");return setTimeout(function(){e.apply(le,n)},t)}function h(e,t){var n=!0;return Le(e,function(e,i,o){return n=!!t(e,i,o)}),n}function v(e,t){var n=[];return Le(e,function(e,i,o){t(e,i,o)&&n.push(e)}),n}function g(t,n,i,o){o||(o=[]);for(var r=-1,s=t.length;++r<s;){var a=t[r];n>0&&Z(a)&&V(a)&&(i||Re(a)||Y(a))?n>1?g(a,n-1,i,o):e(o,a):i||(o[o.length]=a)}return o}function m(e,t){return e&&qe(e,t,ie)}function y(e,t){return v(t,function(t){return G(e[t])})}function w(e,t,n,i,o){return e===t||(null==e||null==t||!J(e)&&!Z(t)?e!==e&&t!==t:b(e,t,w,n,i,o))}function b(e,t,n,i,o,r){var s=Re(e),l=Re(t),u="[object Array]",c="[object Array]";s||(u=Ee.call(e),"[object Arguments]"==u&&(u="[object Object]")),l||(c=Ee.call(t),"[object Arguments]"==c&&(c="[object Object]"));var d="[object Object]"==u&&!a(e),l="[object Object]"==c&&!a(t);return!(c=u==c)||s||d?2&o||(u=d&&Se.call(e,"__wrapped__"),l=l&&Se.call(t,"__wrapped__"),!u&&!l)?!!c&&(r||(r=[]),(u=M(r,function(t){return t[0]===e}))&&u[1]?u[1]==t:(r.push([e,t]),t=(s?L:_)(e,t,n,i,o,r),r.pop(),t)):n(u?e.value():e,l?t.value():t,i,o,r):q(e,t,u)}function x(e){var t=typeof e;return"function"==t?e:null==e?se:("object"==t?S:E)(e)}function k(e){e=null==e?e:Object(e);var t,n=[];for(t in e)n.push(t);return n}function T(e,t){var n=-1,i=V(e)?Array(e.length):[];return Le(e,function(e,o,r){i[++n]=t(e,o,r)}),i}function S(e){var t=ie(e);return function(n){var i=t.length;if(null==n)return!i;for(n=Object(n);i--;){var o=t[i];if(!(o in n&&w(e[o],n[o],le,3)))return!1}return!0}}function C(e,t){return e=Object(e),W(t,function(t,n){return n in e&&(t[n]=e[n]),t},{})}function E(e){return function(t){return null==t?le:t[e]}}function $(e,t,n){var i=-1,o=e.length;for(0>t&&(t=-t>o?0:o+t),n=n>o?o:n,0>n&&(n+=o),o=t>n?0:n-t>>>0,t>>>=0,n=Array(o);++i<o;)n[i]=e[i+t];return n}function A(e){return $(e,0,e.length)}function j(e,t){var n;return Le(e,function(e,i,o){return n=t(e,i,o),!n}),!!n}function D(t,n){return W(n,function(t,n){return n.func.apply(n.thisArg,e([t],n.args))},t)}function N(e,t,n,i){n||(n={});for(var o=-1,r=t.length;++o<r;){var s=t[o],a=i?i(n[s],e[s],s,n,e):e[s],l=n,u=l[s];Se.call(l,s)&&(u===a||u!==u&&a!==a)&&(a!==le||s in l)||(l[s]=a)}return n}function O(e){return U(function(t,n){var i=-1,o=n.length,r=o>1?n[o-1]:le,r="function"==typeof r?(o--,r):le;for(t=Object(t);++i<o;){var s=n[i];s&&e(t,s,i,r)}return t})}function H(e){return function(){var t=arguments,n=p(e.prototype),t=e.apply(n,t);return J(t)?t:n}}function P(e,t,n){function i(){for(var r=-1,s=arguments.length,a=-1,l=n.length,u=Array(l+s),c=this&&this!==xe&&this instanceof i?o:e;++a<l;)u[a]=n[a];for(;s--;)u[a++]=arguments[++r];return c.apply(t,u)}if("function"!=typeof e)throw new TypeError("Expected a function");var o=H(e);return i}function L(e,t,n,i,o,r){var s=-1,a=1&o,l=e.length,u=t.length;if(l!=u&&!(2&o&&u>l))return!1;for(u=!0;++s<l;){var c=e[s],d=t[s];if(void 0!==le){u=!1;break}if(a){if(!j(t,function(e){return c===e||n(c,e,i,o,r)})){u=!1;break}}else if(c!==d&&!n(c,d,i,o,r)){u=!1;break}}return u}function q(e,t,n){switch(n){case"[object Boolean]":case"[object Date]":return+e==+t;case"[object Error]":return e.name==t.name&&e.message==t.message;case"[object Number]":return e!=+e?t!=+t:e==+t;case"[object RegExp]":case"[object String]":return e==t+""}return!1}function _(e,t,n,i,o,r){var s=2&o,a=ie(e),l=a.length,u=ie(t).length;if(l!=u&&!s)return!1;for(var c=l;c--;){var d=a[c];if(!(s?d in t:Se.call(t,d)))return!1}for(u=!0;++c<l;){var d=a[c],p=e[d],f=t[d];if(void 0!==le||p!==f&&!n(p,f,i,o,r)){u=!1;break}s||(s="constructor"==d)}return u&&!s&&(n=e.constructor,i=t.constructor,n!=i&&"constructor"in e&&"constructor"in t&&!("function"==typeof n&&n instanceof n&&"function"==typeof i&&i instanceof i)&&(u=!1)),u}function z(e){var t=e?e.length:le;if(Q(t)&&(Re(e)||ee(e)||Y(e))){e=String;for(var n=-1,i=Array(t);++n<t;)i[n]=e(n);t=i}else t=null;return t}function I(e){var t=e&&e.constructor,t=G(t)&&t.prototype||Te;return e===t}function F(e){return e?e[0]:le}function M(e,t){return n(e,x(t),Le)}function R(e,t){return Le(e,"function"==typeof t?t:se)}function W(e,t,n){return i(e,x(t),n,3>arguments.length,Le)}function B(e,t){var n;if("function"!=typeof t)throw new TypeError("Expected a function");return e=We(e),function(){return 0<--e&&(n=t.apply(this,arguments)),1>=e&&(t=le),n}}function U(e){var t;if("function"!=typeof e)throw new TypeError("Expected a function");return t=Pe(t===le?e.length-1:We(t),0),function(){for(var n=arguments,i=-1,o=Pe(n.length-t,0),r=Array(o);++i<o;)r[i]=n[t+i];for(o=Array(t+1),i=-1;++i<t;)o[i]=n[i];return o[t]=r,e.apply(this,o)}}function X(e,t){return e>t}function Y(e){return Z(e)&&V(e)&&Se.call(e,"callee")&&(!Ne.call(e,"callee")||"[object Arguments]"==Ee.call(e))}function V(e){return null!=e&&!("function"==typeof e&&G(e))&&Q(_e(e))}function G(e){return e=J(e)?Ee.call(e):"","[object Function]"==e||"[object GeneratorFunction]"==e}function Q(e){return"number"==typeof e&&e>-1&&0==e%1&&9007199254740991>=e}function J(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function Z(e){return!!e&&"object"==typeof e}function K(e){return"number"==typeof e||Z(e)&&"[object Number]"==Ee.call(e)}function ee(e){return"string"==typeof e||!Re(e)&&Z(e)&&"[object String]"==Ee.call(e)}function te(e,t){return t>e}function ne(e){return"string"==typeof e?e:null==e?"":e+""}function ie(e){var t=I(e);if(!t&&!V(e))return He(Object(e));var n,i=z(e),o=!!i,i=i||[],r=i.length;for(n in e)!Se.call(e,n)||o&&("length"==n||l(n,r))||t&&"constructor"==n||i.push(n);return i}function oe(e){for(var t=-1,n=I(e),i=k(e),o=i.length,r=z(e),s=!!r,r=r||[],a=r.length;++t<o;){var u=i[t];s&&("length"==u||l(u,a))||"constructor"==u&&(n||!Se.call(e,u))||r.push(u)}return r}function re(e){return e?o(e,ie(e)):[]}function se(e){return e}function ae(t,n,i){var o=ie(n),r=y(n,o);null!=i||J(n)&&(r.length||!o.length)||(i=n,n=t,t=this,r=y(n,ie(n)));var s=!(J(i)&&"chain"in i)||i.chain,a=G(t);return Le(r,function(i){var o=n[i];t[i]=o,a&&(t.prototype[i]=function(){var n=this.__chain__;if(s||n){var i=t(this.__wrapped__);return(i.__actions__=A(this.__actions__)).push({func:o,args:arguments,thisArg:t}),i.__chain__=n,i}return o.apply(t,e([this.value()],arguments))})}),t}var le,ue=1/0,ce=/[&<>"'`]/g,de=RegExp(ce.source),pe=/^(?:0|[1-9]\d*)$/,fe={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","`":"&#96;"},he={function:!0,object:!0},ve=he[typeof exports]&&exports&&!exports.nodeType?exports:le,ge=he[typeof module]&&module&&!module.nodeType?module:le,me=ge&&ge.exports===ve?ve:le,ye=r(he[typeof self]&&self),we=r(he[typeof window]&&window),be=r(he[typeof this]&&this),xe=r(ve&&ge&&"object"==typeof global&&global)||we!==(be&&be.window)&&we||ye||be||Function("return this")(),ke=Array.prototype,Te=Object.prototype,Se=Te.hasOwnProperty,Ce=0,Ee=Te.toString,$e=xe._,Ae=xe.Reflect,je=Ae?Ae.f:le,De=Object.create,Ne=Te.propertyIsEnumerable,Oe=xe.isFinite,He=Object.keys,Pe=Math.max,Le=function(e,t){return function(n,i){if(null==n)return n;if(!V(n))return e(n,i);for(var o=n.length,r=t?o:-1,s=Object(n);(t?r--:++r<o)&&!1!==i(s[r],r,s););return n}}(m),qe=function(e){return function(t,n,i){var o=-1,r=Object(t);i=i(t);for(var s=i.length;s--;){var a=i[e?s:++o];if(!1===n(r[a],a,r))break}return t}}();je&&!Ne.call({valueOf:1},"valueOf")&&(k=function(e){e=je(e);for(var t,n=[];!(t=e.next()).done;)n.push(t.value);return n});var _e=E("length"),ze=U(function(t,n){return Re(t)||(t=null==t?[]:[Object(t)]),g(n,1),e(A(t),re)}),Ie=U(function(e,t,n){return P(e,t,n)}),Fe=U(function(e,t){return f(e,1,t)}),Me=U(function(e,t,n){return f(e,Be(t)||0,n)}),Re=Array.isArray,We=Number,Be=Number,Ue=O(function(e,t){N(t,ie(t),e)}),Xe=O(function(e,t){N(t,oe(t),e)}),Ye=O(function(e,t,n,i){N(t,oe(t),e,i)}),Ve=U(function(e){return e.push(le,d),Ye.apply(le,e)}),Ge=U(function(e,t){return null==e?{}:C(e,g(t,1))}),Qe=x;c.prototype=p(u.prototype),c.prototype.constructor=c,u.assignIn=Xe,u.before=B,u.bind=Ie,u.chain=function(e){return e=u(e),e.__chain__=!0,e},u.compact=function(e){return v(e,Boolean)},u.concat=ze,u.create=function(e,t){var n=p(e);return t?Ue(n,t):n},u.defaults=Ve,u.defer=Fe,u.delay=Me,u.filter=function(e,t){return v(e,x(t))},u.flatten=function(e){return e&&e.length?g(e,1):[]},u.flattenDeep=function(e){return e&&e.length?g(e,ue):[]},u.iteratee=Qe,u.keys=ie,u.map=function(e,t){return T(e,x(t))},u.matches=function(e){return S(Ue({},e))},u.mixin=ae,u.negate=function(e){if("function"!=typeof e)throw new TypeError("Expected a function");return function(){return!e.apply(this,arguments)}},u.once=function(e){return B(2,e)},u.pick=Ge,u.slice=function(e,t,n){var i=e?e.length:0;return n=n===le?i:+n,i?$(e,null==t?0:+t,n):[]},u.sortBy=function(e,t){var n=0;return t=x(t),T(T(e,function(e,i,o){return{c:e,b:n++,a:t(e,i,o)}}).sort(function(e,t){var n;e:{n=e.a;var i=t.a;if(n!==i){var o=null===n,r=n===le,s=n===n,a=null===i,l=i===le,u=i===i;if(n>i&&!a||!s||o&&!l&&u||r&&u){n=1;break e}if(i>n&&!o||!u||a&&!r&&s||l&&s){n=-1;break e}}n=0}return n||e.b-t.b}),E("c"))},u.tap=function(e,t){return t(e),e},u.thru=function(e,t){return t(e)},u.toArray=function(e){return V(e)?e.length?A(e):[]:re(e)},u.values=re,u.extend=Xe,ae(u,u),u.clone=function(e){return J(e)?Re(e)?A(e):N(e,ie(e)):e},u.escape=function(e){return(e=ne(e))&&de.test(e)?e.replace(ce,s):e},u.every=function(e,t,n){return t=n?le:t,h(e,x(t))},u.find=M,u.forEach=R,u.has=function(e,t){return null!=e&&Se.call(e,t)},u.head=F,u.identity=se,u.indexOf=function(e,t,n){var i=e?e.length:0;n="number"==typeof n?0>n?Pe(i+n,0):n:0,n=(n||0)-1;for(var o=t===t;++n<i;){var r=e[n];if(o?r===t:r!==r)return n}return-1},u.isArguments=Y,u.isArray=Re,u.isBoolean=function(e){return!0===e||!1===e||Z(e)&&"[object Boolean]"==Ee.call(e)},u.isDate=function(e){return Z(e)&&"[object Date]"==Ee.call(e)},u.isEmpty=function(e){if(V(e)&&(Re(e)||ee(e)||G(e.splice)||Y(e)))return!e.length;for(var t in e)if(Se.call(e,t))return!1;return!0},u.isEqual=function(e,t){return w(e,t)},u.isFinite=function(e){return"number"==typeof e&&Oe(e)},u.isFunction=G,u.isNaN=function(e){return K(e)&&e!=+e},u.isNull=function(e){return null===e},u.isNumber=K,u.isObject=J,u.isRegExp=function(e){return J(e)&&"[object RegExp]"==Ee.call(e)},u.isString=ee,u.isUndefined=function(e){return e===le},u.last=function(e){var t=e?e.length:0;return t?e[t-1]:le},u.max=function(e){return e&&e.length?t(e,se,X):le},u.min=function(e){return e&&e.length?t(e,se,te):le},u.noConflict=function(){return xe._===this&&(xe._=$e),this},u.noop=function(){},u.reduce=W,u.result=function(e,t,n){return t=null==e?le:e[t],t===le&&(t=n),G(t)?t.call(e):t},u.size=function(e){return null==e?0:(e=V(e)?e:ie(e),e.length)},u.some=function(e,t,n){return t=n?le:t,j(e,x(t))},u.uniqueId=function(e){var t=++Ce;return ne(e)+t},u.each=R,u.first=F,ae(u,function(){var e={};return m(u,function(t,n){Se.call(u.prototype,n)||(e[n]=t)}),e}(),{chain:!1}),u.VERSION="4.5.1",Le("pop join replace reverse split push shift sort splice unshift".split(" "),function(e){var t=(/^(?:replace|split)$/.test(e)?String.prototype:ke)[e],n=/^(?:push|sort|unshift)$/.test(e)?"tap":"thru",i=/^(?:pop|join|replace|shift)$/.test(e);u.prototype[e]=function(){var e=arguments;return i&&!this.__chain__?t.apply(this.value(),e):this[n](function(n){return t.apply(n,e)})}}),u.prototype.toJSON=u.prototype.valueOf=u.prototype.value=function(){return D(this.__wrapped__,this.__actions__)},(we||ye||{})._=u,"function"==typeof define&&"object"==typeof define.amd&&define.amd?define(function(){return u}):ve&&ge?(me&&((ge.exports=u)._=u),ve._=u):xe._=u}.call(this),

/*! Magnific Popup - v1.0.0 - 2015-03-30
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2015 Dmitry Semenov; */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isIE7=-1!==c.indexOf("MSIE 7."),b.isIE8=-1!==c.indexOf("MSIE 8."),b.isLowIE=b.isIE7||b.isIE8,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",b.ev=c.mainEl&&c.mainEl.length?c.mainEl.eq(0):d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.wrap.css(b.fixedContentPos?{overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}:{top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),b.currTemplate[d]=f?a(f):!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||2!==c.which&&!c.ctrlKey&&!c.metaKey){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(a,c){if(void 0===c||c===!1)return!0;if(e=a.split("_"),e.length>1){var d=b.find(p+"-"+e[0]);if(d.length>0){var f=e[1];"replaceWith"===f?d[0]!==c[0]&&d.replaceWith(c):"img"===f?d.is("img")?d.attr("src",c):d.replaceWith('<img src="'+c+'" class="'+d.attr("class")+'" />'):d.attr(e[1],c)}}else b.find(p+"-"+a).html(c)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&times;</button>',tClose:"Close (Esc)",tLoading:"Loading..."}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery",g=Boolean(a.fn.mfpFastClick);return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s),h=g?"mfpFastClick":"click";e[h](function(){b.prev()}),f[h](function(){b.next()}),b.isIE7&&(x("b",e[0],!1,!0),x("a",e[0],!1,!0),x("b",f[0],!1,!0),x("a",f[0],!1,!0)),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowLeft&&g&&b.arrowLeft.add(b.arrowRight).destroyMfpFastClick(),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),function(){var b=1e3,c="ontouchstart"in window,d=function(){v.off("touchmove"+f+" touchend"+f)},e="mfpFastClick",f="."+e;a.fn.mfpFastClick=function(e){return a(this).each(function(){var g,h=a(this);if(c){var i,j,k,l,m,n;h.on("touchstart"+f,function(a){l=!1,n=1,m=a.originalEvent?a.originalEvent.touches[0]:a.touches[0],j=m.clientX,k=m.clientY,v.on("touchmove"+f,function(a){m=a.originalEvent?a.originalEvent.touches:a.touches,n=m.length,m=m[0],(Math.abs(m.clientX-j)>10||Math.abs(m.clientY-k)>10)&&(l=!0,d())}).on("touchend"+f,function(a){d(),l||n>1||(g=!0,a.preventDefault(),clearTimeout(i),i=setTimeout(function(){g=!1},b),e())})})}h.on("click"+f,function(){g||e()})})},a.fn.destroyMfpFastClick=function(){a(this).off("touchstart"+f+" click"+f),c&&v.off("touchmove"+f+" touchend"+f)}}(),A()});
/*
 * ScrollToFixed
 * https://github.com/bigspotteddog/ScrollToFixed
 *
 * Copyright (c) 2011 Joseph Cava-Lynch
 * MIT license
 */
(function(a){a.isScrollToFixed=function(b){return !!a(b).data("ScrollToFixed")};a.ScrollToFixed=function(d,i){var l=this;l.$el=a(d);l.el=d;l.$el.data("ScrollToFixed",l);var c=false;var G=l.$el;var H;var E;var e;var y;var D=0;var q=0;var j=-1;var f=-1;var t=null;var z;var g;function u(){G.trigger("preUnfixed.ScrollToFixed");k();G.trigger("unfixed.ScrollToFixed");f=-1;D=G.offset().top;q=G.offset().left;if(l.options.offsets){q+=(G.offset().left-G.position().left)}if(j==-1){j=q}H=G.css("position");c=true;if(l.options.bottom!=-1){G.trigger("preFixed.ScrollToFixed");w();G.trigger("fixed.ScrollToFixed")}}function n(){var I=l.options.limit;if(!I){return 0}if(typeof(I)==="function"){return I.apply(G)}return I}function p(){return H==="fixed"}function x(){return H==="absolute"}function h(){return !(p()||x())}function w(){if(!p()){t.css({display:G.css("display"),width:G.outerWidth(true),height:G.outerHeight(true),"float":G.css("float")});cssOptions={"z-index":l.options.zIndex,position:"fixed",top:l.options.bottom==-1?s():"",bottom:l.options.bottom==-1?"":l.options.bottom,"margin-left":"0px"};if(!l.options.dontSetWidth){cssOptions.width=G.width()}G.css(cssOptions);G.addClass(l.options.baseClassName);if(l.options.className){G.addClass(l.options.className)}H="fixed"}}function b(){var J=n();var I=q;if(l.options.removeOffsets){I="";J=J-D}cssOptions={position:"absolute",top:J,left:I,"margin-left":"0px",bottom:""};if(!l.options.dontSetWidth){cssOptions.width=G.width()}G.css(cssOptions);H="absolute"}function k(){if(!h()){f=-1;t.css("display","none");G.css({"z-index":y,width:"",position:E,left:"",top:e,"margin-left":""});G.removeClass("scroll-to-fixed-fixed");if(l.options.className){G.removeClass(l.options.className)}H=null}}function v(I){if(I!=f){G.css("left",q-I);f=I}}function s(){var I=l.options.marginTop;if(!I){return 0}if(typeof(I)==="function"){return I.apply(G)}return I}function A(){if(!a.isScrollToFixed(G)){return}var K=c;if(!c){u()}else{if(h()){D=G.offset().top;q=G.offset().left}}var I=a(window).scrollLeft();var L=a(window).scrollTop();var J=n();if(l.options.minWidth&&a(window).width()<l.options.minWidth){if(!h()||!K){o();G.trigger("preUnfixed.ScrollToFixed");k();G.trigger("unfixed.ScrollToFixed")}}else{if(l.options.maxWidth&&a(window).width()>l.options.maxWidth){if(!h()||!K){o();G.trigger("preUnfixed.ScrollToFixed");k();G.trigger("unfixed.ScrollToFixed")}}else{if(l.options.bottom==-1){if(J>0&&L>=J-s()){if(!x()||!K){o();G.trigger("preAbsolute.ScrollToFixed");b();G.trigger("unfixed.ScrollToFixed")}}else{if(L>=D-s()){if(!p()||!K){o();G.trigger("preFixed.ScrollToFixed");w();f=-1;G.trigger("fixed.ScrollToFixed")}v(I)}else{if(!h()||!K){o();G.trigger("preUnfixed.ScrollToFixed");k();G.trigger("unfixed.ScrollToFixed")}}}}else{if(J>0){if(L+a(window).height()-G.outerHeight(true)>=J-(s()||-m())){if(p()){o();G.trigger("preUnfixed.ScrollToFixed");if(E==="absolute"){b()}else{k()}G.trigger("unfixed.ScrollToFixed")}}else{if(!p()){o();G.trigger("preFixed.ScrollToFixed");w()}v(I);G.trigger("fixed.ScrollToFixed")}}else{v(I)}}}}}function m(){if(!l.options.bottom){return 0}return l.options.bottom}function o(){var I=G.css("position");if(I=="absolute"){G.trigger("postAbsolute.ScrollToFixed")}else{if(I=="fixed"){G.trigger("postFixed.ScrollToFixed")}else{G.trigger("postUnfixed.ScrollToFixed")}}}var C=function(I){if(G.is(":visible")){c=false;A()}};var F=function(I){(!!window.requestAnimationFrame)?requestAnimationFrame(A):A()};var B=function(){var J=document.body;if(document.createElement&&J&&J.appendChild&&J.removeChild){var L=document.createElement("div");if(!L.getBoundingClientRect){return null}L.innerHTML="x";L.style.cssText="position:fixed;top:100px;";J.appendChild(L);var M=J.style.height,N=J.scrollTop;J.style.height="3000px";J.scrollTop=500;var I=L.getBoundingClientRect().top;J.style.height=M;var K=(I===100);J.removeChild(L);J.scrollTop=N;return K}return null};var r=function(I){I=I||window.event;if(I.preventDefault){I.preventDefault()}I.returnValue=false};l.init=function(){l.options=a.extend({},a.ScrollToFixed.defaultOptions,i);y=G.css("z-index");l.$el.css("z-index",l.options.zIndex);t=a("<div />");H=G.css("position");E=G.css("position");e=G.css("top");if(h()){l.$el.after(t)}a(window).bind("resize.ScrollToFixed",C);a(window).bind("scroll.ScrollToFixed",F);if("ontouchmove" in window){a(window).bind("touchmove.ScrollToFixed",A)}if(l.options.preFixed){G.bind("preFixed.ScrollToFixed",l.options.preFixed)}if(l.options.postFixed){G.bind("postFixed.ScrollToFixed",l.options.postFixed)}if(l.options.preUnfixed){G.bind("preUnfixed.ScrollToFixed",l.options.preUnfixed)}if(l.options.postUnfixed){G.bind("postUnfixed.ScrollToFixed",l.options.postUnfixed)}if(l.options.preAbsolute){G.bind("preAbsolute.ScrollToFixed",l.options.preAbsolute)}if(l.options.postAbsolute){G.bind("postAbsolute.ScrollToFixed",l.options.postAbsolute)}if(l.options.fixed){G.bind("fixed.ScrollToFixed",l.options.fixed)}if(l.options.unfixed){G.bind("unfixed.ScrollToFixed",l.options.unfixed)}if(l.options.spacerClass){t.addClass(l.options.spacerClass)}G.bind("resize.ScrollToFixed",function(){t.height(G.height())});G.bind("scroll.ScrollToFixed",function(){G.trigger("preUnfixed.ScrollToFixed");k();G.trigger("unfixed.ScrollToFixed");A()});G.bind("detach.ScrollToFixed",function(I){r(I);G.trigger("preUnfixed.ScrollToFixed");k();G.trigger("unfixed.ScrollToFixed");a(window).unbind("resize.ScrollToFixed",C);a(window).unbind("scroll.ScrollToFixed",F);G.unbind(".ScrollToFixed");t.remove();l.$el.removeData("ScrollToFixed")});C()};l.init()};a.ScrollToFixed.defaultOptions={marginTop:0,limit:0,bottom:-1,zIndex:1000,baseClassName:"scroll-to-fixed-fixed"};a.fn.scrollToFixed=function(b){return this.each(function(){(new a.ScrollToFixed(this,b))})}})(jQuery);

/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */

!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
!(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/**
 * @license
 * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */
;(function(){function n(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function t(n,t,r){for(var e=-1,u=n.length;++e<u;){var o=n[e],i=t(o);if(null!=i&&(c===an?i===i:r(i,c)))var c=i,f=o}return f}function r(n,t,r){var e;return r(n,function(n,r,u){return t(n,r,u)?(e=n,false):void 0}),e}function e(n,t,r,e,u){return u(n,function(n,u,o){r=e?(e=false,n):t(r,n,u,o)}),r}function u(n,t){return O(t,function(t){return n[t]})}function o(n){return n&&n.Object===Object?n:null}function i(n){return vn[n];
}function c(n){var t=false;if(null!=n&&typeof n.toString!="function")try{t=!!(n+"")}catch(r){}return t}function f(n,t){return n=typeof n=="number"||hn.test(n)?+n:-1,n>-1&&0==n%1&&(null==t?9007199254740991:t)>n}function a(n){if(Y(n)&&!Pn(n)){if(n instanceof l)return n;if(En.call(n,"__wrapped__")){var t=new l(n.__wrapped__,n.__chain__);return t.__actions__=N(n.__actions__),t}}return new l(n)}function l(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t}function p(n,t,r,e){var u;return(u=n===an)||(u=xn[r],
u=(n===u||n!==n&&u!==u)&&!En.call(e,r)),u?t:n}function s(n){return X(n)?Fn(n):{}}function h(n,t,r){if(typeof n!="function")throw new TypeError("Expected a function");return setTimeout(function(){n.apply(an,r)},t)}function v(n,t){var r=true;return $n(n,function(n,e,u){return r=!!t(n,e,u)}),r}function y(n,t){var r=[];return $n(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function _(t,r,e,u){u||(u=[]);for(var o=-1,i=t.length;++o<i;){var c=t[o];r>0&&Y(c)&&L(c)&&(e||Pn(c)||K(c))?r>1?_(c,r-1,e,u):n(u,c):e||(u[u.length]=c);
}return u}function g(n,t){return n&&qn(n,t,en)}function b(n,t){return y(t,function(t){return Q(n[t])})}function j(n,t,r,e,u){return n===t?true:null==n||null==t||!X(n)&&!Y(t)?n!==n&&t!==t:m(n,t,j,r,e,u)}function m(n,t,r,e,u,o){var i=Pn(n),f=Pn(t),a="[object Array]",l="[object Array]";i||(a=kn.call(n),"[object Arguments]"==a&&(a="[object Object]")),f||(l=kn.call(t),"[object Arguments]"==l&&(l="[object Object]"));var p="[object Object]"==a&&!c(n),f="[object Object]"==l&&!c(t);return!(l=a==l)||i||p?2&u||(a=p&&En.call(n,"__wrapped__"),
f=f&&En.call(t,"__wrapped__"),!a&&!f)?l?(o||(o=[]),(a=J(o,function(t){return t[0]===n}))&&a[1]?a[1]==t:(o.push([n,t]),t=(i?I:q)(n,t,r,e,u,o),o.pop(),t)):false:r(a?n.value():n,f?t.value():t,e,u,o):$(n,t,a)}function d(n){var t=typeof n;return"function"==t?n:null==n?cn:("object"==t?x:A)(n)}function w(n){n=null==n?n:Object(n);var t,r=[];for(t in n)r.push(t);return r}function O(n,t){var r=-1,e=L(n)?Array(n.length):[];return $n(n,function(n,u,o){e[++r]=t(n,u,o)}),e}function x(n){var t=en(n);return function(r){
var e=t.length;if(null==r)return!e;for(r=Object(r);e--;){var u=t[e];if(!(u in r&&j(n[u],r[u],an,3)))return false}return true}}function E(n,t){return n=Object(n),P(t,function(t,r){return r in n&&(t[r]=n[r]),t},{})}function A(n){return function(t){return null==t?an:t[n]}}function k(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Array(u);++e<u;)r[e]=n[e+t];return r}function N(n){return k(n,0,n.length)}function S(n,t){var r;return $n(n,function(n,e,u){return r=t(n,e,u),
!r}),!!r}function T(t,r){return P(r,function(t,r){return r.func.apply(r.thisArg,n([t],r.args))},t)}function F(n,t,r,e){r||(r={});for(var u=-1,o=t.length;++u<o;){var i=t[u],c=e?e(r[i],n[i],i,r,n):n[i],f=r,a=f[i];En.call(f,i)&&(a===c||a!==a&&c!==c)&&(c!==an||i in f)||(f[i]=c)}return r}function R(n){return V(function(t,r){var e=-1,u=r.length,o=u>1?r[u-1]:an,o=typeof o=="function"?(u--,o):an;for(t=Object(t);++e<u;){var i=r[e];i&&n(t,i,e,o)}return t})}function B(n){return function(){var t=arguments,r=s(n.prototype),t=n.apply(r,t);
return X(t)?t:r}}function D(n,t,r){function e(){for(var o=-1,i=arguments.length,c=-1,f=r.length,a=Array(f+i),l=this&&this!==wn&&this instanceof e?u:n;++c<f;)a[c]=r[c];for(;i--;)a[c++]=arguments[++o];return l.apply(t,a)}if(typeof n!="function")throw new TypeError("Expected a function");var u=B(n);return e}function I(n,t,r,e,u,o){var i=-1,c=1&u,f=n.length,a=t.length;if(f!=a&&!(2&u&&a>f))return false;for(a=true;++i<f;){var l=n[i],p=t[i];if(void 0!==an){a=false;break}if(c){if(!S(t,function(n){return l===n||r(l,n,e,u,o);
})){a=false;break}}else if(l!==p&&!r(l,p,e,u,o)){a=false;break}}return a}function $(n,t,r){switch(r){case"[object Boolean]":case"[object Date]":return+n==+t;case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object Number]":return n!=+n?t!=+t:n==+t;case"[object RegExp]":case"[object String]":return n==t+""}return false}function q(n,t,r,e,u,o){var i=2&u,c=en(n),f=c.length,a=en(t).length;if(f!=a&&!i)return false;for(var l=f;l--;){var p=c[l];if(!(i?p in t:En.call(t,p)))return false}for(a=true;++l<f;){
var p=c[l],s=n[p],h=t[p];if(void 0!==an||s!==h&&!r(s,h,e,u,o)){a=false;break}i||(i="constructor"==p)}return a&&!i&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(a=false)),a}function z(n){var t=n?n.length:an;if(W(t)&&(Pn(n)||nn(n)||K(n))){n=String;for(var r=-1,e=Array(t);++r<t;)e[r]=n(r);t=e}else t=null;return t}function C(n){var t=n&&n.constructor,t=Q(t)&&t.prototype||xn;return n===t}function G(n){
return n?n[0]:an}function J(n,t){return r(n,d(t),$n)}function M(n,t){return $n(n,typeof t=="function"?t:cn)}function P(n,t,r){return e(n,d(t),r,3>arguments.length,$n)}function U(n,t){var r;if(typeof t!="function")throw new TypeError("Expected a function");return n=Un(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=an),r}}function V(n){var t;if(typeof n!="function")throw new TypeError("Expected a function");return t=In(t===an?n.length-1:Un(t),0),function(){for(var r=arguments,e=-1,u=In(r.length-t,0),o=Array(u);++e<u;)o[e]=r[t+e];
for(u=Array(t+1),e=-1;++e<t;)u[e]=r[e];return u[t]=o,n.apply(this,u)}}function H(n,t){return n>t}function K(n){return Y(n)&&L(n)&&En.call(n,"callee")&&(!Rn.call(n,"callee")||"[object Arguments]"==kn.call(n))}function L(n){return null!=n&&!(typeof n=="function"&&Q(n))&&W(zn(n))}function Q(n){return n=X(n)?kn.call(n):"","[object Function]"==n||"[object GeneratorFunction]"==n}function W(n){return typeof n=="number"&&n>-1&&0==n%1&&9007199254740991>=n}function X(n){var t=typeof n;return!!n&&("object"==t||"function"==t);
}function Y(n){return!!n&&typeof n=="object"}function Z(n){return typeof n=="number"||Y(n)&&"[object Number]"==kn.call(n)}function nn(n){return typeof n=="string"||!Pn(n)&&Y(n)&&"[object String]"==kn.call(n)}function tn(n,t){return t>n}function rn(n){return typeof n=="string"?n:null==n?"":n+""}function en(n){var t=C(n);if(!t&&!L(n))return Dn(Object(n));var r,e=z(n),u=!!e,e=e||[],o=e.length;for(r in n)!En.call(n,r)||u&&("length"==r||f(r,o))||t&&"constructor"==r||e.push(r);return e}function un(n){for(var t=-1,r=C(n),e=w(n),u=e.length,o=z(n),i=!!o,o=o||[],c=o.length;++t<u;){
var a=e[t];i&&("length"==a||f(a,c))||"constructor"==a&&(r||!En.call(n,a))||o.push(a)}return o}function on(n){return n?u(n,en(n)):[]}function cn(n){return n}function fn(t,r,e){var u=en(r),o=b(r,u);null!=e||X(r)&&(o.length||!u.length)||(e=r,r=t,t=this,o=b(r,en(r)));var i=X(e)&&"chain"in e?e.chain:true,c=Q(t);return $n(o,function(e){var u=r[e];t[e]=u,c&&(t.prototype[e]=function(){var r=this.__chain__;if(i||r){var e=t(this.__wrapped__);return(e.__actions__=N(this.__actions__)).push({func:u,args:arguments,
thisArg:t}),e.__chain__=r,e}return u.apply(t,n([this.value()],arguments))})}),t}var an,ln=1/0,pn=/[&<>"'`]/g,sn=RegExp(pn.source),hn=/^(?:0|[1-9]\d*)$/,vn={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","`":"&#96;"},yn={"function":true,object:true},_n=yn[typeof exports]&&exports&&!exports.nodeType?exports:an,gn=yn[typeof module]&&module&&!module.nodeType?module:an,bn=gn&&gn.exports===_n?_n:an,jn=o(yn[typeof self]&&self),mn=o(yn[typeof window]&&window),dn=o(yn[typeof this]&&this),wn=o(_n&&gn&&typeof global=="object"&&global)||mn!==(dn&&dn.window)&&mn||jn||dn||Function("return this")(),On=Array.prototype,xn=Object.prototype,En=xn.hasOwnProperty,An=0,kn=xn.toString,Nn=wn._,Sn=wn.Reflect,Tn=Sn?Sn.f:an,Fn=Object.create,Rn=xn.propertyIsEnumerable,Bn=wn.isFinite,Dn=Object.keys,In=Math.max,$n=function(n,t){
return function(r,e){if(null==r)return r;if(!L(r))return n(r,e);for(var u=r.length,o=t?u:-1,i=Object(r);(t?o--:++o<u)&&false!==e(i[o],o,i););return r}}(g),qn=function(n){return function(t,r,e){var u=-1,o=Object(t);e=e(t);for(var i=e.length;i--;){var c=e[n?i:++u];if(false===r(o[c],c,o))break}return t}}();Tn&&!Rn.call({valueOf:1},"valueOf")&&(w=function(n){n=Tn(n);for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r});var zn=A("length"),Cn=V(function(t,r){return Pn(t)||(t=null==t?[]:[Object(t)]),_(r,1),
n(N(t),on)}),Gn=V(function(n,t,r){return D(n,t,r)}),Jn=V(function(n,t){return h(n,1,t)}),Mn=V(function(n,t,r){return h(n,Vn(t)||0,r)}),Pn=Array.isArray,Un=Number,Vn=Number,Hn=R(function(n,t){F(t,en(t),n)}),Kn=R(function(n,t){F(t,un(t),n)}),Ln=R(function(n,t,r,e){F(t,un(t),n,e)}),Qn=V(function(n){return n.push(an,p),Ln.apply(an,n)}),Wn=V(function(n,t){return null==n?{}:E(n,_(t,1))}),Xn=d;l.prototype=s(a.prototype),l.prototype.constructor=l,a.assignIn=Kn,a.before=U,a.bind=Gn,a.chain=function(n){return n=a(n),
n.__chain__=true,n},a.compact=function(n){return y(n,Boolean)},a.concat=Cn,a.create=function(n,t){var r=s(n);return t?Hn(r,t):r},a.defaults=Qn,a.defer=Jn,a.delay=Mn,a.filter=function(n,t){return y(n,d(t))},a.flatten=function(n){return n&&n.length?_(n,1):[]},a.flattenDeep=function(n){return n&&n.length?_(n,ln):[]},a.iteratee=Xn,a.keys=en,a.map=function(n,t){return O(n,d(t))},a.matches=function(n){return x(Hn({},n))},a.mixin=fn,a.negate=function(n){if(typeof n!="function")throw new TypeError("Expected a function");
return function(){return!n.apply(this,arguments)}},a.once=function(n){return U(2,n)},a.pick=Wn,a.slice=function(n,t,r){var e=n?n.length:0;return r=r===an?e:+r,e?k(n,null==t?0:+t,r):[]},a.sortBy=function(n,t){var r=0;return t=d(t),O(O(n,function(n,e,u){return{c:n,b:r++,a:t(n,e,u)}}).sort(function(n,t){var r;n:{r=n.a;var e=t.a;if(r!==e){var u=null===r,o=r===an,i=r===r,c=null===e,f=e===an,a=e===e;if(r>e&&!c||!i||u&&!f&&a||o&&a){r=1;break n}if(e>r&&!u||!a||c&&!o&&i||f&&i){r=-1;break n}}r=0}return r||n.b-t.b;
}),A("c"))},a.tap=function(n,t){return t(n),n},a.thru=function(n,t){return t(n)},a.toArray=function(n){return L(n)?n.length?N(n):[]:on(n)},a.values=on,a.extend=Kn,fn(a,a),a.clone=function(n){return X(n)?Pn(n)?N(n):F(n,en(n)):n},a.escape=function(n){return(n=rn(n))&&sn.test(n)?n.replace(pn,i):n},a.every=function(n,t,r){return t=r?an:t,v(n,d(t))},a.find=J,a.forEach=M,a.has=function(n,t){return null!=n&&En.call(n,t)},a.head=G,a.identity=cn,a.indexOf=function(n,t,r){var e=n?n.length:0;r=typeof r=="number"?0>r?In(e+r,0):r:0,
r=(r||0)-1;for(var u=t===t;++r<e;){var o=n[r];if(u?o===t:o!==o)return r}return-1},a.isArguments=K,a.isArray=Pn,a.isBoolean=function(n){return true===n||false===n||Y(n)&&"[object Boolean]"==kn.call(n)},a.isDate=function(n){return Y(n)&&"[object Date]"==kn.call(n)},a.isEmpty=function(n){if(L(n)&&(Pn(n)||nn(n)||Q(n.splice)||K(n)))return!n.length;for(var t in n)if(En.call(n,t))return false;return true},a.isEqual=function(n,t){return j(n,t)},a.isFinite=function(n){return typeof n=="number"&&Bn(n)},a.isFunction=Q,a.isNaN=function(n){
return Z(n)&&n!=+n},a.isNull=function(n){return null===n},a.isNumber=Z,a.isObject=X,a.isRegExp=function(n){return X(n)&&"[object RegExp]"==kn.call(n)},a.isString=nn,a.isUndefined=function(n){return n===an},a.last=function(n){var t=n?n.length:0;return t?n[t-1]:an},a.max=function(n){return n&&n.length?t(n,cn,H):an},a.min=function(n){return n&&n.length?t(n,cn,tn):an},a.noConflict=function(){return wn._===this&&(wn._=Nn),this},a.noop=function(){},a.reduce=P,a.result=function(n,t,r){return t=null==n?an:n[t],
t===an&&(t=r),Q(t)?t.call(n):t},a.size=function(n){return null==n?0:(n=L(n)?n:en(n),n.length)},a.some=function(n,t,r){return t=r?an:t,S(n,d(t))},a.uniqueId=function(n){var t=++An;return rn(n)+t},a.each=M,a.first=G,fn(a,function(){var n={};return g(a,function(t,r){En.call(a.prototype,r)||(n[r]=t)}),n}(),{chain:false}),a.VERSION="4.5.1",$n("pop join replace reverse split push shift sort splice unshift".split(" "),function(n){var t=(/^(?:replace|split)$/.test(n)?String.prototype:On)[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|join|replace|shift)$/.test(n);
a.prototype[n]=function(){var n=arguments;return e&&!this.__chain__?t.apply(this.value(),n):this[r](function(r){return t.apply(r,n)})}}),a.prototype.toJSON=a.prototype.valueOf=a.prototype.value=function(){return T(this.__wrapped__,this.__actions__)},(mn||jn||{})._=a,typeof define=="function"&&typeof define.amd=="object"&&define.amd? define(function(){return a}):_n&&gn?(bn&&((gn.exports=a)._=a),_n._=a):wn._=a}).call(this);

/*
 * Debounce function
 * based on unminified version from http://davidwalsh.name/javascript-debounce-function
 */
theme.debounce = function(n,t,u){var e;return function(){var a=this,r=arguments,i=function(){e=null,u||n.apply(a,r)},o=u&&!e;clearTimeout(e),e=setTimeout(i,t),o&&n.apply(a,r)}};

/*!
 * tocca.min.js
 */
/*! tocca v0.2.0-beta.2 || Gianluca Guarini */
var SWIPE_THRESHOLD=50;!function(e,t){"use strict";if("function"!=typeof e.createEvent)return!1;var n,i,r,o,s,a,l,c,u="undefined"!=typeof jQuery,p=function(e){var t=e.toLowerCase(),n="MS"+e;return navigator.msPointerEnabled?n:t},d=!!navigator.pointerEnabled||navigator.msPointerEnabled,h=function(){return"ontouchstart"in window||window.DocumentTouch&&document instanceof DocumentTouch||d},f=function(e){var t=h(),n=/mouse/.test(e.type);return!n&&t&&/touch/.test(e.type)&&!d||!n&&t&&!/touch/.test(e.type)&&d||n&&!t},v={touchstart:p("PointerDown")+" touchstart",touchend:p("PointerUp")+" touchend",touchmove:p("PointerMove")+" touchmove"},g=function(e,t,n){for(var i=t.split(" "),r=i.length;r--;)e.addEventListener(i[r],n,!1)},m=function(e){return e.targetTouches?e.targetTouches[0]:e},y=function(){return(new Date).getTime()},b=function(t,r,o,s){var a=e.createEvent("Event");if(a.originalEvent=o,s=s||{},s.x=n,s.y=i,s.distance=s.distance,u&&(a=$.Event(r,{originalEvent:o}),jQuery(t).trigger(a,s)),a.initEvent){for(var l in s)a[l]=s[l];a.initEvent(r,!0,!0),t.dispatchEvent(a)}t["on"+r]&&t["on"+r](a)},k=function(e){if(f(e)){var t=m(e);r=n=t.pageX,o=i=t.pageY,c=setTimeout(function(){b(e.target,"longtap",e),a=e.target},E),s=y(),A++}},w=function(e){if(f(e)){var t=[],u=y(),p=o-i,d=r-n;if(clearTimeout(l),clearTimeout(c),-S>=d&&t.push("swiperight"),d>=S&&t.push("swipeleft"),-S>=p&&t.push("swipedown"),p>=S&&t.push("swipeup"),t.length)for(var h=0;h<t.length;h++){var v=t[h];b(e.target,v,e,{distance:{x:Math.abs(d),y:Math.abs(p)}})}else r>=n-P&&n+P>=r&&o>=i-P&&i+P>=o&&s+T-u>=0&&(b(e.target,2===A&&a===e.target?"dbltap":"tap",e),a=e.target),l=setTimeout(function(){A=0},C)}},x=function(e){if(f(e)){var t=m(e);n=t.pageX,i=t.pageY}},S=t.SWIPE_THRESHOLD||100,T=t.TAP_THRESHOLD||150,C=t.DBL_TAP_THRESHOLD||200,E=t.LONG_TAP_THRESHOLD||1e3,P=t.TAP_PRECISION/2||30,_=t.JUST_ON_TOUCH_DEVICES,A=0;g(e,v.touchstart+(_?"":" mousedown"),k),g(e,v.touchend+(_?"":" mouseup"),w),g(e,v.touchmove+(_?"":" mousemove"),x)}(document,window),/*!
 * jquery.ba-throttle-debounce.min.js
 */
/*
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
function(e,t){var n,i=e.jQuery||e.Cowboy||(e.Cowboy={});i.throttle=n=function(e,n,r,o){function s(){function i(){l=+new Date,r.apply(c,p)}function s(){a=t}var c=this,u=+new Date-l,p=arguments;o&&!a&&i(),a&&clearTimeout(a),o===t&&u>e?i():n!==!0&&(a=setTimeout(o?s:i,o===t?e-u:e))}var a,l=0;return"boolean"!=typeof n&&(o=r,r=n,n=t),i.guid&&(s.guid=r.guid=r.guid||i.guid++),s},i.debounce=function(e,i,r){return r===t?n(e,i,!1):n(e,r,i!==!1)}}(this);
    
/*!
 * @preserve
 *
 * Readmore.js jQuery plugin
 * Author: @jed_foster
 * Project home: http://jedfoster.github.io/Readmore.js
 * Licensed under the MIT license
 *
 * Debounce function from http://davidwalsh.name/javascript-debounce-function
 */
!function(t){"function"==typeof define&&define.amd?define(["jquery"],t):"object"==typeof exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){"use strict";function e(t,e,i){var o;return function(){var n=this,a=arguments,s=function(){o=null,i||t.apply(n,a)},r=i&&!o;clearTimeout(o),o=setTimeout(s,e),r&&t.apply(n,a)}}function i(t){var e=++h;return String(null==t?"rmjs-":t)+e}function o(t){var e=t.clone().css({height:"auto",width:t.width(),maxHeight:"none",overflow:"hidden"}).insertAfter(t),i=e.outerHeight(),o=parseInt(e.css({maxHeight:""}).css("max-height").replace(/[^-\d\.]/g,""),10),n=t.data("defaultHeight");e.remove();var a=o||t.data("collapsedHeight")||n;t.data({expandedHeight:i,maxHeight:o,collapsedHeight:a}).css({maxHeight:"none"})}function n(t){if(!d[t.selector]){var e=" ";t.embedCSS&&""!==t.blockCSS&&(e+=t.selector+" + [data-readmore-toggle], "+t.selector+"[data-readmore]{"+t.blockCSS+"}"),e+=t.selector+"[data-readmore]{transition: height "+t.speed+"ms;overflow: hidden;}",function(t,e){var i=t.createElement("style");i.type="text/css",i.styleSheet?i.styleSheet.cssText=e:i.appendChild(t.createTextNode(e)),t.getElementsByTagName("head")[0].appendChild(i)}(document,e),d[t.selector]=!0}}function a(e,i){this.element=e,this.options=t.extend({},r,i),n(this.options),this._defaults=r,this._name=s,this.init(),window.addEventListener?(window.addEventListener("load",c),window.addEventListener("resize",c)):(window.attachEvent("load",c),window.attachEvent("resize",c))}var s="readmore",r={speed:100,collapsedHeight:200,heightMargin:16,moreLink:'<a href="#">Read More</a>',lessLink:'<a href="#">Close</a>',embedCSS:!0,blockCSS:"display: block; width: 100%;",startOpen:!1,blockProcessed:function(){},beforeToggle:function(){},afterToggle:function(){}},d={},h=0,c=e(function(){t("[data-readmore]").each(function(){var e=t(this),i="true"===e.attr("aria-expanded");o(e),e.css({height:e.data(i?"expandedHeight":"collapsedHeight")})})},100);a.prototype={init:function(){var e=t(this.element);e.data({defaultHeight:this.options.collapsedHeight,heightMargin:this.options.heightMargin}),o(e);var n=e.data("collapsedHeight"),a=e.data("heightMargin");if(e.outerHeight(!0)<=n+a)return this.options.blockProcessed&&"function"==typeof this.options.blockProcessed&&this.options.blockProcessed(e,!1),!0;var s=e.attr("id")||i(),r=this.options.startOpen?this.options.lessLink:this.options.moreLink;e.attr({"data-readmore":"","aria-expanded":this.options.startOpen,id:s}),e.after(t(r).on("click",function(t){return function(i){t.toggle(this,e[0],i)}}(this)).attr({"data-readmore-toggle":s,"aria-controls":s})),this.options.startOpen||e.css({height:n}),this.options.blockProcessed&&"function"==typeof this.options.blockProcessed&&this.options.blockProcessed(e,!0)},toggle:function(e,i,o){o&&o.preventDefault(),e||(e=t('[aria-controls="'+this.element.id+'"]')[0]),i||(i=this.element);var n=t(i),a="",s="",r=!1,d=n.data("collapsedHeight");n.height()<=d?(a=n.data("expandedHeight")+"px",s="lessLink",r=!0):(a=d,s="moreLink"),this.options.beforeToggle&&"function"==typeof this.options.beforeToggle&&this.options.beforeToggle(e,n,!r),n.css({height:a}),n.on("transitionend",function(i){return function(){i.options.afterToggle&&"function"==typeof i.options.afterToggle&&i.options.afterToggle(e,n,r),t(this).attr({"aria-expanded":r}).off("transitionend")}}(this)),t(e).replaceWith(t(this.options[s]).on("click",function(t){return function(e){t.toggle(this,i,e)}}(this)).attr({"data-readmore-toggle":n.attr("id"),"aria-controls":n.attr("id")}))},destroy:function(){t(this.element).each(function(){var e=t(this);e.attr({"data-readmore":null,"aria-expanded":null}).css({maxHeight:"",height:""}).next("[data-readmore-toggle]").remove(),e.removeData()})}},t.fn.readmore=function(e){var i=arguments,o=this.selector;return e=e||{},"object"==typeof e?this.each(function(){if(t.data(this,"plugin_"+s)){var i=t.data(this,"plugin_"+s);i.destroy.apply(i)}e.selector=o,t.data(this,"plugin_"+s,new a(this,e))}):"string"==typeof e&&"_"!==e[0]&&"init"!==e?this.each(function(){var o=t.data(this,"plugin_"+s);o instanceof a&&"function"==typeof o[e]&&o[e].apply(o,Array.prototype.slice.call(i,1))}):void 0}});
   
/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.4
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */
var Ajaxinate=function(e){var t=e||{};this.settings=Object.assign({method:"scroll",container:"#AjaxinateContainer",pagination:"#AjaxinatePagination",offset:0,loadingText:"Loading",callback:null},t),this.addScrollListeners=this.addScrollListeners.bind(this),this.addClickListener=this.addClickListener.bind(this),this.checkIfPaginationInView=this.checkIfPaginationInView.bind(this),this.stopMultipleClicks=this.stopMultipleClicks.bind(this),this.removeClickListener=this.removeClickListener.bind(this),this.removeScrollListener=this.removeScrollListener.bind(this),this.destroy=this.destroy.bind(this),this.containerElement=document.querySelector(this.settings.container),this.paginationElement=document.querySelector(this.settings.pagination),this.initialize()};Ajaxinate.prototype.initialize=function(){this.containerElement&&{click:this.addClickListener,scroll:this.addScrollListeners}[this.settings.method]()},Ajaxinate.prototype.addScrollListeners=function(){this.paginationElement&&(document.addEventListener("scroll",this.checkIfPaginationInView),window.addEventListener("resize",this.checkIfPaginationInView),window.addEventListener("orientationchange",this.checkIfPaginationInView))},Ajaxinate.prototype.addClickListener=function(){this.paginationElement&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.clickActive=!0,void 0!==this.nextPageLinkElement&&null!==this.nextPageLinkElement&&this.nextPageLinkElement.addEventListener("click",this.stopMultipleClicks))},Ajaxinate.prototype.stopMultipleClicks=function(e){e.preventDefault(),this.clickActive&&(this.nextPageLinkElement.innerText=this.settings.loadingText,this.nextPageUrl=this.nextPageLinkElement.href,this.clickActive=!1,this.loadMore())},Ajaxinate.prototype.checkIfPaginationInView=function(){var e=this.paginationElement.getBoundingClientRect().top-this.settings.offset,t=this.paginationElement.getBoundingClientRect().bottom+this.settings.offset;e<=window.innerHeight&&t>=0&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.removeScrollListener(),this.nextPageLinkElement&&(this.nextPageLinkElement.innerText=this.settings.loadingText,this.nextPageUrl=this.nextPageLinkElement.href,this.loadMore()))},Ajaxinate.prototype.loadMore=function(){this.request=new XMLHttpRequest,this.request.onreadystatechange=function(){if(4===this.request.readyState&&200===this.request.status){var e=this.request.responseXML.querySelectorAll(this.settings.container)[0],t=this.request.responseXML.querySelectorAll(this.settings.pagination)[0];this.containerElement.insertAdjacentHTML("beforeend",e.innerHTML),this.paginationElement.innerHTML=t.innerHTML,this.settings.callback&&"function"==typeof this.settings.callback&&this.settings.callback(this.request.responseXML),this.initialize()}}.bind(this),this.request.open("GET",this.nextPageUrl),this.request.responseType="document",this.request.send()},Ajaxinate.prototype.removeClickListener=function(){this.nextPageLinkElement.removeEventListener("click",this.stopMultipleClicks)},Ajaxinate.prototype.removeScrollListener=function(){document.removeEventListener("scroll",this.checkIfPaginationInView),window.removeEventListener("resize",this.checkIfPaginationInView),window.removeEventListener("orientationchange",this.checkIfPaginationInView)},Ajaxinate.prototype.destroy=function(){return{click:this.removeClickListener,scroll:this.removeScrollListener}[this.settings.method](),this};
   
/*!
 * Isotope PACKAGED v3.0.6
 *
 * Licensed GPLv3 for open source use
 * or Isotope Commercial License for commercial use
 *
 * https://isotope.metafizzy.co
 * Copyright 2010-2018 Metafizzy
 */
!function(t,e){"function"==typeof define&&define.amd?define("jquery-bridget/jquery-bridget",["jquery"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("jquery")):t.jQueryBridget=e(t,t.jQuery)}(window,function(t,e){"use strict";function i(i,s,a){function u(t,e,o){var n,s="$()."+i+'("'+e+'")';return t.each(function(t,u){var h=a.data(u,i);if(!h)return void r(i+" not initialized. Cannot call methods, i.e. "+s);var d=h[e];if(!d||"_"==e.charAt(0))return void r(s+" is not a valid method");var l=d.apply(h,o);n=void 0===n?l:n}),void 0!==n?n:t}function h(t,e){t.each(function(t,o){var n=a.data(o,i);n?(n.option(e),n._init()):(n=new s(o,e),a.data(o,i,n))})}a=a||e||t.jQuery,a&&(s.prototype.option||(s.prototype.option=function(t){a.isPlainObject(t)&&(this.options=a.extend(!0,this.options,t))}),a.fn[i]=function(t){if("string"==typeof t){var e=n.call(arguments,1);return u(this,t,e)}return h(this,t),this},o(a))}function o(t){!t||t&&t.bridget||(t.bridget=i)}var n=Array.prototype.slice,s=t.console,r="undefined"==typeof s?function(){}:function(t){s.error(t)};return o(e||t.jQuery),i}),function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},o=i[t]=i[t]||[];return o.indexOf(e)==-1&&o.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{},o=i[t]=i[t]||{};return o[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var o=i.indexOf(e);return o!=-1&&i.splice(o,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){i=i.slice(0),e=e||[];for(var o=this._onceEvents&&this._onceEvents[t],n=0;n<i.length;n++){var s=i[n],r=o&&o[s];r&&(this.off(t,s),delete o[s]),s.apply(this,e)}return this}},e.allOff=function(){delete this._events,delete this._onceEvents},t}),function(t,e){"function"==typeof define&&define.amd?define("get-size/get-size",e):"object"==typeof module&&module.exports?module.exports=e():t.getSize=e()}(window,function(){"use strict";function t(t){var e=parseFloat(t),i=t.indexOf("%")==-1&&!isNaN(e);return i&&e}function e(){}function i(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},e=0;e<h;e++){var i=u[e];t[i]=0}return t}function o(t){var e=getComputedStyle(t);return e||a("Style returned "+e+". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),e}function n(){if(!d){d=!0;var e=document.createElement("div");e.style.width="200px",e.style.padding="1px 2px 3px 4px",e.style.borderStyle="solid",e.style.borderWidth="1px 2px 3px 4px",e.style.boxSizing="border-box";var i=document.body||document.documentElement;i.appendChild(e);var n=o(e);r=200==Math.round(t(n.width)),s.isBoxSizeOuter=r,i.removeChild(e)}}function s(e){if(n(),"string"==typeof e&&(e=document.querySelector(e)),e&&"object"==typeof e&&e.nodeType){var s=o(e);if("none"==s.display)return i();var a={};a.width=e.offsetWidth,a.height=e.offsetHeight;for(var d=a.isBorderBox="border-box"==s.boxSizing,l=0;l<h;l++){var f=u[l],c=s[f],m=parseFloat(c);a[f]=isNaN(m)?0:m}var p=a.paddingLeft+a.paddingRight,y=a.paddingTop+a.paddingBottom,g=a.marginLeft+a.marginRight,v=a.marginTop+a.marginBottom,_=a.borderLeftWidth+a.borderRightWidth,z=a.borderTopWidth+a.borderBottomWidth,I=d&&r,x=t(s.width);x!==!1&&(a.width=x+(I?0:p+_));var S=t(s.height);return S!==!1&&(a.height=S+(I?0:y+z)),a.innerWidth=a.width-(p+_),a.innerHeight=a.height-(y+z),a.outerWidth=a.width+g,a.outerHeight=a.height+v,a}}var r,a="undefined"==typeof console?e:function(t){console.error(t)},u=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],h=u.length,d=!1;return s}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("desandro-matches-selector/matches-selector",e):"object"==typeof module&&module.exports?module.exports=e():t.matchesSelector=e()}(window,function(){"use strict";var t=function(){var t=window.Element.prototype;if(t.matches)return"matches";if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],i=0;i<e.length;i++){var o=e[i],n=o+"MatchesSelector";if(t[n])return n}}();return function(e,i){return e[t](i)}}),function(t,e){"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["desandro-matches-selector/matches-selector"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("desandro-matches-selector")):t.fizzyUIUtils=e(t,t.matchesSelector)}(window,function(t,e){var i={};i.extend=function(t,e){for(var i in e)t[i]=e[i];return t},i.modulo=function(t,e){return(t%e+e)%e};var o=Array.prototype.slice;i.makeArray=function(t){if(Array.isArray(t))return t;if(null===t||void 0===t)return[];var e="object"==typeof t&&"number"==typeof t.length;return e?o.call(t):[t]},i.removeFrom=function(t,e){var i=t.indexOf(e);i!=-1&&t.splice(i,1)},i.getParent=function(t,i){for(;t.parentNode&&t!=document.body;)if(t=t.parentNode,e(t,i))return t},i.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},i.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.filterFindElements=function(t,o){t=i.makeArray(t);var n=[];return t.forEach(function(t){if(t instanceof HTMLElement){if(!o)return void n.push(t);e(t,o)&&n.push(t);for(var i=t.querySelectorAll(o),s=0;s<i.length;s++)n.push(i[s])}}),n},i.debounceMethod=function(t,e,i){i=i||100;var o=t.prototype[e],n=e+"Timeout";t.prototype[e]=function(){var t=this[n];clearTimeout(t);var e=arguments,s=this;this[n]=setTimeout(function(){o.apply(s,e),delete s[n]},i)}},i.docReady=function(t){var e=document.readyState;"complete"==e||"interactive"==e?setTimeout(t):document.addEventListener("DOMContentLoaded",t)},i.toDashed=function(t){return t.replace(/(.)([A-Z])/g,function(t,e,i){return e+"-"+i}).toLowerCase()};var n=t.console;return i.htmlInit=function(e,o){i.docReady(function(){var s=i.toDashed(o),r="data-"+s,a=document.querySelectorAll("["+r+"]"),u=document.querySelectorAll(".js-"+s),h=i.makeArray(a).concat(i.makeArray(u)),d=r+"-options",l=t.jQuery;h.forEach(function(t){var i,s=t.getAttribute(r)||t.getAttribute(d);try{i=s&&JSON.parse(s)}catch(a){return void(n&&n.error("Error parsing "+r+" on "+t.className+": "+a))}var u=new e(t,i);l&&l.data(t,o,u)})})},i}),function(t,e){"function"==typeof define&&define.amd?define("outlayer/item",["ev-emitter/ev-emitter","get-size/get-size"],e):"object"==typeof module&&module.exports?module.exports=e(require("ev-emitter"),require("get-size")):(t.Outlayer={},t.Outlayer.Item=e(t.EvEmitter,t.getSize))}(window,function(t,e){"use strict";function i(t){for(var e in t)return!1;return e=null,!0}function o(t,e){t&&(this.element=t,this.layout=e,this.position={x:0,y:0},this._create())}function n(t){return t.replace(/([A-Z])/g,function(t){return"-"+t.toLowerCase()})}var s=document.documentElement.style,r="string"==typeof s.transition?"transition":"WebkitTransition",a="string"==typeof s.transform?"transform":"WebkitTransform",u={WebkitTransition:"webkitTransitionEnd",transition:"transitionend"}[r],h={transform:a,transition:r,transitionDuration:r+"Duration",transitionProperty:r+"Property",transitionDelay:r+"Delay"},d=o.prototype=Object.create(t.prototype);d.constructor=o,d._create=function(){this._transn={ingProperties:{},clean:{},onEnd:{}},this.css({position:"absolute"})},d.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},d.getSize=function(){this.size=e(this.element)},d.css=function(t){var e=this.element.style;for(var i in t){var o=h[i]||i;e[o]=t[i]}},d.getPosition=function(){var t=getComputedStyle(this.element),e=this.layout._getOption("originLeft"),i=this.layout._getOption("originTop"),o=t[e?"left":"right"],n=t[i?"top":"bottom"],s=parseFloat(o),r=parseFloat(n),a=this.layout.size;o.indexOf("%")!=-1&&(s=s/100*a.width),n.indexOf("%")!=-1&&(r=r/100*a.height),s=isNaN(s)?0:s,r=isNaN(r)?0:r,s-=e?a.paddingLeft:a.paddingRight,r-=i?a.paddingTop:a.paddingBottom,this.position.x=s,this.position.y=r},d.layoutPosition=function(){var t=this.layout.size,e={},i=this.layout._getOption("originLeft"),o=this.layout._getOption("originTop"),n=i?"paddingLeft":"paddingRight",s=i?"left":"right",r=i?"right":"left",a=this.position.x+t[n];e[s]=this.getXValue(a),e[r]="";var u=o?"paddingTop":"paddingBottom",h=o?"top":"bottom",d=o?"bottom":"top",l=this.position.y+t[u];e[h]=this.getYValue(l),e[d]="",this.css(e),this.emitEvent("layout",[this])},d.getXValue=function(t){var e=this.layout._getOption("horizontal");return this.layout.options.percentPosition&&!e?t/this.layout.size.width*100+"%":t+"px"},d.getYValue=function(t){var e=this.layout._getOption("horizontal");return this.layout.options.percentPosition&&e?t/this.layout.size.height*100+"%":t+"px"},d._transitionTo=function(t,e){this.getPosition();var i=this.position.x,o=this.position.y,n=t==this.position.x&&e==this.position.y;if(this.setPosition(t,e),n&&!this.isTransitioning)return void this.layoutPosition();var s=t-i,r=e-o,a={};a.transform=this.getTranslate(s,r),this.transition({to:a,onTransitionEnd:{transform:this.layoutPosition},isCleaning:!0})},d.getTranslate=function(t,e){var i=this.layout._getOption("originLeft"),o=this.layout._getOption("originTop");return t=i?t:-t,e=o?e:-e,"translate3d("+t+"px, "+e+"px, 0)"},d.goTo=function(t,e){this.setPosition(t,e),this.layoutPosition()},d.moveTo=d._transitionTo,d.setPosition=function(t,e){this.position.x=parseFloat(t),this.position.y=parseFloat(e)},d._nonTransition=function(t){this.css(t.to),t.isCleaning&&this._removeStyles(t.to);for(var e in t.onTransitionEnd)t.onTransitionEnd[e].call(this)},d.transition=function(t){if(!parseFloat(this.layout.options.transitionDuration))return void this._nonTransition(t);var e=this._transn;for(var i in t.onTransitionEnd)e.onEnd[i]=t.onTransitionEnd[i];for(i in t.to)e.ingProperties[i]=!0,t.isCleaning&&(e.clean[i]=!0);if(t.from){this.css(t.from);var o=this.element.offsetHeight;o=null}this.enableTransition(t.to),this.css(t.to),this.isTransitioning=!0};var l="opacity,"+n(a);d.enableTransition=function(){if(!this.isTransitioning){var t=this.layout.options.transitionDuration;t="number"==typeof t?t+"ms":t,this.css({transitionProperty:l,transitionDuration:t,transitionDelay:this.staggerDelay||0}),this.element.addEventListener(u,this,!1)}},d.onwebkitTransitionEnd=function(t){this.ontransitionend(t)},d.onotransitionend=function(t){this.ontransitionend(t)};var f={"-webkit-transform":"transform"};d.ontransitionend=function(t){if(t.target===this.element){var e=this._transn,o=f[t.propertyName]||t.propertyName;if(delete e.ingProperties[o],i(e.ingProperties)&&this.disableTransition(),o in e.clean&&(this.element.style[t.propertyName]="",delete e.clean[o]),o in e.onEnd){var n=e.onEnd[o];n.call(this),delete e.onEnd[o]}this.emitEvent("transitionEnd",[this])}},d.disableTransition=function(){this.removeTransitionStyles(),this.element.removeEventListener(u,this,!1),this.isTransitioning=!1},d._removeStyles=function(t){var e={};for(var i in t)e[i]="";this.css(e)};var c={transitionProperty:"",transitionDuration:"",transitionDelay:""};return d.removeTransitionStyles=function(){this.css(c)},d.stagger=function(t){t=isNaN(t)?0:t,this.staggerDelay=t+"ms"},d.removeElem=function(){this.element.parentNode.removeChild(this.element),this.css({display:""}),this.emitEvent("remove",[this])},d.remove=function(){return r&&parseFloat(this.layout.options.transitionDuration)?(this.once("transitionEnd",function(){this.removeElem()}),void this.hide()):void this.removeElem()},d.reveal=function(){delete this.isHidden,this.css({display:""});var t=this.layout.options,e={},i=this.getHideRevealTransitionEndProperty("visibleStyle");e[i]=this.onRevealTransitionEnd,this.transition({from:t.hiddenStyle,to:t.visibleStyle,isCleaning:!0,onTransitionEnd:e})},d.onRevealTransitionEnd=function(){this.isHidden||this.emitEvent("reveal")},d.getHideRevealTransitionEndProperty=function(t){var e=this.layout.options[t];if(e.opacity)return"opacity";for(var i in e)return i},d.hide=function(){this.isHidden=!0,this.css({display:""});var t=this.layout.options,e={},i=this.getHideRevealTransitionEndProperty("hiddenStyle");e[i]=this.onHideTransitionEnd,this.transition({from:t.visibleStyle,to:t.hiddenStyle,isCleaning:!0,onTransitionEnd:e})},d.onHideTransitionEnd=function(){this.isHidden&&(this.css({display:"none"}),this.emitEvent("hide"))},d.destroy=function(){this.css({position:"",left:"",right:"",top:"",bottom:"",transition:"",transform:""})},o}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("outlayer/outlayer",["ev-emitter/ev-emitter","get-size/get-size","fizzy-ui-utils/utils","./item"],function(i,o,n,s){return e(t,i,o,n,s)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter"),require("get-size"),require("fizzy-ui-utils"),require("./item")):t.Outlayer=e(t,t.EvEmitter,t.getSize,t.fizzyUIUtils,t.Outlayer.Item)}(window,function(t,e,i,o,n){"use strict";function s(t,e){var i=o.getQueryElement(t);if(!i)return void(u&&u.error("Bad element for "+this.constructor.namespace+": "+(i||t)));this.element=i,h&&(this.$element=h(this.element)),this.options=o.extend({},this.constructor.defaults),this.option(e);var n=++l;this.element.outlayerGUID=n,f[n]=this,this._create();var s=this._getOption("initLayout");s&&this.layout()}function r(t){function e(){t.apply(this,arguments)}return e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e}function a(t){if("number"==typeof t)return t;var e=t.match(/(^\d*\.?\d*)(\w*)/),i=e&&e[1],o=e&&e[2];if(!i.length)return 0;i=parseFloat(i);var n=m[o]||1;return i*n}var u=t.console,h=t.jQuery,d=function(){},l=0,f={};s.namespace="outlayer",s.Item=n,s.defaults={containerStyle:{position:"relative"},initLayout:!0,originLeft:!0,originTop:!0,resize:!0,resizeContainer:!0,transitionDuration:"0.4s",hiddenStyle:{opacity:0,transform:"scale(0.001)"},visibleStyle:{opacity:1,transform:"scale(1)"}};var c=s.prototype;o.extend(c,e.prototype),c.option=function(t){o.extend(this.options,t)},c._getOption=function(t){var e=this.constructor.compatOptions[t];return e&&void 0!==this.options[e]?this.options[e]:this.options[t]},s.compatOptions={initLayout:"isInitLayout",horizontal:"isHorizontal",layoutInstant:"isLayoutInstant",originLeft:"isOriginLeft",originTop:"isOriginTop",resize:"isResizeBound",resizeContainer:"isResizingContainer"},c._create=function(){this.reloadItems(),this.stamps=[],this.stamp(this.options.stamp),o.extend(this.element.style,this.options.containerStyle);var t=this._getOption("resize");t&&this.bindResize()},c.reloadItems=function(){this.items=this._itemize(this.element.children)},c._itemize=function(t){for(var e=this._filterFindItemElements(t),i=this.constructor.Item,o=[],n=0;n<e.length;n++){var s=e[n],r=new i(s,this);o.push(r)}return o},c._filterFindItemElements=function(t){return o.filterFindElements(t,this.options.itemSelector)},c.getItemElements=function(){return this.items.map(function(t){return t.element})},c.layout=function(){this._resetLayout(),this._manageStamps();var t=this._getOption("layoutInstant"),e=void 0!==t?t:!this._isLayoutInited;this.layoutItems(this.items,e),this._isLayoutInited=!0},c._init=c.layout,c._resetLayout=function(){this.getSize()},c.getSize=function(){this.size=i(this.element)},c._getMeasurement=function(t,e){var o,n=this.options[t];n?("string"==typeof n?o=this.element.querySelector(n):n instanceof HTMLElement&&(o=n),this[t]=o?i(o)[e]:n):this[t]=0},c.layoutItems=function(t,e){t=this._getItemsForLayout(t),this._layoutItems(t,e),this._postLayout()},c._getItemsForLayout=function(t){return t.filter(function(t){return!t.isIgnored})},c._layoutItems=function(t,e){if(this._emitCompleteOnItems("layout",t),t&&t.length){var i=[];t.forEach(function(t){var o=this._getItemLayoutPosition(t);o.item=t,o.isInstant=e||t.isLayoutInstant,i.push(o)},this),this._processLayoutQueue(i)}},c._getItemLayoutPosition=function(){return{x:0,y:0}},c._processLayoutQueue=function(t){this.updateStagger(),t.forEach(function(t,e){this._positionItem(t.item,t.x,t.y,t.isInstant,e)},this)},c.updateStagger=function(){var t=this.options.stagger;return null===t||void 0===t?void(this.stagger=0):(this.stagger=a(t),this.stagger)},c._positionItem=function(t,e,i,o,n){o?t.goTo(e,i):(t.stagger(n*this.stagger),t.moveTo(e,i))},c._postLayout=function(){this.resizeContainer()},c.resizeContainer=function(){var t=this._getOption("resizeContainer");if(t){var e=this._getContainerSize();e&&(this._setContainerMeasure(e.width,!0),this._setContainerMeasure(e.height,!1))}},c._getContainerSize=d,c._setContainerMeasure=function(t,e){if(void 0!==t){var i=this.size;i.isBorderBox&&(t+=e?i.paddingLeft+i.paddingRight+i.borderLeftWidth+i.borderRightWidth:i.paddingBottom+i.paddingTop+i.borderTopWidth+i.borderBottomWidth),t=Math.max(t,0),this.element.style[e?"width":"height"]=t+"px"}},c._emitCompleteOnItems=function(t,e){function i(){n.dispatchEvent(t+"Complete",null,[e])}function o(){r++,r==s&&i()}var n=this,s=e.length;if(!e||!s)return void i();var r=0;e.forEach(function(e){e.once(t,o)})},c.dispatchEvent=function(t,e,i){var o=e?[e].concat(i):i;if(this.emitEvent(t,o),h)if(this.$element=this.$element||h(this.element),e){var n=h.Event(e);n.type=t,this.$element.trigger(n,i)}else this.$element.trigger(t,i)},c.ignore=function(t){var e=this.getItem(t);e&&(e.isIgnored=!0)},c.unignore=function(t){var e=this.getItem(t);e&&delete e.isIgnored},c.stamp=function(t){t=this._find(t),t&&(this.stamps=this.stamps.concat(t),t.forEach(this.ignore,this))},c.unstamp=function(t){t=this._find(t),t&&t.forEach(function(t){o.removeFrom(this.stamps,t),this.unignore(t)},this)},c._find=function(t){if(t)return"string"==typeof t&&(t=this.element.querySelectorAll(t)),t=o.makeArray(t)},c._manageStamps=function(){this.stamps&&this.stamps.length&&(this._getBoundingRect(),this.stamps.forEach(this._manageStamp,this))},c._getBoundingRect=function(){var t=this.element.getBoundingClientRect(),e=this.size;this._boundingRect={left:t.left+e.paddingLeft+e.borderLeftWidth,top:t.top+e.paddingTop+e.borderTopWidth,right:t.right-(e.paddingRight+e.borderRightWidth),bottom:t.bottom-(e.paddingBottom+e.borderBottomWidth)}},c._manageStamp=d,c._getElementOffset=function(t){var e=t.getBoundingClientRect(),o=this._boundingRect,n=i(t),s={left:e.left-o.left-n.marginLeft,top:e.top-o.top-n.marginTop,right:o.right-e.right-n.marginRight,bottom:o.bottom-e.bottom-n.marginBottom};return s},c.handleEvent=o.handleEvent,c.bindResize=function(){t.addEventListener("resize",this),this.isResizeBound=!0},c.unbindResize=function(){t.removeEventListener("resize",this),this.isResizeBound=!1},c.onresize=function(){this.resize()},o.debounceMethod(s,"onresize",100),c.resize=function(){this.isResizeBound&&this.needsResizeLayout()&&this.layout()},c.needsResizeLayout=function(){var t=i(this.element),e=this.size&&t;return e&&t.innerWidth!==this.size.innerWidth},c.addItems=function(t){var e=this._itemize(t);return e.length&&(this.items=this.items.concat(e)),e},c.appended=function(t){var e=this.addItems(t);e.length&&(this.layoutItems(e,!0),this.reveal(e))},c.prepended=function(t){var e=this._itemize(t);if(e.length){var i=this.items.slice(0);this.items=e.concat(i),this._resetLayout(),this._manageStamps(),this.layoutItems(e,!0),this.reveal(e),this.layoutItems(i)}},c.reveal=function(t){if(this._emitCompleteOnItems("reveal",t),t&&t.length){var e=this.updateStagger();t.forEach(function(t,i){t.stagger(i*e),t.reveal()})}},c.hide=function(t){if(this._emitCompleteOnItems("hide",t),t&&t.length){var e=this.updateStagger();t.forEach(function(t,i){t.stagger(i*e),t.hide()})}},c.revealItemElements=function(t){var e=this.getItems(t);this.reveal(e)},c.hideItemElements=function(t){var e=this.getItems(t);this.hide(e)},c.getItem=function(t){for(var e=0;e<this.items.length;e++){var i=this.items[e];if(i.element==t)return i}},c.getItems=function(t){t=o.makeArray(t);var e=[];return t.forEach(function(t){var i=this.getItem(t);i&&e.push(i)},this),e},c.remove=function(t){var e=this.getItems(t);this._emitCompleteOnItems("remove",e),e&&e.length&&e.forEach(function(t){t.remove(),o.removeFrom(this.items,t)},this)},c.destroy=function(){var t=this.element.style;t.height="",t.position="",t.width="",this.items.forEach(function(t){t.destroy()}),this.unbindResize();var e=this.element.outlayerGUID;delete f[e],delete this.element.outlayerGUID,h&&h.removeData(this.element,this.constructor.namespace)},s.data=function(t){t=o.getQueryElement(t);var e=t&&t.outlayerGUID;return e&&f[e]},s.create=function(t,e){var i=r(s);return i.defaults=o.extend({},s.defaults),o.extend(i.defaults,e),i.compatOptions=o.extend({},s.compatOptions),i.namespace=t,i.data=s.data,i.Item=r(n),o.htmlInit(i,t),h&&h.bridget&&h.bridget(t,i),i};var m={ms:1,s:1e3};return s.Item=n,s}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/item",["outlayer/outlayer"],e):"object"==typeof module&&module.exports?module.exports=e(require("outlayer")):(t.Isotope=t.Isotope||{},t.Isotope.Item=e(t.Outlayer))}(window,function(t){"use strict";function e(){t.Item.apply(this,arguments)}var i=e.prototype=Object.create(t.Item.prototype),o=i._create;i._create=function(){this.id=this.layout.itemGUID++,o.call(this),this.sortData={}},i.updateSortData=function(){if(!this.isIgnored){this.sortData.id=this.id,this.sortData["original-order"]=this.id,this.sortData.random=Math.random();var t=this.layout.options.getSortData,e=this.layout._sorters;for(var i in t){var o=e[i];this.sortData[i]=o(this.element,this)}}};var n=i.destroy;return i.destroy=function(){n.apply(this,arguments),this.css({display:""})},e}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/layout-mode",["get-size/get-size","outlayer/outlayer"],e):"object"==typeof module&&module.exports?module.exports=e(require("get-size"),require("outlayer")):(t.Isotope=t.Isotope||{},t.Isotope.LayoutMode=e(t.getSize,t.Outlayer))}(window,function(t,e){"use strict";function i(t){this.isotope=t,t&&(this.options=t.options[this.namespace],this.element=t.element,this.items=t.filteredItems,this.size=t.size)}var o=i.prototype,n=["_resetLayout","_getItemLayoutPosition","_manageStamp","_getContainerSize","_getElementOffset","needsResizeLayout","_getOption"];return n.forEach(function(t){o[t]=function(){return e.prototype[t].apply(this.isotope,arguments)}}),o.needsVerticalResizeLayout=function(){var e=t(this.isotope.element),i=this.isotope.size&&e;return i&&e.innerHeight!=this.isotope.size.innerHeight},o._getMeasurement=function(){this.isotope._getMeasurement.apply(this,arguments)},o.getColumnWidth=function(){this.getSegmentSize("column","Width")},o.getRowHeight=function(){this.getSegmentSize("row","Height")},o.getSegmentSize=function(t,e){var i=t+e,o="outer"+e;if(this._getMeasurement(i,o),!this[i]){var n=this.getFirstItemSize();this[i]=n&&n[o]||this.isotope.size["inner"+e]}},o.getFirstItemSize=function(){var e=this.isotope.filteredItems[0];return e&&e.element&&t(e.element)},o.layout=function(){this.isotope.layout.apply(this.isotope,arguments)},o.getSize=function(){this.isotope.getSize(),this.size=this.isotope.size},i.modes={},i.create=function(t,e){function n(){i.apply(this,arguments)}return n.prototype=Object.create(o),n.prototype.constructor=n,e&&(n.options=e),n.prototype.namespace=t,i.modes[t]=n,n},i}),function(t,e){"function"==typeof define&&define.amd?define("masonry-layout/masonry",["outlayer/outlayer","get-size/get-size"],e):"object"==typeof module&&module.exports?module.exports=e(require("outlayer"),require("get-size")):t.Masonry=e(t.Outlayer,t.getSize)}(window,function(t,e){var i=t.create("masonry");i.compatOptions.fitWidth="isFitWidth";var o=i.prototype;return o._resetLayout=function(){this.getSize(),this._getMeasurement("columnWidth","outerWidth"),this._getMeasurement("gutter","outerWidth"),this.measureColumns(),this.colYs=[];for(var t=0;t<this.cols;t++)this.colYs.push(0);this.maxY=0,this.horizontalColIndex=0},o.measureColumns=function(){if(this.getContainerWidth(),!this.columnWidth){var t=this.items[0],i=t&&t.element;this.columnWidth=i&&e(i).outerWidth||this.containerWidth}var o=this.columnWidth+=this.gutter,n=this.containerWidth+this.gutter,s=n/o,r=o-n%o,a=r&&r<1?"round":"floor";s=Math[a](s),this.cols=Math.max(s,1)},o.getContainerWidth=function(){var t=this._getOption("fitWidth"),i=t?this.element.parentNode:this.element,o=e(i);this.containerWidth=o&&o.innerWidth},o._getItemLayoutPosition=function(t){t.getSize();var e=t.size.outerWidth%this.columnWidth,i=e&&e<1?"round":"ceil",o=Math[i](t.size.outerWidth/this.columnWidth);o=Math.min(o,this.cols);for(var n=this.options.horizontalOrder?"_getHorizontalColPosition":"_getTopColPosition",s=this[n](o,t),r={x:this.columnWidth*s.col,y:s.y},a=s.y+t.size.outerHeight,u=o+s.col,h=s.col;h<u;h++)this.colYs[h]=a;return r},o._getTopColPosition=function(t){var e=this._getTopColGroup(t),i=Math.min.apply(Math,e);return{col:e.indexOf(i),y:i}},o._getTopColGroup=function(t){if(t<2)return this.colYs;for(var e=[],i=this.cols+1-t,o=0;o<i;o++)e[o]=this._getColGroupY(o,t);return e},o._getColGroupY=function(t,e){if(e<2)return this.colYs[t];var i=this.colYs.slice(t,t+e);return Math.max.apply(Math,i)},o._getHorizontalColPosition=function(t,e){var i=this.horizontalColIndex%this.cols,o=t>1&&i+t>this.cols;i=o?0:i;var n=e.size.outerWidth&&e.size.outerHeight;return this.horizontalColIndex=n?i+t:this.horizontalColIndex,{col:i,y:this._getColGroupY(i,t)}},o._manageStamp=function(t){var i=e(t),o=this._getElementOffset(t),n=this._getOption("originLeft"),s=n?o.left:o.right,r=s+i.outerWidth,a=Math.floor(s/this.columnWidth);a=Math.max(0,a);var u=Math.floor(r/this.columnWidth);u-=r%this.columnWidth?0:1,u=Math.min(this.cols-1,u);for(var h=this._getOption("originTop"),d=(h?o.top:o.bottom)+i.outerHeight,l=a;l<=u;l++)this.colYs[l]=Math.max(d,this.colYs[l])},o._getContainerSize=function(){this.maxY=Math.max.apply(Math,this.colYs);var t={height:this.maxY};return this._getOption("fitWidth")&&(t.width=this._getContainerFitWidth()),t},o._getContainerFitWidth=function(){for(var t=0,e=this.cols;--e&&0===this.colYs[e];)t++;return(this.cols-t)*this.columnWidth-this.gutter},o.needsResizeLayout=function(){var t=this.containerWidth;return this.getContainerWidth(),t!=this.containerWidth},i}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/layout-modes/masonry",["../layout-mode","masonry-layout/masonry"],e):"object"==typeof module&&module.exports?module.exports=e(require("../layout-mode"),require("masonry-layout")):e(t.Isotope.LayoutMode,t.Masonry)}(window,function(t,e){"use strict";var i=t.create("masonry"),o=i.prototype,n={_getElementOffset:!0,layout:!0,_getMeasurement:!0};for(var s in e.prototype)n[s]||(o[s]=e.prototype[s]);var r=o.measureColumns;o.measureColumns=function(){this.items=this.isotope.filteredItems,r.call(this)};var a=o._getOption;return o._getOption=function(t){return"fitWidth"==t?void 0!==this.options.isFitWidth?this.options.isFitWidth:this.options.fitWidth:a.apply(this.isotope,arguments)},i}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/layout-modes/fit-rows",["../layout-mode"],e):"object"==typeof exports?module.exports=e(require("../layout-mode")):e(t.Isotope.LayoutMode)}(window,function(t){"use strict";var e=t.create("fitRows"),i=e.prototype;return i._resetLayout=function(){this.x=0,this.y=0,this.maxY=0,this._getMeasurement("gutter","outerWidth")},i._getItemLayoutPosition=function(t){t.getSize();var e=t.size.outerWidth+this.gutter,i=this.isotope.size.innerWidth+this.gutter;0!==this.x&&e+this.x>i&&(this.x=0,this.y=this.maxY);var o={x:this.x,y:this.y};return this.maxY=Math.max(this.maxY,this.y+t.size.outerHeight),this.x+=e,o},i._getContainerSize=function(){return{height:this.maxY}},e}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/layout-modes/vertical",["../layout-mode"],e):"object"==typeof module&&module.exports?module.exports=e(require("../layout-mode")):e(t.Isotope.LayoutMode)}(window,function(t){"use strict";var e=t.create("vertical",{horizontalAlignment:0}),i=e.prototype;return i._resetLayout=function(){this.y=0},i._getItemLayoutPosition=function(t){t.getSize();var e=(this.isotope.size.innerWidth-t.size.outerWidth)*this.options.horizontalAlignment,i=this.y;return this.y+=t.size.outerHeight,{x:e,y:i}},i._getContainerSize=function(){return{height:this.y}},e}),function(t,e){"function"==typeof define&&define.amd?define(["outlayer/outlayer","get-size/get-size","desandro-matches-selector/matches-selector","fizzy-ui-utils/utils","isotope-layout/js/item","isotope-layout/js/layout-mode","isotope-layout/js/layout-modes/masonry","isotope-layout/js/layout-modes/fit-rows","isotope-layout/js/layout-modes/vertical"],function(i,o,n,s,r,a){return e(t,i,o,n,s,r,a)}):"object"==typeof module&&module.exports?module.exports=e(t,require("outlayer"),require("get-size"),require("desandro-matches-selector"),require("fizzy-ui-utils"),require("isotope-layout/js/item"),require("isotope-layout/js/layout-mode"),require("isotope-layout/js/layout-modes/masonry"),require("isotope-layout/js/layout-modes/fit-rows"),require("isotope-layout/js/layout-modes/vertical")):t.Isotope=e(t,t.Outlayer,t.getSize,t.matchesSelector,t.fizzyUIUtils,t.Isotope.Item,t.Isotope.LayoutMode)}(window,function(t,e,i,o,n,s,r){function a(t,e){return function(i,o){for(var n=0;n<t.length;n++){var s=t[n],r=i.sortData[s],a=o.sortData[s];if(r>a||r<a){var u=void 0!==e[s]?e[s]:e,h=u?1:-1;return(r>a?1:-1)*h}}return 0}}var u=t.jQuery,h=String.prototype.trim?function(t){return t.trim()}:function(t){return t.replace(/^\s+|\s+$/g,"")},d=e.create("isotope",{layoutMode:"masonry",isJQueryFiltering:!0,sortAscending:!0});d.Item=s,d.LayoutMode=r;var l=d.prototype;l._create=function(){this.itemGUID=0,this._sorters={},this._getSorters(),e.prototype._create.call(this),this.modes={},this.filteredItems=this.items,this.sortHistory=["original-order"];for(var t in r.modes)this._initLayoutMode(t)},l.reloadItems=function(){this.itemGUID=0,e.prototype.reloadItems.call(this)},l._itemize=function(){for(var t=e.prototype._itemize.apply(this,arguments),i=0;i<t.length;i++){var o=t[i];o.id=this.itemGUID++}return this._updateItemsSortData(t),t},l._initLayoutMode=function(t){var e=r.modes[t],i=this.options[t]||{};this.options[t]=e.options?n.extend(e.options,i):i,this.modes[t]=new e(this)},l.layout=function(){return!this._isLayoutInited&&this._getOption("initLayout")?void this.arrange():void this._layout()},l._layout=function(){var t=this._getIsInstant();this._resetLayout(),this._manageStamps(),this.layoutItems(this.filteredItems,t),this._isLayoutInited=!0},l.arrange=function(t){this.option(t),this._getIsInstant();var e=this._filter(this.items);this.filteredItems=e.matches,this._bindArrangeComplete(),this._isInstant?this._noTransition(this._hideReveal,[e]):this._hideReveal(e),this._sort(),this._layout()},l._init=l.arrange,l._hideReveal=function(t){this.reveal(t.needReveal),this.hide(t.needHide)},l._getIsInstant=function(){var t=this._getOption("layoutInstant"),e=void 0!==t?t:!this._isLayoutInited;return this._isInstant=e,e},l._bindArrangeComplete=function(){function t(){e&&i&&o&&n.dispatchEvent("arrangeComplete",null,[n.filteredItems])}var e,i,o,n=this;this.once("layoutComplete",function(){e=!0,t()}),this.once("hideComplete",function(){i=!0,t()}),this.once("revealComplete",function(){o=!0,t()})},l._filter=function(t){var e=this.options.filter;e=e||"*";for(var i=[],o=[],n=[],s=this._getFilterTest(e),r=0;r<t.length;r++){var a=t[r];if(!a.isIgnored){var u=s(a);u&&i.push(a),u&&a.isHidden?o.push(a):u||a.isHidden||n.push(a)}}return{matches:i,needReveal:o,needHide:n}},l._getFilterTest=function(t){return u&&this.options.isJQueryFiltering?function(e){return u(e.element).is(t);
}:"function"==typeof t?function(e){return t(e.element)}:function(e){return o(e.element,t)}},l.updateSortData=function(t){var e;t?(t=n.makeArray(t),e=this.getItems(t)):e=this.items,this._getSorters(),this._updateItemsSortData(e)},l._getSorters=function(){var t=this.options.getSortData;for(var e in t){var i=t[e];this._sorters[e]=f(i)}},l._updateItemsSortData=function(t){for(var e=t&&t.length,i=0;e&&i<e;i++){var o=t[i];o.updateSortData()}};var f=function(){function t(t){if("string"!=typeof t)return t;var i=h(t).split(" "),o=i[0],n=o.match(/^\[(.+)\]$/),s=n&&n[1],r=e(s,o),a=d.sortDataParsers[i[1]];return t=a?function(t){return t&&a(r(t))}:function(t){return t&&r(t)}}function e(t,e){return t?function(e){return e.getAttribute(t)}:function(t){var i=t.querySelector(e);return i&&i.textContent}}return t}();d.sortDataParsers={parseInt:function(t){return parseInt(t,10)},parseFloat:function(t){return parseFloat(t)}},l._sort=function(){if(this.options.sortBy){var t=n.makeArray(this.options.sortBy);this._getIsSameSortBy(t)||(this.sortHistory=t.concat(this.sortHistory));var e=a(this.sortHistory,this.options.sortAscending);this.filteredItems.sort(e)}},l._getIsSameSortBy=function(t){for(var e=0;e<t.length;e++)if(t[e]!=this.sortHistory[e])return!1;return!0},l._mode=function(){var t=this.options.layoutMode,e=this.modes[t];if(!e)throw new Error("No layout mode: "+t);return e.options=this.options[t],e},l._resetLayout=function(){e.prototype._resetLayout.call(this),this._mode()._resetLayout()},l._getItemLayoutPosition=function(t){return this._mode()._getItemLayoutPosition(t)},l._manageStamp=function(t){this._mode()._manageStamp(t)},l._getContainerSize=function(){return this._mode()._getContainerSize()},l.needsResizeLayout=function(){return this._mode().needsResizeLayout()},l.appended=function(t){var e=this.addItems(t);if(e.length){var i=this._filterRevealAdded(e);this.filteredItems=this.filteredItems.concat(i)}},l.prepended=function(t){var e=this._itemize(t);if(e.length){this._resetLayout(),this._manageStamps();var i=this._filterRevealAdded(e);this.layoutItems(this.filteredItems),this.filteredItems=i.concat(this.filteredItems),this.items=e.concat(this.items)}},l._filterRevealAdded=function(t){var e=this._filter(t);return this.hide(e.needHide),this.reveal(e.matches),this.layoutItems(e.matches,!0),e.matches},l.insert=function(t){var e=this.addItems(t);if(e.length){var i,o,n=e.length;for(i=0;i<n;i++)o=e[i],this.element.appendChild(o.element);var s=this._filter(e).matches;for(i=0;i<n;i++)e[i].isLayoutInstant=!0;for(this.arrange(),i=0;i<n;i++)delete e[i].isLayoutInstant;this.reveal(s)}};var c=l.remove;return l.remove=function(t){t=n.makeArray(t);var e=this.getItems(t);c.call(this,t);for(var i=e&&e.length,o=0;i&&o<i;o++){var s=e[o];n.removeFrom(this.filteredItems,s)}},l.shuffle=function(){for(var t=0;t<this.items.length;t++){var e=this.items[t];e.sortData.random=Math.random()}this.options.sortBy="random",this._sort(),this._layout()},l._noTransition=function(t,e){var i=this.options.transitionDuration;this.options.transitionDuration=0;var o=t.apply(this,e);return this.options.transitionDuration=i,o},l.getFilteredItemElements=function(){return this.filteredItems.map(function(t){return t.element})},d});    
    
/**
 * van11y-accessible-simple-tooltip-aria - ES2015 accessible tooltip system, using ARIA
 * @version v3.0.0
 * @link https://van11y.net/accessible-simple-tooltip/
 * @license MIT : https://github.com/nico3333fr/van11y-accessible-simple-tooltip-aria/blob/master/LICENSE
 */
"use strict";var _extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var i=arguments[e];for(var n in i)Object.prototype.hasOwnProperty.call(i,n)&&(t[n]=i[n])}return t},loadConfig=function(){var t={},e=function(e,i){t[e]=i},i=function(e){return t[e]},n=function(e){return t[e]};return{set:e,get:i,remove:n}},DATA_HASH_ID="data-hashtooltip-id",pluginConfig=loadConfig(),findById=function(t){var e=arguments.length<=1||void 0===arguments[1]?"":arguments[1];return""!==e?document.querySelector("#"+t+"["+DATA_HASH_ID+'="'+e+'"]'):document.getElementById(t)},addClass=function(t,e){t.classList?t.classList.add(e):t.className+=" "+e},hasClass=function(t,e){return t.classList?t.classList.contains(e):new RegExp("(^| )"+e+"( |$)","gi").test(t.className)},searchParentHashId=function(t,e){for(var i=!1,n=t;1===n.nodeType&&n&&i===!1;)n.hasAttribute(e)===!0?i=!0:n=n.parentNode;return i===!0?n.getAttribute(e):""},wrapItem=function(t,e,i,n){var o=[e,i].filter(Boolean).join("-"),a=document.createElement("SPAN");return addClass(a,o),a.setAttribute(DATA_HASH_ID,n),t.parentNode.insertBefore(a,t),a.appendChild(t),a},createTooltip=function(t){var e=[t.className,t.tooltipSimpleRaw].filter(Boolean).join("-"),i=t.text;if(!i&&t.id){var n=findById(t.id);n&&(i=n.innerHTML)}return'<span class="'+e+" "+t.jsClass+'" id="'+t.tooltipId+'" '+t.roleTooltip+" "+t.hiddenAttribute+" "+t.hashIdAttribute+">"+i+"</span>"},plugin=function(){var t=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],e=_extends({TOOLTIP_SIMPLE:"js-simple-tooltip",TOOLTIP_SIMPLE_CONTAINER:"simpletooltip_container",TOOLTIP_SIMPLE_RAW:"simpletooltip",TOOLTIP_SIMPLE_LABEL_ID:"label_simpletooltip_",TOOLTIP_DATA_TEXT:"data-simpletooltip-text",TOOLTIP_DATA_PREFIX_CLASS:"data-simpletooltip-prefix-class",TOOLTIP_DATA_CONTENT_ID:"data-simpletooltip-content-id",ATTR_DESCRIBEDBY:"aria-describedby",ATTR_HIDDEN:"aria-hidden",ATTR_ROLE:"role",ROLE:"tooltip"},t),i=Math.random().toString(32).slice(2,12);pluginConfig.set(i,e);var n=function(){var t=arguments.length<=0||void 0===arguments[0]?document:arguments[0];return[].slice.call(t.querySelectorAll("."+e.TOOLTIP_SIMPLE))},o=function(t){n(t).forEach(function(t){t.setAttribute(DATA_HASH_ID,i);var n=Math.random().toString(32).slice(2,12),o=t.hasAttribute(e.TOOLTIP_DATA_TEXT)===!0?t.getAttribute(e.TOOLTIP_DATA_TEXT):"",a=t.hasAttribute(e.TOOLTIP_DATA_PREFIX_CLASS)===!0?t.getAttribute(e.TOOLTIP_DATA_PREFIX_CLASS):"",r=t.hasAttribute(e.TOOLTIP_DATA_CONTENT_ID)===!0?t.getAttribute(e.TOOLTIP_DATA_CONTENT_ID):"";t.setAttribute(e.ATTR_DESCRIBEDBY,e.TOOLTIP_SIMPLE_LABEL_ID+n),wrapItem(t,a,e.TOOLTIP_SIMPLE_CONTAINER,i).insertAdjacentHTML("beforeEnd",createTooltip({text:o,className:a,jsClass:e.TOOLTIP_SIMPLE,id:r,tooltipId:e.TOOLTIP_SIMPLE_LABEL_ID+n,tooltipSimpleRaw:e.TOOLTIP_SIMPLE_RAW,hiddenAttribute:e.ATTR_HIDDEN+'="true"',roleTooltip:e.ATTR_ROLE+'="'+e.ROLE+'"',hashIdAttribute:DATA_HASH_ID+'="'+i+'"'}))})};return{attach:o}},main=function(){return["mouseenter","focus","mouseleave","blur","keydown"].forEach(function(t){document.body.addEventListener(t,function(e){var i=searchParentHashId(e.target,DATA_HASH_ID);if(""!==i){var n=pluginConfig.get(i);if(hasClass(e.target,n.TOOLTIP_SIMPLE)===!0){var o=e.target;if("mouseenter"===t||"focus"===t){var a=findById(o.getAttribute(n.ATTR_DESCRIBEDBY),i);a&&a.setAttribute(n.ATTR_HIDDEN,"false")}if("mouseleave"===t||"blur"===t||"keydown"===t&&27===e.keyCode){var a=findById(o.getAttribute(n.ATTR_DESCRIBEDBY),i);a&&a.setAttribute(n.ATTR_HIDDEN,"true")}}}},!0)}),plugin};window.van11yAccessibleSimpleTooltipAria=main();var onLoad=function t(){var e=window.van11yAccessibleSimpleTooltipAria();e.attach(),document.removeEventListener("DOMContentLoaded",t)};document.addEventListener("DOMContentLoaded",onLoad);

    
/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.originalEvent.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '$';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      if( (number / 100.0) % 1 == 0 ) {
        number = (number / 100).toFixed(0);
      } else {
        number = (number / 100).toFixed(precision);
      }

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      const intlCurrency = (Shopify.currency.active === 'CAD' || Shopify.currency.active === 'AUD') 
        ? ' ' + Shopify.currency.active
        : '';
      return dollarsAmount + centsAmount + intlCurrency;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[.@]/
    );

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or media changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),

        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }
      let inventoryHash = document.querySelectorAll('[data-inventorymanagment]'); 
      Array.from(inventoryHash).forEach( 
        (Selectedvariant)=>{ 
  
          if(Selectedvariant.dataset.id == variant.id){
            $("#variant-inventory-load").addClass("visually-opacity-hidden");
            if(Selectedvariant.dataset.inventory > 0) {
              $("#variant-inventory").html("(Only "+ Selectedvariant.dataset.inventory +" left!)"); 
              var selected_product = parseInt(Selectedvariant.dataset.inventory);
              if(selected_product <= 2){
                $("#variant-inventory").removeClass("visually-opacity-hidden");
              }
              else{ 
                $("#variant-inventory").addClass("visually-opacity-hidden"); 
              } 
            } 
            else{ 
              $("#variant-inventory").addClass("visually-opacity-hidden");
            }   
          } 
  
        } 
      ); 

      this._updateMasterSelect(variant);
      this._updateMedia(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;
      this._updatePaymentButton(variant);

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant media changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantMediaChange
     */
    _updateMedia: function(variant) {
      var variantMedia = variant.featured_media || {};

        var currentVariantMedia = this.currentVariant.featured_media || {};
      

      var isMatchingPreviewImage = false;

      if (variantMedia.preview_image && currentVariantMedia.preview_image) {
        isMatchingPreviewImage =
          variantMedia.preview_image.src ===
          currentVariantMedia.preview_image.src;
      }

      
      if (!variant.featured_media || isMatchingPreviewImage) return;
    

      this.$container.trigger({
        type: 'variantMediaChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      /*
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
      */
    },

    /**
     * Trigger event when variant SKU changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (this.currentVariant != undefined ) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }
      }

      if (variant) {
        $('.variant-sku').text(variant.sku);
      }
      else {
        $('.variant-sku').empty();
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    _updatePaymentButton: function(variant) {
      const $paymentButton = $('.btn--add-to-cart');
      const $noVariableButton = $('.btn--no-variant-selected');

      if (this.currentVariant != undefined) {
        
        if ($paymentButton) {
          $paymentButton.removeClass('visually-hidden');
        }
        if ($noVariableButton) {
          $noVariableButton.addClass('visually-hidden');
        }

      } else {
        $paymentButton.addClass('visually-hidden');
        $noVariableButton.removeClass('visually-hidden');
      }
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      if(window.location.href.indexOf('?') > -1 && window.location.href.indexOf('&variant=') > -1){
        var product_url = window.location.href.split('&variant=');
        var newurl =
        product_url[0] +
        '&variant=' +
        variant.id;
      }else{
        var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?variant=' +
          variant.id;
      }      
      window.history.replaceState(
        {
          path: newurl
        },
        '',
        newurl
      );
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39
  }
};


/* ================ GLOBAL ================ */
theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    youtubeSdk: {
      tagId: 'youtube-sdk',
      src: 'https://www.youtube.com/iframe_api',
      type: types.script
    },
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();


/* ================ MODULES ================ */

/*!
handlebars v1.3.0

Copyright (C) 2011 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

@license
*/
var Handlebars=function(){var e=function(){"use strict";function t(e){this.string=e}var e;t.prototype.toString=function(){return""+this.string};e=t;return e}();var t=function(e){"use strict";function o(e){return r[e]||"&"}function u(e,t){for(var n in t){if(Object.prototype.hasOwnProperty.call(t,n)){e[n]=t[n]}}}function c(e){if(e instanceof n){return e.toString()}else if(!e&&e!==0){return""}e=""+e;if(!s.test(e)){return e}return e.replace(i,o)}function h(e){if(!e&&e!==0){return true}else if(l(e)&&e.length===0){return true}else{return false}}var t={};var n=e;var r={"&":"&","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"};var i=/[&<>"'`]/g;var s=/[&<>"'`]/;t.extend=u;var a=Object.prototype.toString;t.toString=a;var f=function(e){return typeof e==="function"};if(f(/x/)){f=function(e){return typeof e==="function"&&a.call(e)==="[object Function]"}}var f;t.isFunction=f;var l=Array.isArray||function(e){return e&&typeof e==="object"?a.call(e)==="[object Array]":false};t.isArray=l;t.escapeExpression=c;t.isEmpty=h;return t}(e);var n=function(){"use strict";function n(e,n){var r;if(n&&n.firstLine){r=n.firstLine;e+=" - "+r+":"+n.firstColumn}var i=Error.prototype.constructor.call(this,e);for(var s=0;s<t.length;s++){this[t[s]]=i[t[s]]}if(r){this.lineNumber=r;this.column=n.firstColumn}}var e;var t=["description","fileName","lineNumber","message","name","number","stack"];n.prototype=new Error;e=n;return e}();var r=function(e,t){"use strict";function h(e,t){this.helpers=e||{};this.partials=t||{};p(this)}function p(e){e.registerHelper("helperMissing",function(e){if(arguments.length===2){return undefined}else{throw new i("Missing helper: '"+e+"'")}});e.registerHelper("blockHelperMissing",function(t,n){var r=n.inverse||function(){},i=n.fn;if(f(t)){t=t.call(this)}if(t===true){return i(this)}else if(t===false||t==null){return r(this)}else if(a(t)){if(t.length>0){return e.helpers.each(t,n)}else{return r(this)}}else{return i(t)}});e.registerHelper("each",function(e,t){var n=t.fn,r=t.inverse;var i=0,s="",o;if(f(e)){e=e.call(this)}if(t.data){o=m(t.data)}if(e&&typeof e==="object"){if(a(e)){for(var u=e.length;i<u;i++){if(o){o.index=i;o.first=i===0;o.last=i===e.length-1}s=s+n(e[i],{data:o})}}else{for(var l in e){if(e.hasOwnProperty(l)){if(o){o.key=l;o.index=i;o.first=i===0}s=s+n(e[l],{data:o});i++}}}}if(i===0){s=r(this)}return s});e.registerHelper("if",function(e,t){if(f(e)){e=e.call(this)}if(!t.hash.includeZero&&!e||r.isEmpty(e)){return t.inverse(this)}else{return t.fn(this)}});e.registerHelper("unless",function(t,n){return e.helpers["if"].call(this,t,{fn:n.inverse,inverse:n.fn,hash:n.hash})});e.registerHelper("with",function(e,t){if(f(e)){e=e.call(this)}if(!r.isEmpty(e))return t.fn(e)});e.registerHelper("log",function(t,n){var r=n.data&&n.data.level!=null?parseInt(n.data.level,10):1;e.log(r,t)})}function v(e,t){d.log(e,t)}var n={};var r=e;var i=t;var s="1.3.0";n.VERSION=s;var o=4;n.COMPILER_REVISION=o;var u={1:"<= 1.0.rc.2",2:"== 1.0.0-rc.3",3:"== 1.0.0-rc.4",4:">= 1.0.0"};n.REVISION_CHANGES=u;var a=r.isArray,f=r.isFunction,l=r.toString,c="[object Object]";n.HandlebarsEnvironment=h;h.prototype={constructor:h,logger:d,log:v,registerHelper:function(e,t,n){if(l.call(e)===c){if(n||t){throw new i("Arg not supported with multiple helpers")}r.extend(this.helpers,e)}else{if(n){t.not=n}this.helpers[e]=t}},registerPartial:function(e,t){if(l.call(e)===c){r.extend(this.partials,e)}else{this.partials[e]=t}}};var d={methodMap:{0:"debug",1:"info",2:"warn",3:"error"},DEBUG:0,INFO:1,WARN:2,ERROR:3,level:3,log:function(e,t){if(d.level<=e){var n=d.methodMap[e];if(typeof console!=="undefined"&&console[n]){console[n].call(console,t)}}}};n.logger=d;n.log=v;var m=function(e){var t={};r.extend(t,e);return t};n.createFrame=m;return n}(t,n);var i=function(e,t,n){"use strict";function a(e){var t=e&&e[0]||1,n=o;if(t!==n){if(t<n){var r=u[n],i=u[t];throw new s("Template was precompiled with an older version of Handlebars than the current runtime. "+"Please update your precompiler to a newer version ("+r+") or downgrade your runtime to an older version ("+i+").")}else{throw new s("Template was precompiled with a newer version of Handlebars than the current runtime. "+"Please update your runtime to a newer version ("+e[1]+").")}}}function f(e,t){if(!t){throw new s("No environment passed to template")}var n=function(e,n,r,i,o,u){var a=t.VM.invokePartial.apply(this,arguments);if(a!=null){return a}if(t.compile){var f={helpers:i,partials:o,data:u};o[n]=t.compile(e,{data:u!==undefined},t);return o[n](r,f)}else{throw new s("The partial "+n+" could not be compiled when running in runtime-only mode")}};var r={escapeExpression:i.escapeExpression,invokePartial:n,programs:[],program:function(e,t,n){var r=this.programs[e];if(n){r=c(e,t,n)}else if(!r){r=this.programs[e]=c(e,t)}return r},merge:function(e,t){var n=e||t;if(e&&t&&e!==t){n={};i.extend(n,t);i.extend(n,e)}return n},programWithDepth:t.VM.programWithDepth,noop:t.VM.noop,compilerInfo:null};return function(n,i){i=i||{};var s=i.partial?i:t,o,u;if(!i.partial){o=i.helpers;u=i.partials}var a=e.call(r,s,n,o,u,i.data);if(!i.partial){t.VM.checkRevision(r.compilerInfo)}return a}}function l(e,t,n){var r=Array.prototype.slice.call(arguments,3);var i=function(e,i){i=i||{};return t.apply(this,[e,i.data||n].concat(r))};i.program=e;i.depth=r.length;return i}function c(e,t,n){var r=function(e,r){r=r||{};return t(e,r.data||n)};r.program=e;r.depth=0;return r}function h(e,t,n,r,i,o){var u={partial:true,helpers:r,partials:i,data:o};if(e===undefined){throw new s("The partial "+t+" could not be found")}else if(e instanceof Function){return e(n,u)}}function p(){return""}var r={};var i=e;var s=t;var o=n.COMPILER_REVISION;var u=n.REVISION_CHANGES;r.checkRevision=a;r.template=f;r.programWithDepth=l;r.program=c;r.invokePartial=h;r.noop=p;return r}(t,n,r);var s=function(e,t,n,r,i){"use strict";var s;var o=e;var u=t;var a=n;var f=r;var l=i;var c=function(){var e=new o.HandlebarsEnvironment;f.extend(e,o);e.SafeString=u;e.Exception=a;e.Utils=f;e.VM=l;e.template=function(t){return l.template(t,e)};return e};var h=c();h.create=c;s=h;return s}(r,e,n,t,i);var o=function(e){"use strict";function r(e){e=e||{};this.firstLine=e.first_line;this.firstColumn=e.first_column;this.lastColumn=e.last_column;this.lastLine=e.last_line}var t;var n=e;var i={ProgramNode:function(e,t,n,s){var o,u;if(arguments.length===3){s=n;n=null}else if(arguments.length===2){s=t;t=null}r.call(this,s);this.type="program";this.statements=e;this.strip={};if(n){u=n[0];if(u){o={first_line:u.firstLine,last_line:u.lastLine,last_column:u.lastColumn,first_column:u.firstColumn};this.inverse=new i.ProgramNode(n,t,o)}else{this.inverse=new i.ProgramNode(n,t)}this.strip.right=t.left}else if(t){this.strip.left=t.right}},MustacheNode:function(e,t,n,s,o){r.call(this,o);this.type="mustache";this.strip=s;if(n!=null&&n.charAt){var u=n.charAt(3)||n.charAt(2);this.escaped=u!=="{"&&u!=="&"}else{this.escaped=!!n}if(e instanceof i.SexprNode){this.sexpr=e}else{this.sexpr=new i.SexprNode(e,t)}this.sexpr.isRoot=true;this.id=this.sexpr.id;this.params=this.sexpr.params;this.hash=this.sexpr.hash;this.eligibleHelper=this.sexpr.eligibleHelper;this.isHelper=this.sexpr.isHelper},SexprNode:function(e,t,n){r.call(this,n);this.type="sexpr";this.hash=t;var i=this.id=e[0];var s=this.params=e.slice(1);var o=this.eligibleHelper=i.isSimple;this.isHelper=o&&(s.length||t)},PartialNode:function(e,t,n,i){r.call(this,i);this.type="partial";this.partialName=e;this.context=t;this.strip=n},BlockNode:function(e,t,i,s,o){r.call(this,o);if(e.sexpr.id.original!==s.path.original){throw new n(e.sexpr.id.original+" doesn't match "+s.path.original,this)}this.type="block";this.mustache=e;this.program=t;this.inverse=i;this.strip={left:e.strip.left,right:s.strip.right};(t||i).strip.left=e.strip.right;(i||t).strip.right=s.strip.left;if(i&&!t){this.isInverse=true}},ContentNode:function(e,t){r.call(this,t);this.type="content";this.string=e},HashNode:function(e,t){r.call(this,t);this.type="hash";this.pairs=e},IdNode:function(e,t){r.call(this,t);this.type="ID";var i="",s=[],o=0;for(var u=0,a=e.length;u<a;u++){var f=e[u].part;i+=(e[u].separator||"")+f;if(f===".."||f==="."||f==="this"){if(s.length>0){throw new n("Invalid path: "+i,this)}else if(f===".."){o++}else{this.isScoped=true}}else{s.push(f)}}this.original=i;this.parts=s;this.string=s.join(".");this.depth=o;this.isSimple=e.length===1&&!this.isScoped&&o===0;this.stringModeValue=this.string},PartialNameNode:function(e,t){r.call(this,t);this.type="PARTIAL_NAME";this.name=e.original},DataNode:function(e,t){r.call(this,t);this.type="DATA";this.id=e},StringNode:function(e,t){r.call(this,t);this.type="STRING";this.original=this.string=this.stringModeValue=e},IntegerNode:function(e,t){r.call(this,t);this.type="INTEGER";this.original=this.integer=e;this.stringModeValue=Number(e)},BooleanNode:function(e,t){r.call(this,t);this.type="BOOLEAN";this.bool=e;this.stringModeValue=e==="true"},CommentNode:function(e,t){r.call(this,t);this.type="comment";this.comment=e}};t=i;return t}(n);var u=function(){"use strict";var e;var t=function(){function t(e,t){return{left:e.charAt(2)==="~",right:t.charAt(0)==="~"||t.charAt(1)==="~"}}function r(){this.yy={}}var e={trace:function(){},yy:{},symbols_:{error:2,root:3,statements:4,EOF:5,program:6,simpleInverse:7,statement:8,openInverse:9,closeBlock:10,openBlock:11,mustache:12,partial:13,CONTENT:14,COMMENT:15,OPEN_BLOCK:16,sexpr:17,CLOSE:18,OPEN_INVERSE:19,OPEN_ENDBLOCK:20,path:21,OPEN:22,OPEN_UNESCAPED:23,CLOSE_UNESCAPED:24,OPEN_PARTIAL:25,partialName:26,partial_option0:27,sexpr_repetition0:28,sexpr_option0:29,dataName:30,param:31,STRING:32,INTEGER:33,BOOLEAN:34,OPEN_SEXPR:35,CLOSE_SEXPR:36,hash:37,hash_repetition_plus0:38,hashSegment:39,ID:40,EQUALS:41,DATA:42,pathSegments:43,SEP:44,$accept:0,$end:1},terminals_:{2:"error",5:"EOF",14:"CONTENT",15:"COMMENT",16:"OPEN_BLOCK",18:"CLOSE",19:"OPEN_INVERSE",20:"OPEN_ENDBLOCK",22:"OPEN",23:"OPEN_UNESCAPED",24:"CLOSE_UNESCAPED",25:"OPEN_PARTIAL",32:"STRING",33:"INTEGER",34:"BOOLEAN",35:"OPEN_SEXPR",36:"CLOSE_SEXPR",40:"ID",41:"EQUALS",42:"DATA",44:"SEP"},productions_:[0,[3,2],[3,1],[6,2],[6,3],[6,2],[6,1],[6,1],[6,0],[4,1],[4,2],[8,3],[8,3],[8,1],[8,1],[8,1],[8,1],[11,3],[9,3],[10,3],[12,3],[12,3],[13,4],[7,2],[17,3],[17,1],[31,1],[31,1],[31,1],[31,1],[31,1],[31,3],[37,1],[39,3],[26,1],[26,1],[26,1],[30,2],[21,1],[43,3],[43,1],[27,0],[27,1],[28,0],[28,2],[29,0],[29,1],[38,1],[38,2]],performAction:function(n,r,i,s,o,u,a){var f=u.length-1;switch(o){case 1:return new s.ProgramNode(u[f-1],this._$);break;case 2:return new s.ProgramNode([],this._$);break;case 3:this.$=new s.ProgramNode([],u[f-1],u[f],this._$);break;case 4:this.$=new s.ProgramNode(u[f-2],u[f-1],u[f],this._$);break;case 5:this.$=new s.ProgramNode(u[f-1],u[f],[],this._$);break;case 6:this.$=new s.ProgramNode(u[f],this._$);break;case 7:this.$=new s.ProgramNode([],this._$);break;case 8:this.$=new s.ProgramNode([],this._$);break;case 9:this.$=[u[f]];break;case 10:u[f-1].push(u[f]);this.$=u[f-1];break;case 11:this.$=new s.BlockNode(u[f-2],u[f-1].inverse,u[f-1],u[f],this._$);break;case 12:this.$=new s.BlockNode(u[f-2],u[f-1],u[f-1].inverse,u[f],this._$);break;case 13:this.$=u[f];break;case 14:this.$=u[f];break;case 15:this.$=new s.ContentNode(u[f],this._$);break;case 16:this.$=new s.CommentNode(u[f],this._$);break;case 17:this.$=new s.MustacheNode(u[f-1],null,u[f-2],t(u[f-2],u[f]),this._$);break;case 18:this.$=new s.MustacheNode(u[f-1],null,u[f-2],t(u[f-2],u[f]),this._$);break;case 19:this.$={path:u[f-1],strip:t(u[f-2],u[f])};break;case 20:this.$=new s.MustacheNode(u[f-1],null,u[f-2],t(u[f-2],u[f]),this._$);break;case 21:this.$=new s.MustacheNode(u[f-1],null,u[f-2],t(u[f-2],u[f]),this._$);break;case 22:this.$=new s.PartialNode(u[f-2],u[f-1],t(u[f-3],u[f]),this._$);break;case 23:this.$=t(u[f-1],u[f]);break;case 24:this.$=new s.SexprNode([u[f-2]].concat(u[f-1]),u[f],this._$);break;case 25:this.$=new s.SexprNode([u[f]],null,this._$);break;case 26:this.$=u[f];break;case 27:this.$=new s.StringNode(u[f],this._$);break;case 28:this.$=new s.IntegerNode(u[f],this._$);break;case 29:this.$=new s.BooleanNode(u[f],this._$);break;case 30:this.$=u[f];break;case 31:u[f-1].isHelper=true;this.$=u[f-1];break;case 32:this.$=new s.HashNode(u[f],this._$);break;case 33:this.$=[u[f-2],u[f]];break;case 34:this.$=new s.PartialNameNode(u[f],this._$);break;case 35:this.$=new s.PartialNameNode(new s.StringNode(u[f],this._$),this._$);break;case 36:this.$=new s.PartialNameNode(new s.IntegerNode(u[f],this._$));break;case 37:this.$=new s.DataNode(u[f],this._$);break;case 38:this.$=new s.IdNode(u[f],this._$);break;case 39:u[f-2].push({part:u[f],separator:u[f-1]});this.$=u[f-2];break;case 40:this.$=[{part:u[f]}];break;case 43:this.$=[];break;case 44:u[f-1].push(u[f]);break;case 47:this.$=[u[f]];break;case 48:u[f-1].push(u[f]);break}},table:[{3:1,4:2,5:[1,3],8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],22:[1,13],23:[1,14],25:[1,15]},{1:[3]},{5:[1,16],8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],22:[1,13],23:[1,14],25:[1,15]},{1:[2,2]},{5:[2,9],14:[2,9],15:[2,9],16:[2,9],19:[2,9],20:[2,9],22:[2,9],23:[2,9],25:[2,9]},{4:20,6:18,7:19,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,8],22:[1,13],23:[1,14],25:[1,15]},{4:20,6:22,7:19,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,8],22:[1,13],23:[1,14],25:[1,15]},{5:[2,13],14:[2,13],15:[2,13],16:[2,13],19:[2,13],20:[2,13],22:[2,13],23:[2,13],25:[2,13]},{5:[2,14],14:[2,14],15:[2,14],16:[2,14],19:[2,14],20:[2,14],22:[2,14],23:[2,14],25:[2,14]},{5:[2,15],14:[2,15],15:[2,15],16:[2,15],19:[2,15],20:[2,15],22:[2,15],23:[2,15],25:[2,15]},{5:[2,16],14:[2,16],15:[2,16],16:[2,16],19:[2,16],20:[2,16],22:[2,16],23:[2,16],25:[2,16]},{17:23,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:29,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:30,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:31,21:24,30:25,40:[1,28],42:[1,27],43:26},{21:33,26:32,32:[1,34],33:[1,35],40:[1,28],43:26},{1:[2,1]},{5:[2,10],14:[2,10],15:[2,10],16:[2,10],19:[2,10],20:[2,10],22:[2,10],23:[2,10],25:[2,10]},{10:36,20:[1,37]},{4:38,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,7],22:[1,13],23:[1,14],25:[1,15]},{7:39,8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,6],22:[1,13],23:[1,14],25:[1,15]},{17:23,18:[1,40],21:24,30:25,40:[1,28],42:[1,27],43:26},{10:41,20:[1,37]},{18:[1,42]},{18:[2,43],24:[2,43],28:43,32:[2,43],33:[2,43],34:[2,43],35:[2,43],36:[2,43],40:[2,43],42:[2,43]},{18:[2,25],24:[2,25],36:[2,25]},{18:[2,38],24:[2,38],32:[2,38],33:[2,38],34:[2,38],35:[2,38],36:[2,38],40:[2,38],42:[2,38],44:[1,44]},{21:45,40:[1,28],43:26},{18:[2,40],24:[2,40],32:[2,40],33:[2,40],34:[2,40],35:[2,40],36:[2,40],40:[2,40],42:[2,40],44:[2,40]},{18:[1,46]},{18:[1,47]},{24:[1,48]},{18:[2,41],21:50,27:49,40:[1,28],43:26},{18:[2,34],40:[2,34]},{18:[2,35],40:[2,35]},{18:[2,36],40:[2,36]},{5:[2,11],14:[2,11],15:[2,11],16:[2,11],19:[2,11],20:[2,11],22:[2,11],23:[2,11],25:[2,11]},{21:51,40:[1,28],43:26},{8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,3],22:[1,13],23:[1,14],25:[1,15]},{4:52,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,5],22:[1,13],23:[1,14],25:[1,15]},{14:[2,23],15:[2,23],16:[2,23],19:[2,23],20:[2,23],22:[2,23],23:[2,23],25:[2,23]},{5:[2,12],14:[2,12],15:[2,12],16:[2,12],19:[2,12],20:[2,12],22:[2,12],23:[2,12],25:[2,12]},{14:[2,18],15:[2,18],16:[2,18],19:[2,18],20:[2,18],22:[2,18],23:[2,18],25:[2,18]},{18:[2,45],21:56,24:[2,45],29:53,30:60,31:54,32:[1,57],33:[1,58],34:[1,59],35:[1,61],36:[2,45],37:55,38:62,39:63,40:[1,64],42:[1,27],43:26},{40:[1,65]},{18:[2,37],24:[2,37],32:[2,37],33:[2,37],34:[2,37],35:[2,37],36:[2,37],40:[2,37],42:[2,37]},{14:[2,17],15:[2,17],16:[2,17],19:[2,17],20:[2,17],22:[2,17],23:[2,17],25:[2,17]},{5:[2,20],14:[2,20],15:[2,20],16:[2,20],19:[2,20],20:[2,20],22:[2,20],23:[2,20],25:[2,20]},{5:[2,21],14:[2,21],15:[2,21],16:[2,21],19:[2,21],20:[2,21],22:[2,21],23:[2,21],25:[2,21]},{18:[1,66]},{18:[2,42]},{18:[1,67]},{8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,4],22:[1,13],23:[1,14],25:[1,15]},{18:[2,24],24:[2,24],36:[2,24]},{18:[2,44],24:[2,44],32:[2,44],33:[2,44],34:[2,44],35:[2,44],36:[2,44],40:[2,44],42:[2,44]},{18:[2,46],24:[2,46],36:[2,46]},{18:[2,26],24:[2,26],32:[2,26],33:[2,26],34:[2,26],35:[2,26],36:[2,26],40:[2,26],42:[2,26]},{18:[2,27],24:[2,27],32:[2,27],33:[2,27],34:[2,27],35:[2,27],36:[2,27],40:[2,27],42:[2,27]},{18:[2,28],24:[2,28],32:[2,28],33:[2,28],34:[2,28],35:[2,28],36:[2,28],40:[2,28],42:[2,28]},{18:[2,29],24:[2,29],32:[2,29],33:[2,29],34:[2,29],35:[2,29],36:[2,29],40:[2,29],42:[2,29]},{18:[2,30],24:[2,30],32:[2,30],33:[2,30],34:[2,30],35:[2,30],36:[2,30],40:[2,30],42:[2,30]},{17:68,21:24,30:25,40:[1,28],42:[1,27],43:26},{18:[2,32],24:[2,32],36:[2,32],39:69,40:[1,70]},{18:[2,47],24:[2,47],36:[2,47],40:[2,47]},{18:[2,40],24:[2,40],32:[2,40],33:[2,40],34:[2,40],35:[2,40],36:[2,40],40:[2,40],41:[1,71],42:[2,40],44:[2,40]},{18:[2,39],24:[2,39],32:[2,39],33:[2,39],34:[2,39],35:[2,39],36:[2,39],40:[2,39],42:[2,39],44:[2,39]},{5:[2,22],14:[2,22],15:[2,22],16:[2,22],19:[2,22],20:[2,22],22:[2,22],23:[2,22],25:[2,22]},{5:[2,19],14:[2,19],15:[2,19],16:[2,19],19:[2,19],20:[2,19],22:[2,19],23:[2,19],25:[2,19]},{36:[1,72]},{18:[2,48],24:[2,48],36:[2,48],40:[2,48]},{41:[1,71]},{21:56,30:60,31:73,32:[1,57],33:[1,58],34:[1,59],35:[1,61],40:[1,28],42:[1,27],43:26},{18:[2,31],24:[2,31],32:[2,31],33:[2,31],34:[2,31],35:[2,31],36:[2,31],40:[2,31],42:[2,31]},{18:[2,33],24:[2,33],36:[2,33],40:[2,33]}],defaultActions:{3:[2,2],16:[2,1],50:[2,42]},parseError:function(t,n){throw new Error(t)},parse:function(t){function v(e){r.length=r.length-2*e;i.length=i.length-e;s.length=s.length-e}function m(){var e;e=n.lexer.lex()||1;if(typeof e!=="number"){e=n.symbols_[e]||e}return e}var n=this,r=[0],i=[null],s=[],o=this.table,u="",a=0,f=0,l=0,c=2,h=1;this.lexer.setInput(t);this.lexer.yy=this.yy;this.yy.lexer=this.lexer;this.yy.parser=this;if(typeof this.lexer.yylloc=="undefined")this.lexer.yylloc={};var p=this.lexer.yylloc;s.push(p);var d=this.lexer.options&&this.lexer.options.ranges;if(typeof this.yy.parseError==="function")this.parseError=this.yy.parseError;var g,y,b,w,E,S,x={},T,N,C,k;while(true){b=r[r.length-1];if(this.defaultActions[b]){w=this.defaultActions[b]}else{if(g===null||typeof g=="undefined"){g=m()}w=o[b]&&o[b][g]}if(typeof w==="undefined"||!w.length||!w[0]){var L="";if(!l){k=[];for(T in o[b])if(this.terminals_[T]&&T>2){k.push("'"+this.terminals_[T]+"'")}if(this.lexer.showPosition){L="Parse error on line "+(a+1)+":\n"+this.lexer.showPosition()+"\nExpecting "+k.join(", ")+", got '"+(this.terminals_[g]||g)+"'"}else{L="Parse error on line "+(a+1)+": Unexpected "+(g==1?"end of input":"'"+(this.terminals_[g]||g)+"'")}this.parseError(L,{text:this.lexer.match,token:this.terminals_[g]||g,line:this.lexer.yylineno,loc:p,expected:k})}}if(w[0]instanceof Array&&w.length>1){throw new Error("Parse Error: multiple actions possible at state: "+b+", token: "+g)}switch(w[0]){case 1:r.push(g);i.push(this.lexer.yytext);s.push(this.lexer.yylloc);r.push(w[1]);g=null;if(!y){f=this.lexer.yyleng;u=this.lexer.yytext;a=this.lexer.yylineno;p=this.lexer.yylloc;if(l>0)l--}else{g=y;y=null}break;case 2:N=this.productions_[w[1]][1];x.$=i[i.length-N];x._$={first_line:s[s.length-(N||1)].first_line,last_line:s[s.length-1].last_line,first_column:s[s.length-(N||1)].first_column,last_column:s[s.length-1].last_column};if(d){x._$.range=[s[s.length-(N||1)].range[0],s[s.length-1].range[1]]}S=this.performAction.call(x,u,f,a,this.yy,w[1],i,s);if(typeof S!=="undefined"){return S}if(N){r=r.slice(0,-1*N*2);i=i.slice(0,-1*N);s=s.slice(0,-1*N)}r.push(this.productions_[w[1]][0]);i.push(x.$);s.push(x._$);C=o[r[r.length-2]][r[r.length-1]];r.push(C);break;case 3:return true}}return true}};var n=function(){var e={EOF:1,parseError:function(t,n){if(this.yy.parser){this.yy.parser.parseError(t,n)}else{throw new Error(t)}},setInput:function(e){this._input=e;this._more=this._less=this.done=false;this.yylineno=this.yyleng=0;this.yytext=this.matched=this.match="";this.conditionStack=["INITIAL"];this.yylloc={first_line:1,first_column:0,last_line:1,last_column:0};if(this.options.ranges)this.yylloc.range=[0,0];this.offset=0;return this},input:function(){var e=this._input[0];this.yytext+=e;this.yyleng++;this.offset++;this.match+=e;this.matched+=e;var t=e.match(/(?:\r\n?|\n).*/g);if(t){this.yylineno++;this.yylloc.last_line++}else{this.yylloc.last_column++}if(this.options.ranges)this.yylloc.range[1]++;this._input=this._input.slice(1);return e},unput:function(e){var t=e.length;var n=e.split(/(?:\r\n?|\n)/g);this._input=e+this._input;this.yytext=this.yytext.substr(0,this.yytext.length-t-1);this.offset-=t;var r=this.match.split(/(?:\r\n?|\n)/g);this.match=this.match.substr(0,this.match.length-1);this.matched=this.matched.substr(0,this.matched.length-1);if(n.length-1)this.yylineno-=n.length-1;var i=this.yylloc.range;this.yylloc={first_line:this.yylloc.first_line,last_line:this.yylineno+1,first_column:this.yylloc.first_column,last_column:n?(n.length===r.length?this.yylloc.first_column:0)+r[r.length-n.length].length-n[0].length:this.yylloc.first_column-t};if(this.options.ranges){this.yylloc.range=[i[0],i[0]+this.yyleng-t]}return this},more:function(){this._more=true;return this},less:function(e){this.unput(this.match.slice(e))},pastInput:function(){var e=this.matched.substr(0,this.matched.length-this.match.length);return(e.length>20?"...":"")+e.substr(-20).replace(/\n/g,"")},upcomingInput:function(){var e=this.match;if(e.length<20){e+=this._input.substr(0,20-e.length)}return(e.substr(0,20)+(e.length>20?"...":"")).replace(/\n/g,"")},showPosition:function(){var e=this.pastInput();var t=(new Array(e.length+1)).join("-");return e+this.upcomingInput()+"\n"+t+"^"},next:function(){if(this.done){return this.EOF}if(!this._input)this.done=true;var e,t,n,r,i,s;if(!this._more){this.yytext="";this.match=""}var o=this._currentRules();for(var u=0;u<o.length;u++){n=this._input.match(this.rules[o[u]]);if(n&&(!t||n[0].length>t[0].length)){t=n;r=u;if(!this.options.flex)break}}if(t){s=t[0].match(/(?:\r\n?|\n).*/g);if(s)this.yylineno+=s.length;this.yylloc={first_line:this.yylloc.last_line,last_line:this.yylineno+1,first_column:this.yylloc.last_column,last_column:s?s[s.length-1].length-s[s.length-1].match(/\r?\n?/)[0].length:this.yylloc.last_column+t[0].length};this.yytext+=t[0];this.match+=t[0];this.matches=t;this.yyleng=this.yytext.length;if(this.options.ranges){this.yylloc.range=[this.offset,this.offset+=this.yyleng]}this._more=false;this._input=this._input.slice(t[0].length);this.matched+=t[0];e=this.performAction.call(this,this.yy,this,o[r],this.conditionStack[this.conditionStack.length-1]);if(this.done&&this._input)this.done=false;if(e)return e;else return}if(this._input===""){return this.EOF}else{return this.parseError("Lexical error on line "+(this.yylineno+1)+". Unrecognized text.\n"+this.showPosition(),{text:"",token:null,line:this.yylineno})}},lex:function(){var t=this.next();if(typeof t!=="undefined"){return t}else{return this.lex()}},begin:function(t){this.conditionStack.push(t)},popState:function(){return this.conditionStack.pop()},_currentRules:function(){return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules},topState:function(){return this.conditionStack[this.conditionStack.length-2]},pushState:function(t){this.begin(t)}};e.options={};e.performAction=function(t,n,r,i){function s(e,t){return n.yytext=n.yytext.substr(e,n.yyleng-t)}var o=i;switch(r){case 0:if(n.yytext.slice(-2)==="\\\\"){s(0,1);this.begin("mu")}else if(n.yytext.slice(-1)==="\\"){s(0,1);this.begin("emu")}else{this.begin("mu")}if(n.yytext)return 14;break;case 1:return 14;break;case 2:this.popState();return 14;break;case 3:s(0,4);this.popState();return 15;break;case 4:return 35;break;case 5:return 36;break;case 6:return 25;break;case 7:return 16;break;case 8:return 20;break;case 9:return 19;break;case 10:return 19;break;case 11:return 23;break;case 12:return 22;break;case 13:this.popState();this.begin("com");break;case 14:s(3,5);this.popState();return 15;break;case 15:return 22;break;case 16:return 41;break;case 17:return 40;break;case 18:return 40;break;case 19:return 44;break;case 20:break;case 21:this.popState();return 24;break;case 22:this.popState();return 18;break;case 23:n.yytext=s(1,2).replace(/\\"/g,'"');return 32;break;case 24:n.yytext=s(1,2).replace(/\\'/g,"'");return 32;break;case 25:return 42;break;case 26:return 34;break;case 27:return 34;break;case 28:return 33;break;case 29:return 40;break;case 30:n.yytext=s(1,2);return 40;break;case 31:return"INVALID";break;case 32:return 5;break}};e.rules=[/^(?:[^\x00]*?(?=(\{\{)))/,/^(?:[^\x00]+)/,/^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,/^(?:[\s\S]*?--\}\})/,/^(?:\()/,/^(?:\))/,/^(?:\{\{(~)?>)/,/^(?:\{\{(~)?#)/,/^(?:\{\{(~)?\/)/,/^(?:\{\{(~)?\^)/,/^(?:\{\{(~)?\s*else\b)/,/^(?:\{\{(~)?\{)/,/^(?:\{\{(~)?&)/,/^(?:\{\{!--)/,/^(?:\{\{![\s\S]*?\}\})/,/^(?:\{\{(~)?)/,/^(?:=)/,/^(?:\.\.)/,/^(?:\.(?=([=~}\s\/.)])))/,/^(?:[\/.])/,/^(?:\s+)/,/^(?:\}(~)?\}\})/,/^(?:(~)?\}\})/,/^(?:"(\\["]|[^"])*")/,/^(?:'(\\[']|[^'])*')/,/^(?:@)/,/^(?:true(?=([~}\s)])))/,/^(?:false(?=([~}\s)])))/,/^(?:-?[0-9]+(?=([~}\s)])))/,/^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)]))))/,/^(?:\[[^\]]*\])/,/^(?:.)/,/^(?:$)/];e.conditions={mu:{rules:[4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32],inclusive:false},emu:{rules:[2],inclusive:false},com:{rules:[3],inclusive:false},INITIAL:{rules:[0,1,32],inclusive:true}};return e}();e.lexer=n;r.prototype=e;e.Parser=r;return new r}();e=t;return e}();var a=function(e,t){"use strict";function s(e){if(e.constructor===i.ProgramNode){return e}r.yy=i;return r.parse(e)}var n={};var r=e;var i=t;n.parser=r;n.parse=s;return n}(u,o);var f=function(e){"use strict";function r(){}function i(e,t,r){if(e==null||typeof e!=="string"&&e.constructor!==r.AST.ProgramNode){throw new n("You must pass a string or Handlebars AST to Handlebars.precompile. You passed "+e)}t=t||{};if(!("data"in t)){t.data=true}var i=r.parse(e);var s=(new r.Compiler).compile(i,t);return(new r.JavaScriptCompiler).compile(s,t)}function s(e,t,r){function s(){var n=r.parse(e);var i=(new r.Compiler).compile(n,t);var s=(new r.JavaScriptCompiler).compile(i,t,undefined,true);return r.template(s)}if(e==null||typeof e!=="string"&&e.constructor!==r.AST.ProgramNode){throw new n("You must pass a string or Handlebars AST to Handlebars.compile. You passed "+e)}t=t||{};if(!("data"in t)){t.data=true}var i;return function(e,t){if(!i){i=s()}return i.call(this,e,t)}}var t={};var n=e;t.Compiler=r;r.prototype={compiler:r,disassemble:function(){var e=this.opcodes,t,n=[],r,i;for(var s=0,o=e.length;s<o;s++){t=e[s];if(t.opcode==="DECLARE"){n.push("DECLARE "+t.name+"="+t.value)}else{r=[];for(var u=0;u<t.args.length;u++){i=t.args[u];if(typeof i==="string"){i='"'+i.replace("\n","\\n")+'"'}r.push(i)}n.push(t.opcode+" "+r.join(" "))}}return n.join("\n")},equals:function(e){var t=this.opcodes.length;if(e.opcodes.length!==t){return false}for(var n=0;n<t;n++){var r=this.opcodes[n],i=e.opcodes[n];if(r.opcode!==i.opcode||r.args.length!==i.args.length){return false}for(var s=0;s<r.args.length;s++){if(r.args[s]!==i.args[s]){return false}}}t=this.children.length;if(e.children.length!==t){return false}for(n=0;n<t;n++){if(!this.children[n].equals(e.children[n])){return false}}return true},guid:0,compile:function(e,t){this.opcodes=[];this.children=[];this.depths={list:[]};this.options=t;var n=this.options.knownHelpers;this.options.knownHelpers={helperMissing:true,blockHelperMissing:true,each:true,"if":true,unless:true,"with":true,log:true};if(n){for(var r in n){this.options.knownHelpers[r]=n[r]}}return this.accept(e)},accept:function(e){var t=e.strip||{},n;if(t.left){this.opcode("strip")}n=this[e.type](e);if(t.right){this.opcode("strip")}return n},program:function(e){var t=e.statements;for(var n=0,r=t.length;n<r;n++){this.accept(t[n])}this.isSimple=r===1;this.depths.list=this.depths.list.sort(function(e,t){return e-t});return this},compileProgram:function(e){var t=(new this.compiler).compile(e,this.options);var n=this.guid++,r;this.usePartial=this.usePartial||t.usePartial;this.children[n]=t;for(var i=0,s=t.depths.list.length;i<s;i++){r=t.depths.list[i];if(r<2){continue}else{this.addDepth(r-1)}}return n},block:function(e){var t=e.mustache,n=e.program,r=e.inverse;if(n){n=this.compileProgram(n)}if(r){r=this.compileProgram(r)}var i=t.sexpr;var s=this.classifySexpr(i);if(s==="helper"){this.helperSexpr(i,n,r)}else if(s==="simple"){this.simpleSexpr(i);this.opcode("pushProgram",n);this.opcode("pushProgram",r);this.opcode("emptyHash");this.opcode("blockValue")}else{this.ambiguousSexpr(i,n,r);this.opcode("pushProgram",n);this.opcode("pushProgram",r);this.opcode("emptyHash");this.opcode("ambiguousBlockValue")}this.opcode("append")},hash:function(e){var t=e.pairs,n,r;this.opcode("pushHash");for(var i=0,s=t.length;i<s;i++){n=t[i];r=n[1];if(this.options.stringParams){if(r.depth){this.addDepth(r.depth)}this.opcode("getContext",r.depth||0);this.opcode("pushStringParam",r.stringModeValue,r.type);if(r.type==="sexpr"){this.sexpr(r)}}else{this.accept(r)}this.opcode("assignToHash",n[0])}this.opcode("popHash")},partial:function(e){var t=e.partialName;this.usePartial=true;if(e.context){this.ID(e.context)}else{this.opcode("push","depth0")}this.opcode("invokePartial",t.name);this.opcode("append")},content:function(e){this.opcode("appendContent",e.string)},mustache:function(e){this.sexpr(e.sexpr);if(e.escaped&&!this.options.noEscape){this.opcode("appendEscaped")}else{this.opcode("append")}},ambiguousSexpr:function(e,t,n){var r=e.id,i=r.parts[0],s=t!=null||n!=null;this.opcode("getContext",r.depth);this.opcode("pushProgram",t);this.opcode("pushProgram",n);this.opcode("invokeAmbiguous",i,s)},simpleSexpr:function(e){var t=e.id;if(t.type==="DATA"){this.DATA(t)}else if(t.parts.length){this.ID(t)}else{this.addDepth(t.depth);this.opcode("getContext",t.depth);this.opcode("pushContext")}this.opcode("resolvePossibleLambda")},helperSexpr:function(e,t,r){var i=this.setupFullMustacheParams(e,t,r),s=e.id.parts[0];if(this.options.knownHelpers[s]){this.opcode("invokeKnownHelper",i.length,s)}else if(this.options.knownHelpersOnly){throw new n("You specified knownHelpersOnly, but used the unknown helper "+s,e)}else{this.opcode("invokeHelper",i.length,s,e.isRoot)}},sexpr:function(e){var t=this.classifySexpr(e);if(t==="simple"){this.simpleSexpr(e)}else if(t==="helper"){this.helperSexpr(e)}else{this.ambiguousSexpr(e)}},ID:function(e){this.addDepth(e.depth);this.opcode("getContext",e.depth);var t=e.parts[0];if(!t){this.opcode("pushContext")}else{this.opcode("lookupOnContext",e.parts[0])}for(var n=1,r=e.parts.length;n<r;n++){this.opcode("lookup",e.parts[n])}},DATA:function(e){this.options.data=true;if(e.id.isScoped||e.id.depth){throw new n("Scoped data references are not supported: "+e.original,e)}this.opcode("lookupData");var t=e.id.parts;for(var r=0,i=t.length;r<i;r++){this.opcode("lookup",t[r])}},STRING:function(e){this.opcode("pushString",e.string)},INTEGER:function(e){this.opcode("pushLiteral",e.integer)},BOOLEAN:function(e){this.opcode("pushLiteral",e.bool)},comment:function(){},opcode:function(e){this.opcodes.push({opcode:e,args:[].slice.call(arguments,1)})},declare:function(e,t){this.opcodes.push({opcode:"DECLARE",name:e,value:t})},addDepth:function(e){if(e===0){return}if(!this.depths[e]){this.depths[e]=true;this.depths.list.push(e)}},classifySexpr:function(e){var t=e.isHelper;var n=e.eligibleHelper;var r=this.options;if(n&&!t){var i=e.id.parts[0];if(r.knownHelpers[i]){t=true}else if(r.knownHelpersOnly){n=false}}if(t){return"helper"}else if(n){return"ambiguous"}else{return"simple"}},pushParams:function(e){var t=e.length,n;while(t--){n=e[t];if(this.options.stringParams){if(n.depth){this.addDepth(n.depth)}this.opcode("getContext",n.depth||0);this.opcode("pushStringParam",n.stringModeValue,n.type);if(n.type==="sexpr"){this.sexpr(n)}}else{this[n.type](n)}}},setupFullMustacheParams:function(e,t,n){var r=e.params;this.pushParams(r);this.opcode("pushProgram",t);this.opcode("pushProgram",n);if(e.hash){this.hash(e.hash)}else{this.opcode("emptyHash")}return r}};t.precompile=i;t.compile=s;return t}(n);var l=function(e,t){"use strict";function u(e){this.value=e}function a(){}var n;var r=e.COMPILER_REVISION;var i=e.REVISION_CHANGES;var s=e.log;var o=t;a.prototype={nameLookup:function(e,t){var n,r;if(e.indexOf("depth")===0){n=true}if(/^[0-9]+$/.test(t)){r=e+"["+t+"]"}else if(a.isValidJavaScriptVariableName(t)){r=e+"."+t}else{r=e+"['"+t+"']"}if(n){return"("+e+" && "+r+")"}else{return r}},compilerInfo:function(){var e=r,t=i[e];return"this.compilerInfo = ["+e+",'"+t+"'];\n"},appendToBuffer:function(e){if(this.environment.isSimple){return"return "+e+";"}else{return{appendToBuffer:true,content:e,toString:function(){return"buffer += "+e+";"}}}},initializeBuffer:function(){return this.quotedString("")},namespace:"Handlebars",compile:function(e,t,n,r){this.environment=e;this.options=t||{};s("debug",this.environment.disassemble()+"\n\n");this.name=this.environment.name;this.isChild=!!n;this.context=n||{programs:[],environments:[],aliases:{}};this.preamble();this.stackSlot=0;this.stackVars=[];this.registers={list:[]};this.hashes=[];this.compileStack=[];this.inlineStack=[];this.compileChildren(e,t);var i=e.opcodes,u;this.i=0;for(var a=i.length;this.i<a;this.i++){u=i[this.i];if(u.opcode==="DECLARE"){this[u.name]=u.value}else{this[u.opcode].apply(this,u.args)}if(u.opcode!==this.stripNext){this.stripNext=false}}this.pushSource("");if(this.stackSlot||this.inlineStack.length||this.compileStack.length){throw new o("Compile completed with content left on stack")}return this.createFunctionContext(r)},preamble:function(){var e=[];if(!this.isChild){var t=this.namespace;var n="helpers = this.merge(helpers, "+t+".helpers);";if(this.environment.usePartial){n=n+" partials = this.merge(partials, "+t+".partials);"}if(this.options.data){n=n+" data = data || {};"}e.push(n)}else{e.push("")}if(!this.environment.isSimple){e.push(", buffer = "+this.initializeBuffer())}else{e.push("")}this.lastContext=0;this.source=e},createFunctionContext:function(e){var t=this.stackVars.concat(this.registers.list);if(t.length>0){this.source[1]=this.source[1]+", "+t.join(", ")}if(!this.isChild){for(var n in this.context.aliases){if(this.context.aliases.hasOwnProperty(n)){this.source[1]=this.source[1]+", "+n+"="+this.context.aliases[n]}}}if(this.source[1]){this.source[1]="var "+this.source[1].substring(2)+";"}if(!this.isChild){this.source[1]+="\n"+this.context.programs.join("\n")+"\n"}if(!this.environment.isSimple){this.pushSource("return buffer;")}var r=this.isChild?["depth0","data"]:["Handlebars","depth0","helpers","partials","data"];for(var i=0,o=this.environment.depths.list.length;i<o;i++){r.push("depth"+this.environment.depths.list[i])}var u=this.mergeSource();if(!this.isChild){u=this.compilerInfo()+u}if(e){r.push(u);return Function.apply(this,r)}else{var a="function "+(this.name||"")+"("+r.join(",")+") {\n  "+u+"}";s("debug",a+"\n\n");return a}},mergeSource:function(){var e="",t;for(var n=0,r=this.source.length;n<r;n++){var i=this.source[n];if(i.appendToBuffer){if(t){t=t+"\n    + "+i.content}else{t=i.content}}else{if(t){e+="buffer += "+t+";\n  ";t=undefined}e+=i+"\n  "}}return e},blockValue:function(){this.context.aliases.blockHelperMissing="helpers.blockHelperMissing";var e=["depth0"];this.setupParams(0,e);this.replaceStack(function(t){e.splice(1,0,t);return"blockHelperMissing.call("+e.join(", ")+")"})},ambiguousBlockValue:function(){this.context.aliases.blockHelperMissing="helpers.blockHelperMissing";var e=["depth0"];this.setupParams(0,e);var t=this.topStack();e.splice(1,0,t);this.pushSource("if (!"+this.lastHelper+") { "+t+" = blockHelperMissing.call("+e.join(", ")+"); }")},appendContent:function(e){if(this.pendingContent){e=this.pendingContent+e}if(this.stripNext){e=e.replace(/^\s+/,"")}this.pendingContent=e},strip:function(){if(this.pendingContent){this.pendingContent=this.pendingContent.replace(/\s+$/,"")}this.stripNext="strip"},append:function(){this.flushInline();var e=this.popStack();this.pushSource("if("+e+" || "+e+" === 0) { "+this.appendToBuffer(e)+" }");if(this.environment.isSimple){this.pushSource("else { "+this.appendToBuffer("''")+" }")}},appendEscaped:function(){this.context.aliases.escapeExpression="this.escapeExpression";this.pushSource(this.appendToBuffer("escapeExpression("+this.popStack()+")"))},getContext:function(e){if(this.lastContext!==e){this.lastContext=e}},lookupOnContext:function(e){this.push(this.nameLookup("depth"+this.lastContext,e,"context"))},pushContext:function(){this.pushStackLiteral("depth"+this.lastContext)},resolvePossibleLambda:function(){this.context.aliases.functionType='"function"';this.replaceStack(function(e){return"typeof "+e+" === functionType ? "+e+".apply(depth0) : "+e})},lookup:function(e){this.replaceStack(function(t){return t+" == null || "+t+" === false ? "+t+" : "+this.nameLookup(t,e,"context")})},lookupData:function(){this.pushStackLiteral("data")},pushStringParam:function(e,t){this.pushStackLiteral("depth"+this.lastContext);this.pushString(t);if(t!=="sexpr"){if(typeof e==="string"){this.pushString(e)}else{this.pushStackLiteral(e)}}},emptyHash:function(){this.pushStackLiteral("{}");if(this.options.stringParams){this.push("{}");this.push("{}")}},pushHash:function(){if(this.hash){this.hashes.push(this.hash)}this.hash={values:[],types:[],contexts:[]}},popHash:function(){var e=this.hash;this.hash=this.hashes.pop();if(this.options.stringParams){this.push("{"+e.contexts.join(",")+"}");this.push("{"+e.types.join(",")+"}")}this.push("{\n    "+e.values.join(",\n    ")+"\n  }")},pushString:function(e){this.pushStackLiteral(this.quotedString(e))},push:function(e){this.inlineStack.push(e);return e},pushLiteral:function(e){this.pushStackLiteral(e)},pushProgram:function(e){if(e!=null){this.pushStackLiteral(this.programExpression(e))}else{this.pushStackLiteral(null)}},invokeHelper:function(e,t,n){this.context.aliases.helperMissing="helpers.helperMissing";this.useRegister("helper");var r=this.lastHelper=this.setupHelper(e,t,true);var i=this.nameLookup("depth"+this.lastContext,t,"context");var s="helper = "+r.name+" || "+i;if(r.paramsInit){s+=","+r.paramsInit}this.push("("+s+",helper "+"? helper.call("+r.callParams+") "+": helperMissing.call("+r.helperMissingParams+"))");if(!n){this.flushInline()}},invokeKnownHelper:function(e,t){var n=this.setupHelper(e,t);this.push(n.name+".call("+n.callParams+")")},invokeAmbiguous:function(e,t){this.context.aliases.functionType='"function"';this.useRegister("helper");this.emptyHash();var n=this.setupHelper(0,e,t);var r=this.lastHelper=this.nameLookup("helpers",e,"helper");var i=this.nameLookup("depth"+this.lastContext,e,"context");var s=this.nextStack();if(n.paramsInit){this.pushSource(n.paramsInit)}this.pushSource("if (helper = "+r+") { "+s+" = helper.call("+n.callParams+"); }");this.pushSource("else { helper = "+i+"; "+s+" = typeof helper === functionType ? helper.call("+n.callParams+") : helper; }")},invokePartial:function(e){var t=[this.nameLookup("partials",e,"partial"),"'"+e+"'",this.popStack(),"helpers","partials"];if(this.options.data){t.push("data")}this.context.aliases.self="this";this.push("self.invokePartial("+t.join(", ")+")")},assignToHash:function(e){var t=this.popStack(),n,r;if(this.options.stringParams){r=this.popStack();n=this.popStack()}var i=this.hash;if(n){i.contexts.push("'"+e+"': "+n)}if(r){i.types.push("'"+e+"': "+r)}i.values.push("'"+e+"': ("+t+")")},compiler:a,compileChildren:function(e,t){var n=e.children,r,i;for(var s=0,o=n.length;s<o;s++){r=n[s];i=new this.compiler;var u=this.matchExistingProgram(r);if(u==null){this.context.programs.push("");u=this.context.programs.length;r.index=u;r.name="program"+u;this.context.programs[u]=i.compile(r,t,this.context);this.context.environments[u]=r}else{r.index=u;r.name="program"+u}}},matchExistingProgram:function(e){for(var t=0,n=this.context.environments.length;t<n;t++){var r=this.context.environments[t];if(r&&r.equals(e)){return t}}},programExpression:function(e){this.context.aliases.self="this";if(e==null){return"self.noop"}var t=this.environment.children[e],n=t.depths.list,r;var i=[t.index,t.name,"data"];for(var s=0,o=n.length;s<o;s++){r=n[s];if(r===1){i.push("depth0")}else{i.push("depth"+(r-1))}}return(n.length===0?"self.program(":"self.programWithDepth(")+i.join(", ")+")"},register:function(e,t){this.useRegister(e);this.pushSource(e+" = "+t+";")},useRegister:function(e){if(!this.registers[e]){this.registers[e]=true;this.registers.list.push(e)}},pushStackLiteral:function(e){return this.push(new u(e))},pushSource:function(e){if(this.pendingContent){this.source.push(this.appendToBuffer(this.quotedString(this.pendingContent)));this.pendingContent=undefined}if(e){this.source.push(e)}},pushStack:function(e){this.flushInline();var t=this.incrStack();if(e){this.pushSource(t+" = "+e+";")}this.compileStack.push(t);return t},replaceStack:function(e){var t="",n=this.isInline(),r,i,s;if(n){var o=this.popStack(true);if(o instanceof u){r=o.value;s=true}else{i=!this.stackSlot;var a=!i?this.topStackName():this.incrStack();t="("+this.push(a)+" = "+o+"),";r=this.topStack()}}else{r=this.topStack()}var f=e.call(this,r);if(n){if(!s){this.popStack()}if(i){this.stackSlot--}this.push("("+t+f+")")}else{if(!/^stack/.test(r)){r=this.nextStack()}this.pushSource(r+" = ("+t+f+");")}return r},nextStack:function(){return this.pushStack()},incrStack:function(){this.stackSlot++;if(this.stackSlot>this.stackVars.length){this.stackVars.push("stack"+this.stackSlot)}return this.topStackName()},topStackName:function(){return"stack"+this.stackSlot},flushInline:function(){var e=this.inlineStack;if(e.length){this.inlineStack=[];for(var t=0,n=e.length;t<n;t++){var r=e[t];if(r instanceof u){this.compileStack.push(r)}else{this.pushStack(r)}}}},isInline:function(){return this.inlineStack.length},popStack:function(e){var t=this.isInline(),n=(t?this.inlineStack:this.compileStack).pop();if(!e&&n instanceof u){return n.value}else{if(!t){if(!this.stackSlot){throw new o("Invalid stack pop")}this.stackSlot--}return n}},topStack:function(e){var t=this.isInline()?this.inlineStack:this.compileStack,n=t[t.length-1];if(!e&&n instanceof u){return n.value}else{return n}},quotedString:function(e){return'"'+e.replace(/\\/g,"\\\\").replace(/"/g,'\\"').replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")+'"'},setupHelper:function(e,t,n){var r=[],i=this.setupParams(e,r,n);var s=this.nameLookup("helpers",t,"helper");return{params:r,paramsInit:i,name:s,callParams:["depth0"].concat(r).join(", "),helperMissingParams:n&&["depth0",this.quotedString(t)].concat(r).join(", ")}},setupOptions:function(e,t){var n=[],r=[],i=[],s,o,u;n.push("hash:"+this.popStack());if(this.options.stringParams){n.push("hashTypes:"+this.popStack());n.push("hashContexts:"+this.popStack())}o=this.popStack();u=this.popStack();if(u||o){if(!u){this.context.aliases.self="this";u="self.noop"}if(!o){this.context.aliases.self="this";o="self.noop"}n.push("inverse:"+o);n.push("fn:"+u)}for(var a=0;a<e;a++){s=this.popStack();t.push(s);if(this.options.stringParams){i.push(this.popStack());r.push(this.popStack())}}if(this.options.stringParams){n.push("contexts:["+r.join(",")+"]");n.push("types:["+i.join(",")+"]")}if(this.options.data){n.push("data:data")}return n},setupParams:function(e,t,n){var r="{"+this.setupOptions(e,t).join(",")+"}";if(n){this.useRegister("options");t.push("options");return"options="+r}else{t.push(r);return""}}};var f=("break else new var"+" case finally return void"+" catch for switch while"+" continue function this with"+" default if throw"+" delete in try"+" do instanceof typeof"+" abstract enum int short"+" boolean export interface static"+" byte extends long super"+" char final native synchronized"+" class float package throws"+" const goto private transient"+" debugger implements protected volatile"+" double import public let yield").split(" ");var l=a.RESERVED_WORDS={};for(var c=0,h=f.length;c<h;c++){l[f[c]]=true}a.isValidJavaScriptVariableName=function(e){if(!a.RESERVED_WORDS[e]&&/^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e)){return true}return false};n=a;return n}(r,n);var c=function(e,t,n,r,i){"use strict";var s;var o=e;var u=t;var a=n.parser;var f=n.parse;var l=r.Compiler;var c=r.compile;var h=r.precompile;var p=i;var d=o.create;var v=function(){var e=d();e.compile=function(t,n){return c(t,n,e)};e.precompile=function(t,n){return h(t,n,e)};e.AST=u;e.Compiler=l;e.JavaScriptCompiler=p;e.Parser=a;e.parse=f;return e};o=v();o.create=v;s=o;return s}(s,o,a,f,l);return c}();
/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if (typeof ShopifyAPI === 'undefined') {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if (typeof attribute !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function() {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var formData = new FormData(form);

  for (var pair of formData.entries()) {
      console.log(pair[0]+ ', ' + pair[1]); 
  }

  // Append Blue Pencil attributes for Logged in Customers on MTM flow
  if (($(form).attr("id") == 'AddToCartForm--MTM') && $("#mtm-customer-id").val()) {
    $("#mtm-features-meta-form .bp_attribute").each(function(){
      if(this.value) {
        property_name = this.name;
        property_value = this.value;
        formData.append("properties[" + property_name + "]", property_value)
      }
    })

    if($("#metafield_height_ft").val()) {
      formData.append("properties[_height_ft]", $("#metafield_height_ft").val())
    }
    if($("#metafield_height_in").val()) {
      formData.append("properties[_height_in]", $("#metafield_height_in").val())
    }
  }

  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    processData: false,
    contentType: false,
    dataType: 'json',
    success: function(line_item) {
      if (typeof callback === 'function') {
        callback(line_item, form);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if (typeof errorCallback === 'function') {
        errorCallback(XMLHttpRequest, textStatus, $(form));
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus, $(form));
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function(cart) {
    console.log(cart);
    if (typeof callback === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, properties = '', callback) {
  var propertiesObj = Object.keys(properties).length > 0 ? `&${properties}` : ``;
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line + propertiesObj,
    dataType: 'json',
    success: function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeCompleteItem = function(line, quantity, properties, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: {
      'line': line,
      'quantity': quantity,
      'properties': properties
    },
    dataType: 'json',
    success: function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {
  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer,
    $addToCart,
    $cartCountSelector,
    $cartCostSelector,
    $cartContainer;

  // Private functions
  var updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemErrorCallback,
    cartUpdateCallback,
    buildCart,
    cartCallback,
    adjustCart,
    adjustCartCallback,
    qtySelectors,
    validateQty,
    validateQtyItems;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function(options) {
    // Default settings
    settings = {
      formSelector: '[data-product-form]',
      cartContainer: '#CartContainer',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: '$',
      disableAjaxCart: false,
      enableQtySelectors: true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function() {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function(cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(
        theme.Currency.formatMoney(cart.total_price, settings.moneyFormat)
      );
    }
  };

  formOverride = function() {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(
        evt.target,
        itemAddedCallback,
        itemErrorCallback
      );
    });
  };

  itemAddedCallback = function() {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function(XMLHttpRequest,textStatus,evt) {  
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    evt.find($addToCart).removeClass('is-adding is-added');

    if (data.message) {
      if (data.status === 422) {
        $('.errors.qty-error').remove();
        evt.find($addToCart).after(
          '<div class="errors qty-error">' + data.description + '</div>'
        );
        /*
        setTimeout(function(e){
          $('.errors.qty-error').remove();
        },9000);
        */
      }
    }
  };

  cartUpdateCallback = function(cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function(cart) {
    
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer.append(
        '<div class="cart--empty-message"><p class="cart--empty-message-title">' +
          theme.strings.cartEmpty +
          '</p>\n' +
          theme.settings.empty_cart_elements +
          '<p class="cookie-message">' +
          theme.strings.cartCookies +
          '</p></div>'
      );
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $('#CartTemplate').html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
      var prodImg;
      var prodColor = '';
      var variationName = '';
      var variationStock = '';
      var unitPrice = null;
      var originalProperties = Object.assign({}, cartItem.properties);
      if (cartItem.image !== null) {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_medium$1')
          .replace('http:', '');
      } else {
        prodImg =          
          "//shopmashburn.com/cdn/shop/files/no-image-medium.gif?v=18392299849783744244";
      }

      if (cartItem['_Product Color'] === undefined) {
        if (cartItem.product_title.includes(' in ')) {
          prodColor = cartItem.product_title.split(' in ').at(-1)
        } else if (cartItem.product_title.includes(' - ')) {
          prodColor = cartItem.product_title.split(' - ').at(-1)
        }
      } 

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key == '_Product Color') {
            prodColor = value;
            delete cartItem.properties[key];
          } else if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      if (cartItem.line_level_discount_allocations.length !== 0) {
        for (var discount in cartItem.line_level_discount_allocations) {
          var amount =
            cartItem.line_level_discount_allocations[discount].amount;

          cartItem.line_level_discount_allocations[
            discount
          ].formattedAmount = theme.Currency.formatMoney(
            amount,
            settings.moneyFormat
          );
        }
      }

      if (cart.cart_level_discount_applications.length !== 0) {
        for (var cartDiscount in cart.cart_level_discount_applications) {
          var cartAmount =
            cart.cart_level_discount_applications[cartDiscount]
              .total_allocated_amount;

          cart.cart_level_discount_applications[
            cartDiscount
          ].formattedAmount = theme.Currency.formatMoney(
            cartAmount,
            settings.moneyFormat
          );
        }
      }

      if (cartItem.unit_price_measurement) {
        unitPrice = {
          addRefererenceValue:
            cartItem.unit_price_measurement.reference_value !== 1,
          price: theme.Currency.formatMoney(
            cartItem.unit_price,
            settings.moneyFormat
          ),
          reference_value: cartItem.unit_price_measurement.reference_value,
          reference_unit: cartItem.unit_price_measurement.reference_unit
        };
      }

      // Hide variation if Gift Card product
      if(!cartItem.product_title.includes("Gift Certificate")) {
        variationName = cartItem.variant_title;
      }

      var cartItemProdTitle =  cartItem.product_title.replace('- '+prodColor,'').replace('in '+prodColor,'')
      
      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItemProdTitle,
        color: prodColor,
        variation: variationName,
        variationStockQty:  variationStock,
        properties: cartItem.properties,
        propertiesJson: JSON.stringify(originalProperties),
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: theme.Currency.formatMoney(
          cartItem.original_line_price,
          settings.moneyFormat
        ),
        discountedPrice: theme.Currency.formatMoney(
          cartItem.final_line_price,
          settings.moneyFormat
        ),
        discounts: cartItem.line_level_discount_allocations,
        discountsApplied:
          cartItem.line_level_discount_allocations.length === 0 ? false : true,
        vendor: cartItem.vendor,
        unitPrice: unitPrice,
        product_id: cartItem.product_id,
        variant_id: cartItem.variant_id
      };

      items.push(item);
    });

    // Get Variant Item Stock
    for(let itemIndex=0;itemIndex<items.length;itemIndex++){
      fetch("/cart/?view=compare")
      .then((response) => response.json())
      .then(function(data){
        console.log($('.variant-stock[data-id="'+items[itemIndex].key+'"]'))
        var stock = parseInt(data.itemsStock[0][items[itemIndex].key]);
        if(stock > 0 && stock <= 2){
          $('.variant-stock[data-id="'+items[itemIndex].key+'"]').text('Only '+stock+ ' left!');
        }
        const compareAtPrice = data.items[itemIndex].compare_at_price * data.items[itemIndex].quantity;
        const linePrice = data.items[itemIndex].line_price;
        if (compareAtPrice > linePrice) {
          $('.compare-at-price[data-id="'+items[itemIndex].key+'"]').text(theme.Currency.formatMoney(compareAtPrice, settings.moneyFormat));
          $('.compare-at-price[data-id="'+items[itemIndex].key+'"]').next().addClass('order-discount');
        }
      });
    }

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: theme.Currency.formatMoney(
        cart.total_price,
        settings.moneyFormat
      ),
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied:
        cart.cart_level_discount_applications.length === 0 ? false : true
    };
    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    _swat.initializeActionButtons(".drawer__cart");
  };

  adjustCart = function() {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty,
        $properties = $qtySelector.data('properties');
      
      if($qtySelector.length){
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        qty = validateQty(qty);
      }

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--remove')) {
        qty = 0;
        removeItemFromYourShoppingBagSection(line);
      } else if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
        if ($properties.hasOwnProperty("_It is a Gift")) {
          $properties[`ADD COMPLIMENTARY GIFT WRAPPING (${qty})`] = "No"
        }
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
        removeItemFromYourShoppingBagSection(line);
      }

      const properties = updateGiftWrapProperties(qty, $properties)

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty, properties);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, '')),
        $properties = $el.data('properties');

      qty = validateQty(qty);

      const properties = updateGiftWrapProperties(qty, $properties)

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty, properties);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    // Removes Item From Your Shopping Bag Section on HP
    function removeItemFromYourShoppingBagSection(line) {
      const yourShoppingBagSlider = $("#yourShoppingBagSlider");
      if (yourShoppingBagSlider) {
        yourShoppingBagSlider.slick('slickRemove', line - 1);
        if (yourShoppingBagSlider.slick('getSlick').slideCount === 0) {
          $('.YourShoppingBagSliderSection').addClass('hide');
          $('.CollectionSliderSection').removeClass('hide');
          $('.CollectionSliderSection .collection-slider__container').slick('refresh');
        }
      }
    }

    // Update properties for Gift Wrap
    function updateGiftWrapProperties(qty, properties) {
      const giftWrapProperties = {};
      for (let count = 1; count <= qty; count++) {
        for (const [key, value] of Object.entries(properties)) {
          if (!key.includes((qty + 1))) {
            giftWrapProperties[`properties[${key}]`] = value;
          }
        }
      }
      const params = new URLSearchParams(giftWrapProperties).toString();
      return params;
    }

    function updateQuantity(line, qty, properties) {
      var validQty = validateQtyItems(line, qty);

      if(!validQty) {
        return;
      }


      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass(
        'is-loading'
      );

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, properties, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function() {});
    });
  };

  adjustCartCallback = function(cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
      isUpdating = false;
    }, 150);
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var $numInputs = $('input[type="number"]:not(.simple-input)');

    if ($numInputs.length) {
      $numInputs.each(function() {
        var $el = $(this),
          currentQty = parseInt($el.val()),
          inputName = $el.attr('name'),
          inputId = $el.attr('id'),
          inputMax = $el.attr('max');

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $('#JsQty').html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId,
            inputMax: inputMax
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      /*
      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function(evt) {

        var $el = $(this),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          if(qty < max){
            qty += 1;
          } else {
            evt.preventDefault();
          }
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
      */

    }
  };

  validateQty = function(qty) {
    if (parseFloat(qty) === parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  validateQtyItems = function(line, qty) {

    var inventoryError = false,
        updatingProductHandle,
        updatingVariantId;

    $.ajax({
      url: '/cart.js',
      dataType : 'json',
      async: false,
      success: function(cart){
        if (typeof callback === 'function') {
          callback(cart);
        } else {
          updatingProductHandle = cart.items[line-1].handle;
          updatingVariantId = cart.items[line-1].variant_id;
        }
      }
    });

    $.ajax({
      url: `/products/${updatingProductHandle}.js`,
      dataType : 'json',
      async: false,
      success: function(product){
        $.each(product.variants, function(key, value){
          if(value.id == updatingVariantId){
            console.log(value);
            if( qty > value.inventory_quantity ) {
              inventoryError = true;
            }
          }
        });
      }  
    });

    if(inventoryError){
      console.log("inventory Error: " , inventoryError);
      if(!$('.ajaxcart__row[data-line="' + line + '"] .ajaxcart__error').length > 0){
        $('.ajaxcart__row[data-line="' + line + '"] .ajaxcart__remove').after('<div class="ajaxcart__error errors qty-error">All available inventory for this product is already in your cart</div>');
      }
      return false;
    } else {
      $('.ajaxcart__row[data-line="' + line + '"] .ajaxcart__error').remove();
      return true;
    }
  };
  module = {
    init: init,
    load: loadCart
  };

  return module;
})(ajaxCart || {}, jQuery);


/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
window.timber = window.timber || {};
window.theme = window.theme || {};

timber.initCache = function() {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),
    $window: $(window),

    // Navigation
    $navigation: $('.AccessibleNav'),

    // Product Page
    $optionSelector: $('.single-option-selector'),

    // Customer Pages
    $recoverPasswordLink: $('#RecoverPassword'),
    $hideRecoverPasswordLink: $('#HideRecoverPasswordLink'),
    $recoverPasswordForm: $('#RecoverPasswordForm'),
    $customerLoginForm: $('#CustomerLoginForm'),
    $passwordResetSuccess: $('#ResetSuccess')
  };
};

timber.init = function() {
  timber.initCache();
  timber.accessibleNav();
  timber.drawersInit();
  timber.loginForms();
};

timber.accessibleNav = function() {
  var classes = {
    active: 'nav-hover',
    focus: 'nav-focus',
    outside: 'nav-outside',
    hasDropdown: 'site-nav--has-dropdown',
    link: 'site-nav__link'
  };
  var selectors = {
    active: '.' + classes.active,
    hasDropdown: '.' + classes.hasDropdown,
    dropdown: '[data-meganav-dropdown]',
    link: 'a',
    nextLink: '> a',
    parentLink: '[data-meganav-type="parent"]',
    childLink: '[data-meganav-type="child"]'
  };

  var $nav = timber.cache.$navigation,
    $allLinks = $nav.find(selectors.link),
    $parents = $nav.find(selectors.hasDropdown),
    $childLinks = $nav.find(selectors.childLink),
    $topLevel = $parents.find(selectors.nextLink),
    $dropdowns = $nav.find(selectors.dropdown),
    $subMenuLinks = $dropdowns.find(selectors.link);

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);
    var evtType = evt.type;
    var $dropdowns = $nav.find(selectors.active);

    if (!$el.hasClass(classes.active)) {
      // force stop the click from happening
      evt.preventDefault();
      evt.stopImmediatePropagation();
    }

    // Make sure we close any opened same level dropdown before opening a new one
    if (evtType === 'touchstart' && $dropdowns.length > 0) {
      hideDropdown($el);
    }

    showDropdown($el);
  });

  $childLinks.on('touchstart', function(evt) {
    evt.stopImmediatePropagation();
  });

  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $allLinks.on('focus', function() {
    handleFocus($(this));
  });

  $allLinks.on('blur', function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus($el) {
    var $newFocus = null,
      $previousItem = $el.parent().prev();

    // Always put tabindex -1 on previous element just in case the user is going backward.
    // In that case, we want to focus on the previous parent and not the previous parent childs

    $allLinks.attr('tabindex', '');

    if ($previousItem.hasClass(classes.hasDropdown)) {
      $previousItem.find(selectors.dropdown + ' a').attr('tabindex', -1);
    }

    $newFocus = $el.parents(selectors.hasDropdown).find('> a');
    addFocus($newFocus);
  }

  function showDropdown($el) {
    var $toplevel = $el.find(selectors.nextLink);

    $toplevel.attr('aria-expanded', true);

    $el.addClass(classes.active);
    theme.cache.$siteHeader.addClass(classes.active);

    setTimeout(function() {
      timber.cache.$body.on('touchstart.MegaNav', function() {
        hideDropdowns();
      });
    }, 250);
  }

  function hideDropdown($el) {
    var $dropdowns = $el.parent().find(selectors.active);
    var $parentLink = $dropdowns.find(selectors.nextLink);

    $parentLink.attr('aria-expanded', false);

    $dropdowns.removeClass(classes.active);
    theme.cache.$siteHeader.removeClass(classes.active);

    timber.cache.$body.off('touchstart.MegaNav');
  }

  function hideDropdowns() {
    var $dropdowns = $nav.find(selectors.active);
    $.each($dropdowns, function() {
      hideDropdown($(this));
    });
  }

  function addFocus($el) {
    $el.addClass(classes.focus);

    if ($el.attr('aria-expanded') !== undefined) {
      $el.attr('aria-expanded', true);
    }
  }

  function removeFocus($el) {
    $el.removeClass(classes.focus);

    $subMenuLinks.attr('tabindex', -1);

    if ($el.attr('aria-expanded') !== undefined) {
      $el.attr('aria-expanded', false);
    }
  }

  // Check if dropdown is outside of viewport
  function handleDropdownOffset($dropdowns) {
    var viewportSize = $(window).width();
    $dropdowns.removeClass(classes.outside);

    $.each($dropdowns, function() {
      var $dropdown = $(this);
      var dropdownOffset = $dropdown.offset().left + $dropdown.width();
      if (dropdownOffset > viewportSize) {
        $dropdown.addClass(classes.outside);
      }
    });
  }

  timber.cache.$window.load(function() {
    handleDropdownOffset($dropdowns);
  });

  timber.cache.$window.resize(function() {
    afterResize(function() {
      handleDropdownOffset($dropdowns);
    }, 250);
  });
};

timber.drawersInit = function() {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  if (theme.settings.cartType === 'drawer') {
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
      onDrawerOpen: ajaxCart.load
    });
  }
};

timber.getHash = function() {
  return window.location.hash;
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() === '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function() {
  var Drawer = function(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-button-' + position,
      openButtonLeftClass: 'js-drawer-open-button-left',
      drawerLeftClass: 'drawer--left',
      drawerRightClass: 'drawer--right',
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('body, html'),
      $page: $('#PageContainer'),
      $moved: $('.page-container'),
      $siteHeader: $('.site-header'),
      $announcementBar: $('.announcement-bar'),
      $drawerBlocker: $('#drawer-page__blocker-overlay')
    };
    
    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');
    
    $openBtn.on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Other drawers that might be open (will be closed later)
    var $otherDrawers = $('.drawer').not(this.$drawer);

    // don't open an opened drawer
    if (this.drawerIsOpen) {
      if (evt) {
        evt.preventDefault();
      }
      return;
    }

    // Close other drawers if they are open
    var self = this;
    $otherDrawers.each(function() {
      if (!$(this).hasClass(self.config.openClass)) {
        return;
      }

      if ($(this).hasClass(self.config.drawerLeftClass)) {
        timber.LeftDrawer.close();
      }

      if ($(this).hasClass(self.config.drawerRightClass)) {
        timber.RightDrawer.close();
      }
    });

    // Close search bar when drawer is active
    if($('.mfp-bg.mfp-search-modal').length > 0){
      if(theme.cache.$window.width() < 989){
        if($(".site-nav__link.js-open-search-modal").hasClass('search-open')){
          $(".site-nav__link.js-close-search-modal").trigger('click');
        }
      }
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Adjust drawers top position    
    if($(".site-header").hasClass("has-sticky-announcement")){
      var headerHeight = this.nodes.$siteHeader.outerHeight();
    }else{
      var headerHeight = this.nodes.$siteHeader.outerHeight() + this.nodes.$announcementBar.outerHeight();
    }
    var fixedHeaderHeight = this.nodes.$siteHeader.outerHeight();
    
    if(this.config.dirOpenClass == 'js-drawer-open-left'){
    
      if($(document).scrollTop() >= headerHeight){
        // Sid / Ann Drawer configurator
        this.$drawer.css('top', fixedHeaderHeight - 4);
      } else {
        // General Drawer configurator
        this.$drawer.css('top', headerHeight - $(document).scrollTop() - 4); 
      }
      
    } else {
      this.nodes.$drawerBlocker.show().css('opacity', .3); 
    }
      
    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.nodes.$moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.$drawer.addClass(this.config.openClass);

    // The hamburger 'open' button changes to a 'close' button when the drawer is open.
    if(this.config.dirOpenClass == 'js-drawer-open-left'){
      $(this.config.open).find('.icon').removeClass('icon-hamburger').addClass('icon-close');
    }
    
    this.drawerIsOpen = true;

    // Set focus on drawer
    Drawer.prototype.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when drawer opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Drawer.prototype.close = function(evt) {
    // don't close a closed drawer
    if (!this.drawerIsOpen) {
      return;
    }

    if (evt.keyCode !== 27) {
      evt.preventDefault();
    }
    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.nodes.$moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );
    this.$drawer.removeClass(this.config.openClass);

    // The hamburger 'close' button changes to a 'open' button when the drawer is close.
    if(this.config.dirOpenClass == 'js-drawer-open-left'){
      $(this.config.open).find('.icon').removeClass('icon-close').addClass('icon-hamburger');
    } else {
      this.nodes.$drawerBlocker.fadeOut(); 
    }
    
    this.drawerIsOpen = false;

    // Remove focus on drawer
    Drawer.prototype.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.unbindEvents();
  };

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.trapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
      options.$container.attr('tabindex', '-1');
    }

    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  };

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  };

  Drawer.prototype.bindEvents = function() {
    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.$drawer.on('click.drawer', function(event) {
      if ($(this).hasClass('drawer--left')) {
        event.stopPropagation();
      }
    });

    $('.page-container, .drawer__header-container').on(
      'click.drawer',
      this.close.bind(this)
    );

    // Pressing escape closes drawer
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // The hamburger 'open' button changes to a 'close' button when the drawer
        // is open. Clicking on it will close the drawer.
        if (this.$activeSource !== undefined) {
          this.$activeSource.on(
            'click.drawer',
            $.proxy(function() {
              if (
                !this.$activeSource.hasClass(this.config.openButtonLeftClass)
              ) {
                return;
              }
              this.close();
            }, this)
          );
        }
        if (evt.keyCode === 27) {
          this.close(evt);
        }
      }, this)
    );

    this.nodes.$drawerBlocker.on('click',this.close.bind(this));
  };

  Drawer.prototype.unbindEvents = function() {
    if (this.$activeSource !== undefined) {
      this.$activeSource.off('.drawer');
    }
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);

/*
 * Shopify JS for customizing Slick.js
 *   http://kenwheeler.github.io/slick/
 *   Untouched JS in assets/slick.min.js
 */

theme.Slideshow = (function() {
  'use strict';

  var selectors = {
    activeSlide: '.slick-active',
    heroAdaptTextWrap: '[data-hero-adapt-text-wrap]',
    heroDotsWrapper: '[data-hero-dots-wrapper]',
    heroImage: '[data-hero-image]',
    heroTextContent: '[data-hero-text-content]',
    pagination: '[data-slide-pagination]',
    pause: '[data-pause]',
    slickList: '.slick-list',
    slidePrevious: '[data-slide-previous]',
    slideNext: '[data-slide-next]',
    slides: '.slick-slide'
  };

  var classes = {
    heroSlideHidden: 'hero__slide--hidden',
    isPaused: 'is-paused'
  };

  function Slideshow($slider) {
    var $sliderWrapper = $slider.closest('[data-section-id]');
    var loadSlideA11yString = (this.loadSlideA11yString = $slider.data(
      'slide-nav-a11y'
    ));
    var activeSlideA11yString = (this.activeSlideA11yString = $slider.data(
      'slide-nav-active-a11y'
    ));

    this.$sliderWrapper = $sliderWrapper;
    this.$slider = $slider;

    // Default settings
    this.settings = {
      $element: $slider,
      accessibility: true,
      adaptHeight: $slider.data('adapt'),
      arrows: true,
      dots: false,
      slide: '[data-hero-slide]',
      /* eslint-disable shopify/jquery-dollar-sign-reference */
      prevArrow: $slider.find(selectors.slidePrevious),
      nextArrow: $slider.find(selectors.slideNext),
      appendDots: $slider.find(selectors.heroDotsWrapper),
      /* eslint-enable shopify/jquery-dollar-sign-reference */
      adaptiveHeight: true,
      draggable: false,
      fade: true,
      focusOnChange: false,
      isTouch: Modernizr.touch ? true : false,
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('autoplayspeed'),
      customPaging: function(slick, index) {
        var labelString =
          index === 0 ? activeSlideA11yString : loadSlideA11yString;
        return (
          '<a href="' +
          $slider.attr('id') +
          '" aria-label="' +
          labelString.replace('[slide_number]', index + 1) +
          '" data-slide-number="' +
          index +
          '" data-slide-pagination aria-controls="SlickSlide' +
          (index + 1) +
          '"></a>'
        );
      }
    };

    this.cache = {
      $window: $(window),
      $heroImage: $slider.find(selectors.heroImage),
      $heroText: $slider.find(selectors.heroTextContent),
      $pauseButton: $slider.find(selectors.pause),
      $textWrapperMobile: $sliderWrapper.find(selectors.heroAdaptTextWrap)
    };

    this.currentActiveSlide = 0;

    /*
     * Init slick slider
     *   - Add any additional option changes here
     *   - https://github.com/kenwheeler/slick/#options
     */
    this.$slider
      .on(
        'init',
        function(event, slick) {
          this.onInit(slick);
        }.bind(this)
      )
      .on(
        'beforeChange',
        function(event, slick, currentSlide, nextSlide) {
          this.beforeChange(slick, currentSlide, nextSlide);
        }.bind(this)
      )
      .on(
        'afterChange',
        function(event, slick) {
          this.afterChange(slick);
        }.bind(this)
      );

    this.$slider.slick(this.settings);
  }

  Slideshow.prototype = _.assignIn({}, Slideshow.prototype, {
    onInit: function(obj) {
      this.$allSlides = obj.$slides;
      this.$activeSlide = obj.$slider.find(
        selectors.slides + selectors.activeSlide
      );
      this.$pagination = obj.$slider.find(selectors.pagination);

      if (!this.settings.isTouch) {
        obj.$slides.addClass(classes.heroSlideHidden);
        this.$activeSlide.removeClass(classes.heroSlideHidden);
      }

      if (this.settings.autoplay) {
        this.cache.$pauseButton.on('click', this.togglePause.bind(this));

        $(document).scroll(
          theme.debounce(
            function() {
              var slideshowOffsetY =
                obj.$slider.offset().top + obj.$slider.outerHeight();

              if (slideshowOffsetY < window.pageYOffset) {
                this.togglePauseAttributes(this.cache.$pauseButton, false);
                obj.$slider.slick('slickPause');
              } else if (!this.cache.$pauseButton.hasClass(classes.isPaused)) {
                this.togglePauseAttributes(this.cache.$pauseButton, true);
                obj.$slider.slick('slickPlay');
              }
            }.bind(this),
            250
          )
        );
      }

      // Prevent default slick behaviour of autoplaying on mouseleave
      obj.$slider.find(selectors.slickList).off('mouseleave.slick');

      if (this.settings.adaptHeight) {
        this.showMobileText(0);
      }

      this.slideshowA11ySetup(obj.$slider);
      this.applySlideColor(0, 1);
    },

    beforeChange: function(obj, currentSlide, nextSlide) {
      obj.$slider.attr('data-slide-index', nextSlide);

      if (!this.settings.isTouch) {
        obj.$slides.removeClass(classes.heroSlideHidden);
      }

      if (this.settings.adaptHeight) {
        this.showMobileText(nextSlide);
      }

      this.applySlideColor(nextSlide, currentSlide);

      this.$pagination.each(
        function(index, element) {
          var labelString =
            index === nextSlide
              ? this.activeSlideA11yString
              : this.loadSlideA11yString;

          labelString = labelString.replace('[slide_number]', index + 1);

          $(element).attr('aria-label', labelString);
        }.bind(this)
      );

      // Set upcoming slide as index
      this.currentActiveSlide = nextSlide;
    },

    afterChange: function(obj) {
      if (this.settings.isTouch) {
        return;
      }

      this.$activeSlide = this.$slider.find(
        selectors.slides + selectors.activeSlide
      );

      obj.$slides.addClass(classes.heroSlideHidden).attr('aria-hidden', true);

      this.$activeSlide
        .removeClass(classes.heroSlideHidden)
        .attr('aria-hidden', false);
    },

    keyboardNavigation: function(evt) {
      if (evt.keyCode === 37) {
        this.$slider.slick('slickPrev');
      }
      if (evt.keyCode === 39) {
        this.$slider.slick('slickNext');
      }
    },

    togglePause: function(evt) {
      var $pauseButton = $(evt.currentTarget);
      var isPaused = $pauseButton.hasClass(classes.isPaused);

      this.togglePauseAttributes($pauseButton, isPaused);

      if (this.settings.autoplay) {
        if (isPaused) {
          this.$slider.slick('slickPlay');
        } else {
          this.$slider.slick('slickPause');
        }
      }
    },

    togglePauseAttributes: function($pauseButton, isPaused) {
      if (this.settings.autoplay) {
        $pauseButton
          .toggleClass(classes.isPaused, !isPaused)
          .attr(
            'aria-label',
            isPaused
              ? $pauseButton.data('label-pause')
              : $pauseButton.data('label-play')
          );
      }
    },

    showMobileText: function(slideIndex) {
      var $allTextContent = this.cache.$textWrapperMobile.find(
        selectors.heroTextContent
      );
      var $currentTextContent = this.cache.$textWrapperMobile.find(
        '[data-index="' + slideIndex + '"]'
      );

      if (!$currentTextContent.length && this.$allSlides.length === 1) {
        this.cache.$textWrapperMobile.hide();
      } else {
        this.cache.$textWrapperMobile.show();
      }

      $allTextContent.hide();
      $currentTextContent.show();
    },

    // Apply when slideshow is in first position
    applySlideColor: function(nextSlideIndex, previousSlideIndex) {
      var prefixClassName = 'hero--color-';

      this.$slider
        .removeClass(prefixClassName + previousSlideIndex)
        .addClass(prefixClassName + nextSlideIndex);
      
      this.$sliderWrapper
      	.removeClass(prefixClassName + previousSlideIndex)
        .addClass(prefixClassName + nextSlideIndex);
    },

    slideshowA11ySetup: function($slider) {
      var $list = $slider.find(selectors.slickList);

      // When an element in the slider is focused
      // pause slideshow and set aria-live.
      $slider
        .on(
          'focusin mouseenter',

          function(evt) {
            if (
              !$slider.has(evt.target).length ||
              $list.attr('aria-live') === 'polite'
            ) {
              return;
            }

            $list.attr('aria-live', 'polite');
            if (this.settings.autoplay) {
              $slider.slick('slickPause');
            }
          }.bind(this)
        )
        .on(
          'focusout mouseleave',

          function(evt) {
            if ($slider.has(evt.relatedTarget).length) {
              return;
            }

            $list.removeAttr('aria-live');
            if (this.settings.autoplay) {
              // Only resume playing if the user hasn't paused using the pause
              // button
              if (!this.cache.$pauseButton.hasClass(classes.isPaused)) {
                $slider.slick('slickPlay');
              }
            }
          }.bind(this)
        )
        .on('keyup', this.keyboardNavigation.bind(this));

      $list.removeAttr('tabindex');

      this.$allSlides.each(function(index) {
        $(this)
          .attr('id', 'SlickSlide' + (index + 1))
          .attr('aria-hidden', true);
      });

      this.$activeSlide.attr('aria-hidden', false);

      if (this.$allSlides.length > 1) {
        this.$pagination.each(function() {
          $(this).on('click keyup', function(evt) {
            if (evt.type === 'keyup' && evt.which !== 13) return;

            evt.preventDefault();

            if (evt.type === 'keyup') {
              $slider.focus();
            }
          });
        });
      }
    }
  });

  return Slideshow;
})();

theme.Disclosure = (function() {
  var selectors = {
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]'
  };

  var classes = {
    listVisible: 'disclosure-list--visible'
  };

  function Disclosure($disclosure) {
    this.$container = $disclosure;
    this.cache = {};
    this._cacheSelectors();
    this._connectOptions();
    this._connectToggle();
    this._onFocusOut();
  }

  Disclosure.prototype = _.assignIn({}, Disclosure.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        $disclosureList: this.$container.find(selectors.disclosureList),
        $disclosureToggle: this.$container.find(selectors.disclosureToggle),
        $disclosureInput: this.$container.find(selectors.disclosureInput),
        $disclosureOptions: this.$container.find(selectors.disclosureOptions)
      };
    },

    _connectToggle: function() {
      this.cache.$disclosureToggle.on(
        'click',
        function(evt) {
          var ariaExpanded =
            $(evt.currentTarget).attr('aria-expanded') === 'true';
          $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);

          this.cache.$disclosureList.toggleClass(classes.listVisible);
        }.bind(this)
      );
    },

    _connectOptions: function() {
      this.cache.$disclosureOptions.on(
        'click',
        function(evt) {
          evt.preventDefault();
          this._submitForm($(evt.currentTarget).data('value'));
        }.bind(this)
      );
    },

    _onFocusOut: function() {
      this.cache.$disclosureToggle.on(
        'focusout',
        function(evt) {
          var disclosureLostFocus =
            this.$container.has(evt.relatedTarget).length === 0;

          if (disclosureLostFocus) {
            this._hideList();
          }
        }.bind(this)
      );

      this.cache.$disclosureList.on(
        'focusout',
        function(evt) {
          var childInFocus =
            $(evt.currentTarget).has(evt.relatedTarget).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !childInFocus) {
            this._hideList();
          }
        }.bind(this)
      );

      this.$container.on(
        'keyup',
        function(evt) {
          if (evt.which !== slate.utils.keyboardKeys.ESCAPE) return;
          this._hideList();
          this.cache.$disclosureToggle.focus();
        }.bind(this)
      );

      $('body').on(
        'click',
        function(evt) {
          var isOption = this.$container.has(evt.target).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !isOption) {
            this._hideList();
          }
        }.bind(this)
      );
    },

    _submitForm: function(value) {
      this.cache.$disclosureInput.val(value);
      this.$container.parents('form').submit();
    },

    _hideList: function() {
      this.cache.$disclosureList.removeClass(classes.listVisible);
      this.cache.$disclosureToggle.attr('aria-expanded', false);
    },

    unload: function() {
      this.cache.$disclosureOptions.off();
      this.cache.$disclosureToggle.off();
      this.cache.$disclosureList.off();
      this.$container.off();
    }
  });

  return Disclosure;
})();

theme.ProductModel = (function() {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};

  var selectors = {
    productMediaGroup: '[data-product-single-media-group]',
    productMediaGroupWrapper: '[data-product-single-media-group-wrapper]',
    xrButton: '[data-shopify-xr]',
    xrButtonSingle: '[data-shopify-xr-single]'
  };

  var classes = {
    viewInSpaceDisabled: 'product-single__view-in-space--disabled'
  };

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false
    };

    modelViewerContainers.each(function(index) {
      var $modelViewerContainer = $(this);
      var mediaId = $modelViewerContainer.data('media-id');

      var $modelViewerElement = $(
        $modelViewerContainer.find('model-viewer')[0]
      );
      var modelId = $modelViewerElement.data('model-id');

      if (index === 0) {
        var $xrButton = $modelViewerContainer
          .closest(selectors.productMediaGroupWrapper)
          .find(selectors.xrButtonSingle);

        xrButtons[sectionId] = {
          $element: $xrButton,
          defaultId: modelId
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        $container: $modelViewerContainer,
        $element: $modelViewerElement
      };
    });

    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: setupShopifyXr
      }
    ]);

    if (models.length < 1) return;
    window.Shopify.loadFeatures([
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: setupModelViewerUi
      }
    ]);
    theme.LibraryLoader.load('modelViewerUiStyles');
  }

  function setupShopifyXr(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function(event) {
        if (event.detail.shopifyXREnabled) {
          setupShopifyXr();
        } else {
          $(selectors.xrButton).addClass(classes.viewInSpaceDisabled);
        }
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];

        if (modelSection.loaded) continue;
        var $modelJson = $('#ModelJson-' + sectionId);

        window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) return;

    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];

    var $productMediaGroup = model.$container.closest(
      selectors.productMediaGroup
    );

    model.$element
      .on('shopify_model_viewer_ui_toggle_play', function() {
        theme.updateSlickSwipe($productMediaGroup, false);
      })
      .on('shopify_model_viewer_ui_toggle_pause', function() {
        theme.updateSlickSwipe($productMediaGroup, true);
      });

    model.$container.on('mediaVisible', function() {
      xrButton.$element.attr('data-shopify-model3d-id', model.modelId);
      if (Modernizr.touch) return;
      model.modelViewerUi.play();
    });

    model.$container
      .on('mediaHidden', function() {
        xrButton.$element.attr('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      })
      .on('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          models[key].modelViewerUi.destroy();
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}

theme.ProductVideo = (function() {
  var videos = {};

  var hosts = {
    html5: 'html5',
    youtube: 'youtube'
  };

  var selectors = {
    productMediaWrapper: '[data-product-single-media-wrapper]',
    productMediaGroup: '[data-product-single-media-group]'
  };

  var attributes = {
    enableVideoLooping: 'enable-video-looping',
    videoId: 'video-id'
  };

  function init(videoContainer, sectionId) {
    if (!videoContainer.length) {
      return;
    }

    var videoElement = videoContainer.find('iframe, video')[0];
    var mediaId = videoContainer.data('mediaId');

    if (!videoElement) {
      return;
    }

    videos[mediaId] = {
      mediaId: mediaId,
      sectionId: sectionId,
      host: hostFromVideoElement(videoElement),
      container: videoContainer,
      element: videoElement,
      ready: function() {
        createPlayer(this);
      }
    };

    var video = videos[mediaId];

    switch (video.host) {
      case hosts.html5:
        window.Shopify.loadFeatures([
          {
            name: 'video-ui',
            version: '1.1',
            onLoad: setupPlyrVideos
          }
        ]);
        theme.LibraryLoader.load('plyrShopifyStyles');
        break;
      case hosts.youtube:
        theme.LibraryLoader.load('youtubeSdk');
        break;
    }
  }

  function setupPlyrVideos(errors) {
    if (errors) {
      fallbackToNativeVideo();
      return;
    }

    loadVideos(hosts.html5);
  }

  function createPlayer(video) {
    if (video.player) {
      return;
    }

    var productMediaWrapper = video.container.closest(
      selectors.productMediaWrapper
    );
    var enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);

    switch (video.host) {
      case hosts.html5:
        // eslint-disable-next-line no-undef
        video.player = new Shopify.Plyr(video.element, {
          loop: { active: enableLooping }
        });

        var $productMediaGroup = $(video.container).closest(
          selectors.productMediaGroup
        );

        video.player.on('seeking', function() {
          theme.updateSlickSwipe($productMediaGroup, false);
        });

        video.player.on('seeked', function() {
          theme.updateSlickSwipe($productMediaGroup, true);
        });

        break;
      case hosts.youtube:
        var videoId = productMediaWrapper.data(attributes.videoId);

        video.player = new YT.Player(video.element, {
          videoId: videoId,
          events: {
            onStateChange: function(event) {
              if (event.data === 0 && enableLooping) event.target.seekTo(0);
            }
          }
        });
        break;
    }

    productMediaWrapper.on('mediaHidden xrLaunch', function() {
      if (!video.player) return;

      if (video.host === hosts.html5) {
        video.player.pause();
      }

      if (video.host === hosts.youtube && video.player.pauseVideo) {
        video.player.pauseVideo();
      }
    });

    productMediaWrapper.on('mediaVisible', function() {
      if (Modernizr.touch) return;
      if (!video.player) return;

      if (video.host === hosts.html5) {
        video.player.play();
      }

      if (video.host === hosts.youtube && video.player.playVideo) {
        video.player.playVideo();
      }
    });
  }

  function hostFromVideoElement(video) {
    if (video.tagName === 'VIDEO') {
      return hosts.html5;
    }

    if (video.tagName === 'IFRAME') {
      if (
        /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
          video.src
        )
      ) {
        return hosts.youtube;
      }
    }
    return null;
  }

  function loadVideos(host) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.host === host) {
          video.ready();
        }
      }
    }
  }

  function fallbackToNativeVideo() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.nativeVideo) continue;

        if (video.host === hosts.html5) {
          video.element.setAttribute('controls', 'controls');
          video.nativeVideo = true;
        }
      }
    }
  }

  function removeSectionVideos(sectionId) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.sectionId === sectionId) {
          if (video.player) video.player.destroy();
          delete videos[key];
        }
      }
    }
  }

  return {
    init: init,
    hosts: hosts,
    loadVideos: loadVideos,
    removeSectionVideos: removeSectionVideos
  };
})();


/* ================ Sections ================ */
window.theme = window.theme || {};

theme.Product = (function() {
  function Product(container) {
    var self = this;
    var $window = $(window);
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      productPageLoad: false,
      preloadImage: false,
      enableHistoryState: false,
      namespace: '.productSection',
      sectionId: sectionId,
      zoomEnabled: false
    };
    
    this.nodes = {
      $siteHeader: $('.site-header'),
      $announcementBar: $('.announcement-bar')
    };
    
    this.selectors = {
      productMediaWrapper: '[data-product-single-media-wrapper]',
      productMediaGroup: '[data-product-single-media-group]',
      productMediaFlexWrapper: '[data-product-single-media-flex-wrapper]',
      productMediaTypeModel: '[data-product-media-type-model]',
      productMediaTypeVideo: '[data-product-media-type-video]',
      productThumbnails: '[data-product-thumbnails]',
      productThumbnail: '[data-product-thumbnail]',
      productFullDetails: '.product-single__full-details',
      productImageZoom: '[data-mfp-src]',
      productForm: '.add-to-cart__form',
      addToCart: '.btn--add-to-cart',
      addToCartText: '.btn__text',
      priceContainer: '[data-price-container]',
      productPrice: '#ProductPrice, #ProductPrice-bar',
      productDescription: '.product-single__description',
      SKU: '.variant-sku',
      priceA11y: '#PriceA11y,#PriceA11y-bar',
      comparePrice: '#ComparePrice,#ComparePrice-bar',
      comparePriceA11y: '#ComparePriceA11y,#ComparePriceA11y-bar',
      comparePriceWrapper: '.product-single__price--wrapper',
      quantityElements: '.js-quantity-selector, label + .js-qty',
      nestedNavLink: '.single-product_nested-nav_link',
      originalSelectorId: '#ProductSelect',
      colorOptionsSelectorContainer: '.product-single__color-options',
      activeColor: '.product-single__active-color', 
      singleOptionSelector: '.single-option-selector__radio',
      radioWrapper: '.radio-wrapper',
      meta: '.product-single__meta',
      productWrapper: '.product-single',
      imageZoomWrapper: '[data-image-zoom-wrapper]',
      shopifyPaymentButton: '.shopify-payment-button',
      unitPrice: '[data-unit-price]',
      unitPriceBaseUnit: '[data-unit-price-base-unit]'
    };

    this.classes = {
      priceContainerUnitAvailable: 'price-container--unit-available',
      activeThumb: 'active-thumb',
      hide: 'hide'
    };

    this.slickSettings = {
      slide: this.selectors.productMediaFlexWrapper,
      accessibility: true,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev icon-fallback-text" aria-label="Previous slide"><span class="icon icon-chevron-left" aria-hidden="true"></span><span class="fallback-text">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next icon-fallback-text" aria-label="Next slide"><span class="icon icon-chevron-right" aria-hidden="true"></span><span class="fallback-text">Next</span></button>',
      dots: true,
      infinite: true,
      adaptiveHeight: true
    };
  
    this.slickTranslateDistance = 0;
    this.isCarouselActive = false;

    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );
    
    this.settings.zoomEnabled = $container.data('image-zoom-type')
    
    this.isStackedLayout = $container.data('stacked-layout');

    this.focusableElements = [
      'iframe',
      'input',
      'button',
      'video'
    ].join(',');

    this.initBreakpoints();
    this.stringOverrides();
    this.initNestedCollectionsNav();
    this.initProductVariant();
    this.initProductVideo();
    this.initProductDetailsTabs();
    this.initDescriptionCollapse();

    this.initRecommendedProductsTooltip();
    this.initProductStickyBar();
    this._initModelViewerLibraries();
    this._initShopifyXrLaunch();

    $window.on('load', function(){
      self.initStickyProductThumbs();
      self.initStickyProductMeta();
    });

    $window.on('resize', function(){	
      clearTimeout(window.resizedFinished);	
      window.resizedFinished = setTimeout(function(){	
        self.initStickyProductThumbs();	
        self.initStickyProductMeta();	
      }, 150);	
    });

    if (theme.settings.cartType === 'drawer') {
      ajaxCart.init({
        formSelector: '#AddToCartForm--' + sectionId,
        cartContainer: '#CartContainer',
        addToCartSelector: '#AddToCart--' + sectionId,
        enableQtySelectors: true,
        moneyFormat: theme.strings.moneyFormat
      });
    }

    /*$window
      .on('load' + this.settings.namespace, theme.initStickyProductMeta)
      .on(
        'resize' + this.settings.namespace,
        theme.debounce(this.initStickyProductMeta(true), 150).bind(this)
      )
      .on(
        'resize' + this.settings.namespace,
        theme.debounce(this.initStickyProductThumbs, 150).bind(this)
      );*/
  }

  Product.prototype = _.assignIn({}, Product.prototype, {

    initProductStickyBar: function(){
      $(".single-option-selector-bar").on('change', function(){
        const $this = $(this),
              index = $this.attr('data-index'),
              val = $this.val();

        if( $("#AddToCart-bar").prop('disabled') ){
          //return;
        }

        // if it is a radio
        $(`input.single-option-selector__radio[data-index="${index}"][value="${val}"]`).prop('checked', true).trigger('change');
        // if it is a select
        $(`select.product-form__input[data-index="${index}"]`).val(val).trigger('change');
      });

      $(".single-option-selector-bar").each(function(){
        let val =  $(this).val();
        if( val == ''){
          $("#AddToCart-bar").prop('disabled', true);
        } 
      });
      
      $("#AddToCart-bar").on('click',function(){
        $("#AddToCart--product-template").trigger('click');
      });

      function sticky_atc_bar () {
        if ($(".product-single__meta--wrapper .product-single__add-to-cart").length > 0) {
          var top_of_element = $(".product-single__meta--wrapper .product-single__add-to-cart").offset().top - 15;
          var window_offset = window.pageYOffset;
            if (window_offset > top_of_element) {
              $("#product-sticky-bar").addClass('bar--is-visible');
            } else {
              $("#product-sticky-bar").removeClass('bar--is-visible');
          }
        }
      }
      $(window).on('load scroll', function() {
        sticky_atc_bar();
      });
    },

    initProductVariant: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId:
          this.selectors.originalSelectorId + '--' + this.settings.sectionId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);
      this.$container.on(
        'variantChange' + this.settings.namespace,
        this.productPage.bind(this)
      );
      this.$container.on(
        'variantMediaChange' + this.settings.namespace,
        this.showVariantMedia.bind(this)
      );

      if(window.location.href.indexOf('variant=') > -1){
        var variant = this.variants._getVariantFromOptions();
        this.currentVariant = variant;
        this.variants._updateMasterSelect(variant);
        this.variants._updateMedia(variant);
        this.variants._updatePrice(variant);
        this.variants._updateSKU(variant);
        this.variants._updatePaymentButton(variant);

        if (this.variants.enableHistoryState) {
          this.variants._updateHistoryState(variant);
        }

        var variantID = this.currentVariant.id;
        var inventory = parseInt($('[data-inventorymanagment][data-id="'+variantID+'"]').attr('data-inventory'));
        if(inventory <= 2){
          $('#variant-inventory').removeClass('visually-opacity-hidden');
        }else{
          $('#variant-inventory').addClass('visually-opacity-hidden');
        }
      }
    },

    initBreakpoints: function() {
      var self = this;
      var $container = self.$container;
      self.zoomType = $container.data('image-zoom-type');

      enquire.register(theme.variables.mediaQuerySmall, {
        match: function() {
          self.createMediaCarousel();

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.imageZoomWrapper).each(function() {
              _destroyZoom(this);
            });
          }
        },
        unmatch: function() {
          
          self.destroyMediaCarousel();
          
          // reinit product zoom
          if (self.settings.zoomEnabled) {
            $(self.selectors.imageZoomWrapper).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
      
      enquire.register(theme.variables.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.imageZoomWrapper).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
      
    },

    _initModelViewerLibraries: function() {
      if (!this.$container.data('has-model')) return;

      var $modelViewerElements = $(
        this.selectors.productMediaTypeModel,
        this.$container
      );
      theme.ProductModel.init($modelViewerElements, this.settings.sectionId);
    },

    _initShopifyXrLaunch: function() {
      $(document).on(
        'shopify_xr_launch',
        function() {
          var $currentMedia = $(
            this.selectors.productMediaWrapper +
              ':not(.' +
              this.classes.hide +
              ')',
            this.$container
          );
          $currentMedia.trigger('xrLaunch');
        }.bind(this)
      );
    },

    initProductVideo: function() {
      var sectionId = this.settings.sectionId;

      $(this.selectors.productMediaTypeVideo, this.$container).each(function() {
        var $videoContainer = $(this);
        theme.ProductVideo.init($videoContainer, sectionId);
      });
    },
    
    initProductDetailsTabs: function() {
      var self = this;
      /*
      *   This content is licensed according to the W3C Software License at
      *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
      */
      (function () {
        var tablist = document.querySelectorAll('[role="tablist"]')[0];
        var tabs;
        var panels;
        var delay = determineDelay();

        generateArrays();

        function generateArrays () {
          tabs = document.querySelectorAll('[role="tablist"] button');
          panels = document.querySelectorAll('[role="tabpanel"]');
        };

        // For easy reference
        var keys = {
          end: 35,
          home: 36,
          left: 37,
          up: 38,
          right: 39,
          down: 40,
          delete: 46
        };

        // Add or substract depending on key pressed
        var direction = {
          37: -1,
          38: -1,
          39: 1,
          40: 1
        };

        // Bind listeners
        for (i = 0; i < tabs.length; ++i) {
          addListeners(i);
        };

        function addListeners (index) {
          tabs[index].addEventListener('click', clickEventListener);
          tabs[index].addEventListener('keydown', keydownEventListener);
          tabs[index].addEventListener('keyup', keyupEventListener);

          // Build an array with all tabs (<button>s) in it
          tabs[index].index = index;
        };

        // When a tab is clicked, activateTab is fired to activate it
        function clickEventListener (event) {
          var tab = event.target;
          activateTab(tab, false);
        };

        // Handle keydown on tabs
        function keydownEventListener (event) {
          var key = event.keyCode;

          switch (key) {
            case keys.end:
              event.preventDefault();
              // Activate last tab
              activateTab(tabs[tabs.length - 1]);
              break;
            case keys.home:
              event.preventDefault();
              // Activate first tab
              activateTab(tabs[0]);
              break;

            // Up and down are in keydown
            // because we need to prevent page scroll >:)
            case keys.up:
            case keys.down:
              determineOrientation(event);
              break;
          };
        };

        // Handle keyup on tabs
        function keyupEventListener (event) {
          var key = event.keyCode;

          switch (key) {
            case keys.left:
            case keys.right:
              determineOrientation(event);
              break;
            case keys.delete:
              determineDeletable(event);
              break;
          };
        };

        // When a tablistâ€™s aria-orientation is set to vertical,
        // only up and down arrow should function.
        // In all other cases only left and right arrow function.
        function determineOrientation (event) {
          var key = event.keyCode;
          var vertical = tablist.getAttribute('aria-orientation') == 'vertical';
          var proceed = false;

          if (vertical) {
            if (key === keys.up || key === keys.down) {
              event.preventDefault();
              proceed = true;
            };
          }
          else {
            if (key === keys.left || key === keys.right) {
              proceed = true;
            };
          };

          if (proceed) {
            switchTabOnArrowPress(event);
          };
        };

        // Either focus the next, previous, first, or last tab
        // depening on key pressed
        function switchTabOnArrowPress (event) {
          var pressed = event.keyCode;

          for (x = 0; x < tabs.length; x++) {
            tabs[x].addEventListener('focus', focusEventHandler);
          };

          if (direction[pressed]) {
            var target = event.target;
            if (target.index !== undefined) {
              if (tabs[target.index + direction[pressed]]) {
                tabs[target.index + direction[pressed]].focus();
              }
              else if (pressed === keys.left || pressed === keys.up) {
                focusLastTab();
              }
              else if (pressed === keys.right || pressed == keys.down) {
                focusFirstTab();
              };
            };
          };
        };

        // Activates any given tab panel
        function activateTab (tab, setFocus) {
          setFocus = setFocus || true;
          // Deactivate all other tabs
          deactivateTabs();

          // Remove tabindex attribute
          tab.removeAttribute('tabindex');

          // Set the tab as selected
          tab.setAttribute('aria-selected', 'true');

          // Get the value of aria-controls (which is an ID)
          var controls = tab.getAttribute('aria-controls');

          // Remove hidden attribute from tab panel to make it visible
          document.getElementById(controls).removeAttribute('hidden');

          self.initStickyProductMeta();

          /* Set focus when required
          if (setFocus) {
            tab.focus();
          };
          */
        };

        // Deactivate all tabs and tab panels
        function deactivateTabs () {
          for (t = 0; t < tabs.length; t++) {
            tabs[t].setAttribute('tabindex', '-1');
            tabs[t].setAttribute('aria-selected', 'false');
            tabs[t].removeEventListener('focus', focusEventHandler);
          };

          for (p = 0; p < panels.length; p++) {
            panels[p].setAttribute('hidden', 'hidden');
          };
        };

        // Make a guess
        function focusFirstTab () {
          tabs[0].focus();
        };

        // Make a guess
        function focusLastTab () {
          tabs[tabs.length - 1].focus();
        };

        // Detect if a tab is deletable
        function determineDeletable (event) {
          target = event.target;

          if (target.getAttribute('data-deletable') !== null) {
            // Delete target tab
            deleteTab(event, target);

            // Update arrays related to tabs widget
            generateArrays();

            // Activate the closest tab to the one that was just deleted
            if (target.index - 1 < 0) {
              activateTab(tabs[0]);
            }
            else {
              activateTab(tabs[target.index - 1]);
            };
          };
        };

        // Deletes a tab and its panel
        function deleteTab (event) {
          var target = event.target;
          var panel = document.getElementById(target.getAttribute('aria-controls'));

          target.parentElement.removeChild(target);
          panel.parentElement.removeChild(panel);
        };

        // Determine whether there should be a delay
        // when user navigates with the arrow keys
        function determineDelay () {
          var hasDelay = tablist.hasAttribute('data-delay');
          var delay = 0;

          if (hasDelay) {
            var delayValue = tablist.getAttribute('data-delay');
            if (delayValue) {
              delay = delayValue;
            }
            else {
              // If no value is specified, default to 300ms
              delay = 300;
            };
          };

          return delay;
        };

        //
        function focusEventHandler (event) {
          var target = event.target;

          setTimeout(checkTabFocus, delay, target);
        };

        // Only activate tab on focus if it still has focus after the delay
        function checkTabFocus (target) {
          focused = document.activeElement;

          if (target === focused) {
            activateTab(target, false);
          };
        };
      }());
    },
    
    initDescriptionCollapse: function() {
      var self = this;

      function insertString(str, index, value) {
          var lastSpaceInRange =  str.lastIndexOf(" ",index);
          return str.substr(0, lastSpaceInRange) + value + str.substr(lastSpaceInRange);
      }

      var productDescription = $('.product-single__description div').html();
      function buildReadmore(charCount, charHeight) {
        $('.product-single__description').readmore({ 
          speed: 75, 
          moreLink: '<a href="#" class="rm__link">read more</a>',
          lessLink: '<a href="#" class="rm__link">read less</a>',
          collapsedHeight: charHeight,
          beforeToggle: function(trigger, element, expanded) {
            if(! expanded) {
              $('.product-single__description div').html(productDescription)
              $('.product-single__description').addClass('expanded')
              $('.product-single__description').find('*').removeAttr('style class');
              // setTimeout(function () {
              //   var expandedHeight = $('.product-single__description p').height()
              //   $('.product-single__description').css('height', expandedHeight+'px')
              //   console.log(expandedHeight)
              // }, 75);
            } else {
              $('.product-single__description div').html(insertString(productDescription, charCount, '…<br>'));
              $('.product-single__description').removeClass('expanded')
              $('.product-single__description').find('*').removeAttr('style class');
            }
            // Wait 150 ms after the read more block has been updated before running the sticky calculations
            // !afterToggle callback from the '.readmore' library doesn't work as expected
            setTimeout(function () {
              self.initStickyProductMeta();
            }, 150);
          },
          afterToggle: function() {
            console.log('after')
          }
          
        });

        if (productDescription.length > charCount) {
          $('.product-single__description div').html(insertString(productDescription, charCount, '…<br>'));
          $('.product-single__description').find('*').removeAttr('style class');

        }
      }

      if(theme.cache.$window.width() < 480) {
        buildReadmore(120, 50);
      }else if(theme.cache.$window.width() < 590) {
        buildReadmore(150, 50);
      }else if(theme.cache.$window.width() <= 768) {
        buildReadmore(100, 50);
      } else if (theme.cache.$window.width() <= 1024) {
        buildReadmore(120, 55);
      } else {
        buildReadmore(130, 60);
      }

      theme.cache.$window.resize(function(evt) {
        if(theme.cache.$window.width() < 480) {
          afterResize(function() {
            $(this.selectors.productDescription).readmore('destroy');
            buildReadmore(120, 50);
          }, 250);
        }else if(theme.cache.$window.width() < 590) {
          afterResize(function() {
            $(this.selectors.productDescription).readmore('destroy');
            buildReadmore(150, 50);
          }, 250);
        }else if(theme.cache.$window.width() <= 768) {
          afterResize(function() {
            $(this.selectors.productDescription).readmore('destroy');
            buildReadmore(100, 50);
          }, 250);
        } else if (theme.cache.$window.width() <= 1024) {
          afterResize(function() {
            $(this.selectors.productDescription).readmore('destroy');
            buildReadmore(120, 55);
          }, 250);
        } else {
          afterResize(function() {
            $(this.selectors.productDescription).readmore('destroy');
            buildReadmore(130, 60);
          }, 250);
        }
      });
    },
    
    initRecommendedProductsTooltip: function() {
    
      var tooltipWeight, x;
      $('div.product-related-products__thumb-item').mouseenter(function(e) {
        // Calculate the position of the image tooltip
        tooltipWeight =  $(this).children("div.product-related-products__tooltip").width();
        x = e.pageX - $(this).offset().left - tooltipWeight/2;
        // Set the z-index of the current item
        $(this).css('z-index','15')
        .children("div.product-related-products__tooltip")
        .css({'display':'block'});
        // .css({'left': x,'display':'block'});
      }).mousemove(function(e) {
        // Calculate the position of the image tooltip
        tooltipWeight =  $(this).children("div.product-related-products__tooltip").width();
        x = e.pageX - $(this).offset().left - tooltipWeight/2;
        // This line causes the tooltip will follow the mouse pointer
        // $(this).children("div.product-related-products__tooltip").css({'left': x});
      }).mouseleave(function() {
        // Reset the z-index and hide the image tooltip
        $(this).css('z-index','1')
        .children("div.product-related-products__tooltip")
        .animate({"opacity": "hide"}, "fast");
      });

    },

    stringOverrides: function() {
      // Override defaults in theme.strings with potential
      // template overrides

      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    resizeElements: function() {
      $(this.selectors.productGridImages, this.$container).imagesLoaded(
        function() {
          $(this.selectors.productGridImages, this.$container)
            .css('height', 'auto')
            .equalHeights();
        }
      );
    },
    
    initNestedCollectionsNav: function() {
      var self = this;
      
      /*
      $(this.selectors.nestedNavLink).on('click', function(e){
      
        e.preventDefault();
                  
        var href = $(this).attr('href');

        $.ajax({
          type: 'GET',
          url: href,
          beforeSend: function() {
            //scrollNode.clone().empty().insertAfter(scrollNode).append('<img src=\"//shopmashburn.com/cdn/shop/t/842/assets/loading.gif?166682\" />');
            //scrollNode.hide();
          },
          success: function(data) {
            // remove loading feedback
            var filteredData = $(data).find(".main-content");
            $('.main-content').html(filteredData);
            var sections = new theme.Sections();
            sections.register('product-template', theme.Product);
          },
          dataType: "html"
        });
        
      });
      */
      
    },
    
    showVariantMedia: function(evt) {
      var variant = evt.variant;
      var variantMediaId =
        this.settings.sectionId + '-' + variant.featured_media.id;

      var $newMedia = $(
        this.selectors.productMediaWrapper +
          '[data-media-id="' +
          variantMediaId +
          '"]'
      );

      this.triggerMediaChangeEvent(variantMediaId);

      var mediaIndex;

      if (
        theme.variables.bpSmall &&
        !this.$container.data('featured-product')
      ) {
        // Switch carousel slide, unless it's the first photo on load
        mediaIndex = $newMedia.closest('.slick-slide').data('slick-index');
        // Navigate to slide unless it's the first photo on load
        // If there is no index, slider is not initalized.
        if (_.isUndefined(mediaIndex)) {
          return;
        }

        if (mediaIndex !== 0 || theme.variables.productPageLoad) {
          $(this.selectors.productMediaGroup, this.$container).slick(
            'slickGoTo',
            mediaIndex
          );
        }
        // Switch media variant on thumbnail layout for desktop view;
        // When a media variant is updated on mobile view, update the
        // desktop view also.
        if (!this.isStackedLayout) {
          this.switchMedia(variantMediaId);
        }
      } else {
        if (this.isStackedLayout) {
          mediaIndex = $newMedia.closest('.slick-slide').index();
          // Scroll to/reorder media unless it's the first photo on load
          if (mediaIndex !== 0 || theme.variables.productPageLoad) {
            if (theme.variables.productPageSticky) {
              // Scroll to variant media
              $('html, body').animate(
                {
                  scrollTop: $newMedia.offset().top
                },
                250
              );
            } else {
              // Move selected variant media to top, preventing scrolling
              var currentScroll = $(document).scrollTop();
              $newMedia
                .closest(
                  $(this.selectors.productMediaFlexWrapper, this.$container)
                )
                .prependTo(
                  $(this.selectors.productMediaGroup, this.$container)
                );
              $(document).scrollTop(currentScroll);
            }
          }
        } else {
          // Switch media variant for thumbnail layout
          this.switchMedia(variantMediaId);
        }
      }

      if (!theme.variables.productPageLoad) {
        theme.variables.productPageLoad = true;
      }
    },

    triggerMediaChangeEvent: function(mediaId) {
      var $otherMedia = $(this.selectors.productMediaWrapper, this.$container);
      $otherMedia.trigger('mediaHidden');

      var $newMedia = $(
        this.selectors.productMediaWrapper,
        this.$container
      ).filter('#ProductMediaWrapper-' + mediaId);
      $newMedia.trigger('mediaVisible'); 
    },

    switchMedia: function(mediaId) {
      var $otherMedia = $(this.selectors.productMediaWrapper, this.$container);

      $otherMedia.addClass(this.classes.hide);
      var $newMedia = $(
        this.selectors.productMediaWrapper,
        this.$container
      ).filter('#ProductMediaWrapper-' + mediaId);
      $newMedia.removeClass(this.classes.hide);
    },

    handleMediaFocus: function(evt) {
      if (evt.keyCode !== 13) return;

      var mediaId = $(evt.currentTarget).data('media-id');

      $(
        this.selectors.productMediaWrapper +
          "[data-media-id='" +
          mediaId +
          "']",
        this.$container
      ).focus();
    },
    
    createMediaCarousel: function() {
      if (
        $(this.selectors.productMediaFlexWrapper).length < 2 ||
        !$(this.selectors.productMediaGroup, this.$container) ||
        this.isCarouselActive
      ) {
        return;
      }

      this.isCarouselActive = true;
      var dotStyle = {
        max: 9,
        width: 20
      };

      var focusTrapped = false;
      $(this.selectors.productMediaFlexWrapper, this.$container).on(
        'focusin',
        function() {
          if (focusTrapped) {
            return;
          }
          this.trapCarouselFocus($(this.selectors.productMediaGroup));
          focusTrapped = true;
        }.bind(this)
      );

      $(this.selectors.productMediaGroup, this.$container)
        .slick(this.slickSettings)
        .on(
          'beforeChange',
          function(event, slick, currentSlide, nextSlide) {
            this.updateCarouselDotsA11y(nextSlide);
            this.translateCarouselDots(slick.slideCount, nextSlide, dotStyle);
          }.bind(this)
        )
        .on(
          'afterChange',
          function(event, slick) {
            this.trapCarouselFocus(slick.$slider);
          }.bind(this)
        );

      if (this.isStackedLayout) return;
      var slideIndex = $(
        this.selectors.productMediaWrapper + ':not(.' + this.classes.hide + ')',
        this.$container
      )
        .closest(this.selectors.productMediaFlexWrapper)
        .data('slick-index');

      if (!slideIndex) return;
      $(this.selectors.productMediaGroup, this.$container).slick(
        'slickGoTo',
        slideIndex,
        true
      );
    },

    updateCarouselDotsA11y: function(nextSlide) {
      var $dotLinks = $(this.selectors.slickDots).find('a');
      $dotLinks
        .removeAttr('aria-current')
        .eq(nextSlide)
        .attr('aria-current', 'true');
    },

    translateCarouselDots: function(totalSlides, nextSlide, dotStyle) {
      if (totalSlides <= dotStyle.max) {
        return;
      }
      var calculatedTranslateDistance = 0;

      var maxTranslateDistance = (totalSlides - dotStyle.max) * dotStyle.width;
      if (nextSlide >= dotStyle.max - 1) {
        calculatedTranslateDistance =
          (nextSlide + 2 - dotStyle.max) * dotStyle.width;

        calculatedTranslateDistance =
          maxTranslateDistance < calculatedTranslateDistance
            ? maxTranslateDistance
            : calculatedTranslateDistance;
      }

      $(this.selectors.slickDots)
        .find('ul')
        .css('transform', 'translateX(-' + calculatedTranslateDistance + 'px)');
    },

    trapCarouselFocus: function($slider, removeFocusTrap) {
      if (!$slider) return;

      $slider
        .find('.slick-slide:not(.slick-active)')
        .find(this.focusableElements)
        .attr('tabindex', removeFocusTrap ? '0' : '-1');

      $slider
        .find('.slick-active')
        .find(this.focusableElements)
        .attr('tabindex', '0');
    },

    destroyMediaCarousel: function() {
      if (
        !$(this.selectors.productMediaGroup, this.$container).length ||
        !this.isCarouselActive
      ) {
        return;
      }

      this.trapCarouselFocus(
        $(this.selectors.productMediaGroup, this.$container),
        true
      );

      $(this.selectors.productMediaGroup, this.$container).slick('unslick');
      this.isCarouselActive = false;
    },

    productPage: function(evt) {
      var moneyFormat = theme.strings.moneyFormat;
      var variant = evt.variant;
      var translations = theme.strings;
      var colorOption = false;
      
      if( $(this.selectors.colorOptionsSelectorContainer, this.$container).length ) {
        colorOption = $(this.selectors.colorOptionsSelectorContainer, this.$container).find('.single-option-selector__radio').attr('name');
	  }  
       
      if (variant) {

        // UPDATE STICKY BAR SELECTORS
        for( let j in variant.options ) {
          let index = parseInt(j) + 1;
          let sel = $(`select.single-option-selector-bar[data-index="option${index}"]`);
          sel.val(variant.options[j]);
        }
        // Display variant media on featured product
        if (!$('body').hasClass('template-product')) {
          if (variant.featured_media) {
            var variantMediaId =
              this.settings.sectionId + '-' + variant.featured_media.id;
            var $newMedia = $(
              this.selectors.productMediaWrapper +
                '[data-media-id="' +
                variantMediaId +
                '"]',
              this.$container
            );
            var $otherMedia = $(
              this.selectors.productMediaWrapper +
                ':not([data-media-id="' +
                variantMediaId +
                '"])',
              this.$container
            );

            $newMedia.removeClass(this.classes.hide);
            $otherMedia.addClass(this.classes.hide);
          }
        }

        $(this.selectors.priceContainer).removeClass(
          'visibility-hidden ' + this.classes.priceContainerUnitAvailable
        );
        $(this.selectors.productPrice).attr(
          'aria-hidden',
          'false'
        );
        $(this.selectors.priceA11y).attr(
          'aria-hidden',
          'false'
        );
        
        if(colorOption) {
          $(this.selectors.activeColor).html(variant[colorOption]);
        }

        // Select a valid variant if available
        if (variant.available) {
          // Available, enable the submit button, change text, show quantity elements
          $(this.selectors.addToCart)
            .removeClass('disabled')
            .prop('disabled', false)
            .show();
          $(this.selectors.addToCartText).html(
            translations.addToCart
          );
          
          $('#BIS_trigger').hide();
          
          $(this.selectors.quantityElements).show();
          $(this.selectors.shopifyPaymentButton).show();

          // Update the full details link
          var $link = $(this.selectors.productFullDetails);
          if ($link.length) {
            $link.attr(
              'href',
              this.updateUrlParameter($link.attr('href'), 'variant', variant.id)
            );
          }
        } else {
          // Sold out, disable the submit button, change text, hide quantity elements
          $(this.selectors.addToCart)
            .addClass('disabled')
            .prop('disabled', true)
            .hide();
          $(this.selectors.addToCartText).html(
            translations.soldOut
          );
          
          $('#BIS_trigger').show().attr('data-variant-id', variant.id);
          
          $(this.selectors.quantityElements).hide();
          $(this.selectors.shopifyPaymentButton).hide();
        }

        $(this.selectors.productPrice)
          .html(theme.Currency.formatMoney(variant.price, moneyFormat))
          .show();

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice).html(
            theme.Currency.formatMoney(variant.compare_at_price, moneyFormat)
          );
          $(this.selectors.comparePriceWrapper).removeClass(
            this.classes.hide
          );
          $(this.selectors.productPrice).addClass('on-sale');
          $(this.selectors.comparePriceWrapper).attr(
            'aria-hidden',
            'false'
          );
          $(this.selectors.comparePriceA11y).attr(
            'aria-hidden',
            'false'
          );
        } else {
          $(this.selectors.comparePriceWrapper)
            .addClass(this.classes.hide)
            .attr('aria-hidden', 'true');
          $(this.selectors.productPrice).removeClass(
            'on-sale'
          );
          $(this.selectors.comparePrice).html('');
          $(this.selectors.comparePriceA11y).attr(
            'aria-hidden',
            'true'
          );
        }

        if (variant.unit_price) {
          var $unitPrice = $(this.selectors.unitPrice);
          var $unitPriceBaseUnit = $(
            this.selectors.unitPriceBaseUnit,
            this.$container
          );

          $unitPrice.html(
            theme.Currency.formatMoney(variant.unit_price, moneyFormat)
          );
          $unitPriceBaseUnit.html(this.getBaseUnit(variant));

          $(this.selectors.priceContainer).addClass(
            this.classes.priceContainerUnitAvailable
          );
        }

        // Also Show SKU
        $(this.selectors.SKU).html(variant.sku);
        
      } else {
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        // To only show available variants, implement linked product options:
        //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
        $(this.selectors.addToCart)
          .addClass('disabled')
          .prop('disabled', true);
        $(this.selectors.addToCartText).html(
          translations.unavailable
        );
        $(this.selectors.quantityElements).hide();
        $(this.selectors.shopifyPaymentButton).hide();

        $(this.selectors.priceContainer).addClass(
          'visibility-hidden'
        );
        $(this.selectors.productPrice).attr(
          'aria-hidden',
          'true'
        );
        $(this.selectors.priceA11y).attr(
          'aria-hidden',
          'true'
        );
        $(this.selectors.comparePriceWrapper).attr(
          'aria-hidden',
          'true'
        );
        $(this.selectors.comparePriceA11y).attr(
          'aria-hidden',
          'true'
        );
      }
    },

    updateUrlParameter: function(url, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
      var separator = url.indexOf('?') === -1 ? '?' : '&';

      if (url.match(re)) {
        return url.replace(re, '$1' + key + '=' + value + '$2');
      } else {
        return url + separator + key + '=' + value;
      }
    },

    initStickyProductThumbs: function() {
      
      var self = this;
      var $thumbs = $(this.selectors.productThumbnails, this.$container);
      var $wrapper = $(this.selectors.productWrapper, this.$container);
      
      if (
        !$thumbs.length ||
        $(this.selectors.productMediaWrapper, this.$container).length < 2
      ) {
        return;
      }
      
      // Force detatch if already detached. Prevent layout issues.
      $thumbs.trigger('detach.ScrollToFixed');

      // Detach and stop if on mobile breakpoint
      if (theme.variables.bpSmall) {
        return;
      }
      
      var fixedHeaderHeight = self.nodes.$siteHeader.outerHeight();
      var productThumbsHeight = $thumbs.outerHeight();
      var productMediaGroupHeight = $(
        this.selectors.productMediaGroup,
        this.$container
      ).height();
      
      /*============================================================================
        Calculate when to detach fixed element to avoid content overlap.
        Subtract product thumbs height and fixed header height from the limit because plugin uses offset().top
        .product-single__thumbnails.scroll-to-fixed-fixed = 105px in stylesheet
        .product-single__media-flex-wrapper margin-bottom = 15px in stylesheet
      ==============================================================================*/
      var calcLimit = $wrapper.offset().top + 25 + $wrapper.height();
      calcLimit -= productThumbsHeight + 105 + 15;

      // Init sticky if desc shorter than images and fits in viewport
      // if (
      //   productThumbsHeight < productMediaGroupHeight
      // ) {
      //   theme.variables.productPageSticky = true;
      //   $thumbs.scrollToFixed({
      //     marginTop: fixedHeaderHeight + 25,
      //     limit: calcLimit,
      //     zIndex: 2
      //   });
      // } else {
      //   theme.variables.productPageSticky = false;
      // }

    },
    
    initStickyProductMeta: function(preventScroll) {
      var self = this;
      var $meta = $(this.selectors.meta, this.$container);
      var $wrapper = $(this.selectors.productWrapper, this.$container);

      if ($meta.find('#shopify-product-reviews').length) {
        theme.variables.productPageSticky = false;
        return;
      }

      if (
        !$meta.length ||
        $(this.selectors.productMediaWrapper, this.$container).length < 2
      ) {
        return;
      }

      // Force detatch if already detached. Prevent layout issues.
      $meta.trigger('detach.ScrollToFixed');
      $('.product-single__media-group-wrapper').trigger('detach.ScrollToFixed');

      // Detach and stop if on mobile breakpoint
      if (theme.variables.bpSmall) {
        return;
      }

      var fixedHeaderHeight = self.nodes.$siteHeader.outerHeight();
      var productCopyHeight = $meta.outerHeight();
      var productMediaGroupHeight = $(
        this.selectors.productMediaGroup,
        this.$container
      ).height();

      /*============================================================================
        Calculate when to detach fixed element to avoid content overlap.
        Subtract product thumbs height and fixed header height from the limit because plugin uses offset().top
        .product-single__thumbnails.scroll-to-fixed-fixed = 105px in stylesheet
        .product-single__media-flex-wrapper margin-bottom = 15px in stylesheet
      ==============================================================================*/
      var calcLimit = $wrapper.offset().top + 50 + $wrapper.height();
      calcLimit -= productCopyHeight + 105 + 15;

      // Init sticky if desc shorter than images and fits in viewport
      /* if (
      productCopyHeight < productMediaGroupHeight ||
      productCopyHeight < $(window).height()
      ) 
      {        
       theme.variables.productPageSticky = true;
       if (preventScroll == null || preventScroll == undefined){
         // Autoscroll to fixed component
          $meta.scrollToFixed({
           marginTop: fixedHeaderHeight + 25,
           limit: calcLimit,
            zIndex: 2
        });
         }
       } else {
        theme.variables.productPageSticky = false;
         if (preventScroll == null || preventScroll == undefined){
          // Autoscroll to top
           $('html,body').animate({ scrollTop: 0 }, 'slow');
         }
       } */
      var mediaCalcLimit = $wrapper.offset().top + 50 + $wrapper.height();
      mediaCalcLimit -= $('.product-single__media-group-wrapper').outerHeight() + 60 + 15;
      if(document.querySelector('.product-single__meta').offsetHeight > document.querySelector('.product-single__media-group-wrapper').offsetHeight){
        $('.product-single__media-group-wrapper').scrollToFixed({
            marginTop: fixedHeaderHeight + 25,
            limit: mediaCalcLimit,
            zIndex: 2
        });
      }
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
      theme.ProductModel.removeSectionModels(this.settings.sectionId);
      theme.ProductVideo.removeSectionVideos(this.settings.sectionId);
      this.destroyMediaCarousel();
    },

    getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  });
  
  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl,
      on: 'click',
      touch: false
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();

window.theme = window.theme || {};

theme.Collection = (function() {
  function Collection(container) {
    var self = this;
    var $window = $(window);
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    
    this.settings = {
      namespace: '.collectionSection',
      sectionId: sectionId 
    };
    
    this.nodes = {
      $siteHeader: $('.site-header'),
      $announcementBar: $('.announcement-bar')
    };

    this.selectors = {
      collectionFeedWrapper: '.ss-results', // Selector without SS '.collection-feed',
      $collectionItemsContainer: $('.collection-grid__items__container'),
      $collectionItems: $('.collection-grid__items'),
      collectionProductItems: '.grid-product',
      collectionFirstProduct: ('.grid-item__index__1'),
      productGridImages: '.grid-uniform .grid-product__image-wrapper',
      productGridWrapper: '.grid-product__wrapper',
      productGridMeta: '.grid-product__meta',
      $collectionImage: $('.collection-hero__image'),
      $quickViewContainer: $('.quick-view__container'),
      $quickViewForm: $('.quick-view__form'),
      quickViewOptionsSlider: '.quick-view__options-slider',
      quickViewOptionsSliderItem: '.quick-view__options-slider__item',
      addToCart: '.btn--add-to-cart',
      addToWishlist: '.BIS_trigger',
      addToCartText: '.btn__text',
      originalSelectorId: '#ProductSelect',
      singleOptionSelector: '.single-option-selector__radio',
      quickViewContainer: '.quick-view__container',
      quickViewForm: '.quick-view__form',
      // $filtersContainer: $('.collection-filters__container'), // Selector without SS
      filtersContainer: '.collection-filters__container', 
      filterDropdowns: '.filter-dropdown',
      filterSelect: '.filter-dropdown__select',
      filterLabel: '.filter-dropdown__label',
      filtersButton: '.show-filters__button',
      filterGroupsButton: '#collectionFilters .Accordion-trigger',
      filterItem: '.coll-filter',
      applyFiltersButton: '#ApplyFilters',
      sortDropdown: '#sortBy',
      collectionMeta: '.collection-meta',
      collectionDescription: '.collection-description',
      filtersWrapper: '.ss-facets.collection-filters__container',
      filterAccordion: '#collectionFilters .Accordion',
      ssPagination: '.ss-pagination .ng-scope',
      filtercheckbox: '.ss-facet-options .checkbox', 
      topFiltercheckbox: '.collection-nav a', 
      clearFilters: '.ss-toolbar .clear-filters__button', 
    };
    
    this.gridType = $container.data('grid-type');

    this.selectors.$collectionImage.addClass('is-init');

    // Enable parallax effect if 3d transforms are supported
    if (!Modernizr.csstransforms3d) {
      return;
    }
    
    /*
    theme.cache.$window.on('scroll', function() {
      var scrolled = theme.cache.$window.scrollTop();
      theme.cache.$collectionImage.css({
        transform: 'translate3d(0, ' + scrolled / 4.5 + 'px, 0)'
      });
    });
    */
    
    $(document).ready(function() {
      console.log('test ss.shopmashburn.domReady')
        
      self.initSSCollection(self,sectionId); 

      // Show collection description after product grid has been loaded
      $(self.selectors.collectionMeta).show();
      self.initDescriptionCollapse();
      
    },self);
    
    $window.on('resize', function(){
      //theme.debounce(this.initStickyFilters, 150).bind(this);
      clearTimeout(window.resizedFinished);
      window.resizedFinished = setTimeout(function(){
        self.initFilters(self);
      },100);
    });
    
    this.init();
    
  }

  Collection.prototype = _.assignIn({}, Collection.prototype, {
    init: function() {
      var self = this;

      this.cacheSelectors();
      // this.setQueryParams();
      this.stringOverrides();
      this.initDescriptionCollapse();
      this.updateTopCollectionNav();

      /*
      this.cache.$sortDropdown.on('change', this.sortCollection.bind(this));
      this.cache.$filtersButton.on('click', this.openFilters.bind(this));

      this.cache.$applyFiltersButton.on('click', this.applyFilters.bind(this));

      $(document).on('accordion-item-updated', function() {
        self.initStickyFilters()
        });

      this.initIsotopeGrid();
      this.filterPersistence();
      */
    },
    
    cacheSelectors: function() {
      this.cache = {
        $html: $('html'),
        $window: $(window),
        $productGridWrapper: $(this.selectors.productGridWrapper),
        $collectionProductItems: $(this.selectors.collectionProductItems),
        $collectionFirstProduct: $(this.selectors.collectionFirstProduct),
        $productGridImages: $(this.selectors.productGridImages),
        $productGridMeta: $(this.selectors.productGridMeta),
        $filterDropdowns: $(this.selectors.filterDropdowns),
        $filterSelect: $(this.selectors.filterSelect),
        $filterLabel: $(this.selectors.filterLabel),
        $filtersButton: $(this.selectors.filtersButton),
        $filterGroupsButton: $(this.selectors.filterGroupsButton),
        $applyFiltersButton: $(this.selectors.applyFiltersButton),
        $sortDropdown: $(this.selectors.sortDropdown)
      };
    },

    waitForElement : function(selector, callback, self) {
      if (document.querySelector(selector) !== null) {
        callback();
      } else {
        setTimeout(function() {
          self.waitForElement(selector, callback, self);
        }, 100);
      }
    },

    initFilters : function(self) {
      self.waitForElement(self.selectors.filtersButton,function(){  
        $(self.selectors.filtersButton).on('click', function(){
          setTimeout(function(e){
            self.initStickyFilters();
            if($(self.selectors.filtersWrapper).hasClass('ss-display-block-filters')){
              $(self.selectors.filtersWrapper).addClass('activated');
            }else{
              $(self.selectors.filtersWrapper).removeClass('activated');
            }
          },200);
        });
      },self);

      self.waitForElement(self.selectors.filterGroupsButton,function(){
        /***** Adding aria-label to Filter titles *****/
        var collectionFilters = $('#collectionFilters .Accordion-trigger .Accordion-title');
        if(collectionFilters != null){
          collectionFilters.each(function(i){
            var filterTitle = collectionFilters[i].innerText.replace(/^\s+|\s+$/gm,'').toUpperCase().split('(');
            var filterButton = collectionFilters[i].closest(".Accordion-trigger");
              filterButton.setAttribute('aria-label', filterTitle[0]);
          });
        }
        /***** Adding aria-label to Filter titles *****/

        $(self.selectors.filterGroupsButton).on('click', function() {
          setTimeout(function(e){
            self.initStickyFilters();        
          },300);
        });
      },self);
    },

    appendGridBlock : function(self) {
      self.waitForElement(self.selectors.collectionProductItems,function(){  
        var gridBlockAll = $('.collection-grid-content .grid-item-block').clone(true);
        var gridCount = 0;
        //Removing blocks
        gridBlockAll.each(function(i){
          var blockID = gridBlockAll[i].id;
          if(gridBlockAll[i] && $(".collection-grid__items").find('#'+blockID).length > 0){
            $(".collection-grid__items").find('#'+blockID).remove();
          }
        });
        //Adding blocks
        gridBlockAll.each(function(i){
          var blockIDold = gridBlockAll[i].id;
          var blockIDnew = 'block-link-' + blockIDold + '-' + i;
          if(gridBlockAll[i]){
            $(gridBlockAll[i]).find('.block-link').attr('id',blockIDnew);
            var position = parseInt($(this).attr('data-order'));
            if(position == 1){
              if($(".collection-grid__items .grid-item__index__"+position).length == 0){
                $(".collection-grid__items .grid-product:last-child").before(gridBlockAll[i]);
              }else{
                $(".collection-grid__items .grid-item__index__"+position).before(gridBlockAll[i]);
              }
            }else{
              $(gridBlockAll[i]).find('.block-link').attr('id',blockIDnew);
              if(position > 1){
                position = position - 1;
                /*if(position > gridCount){
                  if(gridCount > 0){
                    position = position - gridCount;
                  }
                }*/
              }
              if($(".collection-grid__items .grid-item__index__"+position).length == 0){
                $(".collection-grid__items .grid-product:last-child").after(gridBlockAll[i]);
              }else{
                $(".collection-grid__items .grid-item__index__"+position).after(gridBlockAll[i]);
              }
              // Hide block when block position is greater than products  
                var grid_items = $('.collection-grid__items .grid-item:not(.grid-banner)').length;
                var block_position = position + 1;
                if(block_position > grid_items){
                  $('.collection-grid__items .grid-product.grid-banner[data-order='+block_position+']').hide();
                }
            }
            equalHeightBlock();
            function equalHeightBlock(){
              var gridHeight = $('.collection-grid__items .grid-item__index__'+position+' .grid-product__wrapper__inner').height();
              $('.collection-grid__items .grid-item-block')
                  .css('height', gridHeight);
            }
            theme.cache.$window.resize(function(evt) {
              afterResize(function() {
                equalHeightBlock();
              }, 250);
            });
            gridCount++;
          }
        });
      },self);

      if(window.location.href.indexOf('#block-link') > 0){
        self.waitForElement('.block-content-info',function(){
          var blockLink = window.location.hash;
          theme.scrollTo(blockLink, 150);
        });
      }

      self.waitForElement(self.selectors.filterGroupsButton,function(){
        $(self.selectors.filterGroupsButton).on('click', function() {
          setTimeout(function(e){
            self.initStickyFilters();        
          },300);
        });
      },self);
    },

    updateTopCollectionNav: function(self = this) {
      let lastUrl = location.href;
      new MutationObserver(() => {
        const url = location.href;
        if (url !== lastUrl) {
          lastUrl = url;
          self.updateTopCollectionNav()
        }
      }).observe(document, { subtree: true, childList: true });
  
      let productTypes = window.location.hash.replace("#", "");
      productTypes = productTypes.split('/filter:product_type');
      productTypes.shift() // removes first element which is an empty string
      if (productTypes.length > 1 || productTypes.length === 0) {
        $('.collection-nav a').removeClass('active');
        $('.collection-nav a:first').addClass('active');
      } else {
        $('.collection-nav a').each((i, el) => {
          const href = $(el).attr('href');
          if (href.includes(productTypes[0])) {
            $('.collection-nav a').removeClass('active');
            $(el).addClass('active');
          }
        })
      }
    },
      
    
    selectAvailableVariantOption: function(parentThis,self) {
      var allOptions = parentThis.find('.single-option-selector__radio.disabled:checked');
      // var inStocked = parentThis.find('.single-option-selector__radio:not(.disabled):first-of-type');
      
      // Ignore the cloned items to be checked
      var inStocked = parentThis.find('.quick-view__options-slider__item:not(.slick-cloned) .single-option-selector__radio:not(.disabled):first-of-type');
      
      if($(allOptions)){ 
        $(allOptions).prop('checked',false);
        if(inStocked[0]){
          $(inStocked[0]).prop('checked',true);
          setTimeout(function(e){
            $(inStocked[0]).trigger('change');
          },100);
        }
      }
    },
    
    initSSCollection: function(self,sectionId) {
      $(self.selectors.quickViewOptionsSlider).removeClass('slick-init');
      self.initStickyFilters();

      self.initProductVariant(sectionId); 

      self.initFilters(self);

      self.appendGridBlock(self);
    },
    
    /*
    openFilters: function(evt) {
      var self = this;
      
      if (!this.cache.$filtersButton.length) {
        return;
      }
      
      if(theme.cache.$window.width() > 768) {

        var currentlyExpanded = $(evt.target).attr('aria-expanded');
        
        if (currentlyExpanded == 'true'){
          // filters drawer is open
          this.selectors.$filtersContainer.hide();
          window.localStorage.setItem("filter_panel_state", "closed");
        
          self.selectors.$collectionItemsContainer.removeClass('large--three-quarters').addClass('large--one-whole');

          self.selectors.$collectionItems.isotope('layout');
          
          this.cache.$filtersButton.attr('aria-expanded', 'false');
          
        } else {
          // filters drawer is close
          this.selectors.$filtersContainer.show().removeClass('mfp-hide');
          window.localStorage.setItem("filter_panel_state", "open");
        
          self.selectors.$collectionItemsContainer.removeClass('large--one-whole').addClass('large--three-quarters');

          self.selectors.$collectionItems.isotope('layout'); 
          
          this.cache.$filtersButton.attr('aria-expanded', 'true');

          self.initStickyFilters();
        }

      } else {

        self.selectors.$filtersContainer.show();

        $.magnificPopup.open({
          mainClass: 'mfp-collection-filters',
          alignTop: true,
          showCloseBtn: false,
          fixedContentPos: true,
          items: {
            src: this.selectors.$filtersContainer,
            type: 'inline',
            callbacks: {
              open: function() {
                window.localStorage.setItem("filter_panel_state", "open");
              },
              close: function() {
                window.localStorage.setItem("filter_panel_state", "closed");
              }
            }
          }
        });

        $('#collection-filters__close-modal').on('click', function(e){
          e.preventDefault();
          $.magnificPopup.close();
        });

      }
    },

    filterPersistence: function(){
      var self = this;

      var filterPanelState = window.localStorage.getItem('filter_panel_state');

      if(filterPanelState == 'open' ){

        if(theme.cache.$window.width() > 768) {
          this.selectors.$filtersContainer.show();
          self.selectors.$collectionItemsContainer.removeClass('large--one-whole').addClass('large--three-quarters');
          self.selectors.$collectionItems.isotope('layout'); 
          this.cache.$filtersButton.attr('aria-expanded', 'true');
        }
      }
    },
    */

    initStickyFilters: function(preventScroll) {
      var self = this;
      var $filtersContainer = $(this.selectors.filtersContainer, this.$container);
      var $wrapper = $(this.selectors.collectionFeedWrapper, this.$container);
      if (
        !$filtersContainer.length || !$wrapper.length
      ) {
        return;
      }

      // Force detatch if already detached. Prevent layout issues.
      $filtersContainer.trigger('detach.ScrollToFixed');

      // Detach and stop if on mobile breakpoint
      if (theme.variables.bpSmall) {
        return;
      }

      var fixedHeaderHeight = self.nodes.$siteHeader.outerHeight();
      var filtersHeight = $filtersContainer.outerHeight();

      /*============================================================================
        Calculate when to detach fixed element to avoid content overlap.
        Subtract product thumbs height and fixed header height from the limit because plugin uses offset().top
        .product-single__thumbnails.scroll-to-fixed-fixed = 105px in stylesheet
        .product-single__media-flex-wrapper margin-bottom = 15px in stylesheet
      ==============================================================================*/
      var calcLimit = $wrapper.offset().top + 50 + $wrapper.height();
      calcLimit -= filtersHeight + 105 + 15;

      if($wrapper.height() > (filtersHeight + 105 + 15)){
        // Always init Sticky
		
        // Autoscroll to fixed component
        $filtersContainer.scrollToFixed({
          marginTop: fixedHeaderHeight + 25,
          limit: calcLimit,
          zIndex: 2
        });
      }
      
    },

    /*
    applyFilters: function(evt) {
      var self = this;

      var collection_handle = $(evt.target).data('collection-handle');

      var newTags = [];
      $(self.selectors.filterItem).each(function(){
        if($(this).is(':checked') && $(this).val() != ''){
          newTags.push($(this).val());
        }
      });      

      if (newTags.length) {
        var query = newTags.join('+');
        window.location.href = '/collections/' + collection_handle + '/' + query;
      }
      else {
        window.location.href = '/collections/' + collection_handle;
      }
    },
    */
    
    initProductVariant: function(sectionId) {
      var self = this;
      
      let handleQuery = "";
      $(self.selectors.quickViewContainer).each(function(){
        var excludeProductList = '7042295660730,6151525466298,6151560396986';
        var quickViewProductId = $(this).data('product-id');
        var quickViewProductURL = $(this).children('.quick-view__product-link').attr('href');
        var n = quickViewProductURL.lastIndexOf('/');
        var quickViewProductHandle = quickViewProductURL.substring(n + 1);
        
        if(excludeProductList.includes(quickViewProductId)){
          $('form#AddToCartForm--collection-template--product-' + quickViewProductId).remove();
          return;
        };
        
        handleQuery = handleQuery + "'"+quickViewProductHandle+"' OR ";
      });
      const endpoint = 'https://shopmashburn.myshopify.com/api/graphql';

        const query = `
        {
          products (first: 100, query: "${handleQuery}") {
            edges {
              node {
                id
                title
                handle
                description
                publishedAt
                createdAt
                vendor
                productType
                tags
                variants (first:50) {
                  edges {
                    node {
                      id
                      title
                      selectedOptions {
                        name
                        value
                      }
                      price {
                        amount
                        currencyCode
                      }
                      availableForSale
                      sku
                      id
                      image {
                        url
                      }
                      compareAtPrice {
                        amount
                      }
                      title
                    }
                  }
                }              
              }
            }
          }
        }
        `;

        fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '69dbe5e686f77b9abc7bb4167918d4be',
          },
          body: JSON.stringify({ query }),
          })
          .then(response => response.json())
          .then(data => {
            data.data.products.edges.forEach((element, index, array) => {
              const product = element.node;
              let newVariantsArray = []
              product.variants.edges.forEach((element, index, array) => {
                let processedId = element.node.id.replace('gid://shopify/ProductVariant/' , '')
                let newVariantObject = {
                  'available': element.node.availableForSale,
                  'sku': element.node.sku,
                  'id': parseInt(processedId),
                  'featured_image': element.node.image.url,
                  'price': parseInt(element.node.price.amount * 100),
                  'compare_at_price': parseInt(element.node.compareAtPrice.amount * 100),
                  'title': element.node.title,
                  'inventory_management': 'shopify'
                };
                element.node.selectedOptions.forEach((element, index, array) => {
                  var optionIndex = parseInt(index) + 1;
                  newVariantObject['option'+ optionIndex] = element.value;
                });
                newVariantsArray.push(newVariantObject);
              });
              product.variants = newVariantsArray;
              product.id = parseInt(product.id.replace('gid://shopify/Product/' , ''));
              var eId = 'ProductSelect--product-' + product.id + '--option-0';
              if(product.variants.length == 1){
                var VariantID = parseInt(product.variants[0].id);
                $('#AddToCartForm--collection-template--product-' + product.id + ' .quick-view__product__variants option:selected').val(VariantID)
              }
              var options = { 
                $container: $('#AddToCartForm--collection-template--product-' + product.id),
                enableHistoryState: false,
                singleOptionSelector: self.selectors.singleOptionSelector,
                originalSelectorId: self.selectors.originalSelectorId + '--' + self.settings.sectionId + '--product-' + product.id,
                product: product
              };
      
              self.variants = new slate.Variants(options);
              var slickSettings = {
                vertical: true,
                verticalSwiping: true,
                accessibility: true,
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 5,
                mobileFirst: false,
                prevArrow: '<button type="button" class="slick-prev icon-fallback-text" aria-label="Previous slide" tabindex="-1"><span class="icon icon-chevron-up" aria-hidden="true"></span><span class="fallback-text">Previous</span></button>',
                nextArrow: '<button type="button" class="slick-next icon-fallback-text" aria-label="Next slide" tabindex="-1"><span class="icon icon-chevron-down" aria-hidden="true"></span><span class="fallback-text">Next</span></button>',
                arrows: true
              };
  
              if($('#' + eId).hasClass('slick-initialized')){
                $('#' + eId).slick('unslick');
                $('#' + eId).removeClass('slick-init');
              }
      
              // On slick init for QV Options Slider calculate with of element
              $('#' + eId).on('init', function(event, slick){
                setTimeout(function(e){
                  slick.$nextArrow.attr('tabindex','-1');
                  slick.$prevArrow.attr('tabindex','-1');
                  var maxWidth = 0, $element;
                  slick.$slides.each(function(){
                    $element = $(this);
                    if($element.width() > maxWidth){
                      maxWidth = $element.width();
                    }
                  });
                  
                  slick.$slideTrack.width(maxWidth);
                  $('#' + eId).addClass('slick-init');
                },10);
              });
              
              $('#' + eId).slick(slickSettings);
  
              self.selectAvailableVariantOption($('#' + eId),self);
      
              $('#' + eId).mouseenter(function(){
                $(this).next().addClass('active');
              }).mouseleave(function(){
                $(this).next().removeClass('active');
              });
  
              $('#' + eId).closest('.quick-view__form').find('.BIS_trigger').removeAttr('data-product-data');
              $('#' + eId).closest('.quick-view__form').find('.BIS_trigger').attr('data-product-data', JSON.stringify(product)).data('product-data', JSON.stringify(product));
            })
          })
          .catch(error => {
            console.error('Error:', error);
          });
      
      //Collection Ajax Cart
      if (theme.settings.cartType === 'drawer') {
        $(self.selectors.quickViewForm).each(function(){
          var quickViewProductId = $(this).data('product-id');
          console.log('#AddToCartForm--' + sectionId + '--product-' + quickViewProductId);
          ajaxCart.init({
            formSelector: '#AddToCartForm--' + sectionId + '--product-' + quickViewProductId,
            cartContainer: '#CartContainer',
            addToCartSelector: '#AddToCart--' + sectionId + '--product-' + quickViewProductId,
            enableQtySelectors: false,
            moneyFormat: theme.strings.moneyFormat
          });
        });
      } 
      
      $(self.selectors.quickViewForm).on(
        'variantChange' + self.settings.namespace,
        self.productQuickView.bind(self)
      );

    },
    
    initDescriptionCollapse: function() {
      jQuery(this.selectors.collectionDescription).readmore({ 
        speed: 75, 
        moreLink: '<a href="#" class="rm__link">read more</a>',
        lessLink: '<a href="#" class="rm__link">read less</a>',
        collapsedHeight: 166
      });
    },

    /*
    updateFilterLabel: function(evt, element) {
      var $select = evt ? $(evt.target) : $(element);
      var $label = $select
        .prev('.filter-dropdown__label')
        .find('.filter-dropdown__label--active');
      var selectedVariant = $select.find('option:selected').text();

      $label.html(' ' + selectedVariant);
      this.cache.$filterDropdowns.addClass('loaded');
    },

    setQueryParams: function() {
      //don't execute if sort dropdown is not present.
      if (!this.cache.$sortDropdown.length) {
        return;
      }

      Shopify.queryParams = this.parseQueryString();
    },

    parseQueryString: function() {
      if (!location.search.length) {
        return {};
      }

      var params = {};

      for (
        var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&');
        i < aCouples.length;
        i++
      ) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          params[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(
            aKeyValue[1]
          );
        }
      }
      return params;
    },

    initIsotope: function() {
      var self = this;
      
      this.selectors.$collectionItems.isotope({
        percentPosition: true,
        itemSelector: '.grid-item',
        masonry: {
          columnWidth: '.grid-product'
        },
        getSortData: {
          category: '[data-order] parseInt'
        },
        sortBy : 'category'
      });
      
    },
    
    equalizeGridItems: function() {
      var self = this;
      
      if(theme.cache.$window.width() > 768) {
        self.selectors.$productGridMeta.css('height', 'auto').equalHeights();
      } else {
        self.selectors.$productGridMeta.css('height', 'auto');
      }
      self.selectors.$collectionItems.isotope('layout');

    },
    
    initIsotopeGrid: function() {
      var self = this;
      
      if (!this.cache.$collectionProductItems.length) {
        return;
      }
      
      this.selectors.$collectionItems.isotope({
        percentPosition: true,
        itemSelector: '.grid-item',
        masonry: {
          columnWidth: '.grid-product'
        },
        getSortData: {
          category: '[data-order] parseInt'
        },
        sortBy : 'category',
        layoutMode: 'fitRows'
      });

      this.isotopeGridHeights();

      theme.cache.$window.on(
        'resize',
        theme.debounce(this.isotopeGridHeights, 100).bind(self)
      );
    },

    isotopeGridHeights: function() {
      if (!this.cache.$collectionProductItems.length) {
        return;
      }
      
      if(theme.cache.$window.width() > 768) {
        this.cache.$productGridMeta.css('height', 'auto').equalHeights();
      } else {
        this.cache.$productGridMeta.css('height', 'auto');
      }
      
      this.selectors.$collectionItems.isotope('layout');
    },

    collectionSorting: function() {
      if (!this.cache.$tagList.length) {
        return;
      }

      this.cache.$tagList.on('change', function() {
        window.location.href = $(this).val();
      });
    },

    sortCollection: function() {
      if (!this.cache.$sortDropdown.length) {
        return;
      }

      if (Shopify.queryParams.page) {
        delete Shopify.queryParams.page;
      }
      Shopify.queryParams.sort_by = this.cache.$sortDropdown.val();
      location.search = decodeURIComponent(jQuery.param(Shopify.queryParams));
    },
    */
    
    stringOverrides: function() {
      // Override defaults in theme.strings with potential
      // template overrides

      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },
    
    productQuickView: function(evt) {
      $('.errors.qty-error').remove();
      var self = this;
      var moneyFormat = theme.strings.moneyFormat;
      var variant = evt.variant;
      var translations = theme.strings;
      var quickView = evt.target;
      
      if (variant) {
        // Display variant media on featured product
        if (!$('body').hasClass('template-product')) {
          if (variant.featured_media) {
            var variantMediaId =
              this.settings.sectionId + '-' + variant.featured_media.id;
            var $newMedia = $(
              this.selectors.productMediaWrapper +
                '[data-media-id="' +
                variantMediaId +
                '"]',
              this.$container
            );
            var $otherMedia = $(
              this.selectors.productMediaWrapper +
                ':not([data-media-id="' +
                variantMediaId +
                '"])',
              this.$container
            );

            $newMedia.removeClass(this.classes.hide);
            $otherMedia.addClass(this.classes.hide);
          }
        }

        /*
        $(this.selectors.priceContainer, this.$container).removeClass(
          'visibility-hidden ' + this.classes.priceContainerUnitAvailable
        );
        $(this.selectors.productPrice, this.$container).attr(
          'aria-hidden',
          'false'
        );
        $(this.selectors.priceA11y, this.$container).attr(
          'aria-hidden',
          'false'
        );
		*/

        // Select a valid variant if available
        if (variant.available) {
          // Available, enable the submit button, change text, show quantity elements
          $(quickView).find(this.selectors.addToCart, this.$container)
            .removeClass('disabled hidden')
            .prop('disabled', false);
          $(quickView).find(this.selectors.addToWishlist, this.$container)
            .addClass('hidden');
          $(quickView).find(this.selectors.addToCartText, this.$container).html(
            translations.addToCart
          );
          
          // $(this.selectors.quantityElements, this.$container).show();
          // $(this.selectors.shopifyPaymentButton, this.$container).show();
		  
        } else {
          // Sold out, disable the submit button, change text, hide quantity elements
          $(quickView).find(this.selectors.addToCart, this.$container)
            .addClass('disabled hidden')
            .prop('disabled', true);
          $(quickView).find(this.selectors.addToWishlist, this.$container)
            .data('variant-id', variant.id ) 
            .attr('data-variant-id', variant.id)
            .removeClass('hidden');
          	
          $(quickView).find(this.selectors.addToCartText, this.$container).html(
            translations.soldOut
          );
          
          // $(this.selectors.quantityElements, this.$container).hide();
          // $(this.selectors.shopifyPaymentButton, this.$container).hide();
        }

        /*
        $(this.selectors.productPrice, this.$container)
          .html(theme.Currency.formatMoney(variant.price, moneyFormat))
          .show();

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice, this.$container).html(
            theme.Currency.formatMoney(variant.compare_at_price, moneyFormat)
          );
          $(this.selectors.comparePriceWrapper, this.$container).removeClass(
            this.classes.hide
          );
          $(this.selectors.productPrice, this.$container).addClass('on-sale');
          $(this.selectors.comparePriceWrapper, this.$container).attr(
            'aria-hidden',
            'false'
          );
          $(this.selectors.comparePriceA11y, this.$container).attr(
            'aria-hidden',
            'false'
          );
        } else {
          $(this.selectors.comparePriceWrapper, this.$container)
            .addClass(this.classes.hide)
            .attr('aria-hidden', 'true');
          $(this.selectors.productPrice, this.$container).removeClass(
            'on-sale'
          );
          $(this.selectors.comparePrice, this.$container).html('');
          $(this.selectors.comparePriceA11y, this.$container).attr(
            'aria-hidden',
            'true'
          );
        }

        if (variant.unit_price) {
          var $unitPrice = $(this.selectors.unitPrice, this.$container);
          var $unitPriceBaseUnit = $(
            this.selectors.unitPriceBaseUnit,
            this.$container
          );

          $unitPrice.html(
            theme.Currency.formatMoney(variant.unit_price, moneyFormat)
          );
          $unitPriceBaseUnit.html(this.getBaseUnit(variant));

          $(this.selectors.priceContainer, this.$container).addClass(
            this.classes.priceContainerUnitAvailable
          );
        }

        // Also Show SKU
        $(this.selectors.SKU).html(variant.sku);
        
      */
      } else {
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        // To only show available variants, implement linked product options:
        //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
        $(this.selectors.addToCart, this.$container)
          .addClass('disabled')
          .prop('disabled', true);
        $(this.selectors.addToCartText, this.$container).html(
          translations.unavailable
        );
        // $(this.selectors.quantityElements, this.$container).hide();
        // $(this.selectors.shopifyPaymentButton, this.$container).hide();

        $(this.selectors.priceContainer, this.$container).addClass(
          'visibility-hidden'
        );
        $(this.selectors.productPrice, this.$container).attr(
          'aria-hidden',
          'true'
        );
        $(this.selectors.priceA11y, this.$container).attr(
          'aria-hidden',
          'true'
        );
        $(this.selectors.comparePriceWrapper, this.$container).attr(
          'aria-hidden',
          'true'
        );
        $(this.selectors.comparePriceA11y, this.$container).attr(
          'aria-hidden',
          'true'
        );
       
      }
    }
    
  });

  return Collection;
})();

window.theme = window.theme || {};

theme.BlogLanding = (function() {
  function BlogLanding(container) {
    var $window = $(window);
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var blogLatestMany = ('.blog-latest-many');
    
    this.$blogLatestMany = $(blogLatestMany);
    
    this.init();
  }

  BlogLanding.prototype = _.assignIn({}, BlogLanding.prototype, {
    init: function() {
      this.createSlider();
    },
    
    createSlider: function() {
      var self = this;
      this.$blogLatestMany.each(function(){
        
        var gridItems = $(this).data('grid-items');
        var tabletGridItems, mobileGridItems;
        
        switch(gridItems){
          case 2: tabletGridItems = 2; mobileGridItems = 1;
            break;
          case 3: tabletGridItems = 3; mobileGridItems = 1;
            break;
          case 4: tabletGridItems = 2; mobileGridItems = 1;
            break;
          default: tabletGridItems = 1; mobileGridItems = 1;
        }
        
        var slickSettings = {
          accessibility: false,
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          adaptiveHeight: true,
          mobileFirst: false,
          arrows: false,
          responsive: [
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false
              }
            },
            {
              breakpoint: 590,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        };
        
        $(this).slick(slickSettings);
        
      });
      
    }
    
  });

  return BlogLanding;
  
})();

window.theme = window.theme || {};

theme.Article = (function() {
  function Article(container) {
    var $window = $(window);
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    
    this.selectors = {
      $articleContent: $('.single-article__content'),
      $latestArticles: $('.single-article__latest-articles')
    }
    
    var self = this;
    
    this.slickSettings = {
      accessibility: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      adaptiveHeight: true,
      mobileFirst: false,
      prevArrow: '<button type="button" class="slick-prev icon-fallback-text" aria-label="Previous slide"><span class="icon icon-slide-prev-btn" aria-hidden="true"></span><span class="fallback-text">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next icon-fallback-text" aria-label="Next slide"><span class="icon icon-slide-next-btn" aria-hidden="true"></span><span class="fallback-text">Next</span></button>',
      arrows: true,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false
          }
        },
        {
          breakpoint: 590,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: true
          }
        }
      ]
    };
    
    this.init();
  }

  Article.prototype = _.assignIn({}, Article.prototype, {
    init: function() {
      // this.addCaptions();
      this.createSlider();
    },
    
    addCaptions: function() {
      
      this.selectors.$articleContent.find("img").each(function( index ) {
        var alt = $(this).attr('alt');
        var src = $(this).attr('src');
        $(this).wrap("<figure />");
        $(this).parent().append("<figcaption>"+alt+"</figcaption>");
      }); 
    },
    
    createSlider: function() {  
      this.selectors.$latestArticles.slick(this.slickSettings);  
    }
    
  });

  return Article;
  
})();

window.theme = window.theme || {};

theme.Press = (function() {
  function Press(container) {
    var $window = $(window);
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var blogHandle = $container.attr('data-section-blog-handle');
    var publicationsSlider = '#PublicationsSlider-' + sectionId;
    
    this.$publicationsSlider = $(publicationsSlider);
    
    this.settings = {
      namespace: '.pressSection',
      sectionId: sectionId,
      blogHandle: blogHandle
    };
    
    this.selectors = {
      productGridImages: '.press-feed__article__featured-image-wrapper',
      filterDropdowns: '.filter-dropdown',
      filterSelect: '.filter-dropdown__select',
      filterLabel: '.filter-dropdown__label',
      logos: "[data-open-intro]"
    };
 
    this.slickSettings = {
      accessibility: false,
      infinite: false,
      adaptiveHeight: true,
      slidesToShow: 6,
      arrows: false,
  	  slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    };
    
    this.init();
  }

  Press.prototype = _.assignIn({}, Press.prototype, {
    init: function() {
      this.cacheSelectors();
      this.setQueryParams();
      this.createSlider();
      this.initAjaxinate();
      this.setLogoIntros();
      
      this.cache.$filterSelect.on('change', this.sortCollection.bind(this));

      theme.equalHeights.call(this);
      
    },
    setLogoIntros: function(){
      this.cache.$logos.on('click',function(e){
        e.preventDefault();
        const id = $(this).attr('data-open-intro');
        $(`[data-intro=${id}]`).siblings().hide();
        $(`[data-intro=${id}]`).show();
      })
    },
    updateFilterLabel: function(evt, element) {
      var $select = evt ? $(evt.target) : $(element);
      var $label = $select
        .prev('.filter-dropdown__label')
        .find('.filter-dropdown__label--active');
      var selectedVariant = $select.find('option:selected').text();

      $label.html(' ' + selectedVariant);
      this.cache.$filterDropdowns.addClass('loaded');
    },

    cacheSelectors: function() {
      this.cache = {
        $html: $('html'),
        $window: $(window),
        $productGridImages: $(this.selectors.productGridImages),
        $filterDropdowns: $(this.selectors.filterDropdowns),
        $filterSelect: $(this.selectors.filterSelect),
        $filterLabel: $(this.selectors.filterLabel),
        $logos: $(this.selectors.logos)
      };
    },

    setQueryParams: function() {
      //don't execute if sort dropdown is not present.
      if (!this.cache.$filterDropdowns.length) {
        return;
      }

      Shopify.queryParams = this.parseQueryString();
    },

    parseQueryString: function() {
      if (!location.search.length) {
        return {};
      }

      var params = {};

      for (
        var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&');
        i < aCouples.length;
        i++
      ) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          params[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(
            aKeyValue[1]
          );
        }
      }
      return params;
    },

    collectionSorting: function() {
      if (!this.cache.$tagList.length) {
        return;
      }

      this.cache.$tagList.on('change', function() {
        window.location.href = $(this).val();
      });
    },

    sortCollection: function() {
      if (!this.cache.$filterSelect.length) {
        return;
      }

      if (Shopify.queryParams.page) {
        delete Shopify.queryParams.page;
      }
      
      var newTags = [];
  	  var newURL = '';
      
      this.cache.$filterSelect.each(function(){
        if ($(this).val()) {
          newTags.push(jQuery(this).val());
        }
      });
      
      if(this.settings.blogHandle){
        newURL = '/blogs/' + this.settings.blogHandle;
        if (newTags.length) {
          newURL += '/tagged/' + newTags.join('+');
        }
        var search = jQuery.param(Shopify.queryParams);
        if (search.length) {
          newURL += '?' + search;
        }
        location.href = newURL;
      } else {
        if (newTags.length) {
          Shopify.queryParams.constraint = newTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }
        location.search = decodeURIComponent(jQuery.param(Shopify.queryParams));
      }
      
    },
    
    createSlider: function() {
      this.$publicationsSlider.slick(this.slickSettings);
    },
    
    initAjaxinate: function(){
      /*
      $(window).load(function(){
        document.addEventListener("DOMContentLoaded", function() {
            var endlessScroll = new Ajaxinate({
              container: '#AjaxinateContainer',
              pagination: '#AjaxinatePagination',
              method: 'click', // scroll
              offset: 1000,
              loadingText: 'Loading...'
              // , callback:
            });
          });
      });
      */
    }
    
  });

  return Press;
  
})();

window.theme = window.theme || {};

theme.VisitArticle = (function() {
  
  function VisitArticle(container) {
    var $window = $(window);
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var visitSlider = '#VisitSlider';
    
    this.$visitSlider = $(visitSlider);

    var visitSliderSection = '#VisitSlider-'+sectionId;	
    	
    this.$visitSliderSection = $(visitSliderSection);
    
    this.selectors = {
      visitNav: '.single-visit__nav',
      visitNavItem: '.single-visit__nav li'
    }
    
    this.nodes = {
      $siteHeader: $('.site-header'),
      $announcementBar: $('.announcement-bar')
    };
    
    this.slickSettings = {
      accessibility: true,
      infinite: false,
      adaptiveHeight: true,
      slidesToShow: 1,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev icon-fallback-text" aria-label="Previous slide"><span class="icon icon-slide-prev-arrow-btn" aria-hidden="true"></span><span class="fallback-text">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next icon-fallback-text" aria-label="Next slide"><span class="icon icon-slide-next-arrow-btn" aria-hidden="true"></span><span class="fallback-text">Next</span></button>',
      dots: true,
  	  slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 520,
          settings: {
            arrows: false
          }
        }
      ]
    };
    
    this.init();
  }
  
  VisitArticle.prototype = _.assignIn({}, VisitArticle.prototype, {
    init: function() {
      this.createSlider();
      this.initNav();
    },
    
    createSlider: function() {
	    if(this.$visitSlider != null){	
        this.$visitSlider.not('.slick-initialized').slick(this.slickSettings);	
      }	
      if(this.$visitSliderSection != null){	
        this.$visitSliderSection.not('.slick-initialized').slick(this.slickSettings);	
      }
    },
    
    initNav: function() {
    
        var self = this;
      
        var navChildren = $(this.selectors.visitNavItem).children();
        var aArray = [];
      
        for (var i = 0; i < navChildren.length; i++) {
          var aChild = navChildren[i];
          var ahref = $(aChild).attr('href');
          aArray.push(ahref);
        }
      
        $(window).scroll(function() {
          var windowPos = $(window).scrollTop();
          var windowHeight = $(window).height();
          var docHeight = $(document).height();
          
          var fixedHeaderHeight = self.nodes.$siteHeader.outerHeight();
          
          for (var i = 0; i < aArray.length; i++) {
            
            var theID = aArray[i];
            var secPosition = $(theID).offset().top;

            secPosition = secPosition - fixedHeaderHeight - 10;
            
            var divHeight = $(theID).height();
            divHeight = divHeight;
            
            if (windowPos >= secPosition && windowPos < (secPosition + divHeight)) {
              $("a[href='" + theID + "']").addClass("active");
            } else {
              $("a[href='" + theID + "']").removeClass("active");
            }
          }
        });

    }
  });
  
  return VisitArticle;
  
})();

window.theme = window.theme || {};

theme.FeaturedCollection = (function() {
  
  function FeaturedCollection(container) {
    var $window = $(window);
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var threeProductsSlider = '.three-products-slider__container';
    
    this.selectors = {
      singleProduct_productWrapper: '.featured-collection__single-product__container .product--wrapper'
    }
    
    this.$threeProductsSlider = $(threeProductsSlider);
    
    this.slickSettings = {
      accessibility: true,
      infinite: false,
      adaptiveHeight: true,
      slidesToShow: 3,
      arrows: false,
  	  slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        }
      ]
    };
   
    this.init();
  }
  
  FeaturedCollection.prototype = _.assignIn({}, FeaturedCollection.prototype, {
    init: function() {
      this.equalizeSingleProductGrid();
      this.createThreeProductsSlider();
    },
    
    equalizeSingleProductGrid: function() {
      var self = this;
      theme.cache.$window.load(function() {
        if(theme.cache.$window.width() > 768) {
          $(self.selectors.singleProduct_productWrapper)
            .css('height', 'auto')
            .equalHeights()
        } else {
          $(self.selectors.singleProduct_productWrapper)
            .css('height', 'auto');
        }
      });

      theme.cache.$window.resize(function(evt) {
        if(theme.cache.$window.width() > 768) {
          afterResize(function() {
            $(self.selectors.singleProduct_productWrapper)
              .css('height', 'auto')
              .equalHeights()
          }, 250);
        } else {
          $(self.selectors.singleProduct_productWrapper)
            .css('height', 'auto');
        }
      });
    },
    
    createThreeProductsSlider: function() {
      this.$threeProductsSlider.slick(this.slickSettings);
    }
  
  });
  
  return FeaturedCollection;
                          
})();

window.theme = window.theme || {};

theme.Appointments = (function() {
  
  function Appointments(container) {
    var $container = $(container);
    var sectionId = $container.attr('data-section-id');
    var tabsContainer = '#tabsContainer-' + sectionId;
    var tabsContentContainer = '#tabsContentContainer-' + sectionId;
    
    this.$tabsContainer = $(tabsContainer);
    this.$tabsContentContainer = $(tabsContentContainer);
    
    this.nodes = {
      $siteHeader: $('.site-header'),
      $announcementBar: $('.announcement-bar')
    };
    
    this.slickSettings = {
      accessibility: false,
      infinite: false,
      cssEase: 'linear',
      adaptiveHeight: false,
      draggable: false,
      slidesToShow: 3,
      arrows: false,
      slidesToScroll: 1,
      speed: 250,
      focusOnSelect: false,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            fade: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            fade: true
          }
        }
      ]
    };

    this.init();
  }
  
  Appointments.prototype = _.assignIn({}, Appointments.prototype, {
    init: function() {
      $('.appointments-form select').on('change', function(){
        $(this).parent('.appointments-form').children('input[type="button"]').prop('disabled', false);
      });
      this.createTabs();
    },

    createTabs: function() {
      var self = this;
      this.$tabsContentContainer.slick(this.slickSettings);
      this.$tabsContentContainer.on('afterChange', function(slick, currentSlide){
        const index = self.$tabsContentContainer.slick('slickCurrentSlide');
        self.$tabsContainer.find('button').removeClass('active');
        self.$tabsContainer.find(`button[data-toggle=${index}]`).addClass('active');

      });
      
      this.$tabsContainer.find('button').click(function(){
        self.$tabsContainer.find('button').removeClass('active');
        $(this).addClass('active');
        
        var slideIndex = parseInt($(this).attr('data-toggle'));
        self.$tabsContentContainer.slick('slickGoTo', slideIndex);
      });
    }
    
  });
  
  return Appointments;
  
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  var classes = {
    headerWrapperTransparent: 'header-wrapper--transparent'
  };

  function Header(container) {
    timber.drawersInit();
    theme.initCache();
    theme.fitNav();
    theme.resizeLogo();
    theme.searchModal();
    theme.stickyHeader.init();
    theme.visitMegamenuSlider.init();

    var $container = (this.$container = $(container));
    this.template = $container.attr('data-template');
    this.$headerWrapper = theme.cache.$siteHeader.closest(
      '[data-header-wrapper]'
    );

    // ajaxCart.init will run from Product.prototype when on the product page
    if (
      theme.settings.cartType === 'drawer' &&
      this.template.indexOf('product') === -1
    ) {
      ajaxCart.init({
        formSelector: '.add-to-cart__form',
        cartContainer: '#CartContainer',
        addToCartSelector: '.add-to-cart',
        enableQtySelectors: true,
        moneyFormat: theme.strings.moneyFormat
      });
    }

    theme.cache.$window.on('load', theme.resizeLogo);
    theme.cache.$window.on('resize', theme.debounce(theme.resizeLogo, 150));

    this.initSideBarDropDowns();
    this.updateHeaderTransparency();

    // Reorder & load events for all section
    // Only trigger when sections list contain slideshow
    $(document).on(
      'shopify:section:reorder shopify:section:load',
      this.updateHeaderTransparency.bind(this)
    );

    // setTimeout is added since we want to see the newest DOM structure
    // unLoad is triggered before the removal of the DOM
    $(document).on(
      'shopify:section:unload',
      function() {
        setTimeout(this.updateHeaderTransparency.bind(this));
      }.bind(this)
    );
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onSelect: function() {
      this.handleDrawerOpenInEditor(event);
    },

    onDeselect: function() {
      timber.LeftDrawer.close(event);
    },

    handleDrawerOpenInEditor: function(event) {
      if (
        theme.cache.$siteNav.hasClass('site-nav--compress') ||
        theme.variables.bpSmall
      ) {
        setTimeout(function() {
          timber.LeftDrawer.drawerIsOpen = false;
          timber.LeftDrawer.open();
        }, 500);
      } else if (!theme.cache.$siteNav.hasClass('site-nav--compress')) {
        timber.LeftDrawer.drawerIsOpen = true;
        timber.LeftDrawer.close(event);
      }
    },

    initSideBarDropDowns: function() {
      var $toggleBtns = $('.mobile-nav__toggle-btn');
      // Setup aria attributes
      $toggleBtns.attr('aria-expanded', 'false');

      $toggleBtns.each(function() {
        var $button = $(this);
        $button.attr('aria-controls', $button.attr('data-aria-controls'));
      });

      $toggleBtns.on('click', function(event) {
        event.preventDefault();
        var $button = $(this);
        var currentlyExpanded = $button.attr('aria-expanded');
        var toggleState = false;
        // Updated aria-expanded value based on state pre-click
        if (currentlyExpanded === 'true') {
          $button.attr('aria-expanded', 'false');
        } else {
          $button.attr('aria-expanded', 'true');
          toggleState = true;
        }

        // Toggle that expands/collapses sublist
        $button
          .closest('.mobile-nav__has-sublist')
          .toggleClass('mobile-nav--expanded', toggleState)
          .next()
          .slideToggle();
      });
    },

    /**
     * Check whether the first section is slideshow
     * and enable transparency setting (header) is enabled
     */
    updateHeaderTransparency: function() {
      var $sectionsWrapper = theme.cache.$body.find('[data-sections-wrapper]');
      var $firstSection = $sectionsWrapper.find('[data-section-type]').first();

      this.$headerWrapper.removeClass(classes.headerWrapperTransparent);

      if (
        $firstSection.data('section-type') === 'slideshow-section' &&
        theme.cache.$siteHeader.data('transparent-header') === true
      ) {
        this.$headerWrapper.addClass(classes.headerWrapperTransparent);
      }
    }
  });

  return Header;
})();

window.theme = window.theme || {};

theme.stickyHeader = (function() {
  var selectors = {
    searchCartWrapper: '#SiteNavSearchCart',
    stickyNavSearchCart: '#StickyNavSearchCart',
    stickyNavWrapper: '#StickNavWrapper',
    stickyBar: '#StickyBar'
  };

  var config = {
    lastScroll: 0,
    navClass: 'sticky--active',
    openTransitionClass: 'sticky--open',
    closeTransitionClass: 'sticky--close'
  };

  var cache = {};

  function cacheSelectors() {
    cache = {
      $window: $(window),
      $siteNavSearchCart: $(selectors.searchCartWrapper),
      $stickyBar: $(selectors.stickyBar)
    };
  }

  function init() {
    cacheSelectors();
    config.isActive = false;

    // Clone search/cart icons into fixed nav
    if (cache.$siteNavSearchCart.contents().length) {
      cache.$siteNavSearchCart
        .contents()
        .clone()
        .appendTo($(selectors.stickyNavSearchCart));
    }

    cache.$window.on('scroll.stickynav', $.throttle(15, stickyHeaderOnScroll));

    if($('.index-sections > .index-slideshow-section:first-child').length > 0){
      $('body').addClass('has-slideshow');
    }else{
      $('body').removeClass('has-slideshow');
    }
    
  }

  function stickyHeaderOnScroll() {
    if(document.querySelector('.has-sticky-announcement')) {
      if (typeof $window !== 'undefined') {
        var scroll = $window.scrollTop();
      }
    } else {
      var scroll = cache.$window.scrollTop();
    }
    var $el = $(selectors.stickyNavWrapper);
    var threshold = $el.offset().top; // + $el.height() + 10; // default for scrolling down

    // Check if scrolling up
    if (scroll < config.lastScroll) {
      threshold = $el.offset().top;
    }

    if (scroll > threshold) {
      stickNav();
    } else {
      unstickNav();
    }

    config.lastScroll = scroll;
  }

  function stickNav() {
    if (config.isActive) {
      return;
    }

    config.isActive = true;

    cache.$stickyBar.addClass(config.navClass);

    // Add open transition class after element is set to fixed
    // so CSS animation is applied correctly
    /*
    setTimeout(function() {
      cache.$stickyBar.addClass(config.openTransitionClass);
    }, 0);
    */

    cache.$stickyBar.addClass(config.openTransitionClass);

    // Prevent page container to be wonky
    var fixedHeaderHeight = $('.site-header').outerHeight();

    if($(window).width() >= 1180){
      if($('.site-header').attr('data-transparent-header') == 'true'){
        $('body:not(#sid-mashburn):not(#ann-mashburn) #PageContainer').css('padding-top',fixedHeaderHeight);
      }else{
        $('body #PageContainer').css('padding-top',fixedHeaderHeight);
      }
    }else{
      $('body #PageContainer').css('padding-top',fixedHeaderHeight);
    }
  }

  function unstickNav() {
    if (!config.isActive) {
      return;
    }

    cache.$stickyBar
      .removeClass(config.openTransitionClass)
      .removeClass(config.navClass);

    if($(window).width() >= 1180){
      if($('.site-header').attr('data-transparent-header') == 'true'){
        $('body:not(#sid-mashburn):not(#ann-mashburn) #PageContainer').css('padding-top',0);
      }else{
        $('body #PageContainer').css('padding-top',0);
      }
    }else{
      $('body #PageContainer').css('padding-top',0);
    }

    config.isActive = false;
  }

  function unload() {
    $(window).off('.stickynav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.visitMegamenuSlider = (function() {
  
  var selectors = {
    visitMegaMenuSlider: '#visit__megamenu__slider',
    visitMegaMenuSliderIcons: '.icons #visit__megamenu__slider'
  };

  var slickSettings = {
      accessibility: true,
      infinite: false,
      adaptiveHeight: true,
      slidesToShow: 6,
      arrows: true,
  	  slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev icon-fallback-text" aria-label="Previous slide"><span class="icon icon-chevron-left" aria-hidden="true"></span><span class="fallback-text">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next icon-fallback-text" aria-label="Next slide"><span class="icon icon-chevron-right" aria-hidden="true"></span><span class="fallback-text">Next</span></button>',
      autoplay: false, 
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        }
      ]
    };

  var showIcons = $(selectors.visitMegaMenuSliderIcons).length > 0;

  if (showIcons) {
    slickSettings = {...slickSettings, ...{ slidesToShow: 8 }}
  }
  
  function init() {

    $(selectors.visitMegaMenuSlider).slick(slickSettings);
    
  }

  return {
    init: init
  };
})();

window.theme = window.theme || {};

theme.VisitPopUp = (function() {
  function VisitPopUp(container) {
    
    var $window = $(window);
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    
    this.selectors = {
      container: container,
      popUp: 'visit-page__pop-up',
      closeDialog: 'visit-page__pop-up__close-dialog',
      $mobileSign: $('#visit-page__mobile-cta')
    };
   
    this.init();
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  };
  
  VisitPopUp.prototype = _.assignIn({}, VisitPopUp.prototype, {
    init: function() {
      var self = this;

      var showedVisitPopUp = readCookie('showedVisitPopUp');
      
      if($(self.selectors.container).data('enable-pop-up') && !showedVisitPopUp){

        // var days = 7; //number of days until the pop-up is shown again
        var date = new Date();
        date.setTime(date.getTime()+(1000));
        var expires = "; expires="+date.toGMTString();
        document.cookie = 'showedVisitPopUp=true;'+expires+"; path=/";
      
        /*
        *   This content is licensed according to the W3C Software License at
        *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
        */

        var aria = aria || {};

        aria.KeyCode = {
            BACKSPACE: 8,
            TAB: 9,
            RETURN: 13,
            ESC: 27,
            SPACE: 32,
            PAGE_UP: 33,
            PAGE_DOWN: 34,
            END: 35,
            HOME: 36,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            DELETE: 46
          };

        aria.Utils = aria.Utils || {};

        var openDialog;

        (function () {
          /*
             * When util functions move focus around, set this true so the focus listener
             * can ignore the events.
             */
          aria.Utils.IgnoreUtilFocusChanges = false;

          aria.Utils.dialogOpenClass = 'has-dialog';

          /**
             * @desc Set focus on descendant nodes until the first focusable element is found.
             * @param element
             *          DOM node for which to find the first focusable descendant.
             * @returns
             *  true if a focusable element is found and focus is set.
             */
          aria.Utils.focusFirstDescendant = function (element) {
            for (var i = 0; i < element.childNodes.length; i++) {
              var child = element.childNodes[i];
              if (aria.Utils.attemptFocus(child) ||
                  aria.Utils.focusFirstDescendant(child)) {
                return true;
              }
            }
            return false;
          }; // end focusFirstDescendant

          /**
             * @desc Find the last descendant node that is focusable.
             * @param element
             *          DOM node for which to find the last focusable descendant.
             * @returns
             *  true if a focusable element is found and focus is set.
             */
          aria.Utils.focusLastDescendant = function (element) {
            for (var i = element.childNodes.length - 1; i >= 0; i--) {
              var child = element.childNodes[i];
              if (aria.Utils.attemptFocus(child) ||
                  aria.Utils.focusLastDescendant(child)) {
                return true;
              }
            }
            return false;
          }; // end focusLastDescendant

          /**
             * @desc Set Attempt to set focus on the current node.
             * @param element
             *          The node to attempt to focus on.
             * @returns
             *  true if element is focused.
             */
          aria.Utils.attemptFocus = function (element) {
            if (!aria.Utils.isFocusable(element)) {
              return false;
            }

            aria.Utils.IgnoreUtilFocusChanges = true;
            try {
              element.focus();
            }
            catch (e) {
            }
            aria.Utils.IgnoreUtilFocusChanges = false;
            return (document.activeElement === element);
          }; // end attemptFocus

          /* Modals can open modals. Keep track of them with this array. */
          aria.OpenDialogList = aria.OpenDialogList || new Array(0);

          /**
             * @returns the last opened dialog (the current dialog)
             */
          aria.getCurrentDialog = function () {
            if (aria.OpenDialogList && aria.OpenDialogList.length) {
              return aria.OpenDialogList[aria.OpenDialogList.length - 1];
            }
          };

          aria.closeCurrentDialog = function () {
            var currentDialog = aria.getCurrentDialog();
            if (currentDialog) {
              currentDialog.close();
              return true;
            }

            return false;
          };

          aria.handleEscape = function (event) {
            var key = event.which || event.keyCode;

            if (key === aria.KeyCode.ESC && aria.closeCurrentDialog()) {
              event.stopPropagation();
            }
          };

          // Polyfill src https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
          aria.Utils.matches = function (element, selector) {
            if (!Element.prototype.matches) {
              Element.prototype.matches =
                Element.prototype.matchesSelector
                || Element.prototype.mozMatchesSelector
                || Element.prototype.msMatchesSelector
                || Element.prototype.oMatchesSelector
                || Element.prototype.webkitMatchesSelector
                || function (s) {
                    var matches = element.parentNode.querySelectorAll(s);
                    var i = matches.length;
                    while (--i >= 0 && matches.item(i) !== this) {}
                    return i > -1;
                  };
            }

            return element.matches(selector);
          };

          aria.Utils.remove = function (item) {
            if (item.remove && typeof item.remove === 'function') {
              return item.remove();
            }
            if (item.parentNode
                && item.parentNode.removeChild
                && typeof item.parentNode.removeChild === 'function') {
              return item.parentNode.removeChild(item);
            }
            return false;
          };

          aria.Utils.isFocusable = function (element) {
            if (element.tabIndex > 0 || (element.tabIndex === 0 && element.getAttribute('tabIndex') !== null)) {
              return true;
            }

            if (element.disabled) {
              return false;
            }

            switch (element.nodeName) {
              case 'A':
                return !!element.href && element.rel != 'ignore';
              case 'INPUT':
                return element.type != 'hidden' && element.type != 'file';
              case 'BUTTON':
              case 'SELECT':
              case 'TEXTAREA':
                return true;
              default:
                return false;
            }
          };

          aria.Utils.getAncestorBySelector = function (element, selector) {
            if (!aria.Utils.matches(element, selector + ' ' + element.tagName)) {
              // Element is not inside an element that matches selector
              return null;
            }

            // Move up the DOM tree until a parent matching the selector is found
            var currentNode = element;
            var ancestor = null;
            while (ancestor === null) {
              if (aria.Utils.matches(currentNode.parentNode, selector)) {
                ancestor = currentNode.parentNode;
              }
              else {
                currentNode = currentNode.parentNode;
              }
            }

            return ancestor;
          };

          aria.Utils.hasClass = function (element, className) {
            return (new RegExp('(\\s|^)' + className + '(\\s|$)')).test(element.className);
          };

          aria.Utils.addClass = function (element, className) {
            if (!aria.Utils.hasClass(element, className)) {
              element.className += ' ' + className;
            }
          };

          aria.Utils.removeClass = function (element, className) {
            var classRegex = new RegExp('(\\s|^)' + className + '(\\s|$)');
            element.className = element.className.replace(classRegex, ' ').trim();
          };

          document.addEventListener('keyup', aria.handleEscape);

          /**
             * @constructor
             * @desc Dialog object providing modal focus management.
             *
             * Assumptions: The element serving as the dialog container is present in the
             * DOM and hidden. The dialog container has role='dialog'.
             *
             * @param dialogId
             *          The ID of the element serving as the dialog container.
             * @param focusAfterClosed
             *          Either the DOM node or the ID of the DOM node to focus when the
             *          dialog closes.
             * @param focusFirst
             *          Optional parameter containing either the DOM node or the ID of the
             *          DOM node to focus when the dialog opens. If not specified, the
             *          first focusable element in the dialog will receive focus.
             */
          aria.Dialog = function (dialogId, focusAfterClosed, focusFirst) {
            this.dialogNode = document.getElementById(dialogId);
            if (this.dialogNode === null) {
              throw new Error('No element found with id="' + dialogId + '".');
            }

            var validRoles = ['dialog', 'alertdialog'];
            var isDialog = (this.dialogNode.getAttribute('role') || '')
            .trim()
            .split(/\s+/g)
            .some(function (token) {
              return validRoles.some(function (role) {
                return token === role;
              });
            });
            if (!isDialog) {
              throw new Error(
                'Dialog() requires a DOM element with ARIA role of dialog or alertdialog.');
            }

            // Wrap in an individual backdrop element if one doesn't exist
            // Native <dialog> elements use the ::backdrop pseudo-element, which
            // works similarly.
            var backdropClass = 'dialog-backdrop';
            if (this.dialogNode.parentNode.classList.contains(backdropClass)) {
              this.backdropNode = this.dialogNode.parentNode;
            }
            else {
              this.backdropNode = document.createElement('div');
              this.backdropNode.className = backdropClass;
              this.dialogNode.parentNode.insertBefore(this.backdropNode, this.dialogNode);
              this.backdropNode.appendChild(this.dialogNode);
            }
            this.backdropNode.classList.add('active');

            // Disable scroll on the body element
            // document.body.classList.add(aria.Utils.dialogOpenClass);

            if (typeof focusAfterClosed === 'string') {
              this.focusAfterClosed = document.getElementById(focusAfterClosed);
            }
            else if (typeof focusAfterClosed === 'object') {
              this.focusAfterClosed = focusAfterClosed;
            }
            else {
              throw new Error(
                'the focusAfterClosed parameter is required for the aria.Dialog constructor.');
            }

            if (typeof focusFirst === 'string') {
              this.focusFirst = document.getElementById(focusFirst);
            }
            else if (typeof focusFirst === 'object') {
              this.focusFirst = focusFirst;
            }
            else {
              this.focusFirst = null;
            }

            // Bracket the dialog node with two invisible, focusable nodes.
            // While this dialog is open, we use these to make sure that focus never
            // leaves the document even if dialogNode is the first or last node.
            var preDiv = document.createElement('div');
            this.preNode = this.dialogNode.parentNode.insertBefore(preDiv,
                                                                   this.dialogNode);
            this.preNode.tabIndex = 0;
            var postDiv = document.createElement('div');
            this.postNode = this.dialogNode.parentNode.insertBefore(postDiv,
                                                                    this.dialogNode.nextSibling);
            this.postNode.tabIndex = 0;

            // If this modal is opening on top of one that is already open,
            // get rid of the document focus listener of the open dialog.
            if (aria.OpenDialogList.length > 0) {
              aria.getCurrentDialog().removeListeners();
            }

            this.addListeners();
            aria.OpenDialogList.push(this);
            this.clearDialog();
            this.dialogNode.className = 'default_dialog'; // make visible

            if (this.focusFirst) {
              this.focusFirst.focus();
            }
            else {
              aria.Utils.focusFirstDescendant(this.dialogNode);
            }

            this.lastFocus = document.activeElement;
          }; // end Dialog constructor

          aria.Dialog.prototype.clearDialog = function () {
            Array.prototype.map.call(
              this.dialogNode.querySelectorAll('input'),
              function (input) {
                input.value = '';
              }
            );
          };

          /**
             * @desc
             *  Hides the current top dialog,
             *  removes listeners of the top dialog,
             *  restore listeners of a parent dialog if one was open under the one that just closed,
             *  and sets focus on the element specified for focusAfterClosed.
             */
          aria.Dialog.prototype.close = function () {
            aria.OpenDialogList.pop();
            this.removeListeners();
            aria.Utils.remove(this.preNode);
            aria.Utils.remove(this.postNode);
            this.dialogNode.className = 'hidden';
            this.backdropNode.classList.remove('active');
            this.focusAfterClosed.focus();

            // If a dialog was open underneath this one, restore its listeners.
            if (aria.OpenDialogList.length > 0) {
              aria.getCurrentDialog().addListeners();
            }
            else {
              document.body.classList.remove(aria.Utils.dialogOpenClass);
            }
          }; // end close

          aria.Dialog.prototype.addListeners = function () {
            document.addEventListener('focus', this.trapFocus, true);
          }; // end addListeners

          aria.Dialog.prototype.removeListeners = function () {
            document.removeEventListener('focus', this.trapFocus, true);
          }; // end removeListeners

          aria.Dialog.prototype.trapFocus = function (event) {
            if (aria.Utils.IgnoreUtilFocusChanges) {
              return;
            }
            var currentDialog = aria.getCurrentDialog();
            if (currentDialog.dialogNode.contains(event.target)) {
              currentDialog.lastFocus = event.target;
            }
            else {
              aria.Utils.focusFirstDescendant(currentDialog.dialogNode);
              if (currentDialog.lastFocus == document.activeElement) {
                aria.Utils.focusLastDescendant(currentDialog.dialogNode);
              }
              currentDialog.lastFocus = document.activeElement;
            }
          }; // end trapFocus

          openDialog = function (dialogId, focusAfterClosed, focusFirst) {
            var dialog = new aria.Dialog(dialogId, focusAfterClosed, focusFirst);
          };

          window.closeDialog = function (closeButton) {
            var topDialog = aria.getCurrentDialog();
            if (topDialog.dialogNode.contains(closeButton)) {
              topDialog.close();
            }
          }; // end closeDialog
          
          // window.closeMobileDialog = function(closeButton) {
          //   document.removeEventListener('focus', this.trapFocus, true);
          //   $('#visit-page__mobile-cta__container').hide();
          // } 

        }());

        window.triggerOpenDialog = function (){
          openDialog(self.selectors.popUp, self.selectors.container, self.selectors.closeDialog);
        }
        
        if($(window).width() >= 590 ){
          openDialog(this.selectors.popUp, this.selectors.container, this.selectors.closeDialog);
        }

      }
      
    }
  });
                                    
  return VisitPopUp;
    
})();

window.theme = window.theme || {};

theme.CollectionSliderSection = (function() {

  function CollectionSliderSection(container) {
    var $container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slickAutoplay = $container.attr('data-slider-autoplay');
    var slickAutoplaySpeed = $container.attr('data-slider-autoplay-speed');
    var slickSpeed = $container.attr('data-slider-speed');
    var sectionId = $container.attr('data-section-id');
    var collectionSlider = '#CollectionSlider-' + sectionId;
    var prevArrowDesktop = '#slick__arrow--previous-' + sectionId;
    var nextArrowDesktop = '#slick__arrow--next-' + sectionId;
    var pagingInfo = '#slick__paging-info-' + sectionId;
    
    if (slickAutoplay == "true"){
      var slickValue = (/true/).test(slickAutoplay);
    }else{
      var slickValue = false;
    }

    this.$collectionSlider = $(collectionSlider);
    this.$pagingInfo =$(pagingInfo);
    this.$container = $container;
 
    this.slickSettings = {    
      accessibility: true,
      autoplay: slickValue,
      autoplaySpeed: slickAutoplaySpeed,
      speed: slickSpeed,
      arrows: true,
      prevArrow: prevArrowDesktop,
      nextArrow: nextArrowDesktop,
      infinite: false,
      dots: true,
      adaptiveHeight: true,
      slidesToShow: 3,
  	  slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    };
    console.log(this.slickSettings);
    this.createSlider();
  }
  
  CollectionSliderSection.prototype = _.assignIn({}, CollectionSliderSection.prototype, {
    createSlider: function() {
      var self = this;
      this.$collectionSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        // no dots -> no slides
        if(!slick.$dots){
          return;
        }

        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var slidesToShow = Math.ceil( slick.slideCount/(slick.$dots[0].children.length) );
        var currentCustomSlide = currentSlide ? Math.ceil((currentSlide + 1)/slidesToShow) : 1;
        // use dots to get some count information
        self.$pagingInfo.text(currentCustomSlide + '/' + (slick.$dots[0].children.length));
        if((slick.$dots[0].children.length) == 1){
          self.$container.find('.slick__controls').addClass('hide');
        }else{
          self.$container.find('.slick__controls').removeClass('hide');
        }
      });
      
      this.$collectionSlider.slick(this.slickSettings);
    }
  });
  
  return CollectionSliderSection;
})();

window.theme = window.theme || {};

theme.CollectionSection = (function() {
  
  function CollectionSection(container) {
    var $container = $(container);
    var sectionId = $container.attr('data-section-id');
    var collectionSlider = '#CollectionSlider-' + sectionId;
    
    this.$collectionSlider = $(collectionSlider);
 
    this.slickSettings = {
      accessibility: true,
      infinite: false,
      adaptiveHeight: true,
      slidesToShow: 3,
      arrows: false,
  	  slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    
    this.createSlider();
  }
  
  CollectionSection.prototype = _.assignIn({}, CollectionSection.prototype, {
    createSlider: function() {
      this.$collectionSlider.slick(this.slickSettings);
    }
  });
  
  return CollectionSection;
})();

window.theme = window.theme || {};

theme.FeaturedRowItemsSection = (function() {

  function FeaturedRowItems(container) {
    var $container = $(container);
    var sectionContentType = $container.attr('data-section-content-type');
    var sectionId = $container.attr('data-section-id');
    var tabsContainer = '#tabsContainer-' + sectionId;
    var tabsContentContainer = '#tabsContentContainer-' + sectionId;
    
    this.$tabsContainer = $(tabsContainer);
    this.$tabsContentContainer = $(tabsContentContainer);
    
    if(sectionContentType == 'tabs'){
      this.slickSettings = {
        accessibility: false,
        infinite: false,
  		cssEase: 'linear',
        adaptiveHeight: false,
        draggable: false,
        slidesToShow: 3,
        arrows: false,
        slidesToScroll: 1,
        speed: 250,
        focusOnSelect: false,
        responsive: [
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              fade: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              fade: true
            }
          }
        ]
      };

      this.createTabs();
    }
  }
  
  FeaturedRowItems.prototype = _.assignIn({}, FeaturedRowItems.prototype, {
    createTabs: function() {
      var self = this;
      this.$tabsContentContainer.slick(this.slickSettings);
      
      this.$tabsContentContainer.on('afterChange', function(slick, currentSlide){
        const index = self.$tabsContentContainer.slick('slickCurrentSlide');
        self.$tabsContainer.find('button').removeClass('active');
        self.$tabsContainer.find(`button[data-toggle=${index}]`).addClass('active');

      });
      this.$tabsContainer.find('button').click(function(){
        
        self.$tabsContainer.find('button').removeClass('active');
        $(this).addClass('active');
        
        var slideIndex = parseInt($(this).attr('data-toggle'));
        self.$tabsContentContainer.slick('slickGoTo', slideIndex);
        
      });
    }
  });
  
  return FeaturedRowItems;
})();
  
window.theme = window.theme || {};

theme.FeaturedContentSection = (function() {
  function FeaturedContent() {
    theme.styleTextLinks();
  }

  return FeaturedContent;
})();

window.theme = window.theme || {};

theme.NewsletterSection = (function() {
  function Newsletter() {
    theme.styleTextLinks();
  }

  return Newsletter;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  var classes = {
    headerWrapperTransparent: 'header-wrapper--transparent',
    isPaused: 'is-paused'
  };

  var selectors = {
    pause: '[data-pause]',
    headerWrapper: '[data-header-wrapper]'
  };

  function SlideshowSection(container) {
    theme.initCache();

    var $container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = '#Hero-' + sectionId;
    this.$slideshow = $(slideshow);
    this.autoplay = this.$slideshow.data('autoplay');
    this.$headerWrapper = theme.cache.$siteHeader.closest(
      selectors.headerWrapper
    );

    theme.slideshows[slideshow] = new theme.Slideshow(this.$slideshow);

    // remove header absolute display if slideshow is empty
    if (!this.$slideshow.hasClass('hero')) {
      this.$headerWrapper.removeClass(classes.headerWrapperTransparent);
    }

    if (Shopify.designMode) {
      // Fix the slideshow height in the iOS theme editor
      this.setSlideshowHeight(this.$slideshow);
    }
  }

  SlideshowSection.prototype = _.assignIn({}, SlideshowSection.prototype, {
    onUnload: function() {
      this.$slideshow.slick('unslick');
    },

    onBlockSelect: function(evt) {
      var $slide = $('.slide--' + evt.detail.blockId);
      var slideIndex = $slide.attr('index');

      // Go to selected slide, pause autoplay
      this.$slideshow.slick('slickGoTo', slideIndex);

      if (this.autoplay) {
        this.$slideshow.slick('slickPause');
      }
    },

    onBlockDeselect: function() {
      var $pauseButton = this.$slideshow.find(selectors.pause);

      if (this.autoplay && $pauseButton.hasClass(classes.isPaused)) {
        this.$slideshow.slick('slickPlay');
      }
    },

    setSlideshowHeight: function($slideshow) {
      enquire.register(theme.variables.mediaQuerySmall, {
        match: function() {
          $slideshow.css('height', $(window.parent.document).height());
        },
        unmatch: function() {
          $slideshow.removeAttr('height');
        }
      });
    }
  });

  return SlideshowSection;
})();

window.theme = window.theme || {};

theme.MTMOverviewOffering = (function() {

  function MTMOverviewOffering(container) {
    var $container = $(container);
    var sectionId = $container.attr('data-section-id');
    var tabsContainer = '#tabsContainer-' + sectionId;
    var tabsContentContainer = '#tabsContentContainer-' + sectionId;
    
    this.$tabsContainer = $(tabsContainer);
    this.$tabsContentContainer = $(tabsContentContainer);
    
    this.nodes = {
      $siteHeader: $('.site-header'),
      $announcementBar: $('.announcement-bar')
    };
    
    this.slickSettings = {
      accessibility: false,
      infinite: false,
      cssEase: 'linear',
      adaptiveHeight: false,
      draggable: false,
      slidesToShow: 3,
      arrows: false,
      slidesToScroll: 1,
      speed: 250,
      focusOnSelect: false,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            fade: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            fade: true
          }
        }
      ]
    };

    this.createTabs();
  }
  
  MTMOverviewOffering.prototype = _.assignIn({}, MTMOverviewOffering.prototype, {
    createTabs: function() {
      var self = this;
      this.$tabsContentContainer.slick(this.slickSettings);
      
      this.$tabsContentContainer.on('afterChange', function(slick, currentSlide){
        const index = self.$tabsContentContainer.slick('slickCurrentSlide');
        self.$tabsContainer.find('button').removeClass('active');
        self.$tabsContainer.find(`button[data-toggle=${index}]`).addClass('active');

      });
      this.$tabsContainer.find('button').click(function(){
        
        self.$tabsContainer.find('button').removeClass('active');
        $(this).addClass('active');
        
        var slideIndex = parseInt($(this).attr('data-toggle'));
        self.$tabsContentContainer.slick('slickGoTo', slideIndex);
        
      });
    }
    
  });
  
  return MTMOverviewOffering;
})();

window.theme = window.theme || {};

theme.PasswordHeader = (function() {
  function PasswordHeader() {
    this.init();
  }

  PasswordHeader.prototype = _.assignIn({}, PasswordHeader.prototype, {
    init: function() {
      $('.js-toggle-login-modal').magnificPopup({
        type: 'inline',
        mainClass: 'mfp-fade',
        closeOnBgClick: false,
        closeBtnInside: false,
        closeOnContentClick: false,
        tClose: password.strings.pageClose,
        removalDelay: 500,
        callbacks: {
          open: function() {
            window.setTimeout(function() {
              document.getElementById('password').focus();
            }, 50);
          },
          close: function() {
            window.setTimeout(function() {
              document.getElementById('email').focus();
            }, 50);
          }
        }
      });
      if ($('.storefront-password-form .errors').size()) {
        $('.js-toggle-login-modal').click();
      }
    }
  });

  return PasswordHeader;
})();

window.theme = window.theme || {};

theme.PasswordContent = (function() {
  function PasswordContent() {
    theme.styleTextLinks();
  }

  return PasswordContent;
})();

window.theme = window.theme || {};

theme.ProductRecommendations = (function() {
  function ProductRecommendations(container) {
    this.$container = $(container);

    var self = this;
    var baseUrl = this.$container.data('baseUrl');
    var productId = this.$container.data('productId');
    var recommendationsSectionUrl =
      baseUrl +
      '?section_id=product-recommendations&product_id=' +
      productId +
      '&limit=50';

   var productRecommendationsSlider = '#productRecommendationsSlider';

   var slickSettings = {
      accessibility: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      adaptiveHeight: true,
      mobileFirst: false,
      prevArrow: '<button type="button" class="slick-prev icon-fallback-text" aria-label="Previous slide"><span class="icon icon-slide-prev-btn" aria-hidden="true"></span><span class="fallback-text">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next icon-fallback-text" aria-label="Next slide"><span class="icon icon-slide-next-btn" aria-hidden="true"></span><span class="fallback-text">Next</span></button>',
      arrows: true,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false
          }
        },
        {
          breakpoint: 590,
          settings: {
            slidesToShow: 2.11,
            slidesToScroll: 2,
            arrows: false
          }
        }
      ]
    };

    $.get(recommendationsSectionUrl).then(function(section) {
      var recommendationsMarkup = $(section).html();
      if (recommendationsMarkup.trim() !== '') {
        self.$container.html(recommendationsMarkup);
        // Slight delay to make sure HTML injection is done before calling slick
        setTimeout(function() {
          $(productRecommendationsSlider).slick(slickSettings);
        }, 250);
      }
    });
  }

  return ProductRecommendations;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) return;

    if (Shopify.designMode) {
      $(selectors.section).addClass(classes.mapError);
      $(selectors.map).remove();
      $(selectors.mapOverlay).after(
        '<div class="' +
          classes.errorMsg +
          '">' +
          theme.strings.authError +
          '</div>'
      );
    }
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key !== 'string' || this.key === '') {
      return;
    }

    if (apiStatus === 'loaded') {
      var self = this;

      // Check if the script has previously been loaded with this key
      var $script = $('script[src*="' + this.key + '&"]');
      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + this.key
        ).then(function() {
          apiStatus = 'loaded';
          self.createMap();
        });
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(window, 'resize', function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
              $map.removeAttr('style');
            });
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

window.theme = window.theme || {};

theme.Search = (function() {
  function Search() {
    theme.equalHeights();
  }

  return Search;
})();

window.theme = window.theme || {};

var selectors = {
  disclosureLocale: '[data-disclosure-locale]',
  disclosureCurrency: '[data-disclosure-currency]'
};

theme.FooterSection = (function() {
  function Footer(container) {
    this.$container = $(container);
    this.cache = {};
    this.cacheSelectors();

    if (this.cache.$localeDisclosure.length) {
      this.localeDisclosure = new theme.Disclosure(
        this.cache.$localeDisclosure
      );
    }

    if (this.cache.$currencyDisclosure.length) {
      this.currencyDisclosure = new theme.Disclosure(
        this.cache.$currencyDisclosure
      );
    }
  }

  Footer.prototype = _.assignIn({}, Footer.prototype, {
    cacheSelectors: function() {
      this.cache = {
        $localeDisclosure: this.$container.find(selectors.disclosureLocale),
        $currencyDisclosure: this.$container.find(selectors.disclosureCurrency)
      };
    },

    onUnload: function() {
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure.unload();
      }

      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure.unload();
      }
    }
  });

  return Footer;
})();

window.theme = window.theme || {};

theme.MTM = (function() {

  function MTM() {
    var self = this;
    var $window = $(window);
    this.$window = $(window);
    this.$body = $('body');

    // Init SM Youtube Player
    this.yt_player;
    
    this.settings = {
        selfMeasurementsVideoId: 'Ugc7RquA9rk',
        namespace: '.mtmSection'
    }

    this.nodes = {
      $siteHeader: $('.site-header'),
      $announcementBar: $('.announcement-bar')
    };

    this.selectors = {
        siteHeader: '.site-header',
        mtmGeneralContainer: '.mtm-general__container',
        mtmMainContainer: '#mtm-main__container',
        $heroImage: $('.mtm-hero__image'),
        mtmOverviewContainer: '.mtm-overview__container',
        $mtmOverviewInner: $('.mtm-overview__inner'),
        chooseFabricTab: '#choose-fabric_tab',
        chooseFeaturesTab: '#choose-features_tab',
        chooseFitTab: '#choose-fit_tab',
        $mtmFabricId: $('#mtm-fabrics__input__id'),
        $mtmFabricSelectedColor: $('#mtm-fabrics__selected_Color'),
        $mtmItemsContainer: $('.mtm-grid__items__container'),
        $mtmItems: $('.mtm-grid__items'),
        mtmProductItems: '.grid-product',
        fabricsViewRadio: 'input[name="mtm-fabrics__view-option"]',
        fabricsButton: '.mtm-fabrics__option-button',
        productGridMeta: '.grid-product__meta',
        fabricDetailCloseButton: '.mtm-fabric-detail__close-button',
        fabricDetailSelectButton: '.mtm-fabric-detail__select-button',
        sizeAttrLink: '.mtm-size__sm__attr-link',
        addToCart: '#AddToCart--MTM',
        mtmStartOver: '.mtm-action-icon__start-over'
    }
    
    this.selectors.$heroImage.addClass('is-init');

    ajaxCart.init({
        formSelector: '#AddToCartForm--MTM',
        cartContainer: '#CartContainer',
        addToCartSelector: '#AddToCart--MTM',
        enableQtySelectors: true,
        moneyFormat: theme.strings.moneyFormat
    });

    theme.cache.$window
      .on(
        'resize' + this.settings.namespace,
        theme.debounce(this.initStickyMtmOverview, 150).bind(this)
      )
      .on('scroll', function() {
          var scrolled = theme.cache.$window.scrollTop();
          theme.cache.$heroImage.css({
              transform: 'translate3d(0, ' + scrolled / 4.5 + 'px, 0)'
          });
      });

    this.init();

    $window.on('load', function(){
      self.initStickyMtmOverview();
    });
 }
  var saver =  {
    store: function(data){
      window.localStorage.setItem("mtm_details", JSON.stringify(data));
    },
    clear: function(){
      window.localStorage.setItem("mtm_details", "{}");
    },
    retreive: function(){
      stored = window.localStorage.getItem('mtm_details');
      if ( stored == "" || stored == undefined || stored == null ) {
        return {};
      }
      let data = JSON.parse(stored);
      if (data == null ) {
        return {};
      }
      return data;
    },
    get: function(key){
      const data  = this.retreive();
      if( data.hasOwnProperty(key)){
        return data[key];
      }
      return false;
    },
    save: function(key, value){
      let data = this.retreive();
      data[key] = value;
      this.store(data);
    },
    saveStyle: function(key, value) {
      console.log('saving style ' + key + ' : ' + value);
      let data = this.retreive();
      styles = {};
      if(data.hasOwnProperty('styles')) {
        styles = data.styles;
      }
      
      styles[key] = value;
      this.save("styles", styles);
    },
    saveDetails: function(key, value) {
      console.log('saving details ' + key + ' : ' + value);
      let data = this.retreive();
      details = {};
      if(data.hasOwnProperty('details')) {
        details = data.details;
      }
      
      details[key] = value;
      this.save("details", details);
    },
    autoload_hook: function(container){
      if( this.get('autoload') == "yes") {
        this.load(container);
        saver.save('autoload' , 'no');
        saver.clear();
      }
    },
    load: function(container){
      const data = this.retreive();
      const saved_style = this.get('style-option');
      if ( saved_style ) {
        $(`input[name="properties[_styles-option]"][value="${saved_style}"]`).trigger("click");
      }

      if( this.get('fabric')) {
        const fabricBtn = $(`.mtm-fabrics__option-button[data-variant-id=${data.fabric}]`);
        const fabric_product_handle = fabricBtn.data('product-handle');
        // console.log($(`.mtm-fabric-detail__select-button[data-variant-id=${data.fabric_variant_id}]`));

        jQuery.getJSON('/products/' + fabric_product_handle + '.js', function(product) {
          console.log(product);
          fabricBtn.addClass('selected');

          container.selectors.$mtmFabricId.val(product.variants[0].id);
          $('#mtm-os__fabric .val').removeClass('incomplete').html('- ' + product.title);
          $(container.selectors.chooseFabricTab).addClass('completed');

          // Update fabric price in Add to Cart button
          $('#AddToCart--MTM').data('price',product.variants[0].price);
        });
      }


      if( this.get('style')) {
        const style = this.get('style');
        $(`input[name="properties[Style]"][value="${style}"]`).trigger('click');

        if( style.toLowerCase() == "from scratch"){
          const styles = saver.get('styles');
          const details = saver.get('details');
          for( let i in styles ) {
            console.log(i, styles[i]);

            // console.log(`input[name="properties[${i}]"][value="${styles[i]}"]`);
            let input = $(`input[name="properties[${i}]"][value="${styles[i]}"]`);

            input.trigger('click').trigger('change');
            if(input.siblings('.mtm-choose-features__details__container').length > 0 ){
              // $('#mtm-os__' + property_name + '-detail').removeAttr('hidden');
              let sel = input.siblings('.mtm-choose-features__details__container').find(`select`);
              sel.val(details[i.toLowerCase()]);
              var detail_for = sel.data('detail-for');
              var detail_for_handle = detail_for.toLowerCase();
              var property_val = sel.val(); 
              
              // Update input val
              $('input[name="properties[' + detail_for + ' Detail]').val(property_val);
              // Update overview step details
              $('#mtm-os__' + detail_for_handle + '-detail .val').removeClass('incomplete').html(property_val);
            }
          }
        }
      }

      if( this.get('fit')) {
        // console.log(`input[name="properties[Fit]"][value="${this.get('fit')}]`));
        $(`input[name="properties[Fit]"][value="${this.get('fit')}"]`).trigger('click').trigger('change');

      }
      if( this.get('size_type')) {
        if(this.get('size_type') != 'Self Measure'){
          $(`input[name="properties[Size Type]"][value="${this.get('size_type')}"]`).trigger('click').trigger('change');
        }
      }
    }
  };
  window.saver = saver;
  MTM.prototype = _.assignIn({}, MTM.prototype, {
    init: function() {
        this.cacheSelectors();
        this.initOverviewTabs();
        this.initFabricsGrid();
        this.initFeaturesTabs();
        this.initChooseFeatures();
        this.initChooseFit();
        this.initYouTubeAPI();
        this.initCustomFeaturesAccordion();
        this.loggedInSelectedSize();

        // Bind Events
        // Fabric View toggle 
        this.cache.$fabricsViewRadio.on('change', this.toggleFabricsView.bind(this));
        // Fabric Btn click
        this.cache.$fabricsButton.on('click', this.openFabricDetails.bind(this));
        // Size Self-Measurement Attr Btn click
        this.cache.$sizeAttrLink.on('click', this.showSizeAttrDetails.bind(this));

        this.cache.$mtmStartOver.on('click', this.startOver.bind(this));

        saver.autoload_hook(this);
    },
    
    cacheSelectors: function() {
        this.cache = {
          $html: $('html'),
          $window: $(window),
          $siteHeader: $(this.selectors.siteHeader),
          $mtmChooseFabricTab: $(this.selectors.chooseFabricTab),
          $chooseFeaturesTab: $(this.selectors.chooseFeaturesTab),
          $chooseFitTab: $(this.selectors.chooseFitTab),
          $mtmProductItems: $(this.selectors.mtmProductItems),
          $productGridMeta: $(this.selectors.productGridMeta),
          $fabricsViewRadio: $(this.selectors.fabricsViewRadio),
          $fabricsButton: $(this.selectors.fabricsButton),
          $sizeAttrLink: $(this.selectors.sizeAttrLink),
          $addToCart: $(this.selectors.addToCart),
          $mtmStartOver: $(this.selectors.mtmStartOver)
        };
    },

    
    initCustomFeaturesAccordion: function(){
      const self = this;

      $(".mtmTab_mobile-header").on('click',function(){
        var selected_option = $('.mtm-choose-features__single-option.active .mtm-choose-features__details-select:not(.selected)');
        if(selected_option.length > 0 && selected_option.val() == null){
          var currentTab = selected_option.parents('.mtm-choose-features__options-group');
          if(currentTab.find('.mtm__error').length > 0){
            currentTab.find('.mtm__error').remove();
          }
          if(currentTab.find('.mtm__error').length == 0){
            currentTab.prepend('<div class="mtm__error errors">Please choose an option from the Dropdown.</div>');
            theme.scrollTo(selected_option, 150);
          }
          selected_option.addClass('error-highlighted');
        }else{
          if($('.mtm__error').length > 0){
            $('.mtm__error').remove();
            selected_option.removeClass('error-highlighted');
            selected_option.addClass('selected');
          }
          if($('.mtm__error').length == 0){
            changeAccordion($(this));
          }
        }
        

        function changeAccordion(heaeder){
          const t = heaeder,
              tab = heaeder.next(".mtmTab_inner");
          t.toggleClass('expanded');

          if( t.hasClass('expanded')){
            $("[data-mtm-tab-inner]").not(tab).slideUp();
            $(".mtmTab_mobile-header").not(t).removeClass('expanded');
            tab.slideDown();
          } else {
            tab.slideUp();
          }
          //
        }
      });
    },

    initOverviewTabs: function() {
        var self = this;
        /*
        *   This content is licensed according to the W3C Software License at
        *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
        */
        (function () {
            var tablist = document.querySelectorAll('[role="overviewTablist"]')[0];
            var tabs;
            var panels;
            var delay = determineDelay();
    
            generateArrays();
    
            function generateArrays () {
                tabs = document.querySelectorAll('[role="overviewTab"]');
                panels = document.querySelectorAll('[role="overviewTabpanel"]');
            };
    
            // For easy reference
            var keys = {
                end: 35,
                home: 36,
                left: 37,
                up: 38,
                right: 39,
                down: 40,
                delete: 46
            };
    
            // Add or substract depending on key pressed
            var direction = {
                37: -1,
                38: -1,
                39: 1,
                40: 1
            };
    
            // Bind listeners
            for (i = 0; i < tabs.length; ++i) {
                addListeners(i);
            };
    
            function addListeners (index) {
                tabs[index].addEventListener('click', clickEventListener);
                tabs[index].addEventListener('keydown', keydownEventListener);
                tabs[index].addEventListener('keyup', keyupEventListener);
    
                // Build an array with all tabs (<button>s) in it
                tabs[index].index = index;
            };
    
            // When a tab is clicked, activateTab is fired to activate it
            function clickEventListener (event) {
                var tab = event.target;
                activateTab(tab, false);
            };
    
            // Handle keydown on tabs
            function keydownEventListener (event) {
                var key = event.keyCode;
    
                switch (key) {
                case keys.end:
                    event.preventDefault();
                    // Activate last tab
                    activateTab(tabs[tabs.length - 1]);
                    break;
                case keys.home:
                    event.preventDefault();
                    // Activate first tab
                    activateTab(tabs[0]);
                    break;
    
                // Up and down are in keydown
                // because we need to prevent page scroll >:)
                case keys.up:
                case keys.down:
                    determineOrientation(event);
                    break;
                };
            };
    
            // Handle keyup on tabs
            function keyupEventListener (event) {
                var key = event.keyCode;
    
                switch (key) {
                case keys.left:
                case keys.right:
                    determineOrientation(event);
                    break;
                case keys.delete:
                    determineDeletable(event);
                    break;
                };
            };
    
            // When a tablistâ€™s aria-orientation is set to vertical,
            // only up and down arrow should function.
            // In all other cases only left and right arrow function.
            function determineOrientation (event) {
                var key = event.keyCode;
                var vertical = tablist.getAttribute('aria-orientation') == 'vertical';
                var proceed = false;
    
                if (vertical) {
                if (key === keys.up || key === keys.down) {
                    event.preventDefault();
                    proceed = true;
                };
                }
                else {
                if (key === keys.left || key === keys.right) {
                    proceed = true;
                };
                };
    
                if (proceed) {
                switchTabOnArrowPress(event);
                };
            };
    
            // Either focus the next, previous, first, or last tab
            // depening on key pressed
            function switchTabOnArrowPress (event) {
                var pressed = event.keyCode;
    
                for (x = 0; x < tabs.length; x++) {
                tabs[x].addEventListener('focus', focusEventHandler);
                };
    
                if (direction[pressed]) {
                var target = event.target;
                if (target.index !== undefined) {
                    if (tabs[target.index + direction[pressed]]) {
                    tabs[target.index + direction[pressed]].focus();
                    }
                    else if (pressed === keys.left || pressed === keys.up) {
                    focusLastTab();
                    }
                    else if (pressed === keys.right || pressed == keys.down) {
                    focusFirstTab();
                    };
                };
                };
            };
    
            // Activates any given tab panel
            function activateTab (tab, setFocus) {
              if(tab.id == 'style-options_tab'){
                if($('.mtm__error').length > 0){
                  $('.mtm__error').remove();
                }
                changeTab();
              }else{
                var selected_option = $('.mtm-choose-features__single-option.active .mtm-choose-features__details-select:not(.selected)');
                if(selected_option.length > 0 && selected_option.val() == null){
                  var currentTab = selected_option.parents('.mtm-choose-features__options-group');
                  if(currentTab.find('.mtm__error').length > 0){
                    currentTab.find('.mtm__error').remove();
                  }
                  if(currentTab.find('.mtm__error').length == 0){
                    currentTab.prepend('<div class="mtm__error errors">Please choose an option from the Dropdown.</div>');
                  }
                  selected_option.addClass('error-highlighted');
                }else{
                  if($('.mtm__error').length > 0){
                    $('.mtm__error').remove();
                    selected_option.removeClass('error-highlighted');
                    selected_option.addClass('selected');
                  }
                  if($('.mtm__error').length == 0){
                    changeTab();
                  }
                }
              }

              function changeTab(){
                setFocus = setFocus || true;
                // Deactivate all other tabs
                deactivateTabs();
    
                // Remove tabindex attribute
                tab.removeAttribute('tabindex');
    
                // Set the tab as selected
                tab.setAttribute('aria-selected', 'true');
    
                // Get the value of aria-controls (which is an ID)
                var controls = tab.getAttribute('aria-controls');
    
                // Remove hidden attribute from tab panel to make it visible
                document.getElementById(controls).removeAttribute('hidden');
    
                /* Set focus when required
                if (setFocus) {
                  tab.focus();
                };
                */
                //Removing Sold Out Div
                if($('#choose-fabric_tab').hasClass('completed')){
                  if($('.mtm-overview__container').find('.qty-error').length > 0){
                    $('.mtm-overview__container').find('.qty-error').remove();
                  }
                }

                // Scroll to top
                var offset = self.cache.$siteHeader.outerHeight();
                theme.scrollTo(self.selectors.mtmMainContainer, offset);

                self.fabricsGridHeights();
                setTimeout(function(e){
                  // Restart Sticky MTM Overview
                  self.initStickyMtmOverview();
                },200)
              }
            };
    
            // Deactivate all tabs and tab panels
            function deactivateTabs () {
                for (t = 0; t < tabs.length; t++) {
                tabs[t].setAttribute('tabindex', '-1');
                tabs[t].setAttribute('aria-selected', 'false');
                tabs[t].removeEventListener('focus', focusEventHandler);
                };
    
                for (p = 0; p < panels.length; p++) {
                panels[p].setAttribute('hidden', 'hidden');
                };
            };
    
            // Make a guess
            function focusFirstTab () {
                tabs[0].focus();
            };
    
            // Make a guess
            function focusLastTab () {
                tabs[tabs.length - 1].focus();
            };
    
            // Detect if a tab is deletable
            function determineDeletable (event) {
                target = event.target;
    
                if (target.getAttribute('data-deletable') !== null) {
                // Delete target tab
                deleteTab(event, target);
    
                // Update arrays related to tabs widget
                generateArrays();
    
                // Activate the closest tab to the one that was just deleted
                if (target.index - 1 < 0) {
                    activateTab(tabs[0]);
                }
                else {
                    activateTab(tabs[target.index - 1]);
                };
                };
            };
    
            // Deletes a tab and its panel
            function deleteTab (event) {
                var target = event.target;
                var panel = document.getElementById(target.getAttribute('aria-controls'));
    
                target.parentElement.removeChild(target);
                panel.parentElement.removeChild(panel);
            };
    
            // Determine whether there should be a delay
            // when user navigates with the arrow keys
            function determineDelay () {
                var hasDelay = tablist.hasAttribute('data-delay');
                var delay = 0;
    
                if (hasDelay) {
                var delayValue = tablist.getAttribute('data-delay');
                if (delayValue) {
                    delay = delayValue;
                }
                else {
                    // If no value is specified, default to 300ms
                    delay = 300;
                };
                };
    
                return delay;
            };
    
            //
            function focusEventHandler (event) {
                var target = event.target;
    
                setTimeout(checkTabFocus, delay, target);
            };
    
            // Only activate tab on focus if it still has focus after the delay
            function checkTabFocus (target) {
                focused = document.activeElement;
    
                if (target === focused) {
                activateTab(target, false);
                };
            };
        }());
    }, // END f. initOverviewTabs

    initStickyMtmOverview: function() {
      var self = this;
      var $overviewContainer = $(this.selectors.mtmOverviewContainer, this.$container);
      var $wrapper = $(this.selectors.mtmGeneralContainer, this.$container);
      
      if ( !$overviewContainer.length ) {
        return;
      }

      // Force detatch if already detached. Prevent layout issues.
      $overviewContainer.trigger('detach.ScrollToFixed');

      // Detach and stop if on mobile breakpoint
      /* if (theme.variables.bpSmall) {
        return;
      } */

      var fixedHeaderHeight = self.nodes.$siteHeader.outerHeight();
      var mtmOverviewHeight = $overviewContainer.outerHeight();
      var mtmMainContainerHeight = $(
        this.selectors.mtmMainContainer,
        this.$container
      ).height();
      console.log('overview',mtmOverviewHeight, mtmMainContainerHeight - fixedHeaderHeight)
      /*============================================================================
        Calculate when to detach fixed element to avoid content overlap.
      ==============================================================================*/
      var calcLimit = $wrapper.offset().top + $wrapper.height();
      calcLimit -= mtmOverviewHeight + fixedHeaderHeight;

      // Init sticky if overview shorter than main container and fits in viewport
      /*if (
        mtmOverviewHeight < mtmMainContainerHeight - fixedHeaderHeight &&
        mtmOverviewHeight < $(window).height() - fixedHeaderHeight
      ) {
        $overviewContainer.scrollToFixed({
          limit: calcLimit,
          zIndex: 4
        });
      } */

      if (
        mtmOverviewHeight < mtmMainContainerHeight - fixedHeaderHeight
      ) {
        $overviewContainer.scrollToFixed({
          limit: calcLimit,
          zIndex: 4
        });
      }
    },

    loggedInSelectedSize: function(self) {
      if(window.location.href.indexOf('#mtm-size__from-file') > -1){
        $('#choose-fit_tab').trigger('click');
        $('#mtm-size-preference').removeClass('inactive');
        setTimeout(function(e){
          $('#mtm-size__from-file:not([disabled])').prop('checked',true).trigger('change');
        },10);
      }
    }, // END f. loggedInSelectedSize

    initFabricsGrid: function() {
        var self = this;
        console.log('test')
        if (!this.cache.$mtmProductItems.length) {
          return;
        }
        
        this.selectors.$mtmItems.isotope({
          percentPosition: true,
          itemSelector: '.grid-item',
          masonry: {
            columnWidth: '.grid-product'
          },
          getSortData: {
            category: '[data-order] parseInt'
          },
          sortBy : 'category'
        });
  
        this.fabricsGridHeights();
  
        theme.cache.$window.on(
          'resize',
          theme.debounce(this.fabricsGridHeights, 100).bind(self)
        );

        this.defaultSelectedFabric(self);

        // Restart Sticky MTM Overview
        self.initStickyMtmOverview();

    }, // END f. initFabricsGrid

    defaultSelectedFabric: function(self) {
      if (!self.cache.$mtmProductItems.length) {
        return;
      }

      function waitForElement(selector, callback, self) {
        if (document.querySelector(selector) !== null) {
          callback();
        } else {
          setTimeout(function() {
            waitForElement(selector, callback, self);
          }, 100);
        }
      }

      if(window.location.href.indexOf('#fabricID') > -1){
        var fabricID = window.location.href.split('#fabricID=');
        var selectedFabric = $('.mtm-fabrics__option-button[data-variant-id="'+fabricID[1]+'"]');
        
        setTimeout(function(e){
          selectedFabric.trigger('click');
          waitForElement('.mtm-fabric-detail__select-button[data-variant-id="'+fabricID[1]+'"]', function(){ 
            var selectThisFabric = $('.mtm-fabric-detail__select-button[data-variant-id="'+fabricID[1]+'"]');
            selectThisFabric.trigger('click');
          });
        },10);
      }
    }, // END f. defaultSelectedFabric

    fabricsGridHeights: function() {
        if (!this.cache.$mtmProductItems.length) {
          return;
        }
        
        if(theme.cache.$window.width() > 768) {
          this.cache.$productGridMeta.css('height', 'auto').equalHeights();
        } else {
          this.cache.$productGridMeta.css('height', 'auto');
        }

        this.selectors.$mtmItems.isotope('layout');
    }, // END f. fabricsGridHeights

    toggleFabricsView: function(evt) {

      var val = $(evt.target).val();

      if (val == 'Shirt'){
        $('.mtm-fabrics__option-button').addClass('show-shirt');
      } else {
        $('.mtm-fabrics__option-button').removeClass('show-shirt');
      }
    },

    openFabricDetails: function(evt) {
        var self = this;
        
        const fabricTemplate = Handlebars.compile($("#mtm-fabric-template").html());
      
        if (!this.cache.$fabricsButton.length) {
            return;
        }
   
        if ( $(evt.target).hasClass('active') ) {
            this.closeFabricDetails();
            return;
        }

        // Remove active class from any selected fabric button
        this.cache.$fabricsButton.not('.selected').removeClass('active').find('.mtm-fabrics__product-status').html('View Details');

        var fabric_product_handle = $(evt.target).data('product-handle');
        var fabric_variant_id = $(evt.target).data('variant-id');
        var fabric_index_order = $(evt.target).data('order');

        var product_wear_for = $(evt.target).data('product-wear-for');
        var product_seasonality = $(evt.target).data('product-seasonality');
        var product_content = $(evt.target).data('product-content');
        var product_yarn_count = $(evt.target).data('product-yarn-count');
        var product_origin = $(evt.target).data('product-origin');
        var product_fabric_color = $(evt.target).data('product-fabric-color');

        var row_index_order = theme.calcFabricDetailPositionGrid(fabric_index_order);
        window.location.href = '#fabricID='+fabric_variant_id;
        saver.save('fabric', fabric_variant_id);
        jQuery.getJSON('/products/' + fabric_product_handle + '.js', function(product) {

            var $grid = self.selectors.$mtmItems.isotope();
           
            // Remove any previous instance of Fabric Details
            $grid.isotope('remove', $('.grid-fabric-details'));

            // Fabric Details Button Dom 
            var fabric_details_button_dom;
            if($(evt.target).hasClass('selected')){
                fabric_details_button_dom = '<button type="button" class="btn mtm-fabric-detail__select-button selected" data-variant-id="' + product.variants[0].id + '" data-fabric-name="' + product.title + '" data-fabric-color="' + product_fabric_color + '" data-fabric-price="' + product.variants[0].price + '">Selected fabric</button>';
            } else {
                fabric_details_button_dom = '<button type="button" class="btn mtm-fabric-detail__select-button" data-variant-id="' + product.variants[0].id + '" data-fabric-name="' + product.title + '" data-fabric-color="' + product_fabric_color + '" data-fabric-price="' + product.variants[0].price + '">Select fabric & Continue</button>';
            } 
            var fabric_details_dom = fabricTemplate({
              row_index_order: row_index_order,
              title: product.title,
              description: product.description,
              button: fabric_details_button_dom,
              first_image: product.images[0],
              second_image: product.images[1],
              third_image: product.images[2],
              wear_for: product_wear_for,
              seasonality: product_seasonality,
              content: product_content,
              yarn_count: product_yarn_count,
              origin: product_origin
            })


            // Insert fabric details DOM into isotope grid
            const fabricEl = $(fabric_details_dom);
            fabricEl.find('img').one('load',function(){
              $grid.isotope('layout');
            });

            $grid.isotope('insert', fabricEl);

            const zoomElOne = fabricEl.find('.mtm-fabric-zoom-1');
            zoomElOne.zoom({
              url: zoomElOne.data('zoom')
            });

            const zoomElTwo = fabricEl.find('.mtm-fabric-zoom-2');
            zoomElTwo.zoom({
              url: zoomElTwo.data('zoom')
            });

            $grid.isotope('layout');
            
            // Add active class from specific fabric button evt target  
            if($(evt.target).hasClass('selected')){
                $(evt.target).addClass('active');
            } else {
                $(evt.target).addClass('active').find('.mtm-fabrics__product-status').html('Close Details');
            }

            // Scroll to fabric details position
            var offset = 0;
            if($(window).width() < 769) {
              offset = self.cache.$siteHeader.outerHeight() + self.selectors.$mtmOverviewInner.outerHeight();
            } else {
              offset = self.cache.$siteHeader.outerHeight();
            }

            setTimeout(function(e){
            $('html,body').animate({scrollTop: fabricEl.offset().top - offset },500);
            },500);
            
            // Fabric Details Bind Close Btn Click
            $(self.selectors.fabricDetailCloseButton, self.$container).on('click', self.closeFabricDetails.bind(self));

            // Fabric Detais Bind Select Btn Click
            $(self.selectors.fabricDetailSelectButton, self.$container).on('click', self.selectFabric.bind(self));
        });
    }, // END f. openFabricDetails

    startOver: function() {
      window.saver.clear();

      /*------ Fabric Tab Start ------*/
      this.cache.$fabricsButton.each(function(){
        // Remove active class from any selected fabric button
        $(this).removeClass('active selected').find('.mtm-fabrics__product-status').html('View Details');
      });
      // this.selectors.$mtmItems.isotope('remove', $('.grid-fabric-details')).isotope('layout');
      $('#mtm-os__fabric .val').addClass('incomplete').html('- not yet selected');

      // deactivateTabs();
      $(this.selectors.chooseFabricTab).removeClass('completed');
      $(this.selectors.chooseFabricTab).attr('aria-selected', 'true');
      $('#mtmMain__chooseFabric').removeAttr('hidden');

      if($(".mtm-fabric-detail__close-button").length) {
        $(".mtm-fabric-detail__close-button").click();
      }
      /*------ Fabric Tab End ------*/

      /*------ Features Tab Start ------*/
      $('.mtm-choose-features__styles-option__item').hide();
      // Clear features radio selection 
      $('.mtm-choose-features__single-option input[type=radio]').prop('checked', false);
      $('.mtm-choose-features__single-option input[type=radio]').parent('.mtm-choose-features__single-option').removeClass('active');
      $(this.selectors.chooseFeaturesTab).removeClass('completed');
      $('.mtm-choose-features__tabs').removeClass('completed');
      $(this.selectors.chooseFeaturesTab).attr('aria-selected', 'false');

      $('#mtmChooseFeatures__styleTab input[type="radio"]').prop('checked', false);
      $('#mtmChooseFeatures__collarTab input[type="radio"]').prop('checked', false)

      $('#mtm-os__style .val').addClass('incomplete').html('');
      $('.mtm-os__style__item .val').addClass('incomplete').html('not yet selected');
      $('#mtm-os__style .attr').html('');

      $('#mtmChooseFeatures__styleTab').removeAttr('hidden');
      $('#mtmChooseFeatures__collarTab').attr('hidden','');
      $('#choose-features_tab .mtm-os__detail').attr('hidden','');
      $('#mtmMain__chooseFeatures').attr('hidden','');
      $('.mtm-choose-features__options-group').attr('hidden','');
      $('.mtm-choose-features__tabs').attr('hidden','');
      $('#mtm-os__features.is-empty').removeAttr('hidden');
      /*------ Features Tab End ------*/

      /*------ Fit Tab Start --------*/
      $('#choose-fit-options_tab').removeClass('tab-done').attr('aria-selected',true);
      $('#choose-size-options_tab').removeClass('tab-done').attr('aria-selected',false);    
      $('#mtm-size-preference').addClass('inactive');
      $('#mtm-fit-preference .mtm-fit__error').attr('hidden','');
      $('#mtmMain__chooseFit input[type=radio]').prop('checked', false);
      $('#mtm-size__stock-size__dress-shirt-size option:disabled').prop("selected", true).trigger('change');
      $('#mtm-size__stock-size__sport-shirt-size option:disabled').prop("selected", true).trigger('change');
      $('#stock-size__btn').attr('disabled','');
      $('.mtm-size__option-details').attr('hidden','');
      $('#choose-fit_tab .mtm-os__detail').attr('hidden','');

      $(this.selectors.chooseFitTab).removeClass('completed');
      $(this.selectors.chooseFitTab).attr('aria-selected', 'false');

      $('#choose-fit_tab .mtm-os__detail:not(.is-empty) .val').addClass('incomplete').html('');
      $('#mtm-os__fits.is-empty').removeAttr('hidden');
      /*------- Fit Tab End --------*/

      $('#AddToCart--MTM .price').html('');
      $('#AddToCart--MTM').attr('disabled','');
      $('.mtm-overview__footer').removeClass('active');

      // Scroll to top
      var offset = this.cache.$siteHeader.outerHeight();
      theme.scrollTo(this.selectors.mtmMainContainer, offset);

      this.fabricsGridHeights();
      
      // Restart Sticky MTM Overview
      this.initStickyMtmOverview();
    },

    closeFabricDetails: function() {

      this.cache.$fabricsButton.removeClass('active')
      this.cache.$fabricsButton.not('.selected').find('.mtm-fabrics__product-status').html('View Details');

      this.selectors.$mtmItems.isotope('remove', $('.grid-fabric-details')).isotope('layout');
      // Restart Sticky MTM Overview
      this.initStickyMtmOverview();

    }, // END f. closeFabricDetails

    selectFabric: function(evt) {
      if($(this.selectors.mtmOverviewContainer).find('.qty-error').length > 0){
        $(this.selectors.mtmOverviewContainer).find('.qty-error').remove();
      }
      var selected_variant_id = $(evt.target).data('variant-id');
        var grid_product = $('.mtm-fabrics__option-button[data-variant-id='+selected_variant_id+']').closest('.grid-product');
        if(grid_product.hasClass('is-sold-out')){
          $(evt.target).html('Fabric Sold Out');
          $(evt.target).addClass('sold-out-fabric');
          $(evt.target).prop('disabled',true);
          var product_name = grid_product.find('.grid-product__title').text();
          if($(this.selectors.mtmOverviewContainer).find('.qty-error').length == 0){
            $(this.selectors.addToCart).after(
              '<div class="errors qty-error">So sorry, but the product ' + product_name + ' is already sold out.</div>'
            );
          }
        }else{
          $(evt.target).addClass('selected');

          window.location.href = '#fabricID='+selected_variant_id;
          // Update class from currently active selected fabric button
          this.cache.$fabricsButton.each(function(){
              if($(this).hasClass('active')){
                  $(this).removeClass('active').addClass('selected').find('.mtm-fabrics__product-status').html('Selected Fabric');
              } else {
                  // Remove active class from any selected fabric button
                  $(this).removeClass('active selected').find('.mtm-fabrics__product-status').html('View Details');
              }
          });

          this.selectors.$mtmItems.isotope('remove', $('.grid-fabric-details')).isotope('layout');

          // Update [name="id"] input with variant id and overview tab with fabric name
          var variant_id = $(evt.target).data('variant-id');
          this.selectors.$mtmFabricId.val(variant_id);

          var fabricColor = $(evt.target).data('fabric-color');
          this.selectors.$mtmFabricSelectedColor.val(fabricColor);

          saver.save('fabric', variant_id);
          
          // Update fabric name in overview step
          var fabric_name = $(evt.target).data('fabric-name');

          if ( fabric_name == undefined) {
            $('#mtm-os__fabric .val').addClass('incomplete').html('- not yet selected');
            $(this.selectors.chooseFabricTab).removeClass('completed');
            return;
          }

          $('#mtm-os__fabric .val').removeClass('incomplete').html('- ' + fabric_name);
          $(this.selectors.chooseFabricTab).addClass('completed');
          this.validateOverviewSteps();

          // Update fabric price in Add to Cart button
          var fabric_price = $(evt.target).data('fabric-price');
          $('#AddToCart--MTM').data('price',fabric_price);

          // If active error message due to missing stock, hide it
          $('.errors.qty-error').remove();
          // Navigate to second step
          $(this.selectors.chooseFeaturesTab).trigger('click');
        }
        
        // Restart Sticky MTM Overview
        this.initStickyMtmOverview();
    }, // END f. selectFabric 

    initFeaturesTabs: function() {
        var self = this;
        /*
        *   This content is licensed according to the W3C Software License at
        *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
        */
        (function () {
            var tablist = document.querySelectorAll('[role="featuresTablist"]')[0];
            var tabs;
            var panels;
            var delay = determineDelay();
    
            generateArrays();
    
            function generateArrays () {
                tabs = document.querySelectorAll('[role="featuresTab"]');
                panels = document.querySelectorAll('[role="featuresTabpanel"]');
            };
    
            // For easy reference
            var keys = {
                end: 35,
                home: 36,
                left: 37,
                up: 38,
                right: 39,
                down: 40,
                delete: 46
            };
    
            // Add or substract depending on key pressed
            var direction = {
                37: -1,
                38: -1,
                39: 1,
                40: 1
            };
    
            // Bind listeners
            for (i = 0; i < tabs.length; ++i) {
                addListeners(i);
            };
    
            function addListeners (index) {
                tabs[index].addEventListener('click', clickEventListener);
                tabs[index].addEventListener('keydown', keydownEventListener);
                tabs[index].addEventListener('keyup', keyupEventListener);
    
                // Build an array with all tabs (<button>s) in it
                tabs[index].index = index;
            };
    
            // When a tab is clicked, activateTab is fired to activate it
            function clickEventListener (event) {
                var tab = event.target;
                activateTab(tab, false);
            };
    
            // Handle keydown on tabs
            function keydownEventListener (event) {
                var key = event.keyCode;
    
                switch (key) {
                case keys.end:
                    event.preventDefault();
                    // Activate last tab
                    activateTab(tabs[tabs.length - 1]);
                    break;
                case keys.home:
                    event.preventDefault();
                    // Activate first tab
                    activateTab(tabs[0]);
                    break;
    
                // Up and down are in keydown
                // because we need to prevent page scroll >:)
                case keys.up:
                case keys.down:
                    determineOrientation(event);
                    break;
                };
            };
    
            // Handle keyup on tabs
            function keyupEventListener (event) {
                var key = event.keyCode;
    
                switch (key) {
                case keys.left:
                case keys.right:
                    determineOrientation(event);
                    break;
                case keys.delete:
                    determineDeletable(event);
                    break;
                };
            };
    
            // When a tablistâ€™s aria-orientation is set to vertical,
            // only up and down arrow should function.
            // In all other cases only left and right arrow function.
            function determineOrientation (event) {
                var key = event.keyCode;
                var vertical = tablist.getAttribute('aria-orientation') == 'vertical';
                var proceed = false;
    
                if (vertical) {
                if (key === keys.up || key === keys.down) {
                    event.preventDefault();
                    proceed = true;
                };
                }
                else {
                if (key === keys.left || key === keys.right) {
                    proceed = true;
                };
                };
    
                if (proceed) {
                switchTabOnArrowPress(event);
                };
            };
    
            // Either focus the next, previous, first, or last tab
            // depening on key pressed
            function switchTabOnArrowPress (event) {
                var pressed = event.keyCode;
    
                for (x = 0; x < tabs.length; x++) {
                tabs[x].addEventListener('focus', focusEventHandler);
                };
    
                if (direction[pressed]) {
                var target = event.target;
                if (target.index !== undefined) {
                    if (tabs[target.index + direction[pressed]]) {
                    tabs[target.index + direction[pressed]].focus();
                    }
                    else if (pressed === keys.left || pressed === keys.up) {
                    focusLastTab();
                    }
                    else if (pressed === keys.right || pressed == keys.down) {
                    focusFirstTab();
                    };
                };
                };
            };
    
            // Activates any given tab panel
            function activateTab (tab, setFocus) {
              if(tab.id == 'style-options_tab'){
                if($('.mtm__error').length > 0){
                  $('.mtm__error').remove();
                }
                changeTab();
              }else{
                var selected_option = $('.mtm-choose-features__single-option.active .mtm-choose-features__details-select:not(.selected)');
                if(selected_option.length > 0 && selected_option.val() == null){
                  var currentTab = selected_option.parents('.mtm-choose-features__options-group');
                  if(currentTab.find('.mtm__error').length > 0){
                    currentTab.find('.mtm__error').remove();
                  }
                  if(currentTab.find('.mtm__error').length == 0){
                    currentTab.prepend('<div class="mtm__error errors">Please choose an option from the Dropdown.</div>');
                  }
                  selected_option.addClass('error-highlighted');
                }else{
                  if($('.mtm__error').length > 0){
                    $('.mtm__error').remove();
                    selected_option.removeClass('error-highlighted');
                    selected_option.addClass('selected');
                  }
                  if($('.mtm__error').length == 0){
                    changeTab();
                  }
                }
              }

                function changeTab(){                  
                  setFocus = setFocus || true;
                  // Deactivate all other tabs
                  deactivateTabs();
      
                  // Remove tabindex attribute
                  tab.removeAttribute('tabindex');
      
                  // Set the tab as selected
                  tab.setAttribute('aria-selected', 'true');
      
                  // Get the value of aria-controls (which is an ID)
                  var controls = tab.getAttribute('aria-controls');
                  console.log(controls)
                  // Remove hidden attribute from tab panel to make it visible
                  document.getElementById(controls).removeAttribute('hidden');
      
                  /* Set focus when required
                  if (setFocus) {
                    tab.focus();
                  };
                  */

                  // Restart Sticky MTM Overview
                  self.initStickyMtmOverview();
                }
            };
    
            // Deactivate all tabs and tab panels
            function deactivateTabs () {
                for (t = 0; t < tabs.length; t++) {
                tabs[t].setAttribute('tabindex', '-1');
                tabs[t].setAttribute('aria-selected', 'false');
                tabs[t].removeEventListener('focus', focusEventHandler);
                };
    
                for (p = 0; p < panels.length; p++) {
                panels[p].setAttribute('hidden', 'hidden');
                };
            };
    
            // Make a guess
            function focusFirstTab () {
                tabs[0].focus();
            };
    
            // Make a guess
            function focusLastTab () {
                tabs[tabs.length - 1].focus();
            };
    
            // Detect if a tab is deletable
            function determineDeletable (event) {
                target = event.target;
    
                if (target.getAttribute('data-deletable') !== null) {
                // Delete target tab
                deleteTab(event, target);
    
                // Update arrays related to tabs widget
                generateArrays();
    
                // Activate the closest tab to the one that was just deleted
                if (target.index - 1 < 0) {
                    activateTab(tabs[0]);
                }
                else {
                    activateTab(tabs[target.index - 1]);
                };
                };
            };
    
            // Deletes a tab and its panel
            function deleteTab (event) {
                var target = event.target;
                var panel = document.getElementById(target.getAttribute('aria-controls'));
    
                target.parentElement.removeChild(target);
                panel.parentElement.removeChild(panel);
            };
    
            // Determine whether there should be a delay
            // when user navigates with the arrow keys
            function determineDelay () {
                var hasDelay = tablist.hasAttribute('data-delay');
                var delay = 0;
    
                if (hasDelay) {
                var delayValue = tablist.getAttribute('data-delay');
                if (delayValue) {
                    delay = delayValue;
                }
                else {
                    // If no value is specified, default to 300ms
                    delay = 300;
                };
                };
    
                return delay;
            };
    
            //
            function focusEventHandler (event) {
                var target = event.target;
    
                setTimeout(checkTabFocus, delay, target);
            };
    
            // Only activate tab on focus if it still has focus after the delay
            function checkTabFocus (target) {
                focused = document.activeElement;
    
                if (target === focused) {
                activateTab(target, false);
                };
            };
        }());

        // Restart Sticky MTM Overview
        self.initStickyMtmOverview();
    }, // END f. initFeaturesTabs

    initChooseFeatures: function() {
      
      var self = this;

      /* === Style options == */
      $('input[name="properties[_styles-option]"]').on('change', function(){

        // Reset styles options  
        $('.mtm-choose-features__styles-option__item').hide();

        // Clear features radio selection 
        $('.mtm-choose-features__single-option input[type=radio]').prop('checked', false).trigger("change");
        $('.mtm-os__style__item .val').addClass('incomplete').html('not yet selected');

        // Remove complete status from tab
        $(self.selectors.chooseFeaturesTab).removeClass('completed');
        $('.mtm-choose-features__tabs').removeClass('completed');

        // TODO: Logic for start shirt from saved
        var selected_element_id = $(this).data('style-id');
        var selected_element_name = $(this).val();
        saver.save('style-option',  selected_element_name);

        if(selected_element_id == 'mtm-build-your-own') {
          // TODO: Logic for start shirt from saved
          // Component with "Start your Shirt" options
          // $("#mtm-build-your-own").removeAttr('hidden').show();
          // $('#mtm-os__style').removeAttr('hidden','').nextAll().attr('hidden','');

          // $('#mtm-os__style .attr').html('Build Your Own' + ': ');
          // $('#mtm-os__style .val').addClass('incomplete').html('not yet selected');

          $('.mtm-choose-features__tabs').removeAttr('hidden');

          $('.mtm-choose-features__options-group').addClass('active').find('.mtmTab_mobile-header').removeClass('tab-done expanded');
          $('.mtm-choose-features__standard-tab').removeClass('tab-done');
          if ($('.mtm-choose-features__options-group .mtmTab_mobile-header').is(':visible')) {
            $('.mtm-choose-features__options-group .mtmTab_inner').hide();
          }

          // // Show collar tab
          $('#collar_tab').trigger('click');
          
          // Update overview step details
          $('#mtm-os__features.is-empty').attr('hidden','');
          $('#mtm-os__style, .mtm-os__style__item').removeAttr('hidden');
          $('#mtm-os__style .attr').html(selected_element_name);
          $('#mtm-os__style .val').html('From Scratch');

        } else {
          $('.mtm-choose-features__options-group').removeClass('active');

          $('#' + selected_element_id).find('[name="properties[Style]"]').prop('checked', false)
            .end().show().addClass('show');

          // Update overview step details
          $('#mtm-os__features.is-empty').attr('hidden','');
          $('#mtm-os__style, .mtm-os__style__item').removeAttr('hidden').show().addClass('show');
          $('#mtm-os__style').removeAttr('hidden').nextAll().attr('hidden','');
          $('#mtm-os__style .attr').html(selected_element_name + ': ');
          $('#mtm-os__style .val').addClass('incomplete').html('not yet selected');

          // Restart Sticky MTM Overview
          self.initStickyMtmOverview();
        }
        
      });

      /*================ Build your own or saved one ======== */
      /*
      $("#mtm-build-your-own__from-scratch").on('change', function(){
        $('.mtm-choose-features__tabs').removeAttr('hidden');

        var selected_element_name = $(this).val();
          // $('#mtm-os__style');
          // Show collar tab
          $('#collar_tab').trigger('click');
          
          // Update overview step details
          $('#mtm-os__style, .mtm-os__style__item').removeAttr('hidden');
          $('#mtm-os__style .attr').html("Build Your Own:" );
          $('#mtm-os__style .val').html(selected_element_name);

          saver.save('style', selected_element_name);
      });
      */


      /* === Our House Style options === */
      $('#mtm-house-style__dress-shirt').on('change', function(){
        // $('.mtm-os__detail').attr('');
        // Update overview step details
        $('#mtm-os__style .val').removeClass('incomplete').html('Dress Shirt');

        saver.save('style', $(this).val());
        // Select Dress Shirt style radio options
        $('#mtm-collar__spread').prop("checked", true).trigger("change");
        $('#mtm-collar__spread').parent('.mtm-choose-features__single-option.active').find('.mtm-choose-features__details-select').addClass('selected');
        $('#mtm-front__full-placket').prop("checked", true).trigger("change");
        $('#mtm-back__side-pleats').prop("checked", true).trigger("change");
        $('#mtm-pocket__standard').prop("checked", true).trigger("change");
        $('#mtm-pocket__standard').parent('.mtm-choose-features__single-option.active').find('.mtm-choose-features__details-select').addClass('selected');
        $('#mtm-cuff__single-barrel').prop("checked", true).trigger("change");

        // Select Dress Shirt style details
        $('input[name="properties[Collar Detail]').val('Dress (crisp and clean)');
        $('#mtm-os__collar-detail .val').removeClass('incomplete').html('Dress (crisp and clean)');
        $('input[name="properties[Pocket Detail]').val('Single pocket');
        $('#mtm-os__pocket-detail .val').removeClass('incomplete').html('Single pocket');

        $(self.selectors.chooseFeaturesTab).addClass('completed');
        $('.mtm-choose-features__tabs').addClass('completed');
        self.validateOverviewSteps();

        // Scroll to top
        // var offset = self.cache.$siteHeader.outerHeight();
        // theme.scrollTo(self.selectors.mtmMainContainer, offset);

        // Restart Sticky MTM Overview
        self.initStickyMtmOverview();
      });

      $('#mtm-house-style__sport-shirt').on('change', function(){
        // $('#mtm-os__style').show().nextAll().show();
        // Update overview step details
        $('#mtm-os__style .val').removeClass('incomplete').html('Sport Shirt');

        saver.save('style', $(this).val());
        // Select Sport Shirt style radio options
        $('#mtm-collar__spread').prop("checked", true).trigger("change");
        $('#mtm-collar__spread').parent('.mtm-choose-features__single-option.active').find('.mtm-choose-features__details-select').addClass('selected');
        $('#mtm-front__full-placket').prop("checked", true).trigger("change");
        $('#mtm-back__side-pleats').prop("checked", true).trigger("change");
        $('#mtm-pocket__standard').prop("checked", true).trigger("change");
        $('#mtm-pocket__standard').parent('.mtm-choose-features__single-option.active').find('.mtm-choose-features__details-select').addClass('selected');
        $('#mtm-cuff__single-barrel').prop("checked", true).trigger("change");

        // Select Sport Shirt style details
        $('input[name="properties[Collar Detail]').val('Sport (soft and relaxed)');
        $('#mtm-os__collar-detail .val').removeClass('incomplete').html('Sport (soft and relaxed)');
        $('input[name="properties[Pocket Detail]').val('Single pocket');
        $('#mtm-os__pocket-detail .val').removeClass('incomplete').html('Single pocket');

        $(self.selectors.chooseFeaturesTab).addClass('completed');
        $('.mtm-choose-features__tabs').addClass('completed');
        self.validateOverviewSteps();

        // Scroll to top
        // var offset = self.cache.$siteHeader.outerHeight();
        // theme.scrollTo(self.selectors.mtmMainContainer, offset);

        // Restart Sticky MTM Overview
        self.initStickyMtmOverview();
      });

      $('.mtm-style__select-button, #fit-options_tab').on('click', function(){
        $('#choose-fit_tab').trigger('click');
        // Restart Sticky MTM Overview
        self.initStickyMtmOverview();
      });

      /* === Style Options Tabs === */
      $('#style-options_tab').on('click', function(){

        // Hide features tabs
        $('.mtm-choose-features__tabs').attr('hidden','');

        // Select House Styles radio
        $('#mtm-choose-features__house-sytles').prop("checked", true).trigger("change");

        // Restart Sticky MTM Overview
        self.initStickyMtmOverview();
      });

      /* === Single Features Option === */
      $('.mtm-choose-features__single-option input[type=radio]').on('change', function(){

        var name_attr = $(this).attr('name');
        var child_select_name_attr = name_attr.replace('properties[','').replace(']','');
        var property_name_caps = name_attr.replace('properties[','').replace(']','');
        var property_name = property_name_caps.toLowerCase();
        var property_val = $(this).val();

        

        // Disable radio parent siblings
        $('.mtm-choose-features__single-option input[type=radio][name="' + name_attr + '"]').parent('.mtm-choose-features__single-option').removeClass('active');
        // Reset option select details
        $('.mtm-choose-features__details__container select[data-detail-for="' + child_select_name_attr + '"] option:disabled').prop("selected", true);
        // Reset option input details
        $('input[name="properties[' + child_select_name_attr + ' Detail]"]').val('');

        
        $('#mtm-os__' + property_name).removeAttr('hidden');
        // Reset item options overview step details
        $('#mtm-os__' + property_name + '-detail').attr('hidden','');
        $('#mtm-os__' + property_name + '-detail .val').addClass('incomplete').html('not yet selected');

        if($(this).is(":checked")){

          saver.saveStyle(property_name_caps, property_val);
          $(this).closest('.mtmTab_inner').prev('.mtmTab_mobile-header').addClass('tab-done');
          var getTab = $(this).closest('.mtm-choose-features__options-group').attr('aria-labelledby');
          $('#'+getTab).addClass('tab-done');
          // Set triggered radio parent as active
          $(this).parent('.mtm-choose-features__single-option').addClass('active');
          //check if dropdown value selected
          var activeOption = $(this).parent('.mtm-choose-features__single-option.active');
          activeOption.find('.mtm-choose-features__details-select').removeClass('error-highlighted')
          activeOption.find('.mtm-choose-features__details-select').removeClass('selected');
          if($('.mtm__error').length > 0){
            $('.mtm__error').remove();
          }
          // Update overview step details
          $('#mtm-os__' + property_name + ' .val').removeClass('incomplete').html(property_val);
          // Show item options overview step details
          if($(this).siblings('.mtm-choose-features__details__container').length > 0 ){
            $('#mtm-os__' + property_name + '-detail').removeAttr('hidden');
          }

          self.updateMetafieldsForm(property_name, property_val, true);
        } 

        self.validateFeaturesOptions();

        // Restart Sticky MTM Overview
        self.initStickyMtmOverview();
      });

      /* === Single Features Option Details === */
      $('.mtm-choose-features__single-option select').on('change', function(){
        console.log("change triggered");
        if(!$(this).closest('.mtm-choose-features__details__container').is(':hidden')) {
          console.log("updating change");
          var detail_for = $(this).data('detail-for');
          var detail_for_handle = detail_for.toLowerCase();
          var property_val = $(this).val(); 
          //Remove Error
          if(property_val != '' || property_val != null){
            if($('.mtm__error').length > 0){
              $('.mtm__error').remove();
            }
            $(this).removeClass('error-highlighted');
            $(this).addClass('selected');
          }  
          // Update input val
          $('input[name="properties[' + detail_for + ' Detail]').val(property_val);
          // Update overview step details
          $('#mtm-os__' + detail_for_handle + '-detail .val').removeClass('incomplete').html(property_val);

          self.updateMetafieldsForm(detail_for_handle + '-detail', property_val);
         
        }

        saver.saveDetails(detail_for_handle, property_val);
        self.validateFeaturesOptions();
        // Restart Sticky MTM Overview
        self.initStickyMtmOverview();
      });

      // Restart Sticky MTM Overview
      self.initStickyMtmOverview();

    }, // END f. initChooseStyle
    updateMetafieldsForm: function(id, value, parent = false){
      // console.log(id);
      $(`form#mtm-features-meta-form input[name="${id.replaceAll('-','_')}"]`).val(value);

      if( parent ) {
        $(`form#mtm-features-meta-form input[name="${id.replaceAll('-','_')}_detail"]`).val("");
      }
    },
    saveMetafields: function(formEl, key){
      function getFormData($form){
        var unindexed_array = $form.serializeArray();
        var indexed_array = {};
    
        $.map(unindexed_array, function(n, i){
            indexed_array[n['name']] = n['value'];
        });
    
        return indexed_array;
      }

      const customer_logged_in = $("#mtm-customer-id").val();
      if( customer_logged_in != "") {
        const fdata = getFormData(formEl);
        let dataobj = {
          'customer[id]' : fdata.customer_id
        };
        
        dataobj[`metafield[${key}]`] = JSON.stringify(fdata);
          $.ajax({
            type: "POST",
            datatype: "json",
            data: $.param(dataobj),
            url: '/a/custmeta',
            success: function (data) {
                  var formValid = (data.status === 'OK');
                  if (formValid) {
                    var msgs = '';
                    for (var i=0;i<data.messages.length;i++) {
                      msgs += '-- ' + data.messages[i] + '\n';
                    }
                    if (msgs > '') {
                      console.log('SUCCESS WITH MESSAGES:\n\n' + msgs);
                    }
                    else {
                      console.log('SUCCESS!');
                    }
                  }
                  else {
                    console.log('Status: ' + data.status + '\nMessage: ' + data.message);
                  }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                  alert('AJAX or Server 500 error occurred');
                }
          });
      }
    },
    validateFeaturesOptions: function() {
      const self = this;
      // Validate if Features Options complete 
      var mtm_os_styles_complete = true;
      $('.mtm-os__style__item').each(function(){
        if($(this).children('.val').hasClass('incomplete')){
          mtm_os_styles_complete = false;
        }
      });

      $('.mtm-os__style__item-detail').each(function(){
        if(!$(this).is(':hidden') && $(this).children('.val').hasClass('incomplete')){
          mtm_os_styles_complete = false;
        }
      });

      if(mtm_os_styles_complete) {
        console.log('completed');
        self.saveMetafields($("#mtm-features-meta-form"), 'ccmtm.features');
        $(this.selectors.chooseFeaturesTab).addClass('completed');
        $('.mtm-choose-features__tabs').addClass('completed');
        this.validateOverviewSteps();
      } else {
        $(this.selectors.chooseFeaturesTab).removeClass('completed');
        $('.mtm-choose-features__tabs').removeClass('completed');
      }

    }, // END f. validateFeaturesOptions

    initChooseFit: function() {

      var self = this;

      $(".close-mtm-login-popup").on('click',function(){
        $("#mtm-login-popup").removeClass('is-active');
        // Restart Sticky MTM Overview
        self.initStickyMtmOverview();
      });
      /* === Fit options == */
      $('input[name="properties[Fit]"]').on('change', function(){
        $('#choose-fit-options_tab').addClass('tab-done').attr('aria-selected',false);
        $('#choose-size-options_tab').attr('aria-selected',true);
        $('#mtm-size-preference').removeClass('inactive');
        $('#mtm-fit-preference .mtm-fit__error').attr('hidden','');
        var property_val = $(this).val();
        // Update overview step details
        $('#mtm-os__fits.is-empty').attr('hidden','');
        $('#mtm-os__fit-title, #mtm-os__fit').removeAttr('hidden');
        $('#mtm-os__fit .val').removeClass('incomplete').html(property_val);
        saver.save('fit', property_val);
        self.validateFitOptions();
        // Restart Sticky MTM Overview
        self.initStickyMtmOverview();
      });

      /* === Size options Navigation == */
      $('input[name="properties[Size Type]"]').on('change', function(){
        if($(this).parents('#mtm-size-preference').hasClass('inactive')){
          theme.scrollTo('#mtm-fit-preference', 150);
          $(this).prop('checked',false);
          $('#mtm-fit-preference .mtm-fit__error').removeAttr('hidden');
        }else{
          $('#choose-size-options_tab').addClass('tab-done');
          // Hide overview option details 
          $('.mtm-size__option-details').attr('hidden','');
          // Disable all input/select elements in Size Type tab panels
          $('.mtm-size__option-details').find('input, select').each((idx, el) => {
            $(el).prop('disabled', true);
          });

          var radio_val = $(this).val();
          if (radio_val == "From file") {
            //Disable ATC
            $('#AddToCart--MTM .price').html('');
            $('#AddToCart--MTM').attr('disabled','');
            $('.mtm-overview__footer').removeClass('active');

            //Removing values form Self measurement
            $('.mtm-os__self-measure__item').each(function(){
              $(this).children('.val').html('').addClass('incomplete');
            });

            $('#mtm-os__size-type .val').removeClass('incomplete').html(radio_val);
            if($(this).attr('data-logged-in') == "false") {
              saver.save('autoload', "yes");
              $('#mtm-os__size').attr('hidden','');
              $("#mtm-login-popup").addClass('is-active');
              // Restart Sticky MTM Overview
              self.initStickyMtmOverview();
              return;
            }
            else {
              $('.mtm-os__size__item').attr('hidden','');
              $('.self-measurement__input').each(function(){
                var attr_name = $(this).attr('id').replace('self-measurement__','');
                var attr_val = $(this).val();
                if(attr_val != '' && attr_val != null){
                  $('#mtm-os__' + attr_name + ' .val').removeClass('incomplete').html(attr_val);
                  $('.mtm-os__self-measure__item').removeAttr('hidden');
                  has_file = true;
                }
              });
      
              $('.self-measurement__select').each(function(){
                var attr_name = $(this).attr('id').replace('self-measurement__','');
                var attr_val = $(this).val();
                if(attr_val != '' && attr_val != null){
                  $('#mtm-os__' + attr_name + ' .val').removeClass('incomplete').html(attr_val);
                  $('.mtm-os__self-measure__item').removeAttr('hidden');
                  has_file = true;
                }
              });

              if(!has_file){
                $('#mtm-size__from-file').attr('disabled','');
              }
      
              self.validateFitOptions();
            }
          }

          saver.save('size_type', radio_val);
          // Show active size options
          var radio_id = $(this).attr('id');
          var aria_controls = $('label[for="' + radio_id + '"]').attr('aria-controls');
          $('#' + aria_controls).removeAttr('hidden');
          // Enable all input/select elements in current active tab panel
          $('#' + aria_controls).find('input, select').each((idx, el) => {
            $(el).prop('disabled', false);
          });
        
          // Update overview step details
          $('#mtm-os__fits.is-empty').attr('hidden','');
          $('#mtm-os__fit-title, #mtm-os__size-type').removeAttr('hidden');
          $('#mtm-os__size-type .val').removeClass('incomplete').html(radio_val);
          if (radio_val == 'Stock Size'){
            $('.mtm-os__self-measure__item').attr('hidden','');
            $('.mtm-os__size__item').removeAttr('hidden'); 
            $("#mtm-login-popup").removeClass('is-active');
          } else if (radio_val == 'Self Measure'){
            $('.mtm-os__size__item').attr('hidden','');
            $('.mtm-os__self-measure__item').removeAttr('hidden');
            $("#mtm-login-popup").removeClass('is-active');
            self.initSMYouTubeVideo();
          } else {
            if($(this).attr('data-logged-in') == "false") {
              $('.mtm-os__size__item, .mtm-os__self-measure__item').attr('hidden','');
            }
          }

          self.validateFitOptions();

          // Restart Sticky MTM Overview
          self.initStickyMtmOverview();
        }
      });

      /* === Size options Header == */
      $('.mtm-size__btn-close').on('click', function(){  

        // Hide option detail
        $('.mtm-size__option-details').attr('hidden','');
        // Uncheck size type radio 
        $('input[name="properties[Size Type]"]').prop('checked', false);
        // Update overview step details
        $('#mtm-os__size .val').addClass('incomplete').html('not yet selected');   
        // Restart Sticky MTM Overview
        self.initStickyMtmOverview();
      });

      /* === Stock Size Options == */
      $('#mtm-size__stock-size__dress-shirt-size').on('change', function(){

        if($(this).val() != ''){
          // Clear sport shirt size
          $('#mtm-size__stock-size__sport-shirt-size option:disabled').prop("selected", true);
          // Enable confirm size btn
          $('#stock-size__btn').removeAttr('disabled');
        }
      });

      $('#mtm-size__stock-size__sport-shirt-size').on('change', function(){

        if($(this).val() != ''){
          // Clear dress shirt size
          $('#mtm-size__stock-size__dress-shirt-size option:disabled').prop("selected", true);
          // Enable confirm size btn
          $('#stock-size__btn').removeAttr('disabled');
        }
      });

      $('#stock-size__btn').on('click', function(){

          var dress_shirt_size = $('#mtm-size__stock-size__dress-shirt-size').val();
          var sport_shirt_size = $('#mtm-size__stock-size__sport-shirt-size').val();

          if(dress_shirt_size != "" && dress_shirt_size !== null){
            $('#mtm-os__size .val').removeClass('incomplete').html(dress_shirt_size);
          } else {
            $('#mtm-os__size .val').removeClass('incomplete').html(sport_shirt_size);
          }
          self.validateFitOptions();
      });

      // Set Customer data to YOUR MEASUREMENTS form
      var mtm_sm_input_complete = true;
      $('.self-measurement__input, .self-measurement__select').each(function(){
        const t = $(this);
        let prop = t.attr('name').replaceAll('properties[','').replaceAll(']','').replaceAll(' ','_').toLowerCase();

        if ($(this).attr("id") == "self-measurement__height") {
          if ($("#mtm-features-meta-form input[name=height_ft]").val() && $("#mtm-features-meta-form input[name=height_in]").val()) {
            $(this).val($("#mtm-features-meta-form input[name=height_ft]").val() + " ft. " + $("#mtm-features-meta-form input[name=height_in]").val() + " in.")
          }
        }
        else {
          $(this).val($("#mtm-features-meta-form input[name='" + prop + "']").val());
        }
      })

      makeMetafields();

      //check if user have previous size file
      var has_file = false;
      if($('#mtm-size__from-file').attr('data-logged-in') == "true") {
        $('.self-measurement__input').each(function(){
          var attr_name = $(this).attr('id').replace('self-measurement__','');
          var attr_val = $(this).val();
          if(attr_val != '' && attr_val != null){
            $('#mtm-os__' + attr_name + ' .val').removeClass('incomplete').html(attr_val);
            $('.mtm-os__self-measure__item').removeAttr('hidden');
            has_file = true;
          }
        });

        $('.self-measurement__select').each(function(){
          var attr_name = $(this).attr('id').replace('self-measurement__','');
          var attr_val = $(this).val();
          if(attr_val != '' && attr_val != null){
            $('#mtm-os__' + attr_name + ' .val').removeClass('incomplete').html(attr_val);
            $('.mtm-os__self-measure__item').removeAttr('hidden');
            has_file = true;
          }
        });
        console.log('has_file',has_file)
        if(!has_file){
          $('#mtm-size__from-file').attr('disabled','');
        }
        $('#mtm-size__from-file:not([disabled])').prop('checked',true).trigger('change');
        setTimeout(function(e){
          self.validateFitOptions();
        },2000);
      }
      
      $('.self-measurement__input').each(function(){
        if($(this).val() == '') { 
          mtm_sm_input_complete = false;
        } 
      });

      if(mtm_sm_input_complete) {
        $('#self-measurement__btn').removeAttr('disabled');
        this.validateOverviewSteps();
      }

      function makeMetafields(){
        const form = $("#mtm-fit-meta-form");
        form.find('input.metafield-input').remove();

        $('.self-measurement__input, .self-measurement__select').each(function(){
          const t = $(this),
                v = t.val();

          let prop = t.attr('name').replaceAll('properties[','').replaceAll(']','');
          
          if( v != "" && v != null ) {
            if (t.attr("id") == "self-measurement__height") {
              let ft_value = $(this).val().match(/\d+/g)[0];
              let in_value = $(this).val().match(/\d+/g)[1];

              let input_ft = $(`<input type="hidden" name="metafield[ccmtm.height_ft]" id="metafield_height_ft" class="metafield-input" />`).val(ft_value);
              let input_in = $(`<input type="hidden" name="metafield[ccmtm.height_in]" id="metafield_height_in" class="metafield-input" />`).val(in_value);

              input_ft.appendTo(form);
              input_in.appendTo(form);
            }
            else {
              let input = $(`<input type="hidden" name="metafield[ccmtm.${prop.replaceAll('-','_').replaceAll(' ','_').toLowerCase()}]"  class="metafield-input" />`).val(v);
              input.appendTo(form);
            }
          }
        })
      }
      /* === Self Measurement Size Options == */
      $('.self-measurement__input, .self-measurement__select').on('change', function() {

        makeMetafields();

        // Validate if self measurement complete 
        mtm_sm_input_complete = true;
        $('.self-measurement__input').each(function(){
          if($(this).val() == '') { 
            mtm_sm_input_complete = false;
          } 
        });

        $('.self-measurement__select').each(function(){
          if( $(this).val() == null) {
            mtm_sm_input_complete = false;
          } 
        });

        if(mtm_sm_input_complete) {
          const formEl = $("#mtm-fit-meta-form");
          $.ajax({
            type: "POST",
            dataType: "json",
            data: formEl.serialize(),
            url: formEl.attr('action'),
            success: function (data) {
              var formValid = (data.status === 'OK');
              if (formValid) {
                var msgs = '';
                for (var i=0;i<data.messages.length;i++) {
                  msgs += '-- ' + data.messages[i] + '\n';
                }
                if (msgs > '') {
                  // alert('SUCCESS WITH MESSAGES:\n\n' + msgs);
                }
                else {
                  // alert('SUCCESS!');
                }
              }
              else {
                  // alert('Status: ' + data.status + '\nMessage: ' + data.message);
              }
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.log('AJAX or Server 500 error occurred');
            }
          });

          $('#self-measurement__btn').removeAttr('disabled');
        } else {
          $('#self-measurement__btn').attr('disabled','');
        }
      });

      $(document).on('click','#self-measurement__btn:not([disabled])', function(){
        document.getElementById('self-measurement__cross-shoulder').validity.rangeOverflow;
        document.getElementById('self-measurement__neck').validity.rangeOverflow;
        document.getElementById('self-measurement__chest').validity.rangeOverflow;
        document.getElementById('self-measurement__waist').validity.rangeOverflow;
        document.getElementById('self-measurement__hip').validity.rangeOverflow;
        document.getElementById('self-measurement__left-sleeve').validity.rangeOverflow;
        document.getElementById('self-measurement__left-wrist').validity.rangeOverflow;
        document.getElementById('self-measurement__right-sleeve').validity.rangeOverflow;
        document.getElementById('self-measurement__right-wrist').validity.rangeOverflow;
        
        // Adding validation on saving my measurements
        let valid = true;
        $('.sm__your-measurements__container').find('input, select').each((idx, el) => {
          if (el.checkValidity() == false || el.value == '') {
            valid = false;
          }
        })
        
        if (!valid) {
          if (self.cache.$addToCart.prop('disabled')) {
            self.cache.$addToCart.prop('disabled', false);
            self.cache.$addToCart.click();
            self.cache.$addToCart.prop('disabled', true);
          } else {
            self.cache.$addToCart.click();
          }
          return;
        }

        $('.self-measurement__input').each(function(){
          var attr_name = $(this).attr('id').replace('self-measurement__','');
          var attr_val = $(this).val();
          $('#mtm-os__' + attr_name + ' .val').removeClass('incomplete').html(attr_val);
        });

        $('.self-measurement__select').each(function(){
          var attr_name = $(this).attr('id').replace('self-measurement__','');
          var attr_val = $(this).val();
          $('#mtm-os__' + attr_name + ' .val').removeClass('incomplete').html(attr_val);
        });

        self.validateFitOptions();
      });

      // Restart Sticky MTM Overview
      self.initStickyMtmOverview();   
    },

    validateFitOptions: function() {

      // Validate if Fit Options complete 
      var mtm_os_fit_complete = true;
      if($('#mtm-os__fit .val, #mtm-os__size-type .val').hasClass('incomplete')) {
          mtm_os_fit_complete = false;
      }

      $('.mtm-os__size__item, .mtm-os__self-measure__item').each(function(){
        if(!$(this).prop('hidden') && $(this).children('.val').hasClass('incomplete')){
          mtm_os_fit_complete = false;
        }
      });

      if(mtm_os_fit_complete) {
        $(this.selectors.chooseFitTab).addClass('completed');
      } else {
        $(this.selectors.chooseFitTab).removeClass('completed');
      }

      this.validateOverviewSteps();
    }, // END f. validateFitOptions

    initYouTubeAPI: function() {
        // Init Youtube API
        var tag = document.createElement('script');
        tag.src = "//www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    }, // END f. initYouTubeAPI

    initSMYouTubeVideo: function() {
        var playerInfo = {
                id:'mtm-size__self-measurement__ytplayer',
                height:'620px',
                width:'100%',
                videoId:'Ugc7RquA9rk', 
                playerVars: {
                    rel: 0, 
                    wmode: 'opaque', 
                    showinfo: 0 
                }
            };

            this.yt_player = new YT.Player(playerInfo.id, {
                height: playerInfo.height,
                width: playerInfo.width,
                videoId: playerInfo.videoId,
                playerVars: playerInfo.playerVars,
                color: "white"
            });
    }, // END f. initSMYouTubeVideo
    
    // Show Size Self-Measurement Attr Details
    showSizeAttrDetails: function(evt) {
       
        var v_seconds = $(evt.target).data('seconds');
        var attribute = $(evt.target).data('attr');

        this.yt_player.seekTo(v_seconds);

        // Scroll to top
        var offset = this.cache.$siteHeader.outerHeight();
        theme.scrollTo('#mtm-size__self-measurement__ytplayer', offset);
        
        // Update Attr Details on the right
        $('.sm__item-info').attr('hidden','');
        $('#sm__detail-' + attribute).removeAttr('hidden');

    }, // END f. showSizeAttrDetails

    validateOverviewSteps: function() {

      if ($(this.selectors.chooseFabricTab).hasClass('completed') &&
          $(this.selectors.chooseFeaturesTab).hasClass('completed') &&
          $(this.selectors.chooseFitTab).hasClass('completed')) {
        var price = $('#AddToCart--MTM').data('price');
        var moneyFormat = theme.strings.moneyFormat;
        $('#AddToCart--MTM .price').html(' - ' + theme.Currency.formatMoney(price, moneyFormat));
        $('#AddToCart--MTM').removeAttr('disabled');
        $('.mtm-overview__footer').addClass('active');
      } else {
        $('#AddToCart--MTM .price').html('');
        $('#AddToCart--MTM').attr('disabled','');
        $('.mtm-overview__footer').removeClass('active');
      }

    } // END f. validateOverviewSteps
  });

  return MTM;
})();

theme.MTO = (function() {

  function MTO() {
    var self = this;
    var $window = $(window);
    this.$window = $(window);
    this.$body = $('body');

    // Init SM Youtube Player
    this.yt_player;
    
    this.settings = {
        selfMeasurementsVideoId: 'Ugc7RquA9rk',
        namespace: '.mtoSection'
    }

    this.nodes = {
      $siteHeader: $('.site-header'),
      $announcementBar: $('.announcement-bar')
    };

    this.selectors = {
        siteHeader: '.site-header',
        mtoGeneralContainer: '.mto-general__container',
        mtoMainContainer: '#mto-main__container',
        $heroImage: $('.mto-hero__image'),
        mtoOverviewContainer: '.mto-overview__container',
        $mtoOverviewInner: $('.mto-overview__inner'),
        chooseFabricTab: '#choose-fabric_tab',
        chooseBodyTab: '#choose-body_tab',
        bodyPrice: '.mto-house-style__price',
        chooseFitTab: '#choose-fit_tab',
        $mtoFabricId: $('#mto-fabrics__input__id'),
        $mtoFabricSelected: $('#mto-fabrics__selected'),
        $mtoFabricSelectedId: $('#mto-fabrics__selected_Id'),
        $mtoFinalSale: $('#mto-final_sale'),
        $mtoFabricSelectedColor: $('#mto-fabrics__selected_Color'),
        $mtoItemsContainer: $('.mto-grid__items__container'),
        $mtoItems: $('.mto-grid__items'),
        mtoProductItems: '.grid-product',
        fabricsViewRadio: 'input[name="mto-fabrics__view-option"]',
        fabricsButton: '.mto-fabrics__option-button',
        productGridMeta: '.grid-product__meta',
        fabricDetailCloseButton: '.mto-fabric-detail__close-button',
        fabricDetailSelectButton: '.mto-fabric-detail__select-button',
        sizeAttrLink: '.mto-size__sm__attr-link',
        addToCart: '#AddToCart--MTO',
        mtoStartOver: '.mto-action-icon__start-over'
    }
    
    this.selectors.$heroImage.addClass('is-init');

    ajaxCart.init({
        formSelector: '#AddToCartForm--MTO',
        cartContainer: '#CartContainer',
        addToCartSelector: '#AddToCart--MTO',
        enableQtySelectors: true,
        moneyFormat: theme.strings.moneyFormat
    });

    theme.cache.$window
      .on(
        'resize' + this.settings.namespace,
        theme.debounce(this.initStickyMtoOverview, 150).bind(this)
      )
      .on('scroll', function() {
          var scrolled = theme.cache.$window.scrollTop();
          theme.cache.$heroImage.css({
              transform: 'translate3d(0, ' + scrolled / 4.5 + 'px, 0)'
          });
      });

    this.init();

    $window.on('load', function(){
      self.initStickyMtoOverview();
    });
 }
  var saver =  {
    store: function(data){
      window.localStorage.setItem("mto_details", JSON.stringify(data));
    },
    clear: function(){
      window.localStorage.setItem("mto_details", "{}");
    },
    retreive: function(){
      stored = window.localStorage.getItem('mto_details');
      if ( stored == "" || stored == undefined || stored == null ) {
        return {};
      }
      let data = JSON.parse(stored);
      if (data == null ) {
        return {};
      }
      return data;
    },
    get: function(key){
      const data  = this.retreive();
      if( data.hasOwnProperty(key)){
        return data[key];
      }
      return false;
    },
    save: function(key, value){
      let data = this.retreive();
      data[key] = value;
      this.store(data);
    },
    saveStyle: function(key, value) {
      console.log('saving style ' + key + ' : ' + value);
      let data = this.retreive();
      styles = {};
      if(data.hasOwnProperty('styles')) {
        styles = data.styles;
      }
      
      styles[key] = value;
      this.save("styles", styles);
    },
    saveDetails: function(key, value) {
      console.log('saving details ' + key + ' : ' + value);
      let data = this.retreive();
      details = {};
      if(data.hasOwnProperty('details')) {
        details = data.details;
      }
      
      details[key] = value;
      this.save("details", details);
    },
    autoload_hook: function(container){
      if( this.get('autoload') == "yes") {
        this.load(container);
        saver.save('autoload' , 'no');
        saver.clear();
      }
    },
    load: function(container){
      const data = this.retreive();
      const saved_style = this.get('body-type');
      if ( saved_style ) {
        $(`input[name="properties[_styles-option]"][value="${saved_style}"]`).trigger("click");
      }

      if( this.get('fabric')) {
        const fabricBtn = $(`.mto-fabrics__option-button[data-variant-id=${data.fabric}]`);
        const fabric_product_handle = fabricBtn.data('product-handle');
        // console.log($(`.mto-fabric-detail__select-button[data-variant-id=${data.fabric_variant_id}]`));

        jQuery.getJSON('/products/' + fabric_product_handle + '.js', function(product) {
          fabricBtn.addClass('selected');
          container.selectors.$mtoFabricId.val(product.variants[0].id);
          container.selectors.$mtoFabricSelected.val(product.title);
          container.selectors.$mtoFabricSelectedId.val(product.variants[0].id);
          $('#mto-os__fabric .val').removeClass('incomplete').html('- ' + product.title);
          $(container.selectors.chooseFabricTab).addClass('completed');

          // Update fabric price in Add to Cart button
          $('#AddToCart--MTO').data('price',product.variants[0].price);
        });
      }


      if( this.get('style')) {
        const style = this.get('style');
        $(`input[name="properties[Body Type]"][value="${style}"]`).trigger('click');

        if( style.toLowerCase() == "from scratch"){
          const styles = saver.get('styles');
          const details = saver.get('details');
          for( let i in styles ) {
            console.log(i, styles[i]);

            // console.log(`input[name="properties[${i}]"][value="${styles[i]}"]`);
            let input = $(`input[name="properties[${i}]"][value="${styles[i]}"]`);

            input.trigger('click').trigger('change');
            if(input.siblings('.mto-choose-body__details__container').length > 0 ){
              // $('#mto-os__' + property_name + '-detail').removeAttr('hidden');
              let sel = input.siblings('.mto-choose-body__details__container').find(`select`);
              sel.val(details[i.toLowerCase()]);
              var detail_for = sel.data('detail-for');
              var detail_for_handle = detail_for.toLowerCase();
              var property_val = sel.val(); 
              
              // Update input val
              $('input[name="properties[' + detail_for + ' Detail]').val(property_val);
              // Update overview step details
              $('#mto-os__' + detail_for_handle + '-detail .val').removeClass('incomplete').html(property_val);
            }
          }
        }
      }

      if( this.get('fit')) {
        // console.log(`input[name="properties[Fit]"][value="${this.get('fit')}]`));
        $(`input[name="properties[Fit]"][value="${this.get('fit')}"]`).trigger('click').trigger('change');

      }
      if( this.get('size_type')) {
        if(this.get('size_type') != 'Self Measure'){
          $(`input[name="properties[Size Type]"][value="${this.get('size_type')}"]`).trigger('click').trigger('change');
        }
      }
    }
  };
  window.saver = saver;
  MTO.prototype = _.assignIn({}, MTO.prototype, {
    init: function() {
        this.cacheSelectors();
        this.initOverviewTabs();
        this.initFabricsGrid();
        this.initBodyTabs();
        this.initChooseBody();
        this.initChooseFit();
        this.initYouTubeAPI();
        this.initCustomBodyAccordion();
        

        // Bind Events
        // Fabric View toggle 
        this.cache.$fabricsViewRadio.on('change', this.toggleFabricsView.bind(this));
        // Fabric Btn click
        this.cache.$fabricsButton.on('click', this.openFabricDetails.bind(this));
        // Size Self-Measurement Attr Btn click
        this.cache.$sizeAttrLink.on('click', this.showSizeAttrDetails.bind(this));

        this.cache.$mtoStartOver.on('click', this.startOver.bind(this));

        saver.autoload_hook(this);
    },
    
    cacheSelectors: function() {
        this.cache = {
          $html: $('html'),
          $window: $(window),
          $siteHeader: $(this.selectors.siteHeader),
          $mtoChooseFabricTab: $(this.selectors.chooseFabricTab),
          $chooseBodyTab: $(this.selectors.chooseBodyTab),
          $chooseFitTab: $(this.selectors.chooseFitTab),
          $mtoProductItems: $(this.selectors.mtoProductItems),
          $productGridMeta: $(this.selectors.productGridMeta),
          $fabricsViewRadio: $(this.selectors.fabricsViewRadio),
          $fabricsButton: $(this.selectors.fabricsButton),
          $bodyPrice: $(this.selectors.bodyPrice),
          $sizeAttrLink: $(this.selectors.sizeAttrLink),
          $addToCart: $(this.selectors.addToCart),
          $mtoStartOver: $(this.selectors.mtoStartOver)
        };
    },

    
    initCustomBodyAccordion: function(){
      const self = this;

      $(".mtoTab_mobile-header").on('click',function(){
        var selected_option = $('.mto-choose-body__single-option.active .mto-choose-body__details-select:not(.selected)');
        console.log(selected_option);
        if(selected_option.length > 0 && selected_option.val() == null){
          var currentTab = selected_option.parents('.mto-choose-body__options-group');
          if(currentTab.find('.mto__error').length > 0){
            currentTab.find('.mto__error').remove();
          }
          if(currentTab.find('.mto__error').length == 0){
            currentTab.prepend('<div class="mto__error errors">Please choose an option from the Dropdown.</div>');
            theme.scrollTo(selected_option, 150);
          }
          selected_option.addClass('error-highlighted');
        }else{
          if($('.mto__error').length > 0){
            $('.mto__error').remove();
            selected_option.removeClass('error-highlighted');
            selected_option.addClass('selected');
          }
          if($('.mto__error').length == 0){
            changeAccordion($(this));
          }
        }
        

        function changeAccordion(heaeder){
          const t = heaeder,
              tab = heaeder.next(".mtoTab_inner");
          t.toggleClass('expanded');

          if( t.hasClass('expanded')){
            $("[data-mto-tab-inner]").not(tab).slideUp();
            $(".mtoTab_mobile-header").not(t).removeClass('expanded');
            tab.slideDown();
          } else {
            tab.slideUp();
          }
          //
        }
      });
    },

    initOverviewTabs: function() {
        var self = this;
        /*
        *   This content is licensed according to the W3C Software License at
        *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
        */
        (function () {
            var tablist = document.querySelectorAll('[role="overviewTablist"]')[0];
            var tabs;
            var panels;
            var delay = determineDelay();
    
            generateArrays();
    
            function generateArrays () {
                tabs = document.querySelectorAll('[role="overviewTab"]');
                panels = document.querySelectorAll('[role="overviewTabpanel"]');
            };
    
            // For easy reference
            var keys = {
                end: 35,
                home: 36,
                left: 37,
                up: 38,
                right: 39,
                down: 40,
                delete: 46
            };
    
            // Add or substract depending on key pressed
            var direction = {
                37: -1,
                38: -1,
                39: 1,
                40: 1
            };
    
            // Bind listeners
            for (i = 0; i < tabs.length; ++i) {
                addListeners(i);
            };
    
            function addListeners (index) {
                tabs[index].addEventListener('click', clickEventListener);
                tabs[index].addEventListener('keydown', keydownEventListener);
                tabs[index].addEventListener('keyup', keyupEventListener);
    
                // Build an array with all tabs (<button>s) in it
                tabs[index].index = index;
            };
    
            // When a tab is clicked, activateTab is fired to activate it
            function clickEventListener (event) {
                var tab = event.target;
                activateTab(tab, false);
            };
    
            // Handle keydown on tabs
            function keydownEventListener (event) {
                var key = event.keyCode;
    
                switch (key) {
                case keys.end:
                    event.preventDefault();
                    // Activate last tab
                    activateTab(tabs[tabs.length - 1]);
                    break;
                case keys.home:
                    event.preventDefault();
                    // Activate first tab
                    activateTab(tabs[0]);
                    break;
    
                // Up and down are in keydown
                // because we need to prevent page scroll >:)
                case keys.up:
                case keys.down:
                    determineOrientation(event);
                    break;
                };
            };
    
            // Handle keyup on tabs
            function keyupEventListener (event) {
                var key = event.keyCode;
    
                switch (key) {
                case keys.left:
                case keys.right:
                    determineOrientation(event);
                    break;
                case keys.delete:
                    determineDeletable(event);
                    break;
                };
            };
    
            // When a tablistâ€™s aria-orientation is set to vertical,
            // only up and down arrow should function.
            // In all other cases only left and right arrow function.
            function determineOrientation (event) {
                var key = event.keyCode;
                var vertical = tablist.getAttribute('aria-orientation') == 'vertical';
                var proceed = false;
    
                if (vertical) {
                if (key === keys.up || key === keys.down) {
                    event.preventDefault();
                    proceed = true;
                };
                }
                else {
                if (key === keys.left || key === keys.right) {
                    proceed = true;
                };
                };
    
                if (proceed) {
                switchTabOnArrowPress(event);
                };
            };
    
            // Either focus the next, previous, first, or last tab
            // depening on key pressed
            function switchTabOnArrowPress (event) {
                var pressed = event.keyCode;
    
                for (x = 0; x < tabs.length; x++) {
                tabs[x].addEventListener('focus', focusEventHandler);
                };
    
                if (direction[pressed]) {
                var target = event.target;
                if (target.index !== undefined) {
                    if (tabs[target.index + direction[pressed]]) {
                    tabs[target.index + direction[pressed]].focus();
                    }
                    else if (pressed === keys.left || pressed === keys.up) {
                    focusLastTab();
                    }
                    else if (pressed === keys.right || pressed == keys.down) {
                    focusFirstTab();
                    };
                };
                };
            };
    
            // Activates any given tab panel
            function activateTab (tab, setFocus) {
              if(tab.id == 'style-options_tab'){
                if($('.mto__error').length > 0){
                  $('.mto__error').remove();
                }
                changeTab();
              }else{
                var selected_option = $('.mto-choose-body__single-option.active .mto-choose-body__details-select:not(.selected)');
                if(selected_option.length > 0 && selected_option.val() == null){
                  var currentTab = selected_option.parents('.mto-choose-body__options-group');
                  if(currentTab.find('.mto__error').length > 0){
                    currentTab.find('.mto__error').remove();
                  }
                  if(currentTab.find('.mto__error').length == 0){
                    currentTab.prepend('<div class="mto__error errors">Please choose an option from the Dropdown.</div>');
                  }
                  selected_option.addClass('error-highlighted');
                }else{
                  if($('.mto__error').length > 0){
                    $('.mto__error').remove();
                    selected_option.removeClass('error-highlighted');
                    selected_option.addClass('selected');
                  }
                  if($('.mto__error').length == 0){
                    changeTab();
                  }
                }

                if(tab.id == 'choose-fabric_tab'){
                  //disable not available fabric if body type is selected already
                  if($('.mto-card').find('input[type=radio]').is(':checked')){
                    self.cache.$mtoProductItems.each(function() {
                      $(this).addClass('disabled');
                      $(this).find('.mto-fabrics__option-button').prop('disabled', true);
                    });
                    let bodyTypeSelected = $('.mto-card').find('input[type=radio]:checked').val();
                    self.cache.$mtoProductItems.each(function() {
                      let availabel_body_type =  $(this).find('.mto-fabrics__option-button').data('available-body-type');                   
                      if(availabel_body_type.indexOf(bodyTypeSelected) > -1){
                        $(this).removeClass('disabled');
                        $(this).find('.mto-fabrics__option-button').prop('disabled', false);
                      }
                    });
                    if($('.mto-fabrics__option-button.selected').attr('disabled') == true){
                     self.initFabricsGrid(); 
                    }
                  }
                }
              }

              function changeTab(){
                setFocus = setFocus || true;
                // Deactivate all other tabs
                deactivateTabs();
    
                // Remove tabindex attribute
                tab.removeAttribute('tabindex');
    
                // Set the tab as selected
                tab.setAttribute('aria-selected', 'true');
    
                // Get the value of aria-controls (which is an ID)
                var controls = tab.getAttribute('aria-controls');
    
                // Remove hidden attribute from tab panel to make it visible
                document.getElementById(controls).removeAttribute('hidden');
    
                /* Set focus when required
                if (setFocus) {
                  tab.focus();
                };
                */
                //Removing Sold Out Div
                if($('#choose-fabric_tab').hasClass('completed')){
                  if($('.mto-overview__container').find('.qty-error').length > 0){
                    $('.mto-overview__container').find('.qty-error').remove();
                  }
                }

                // Scroll to top
                var offset = self.cache.$siteHeader.outerHeight();
                theme.scrollTo(self.selectors.mtoMainContainer, offset);

                self.fabricsGridHeights();	
                setTimeout(function(e){	
                  // Restart Sticky MTO Overview	
                  self.initStickyMtoOverview();	
                },200)
              }
            };
    
            // Deactivate all tabs and tab panels
            function deactivateTabs () {
                for (t = 0; t < tabs.length; t++) {
                tabs[t].setAttribute('tabindex', '-1');
                tabs[t].setAttribute('aria-selected', 'false');
                tabs[t].removeEventListener('focus', focusEventHandler);
                };
    
                for (p = 0; p < panels.length; p++) {
                panels[p].setAttribute('hidden', 'hidden');
                };
            };
    
            // Make a guess
            function focusFirstTab () {
                tabs[0].focus();
            };
    
            // Make a guess
            function focusLastTab () {
                tabs[tabs.length - 1].focus();
            };
    
            // Detect if a tab is deletable
            function determineDeletable (event) {
                target = event.target;
    
                if (target.getAttribute('data-deletable') !== null) {
                // Delete target tab
                deleteTab(event, target);
    
                // Update arrays related to tabs widget
                generateArrays();
    
                // Activate the closest tab to the one that was just deleted
                if (target.index - 1 < 0) {
                    activateTab(tabs[0]);
                }
                else {
                    activateTab(tabs[target.index - 1]);
                };
                };
            };
    
            // Deletes a tab and its panel
            function deleteTab (event) {
                var target = event.target;
                var panel = document.getElementById(target.getAttribute('aria-controls'));
    
                target.parentElement.removeChild(target);
                panel.parentElement.removeChild(panel);
            };
    
            // Determine whether there should be a delay
            // when user navigates with the arrow keys
            function determineDelay () {
                var hasDelay = tablist.hasAttribute('data-delay');
                var delay = 0;
    
                if (hasDelay) {
                var delayValue = tablist.getAttribute('data-delay');
                if (delayValue) {
                    delay = delayValue;
                }
                else {
                    // If no value is specified, default to 300ms
                    delay = 300;
                };
                };
    
                return delay;
            };
    
            //
            function focusEventHandler (event) {
                var target = event.target;
    
                setTimeout(checkTabFocus, delay, target);
            };
    
            // Only activate tab on focus if it still has focus after the delay
            function checkTabFocus (target) {
                focused = document.activeElement;
    
                if (target === focused) {
                activateTab(target, false);
                };
            };
        }());
    }, // END f. initOverviewTabs

    initStickyMtoOverview: function() {
      var self = this;
      var $overviewContainer = $(this.selectors.mtoOverviewContainer, this.$container);
      var $wrapper = $(this.selectors.mtoGeneralContainer, this.$container);

      if ( !$overviewContainer.length ) {
        return;
      }

      // Force detatch if already detached. Prevent layout issues.
      $overviewContainer.trigger('detach.ScrollToFixed');

      // Detach and stop if on mobile breakpoint
      /* if (theme.variables.bpSmall) {
        return;
      } */

      var fixedHeaderHeight = self.nodes.$siteHeader.outerHeight();
      var mtoOverviewHeight = $overviewContainer.outerHeight();
      var mtoMainContainerHeight = $(
        this.selectors.mtoMainContainer,
        this.$container
      ).height();

      /*============================================================================
        Calculate when to detach fixed element to avoid content overlap.
      ==============================================================================*/
      var calcLimit = $wrapper.offset().top + $wrapper.height();
      calcLimit -= mtoOverviewHeight + fixedHeaderHeight;

      // Init sticky if overview shorter than main container and fits in viewport
      /*if (
        mtoOverviewHeight < mtoMainContainerHeight - fixedHeaderHeight &&
        mtoOverviewHeight < $(window).height() - fixedHeaderHeight
      ) {
        $overviewContainer.scrollToFixed({
          limit: calcLimit,
          zIndex: 4
        });
      }*/

      if (
        mtoOverviewHeight < mtoMainContainerHeight - fixedHeaderHeight
      ) {
        $overviewContainer.scrollToFixed({
          limit: calcLimit,
          zIndex: 4
        });
      }
    },

    initFabricsGrid: function() {
        var self = this;
        
        if (!this.cache.$mtoProductItems.length) {
          return;
        }

        this.selectors.$mtoItems.isotope({
          percentPosition: true,
          itemSelector: '.grid-item',
          masonry: {
            columnWidth: '.grid-product'
          },
          getSortData: {
            category: '[data-order] parseInt'
          },
          sortBy : 'category'
        });
  
        this.fabricsGridHeights();
  
        theme.cache.$window.on(
          'resize',
          theme.debounce(this.fabricsGridHeights, 100).bind(self)
        );

        this.defaultSelectedFabric(self);

        // Restart Sticky MTO Overview	
        self.initStickyMtoOverview();

    }, // END f. initFabricsGrid

    defaultSelectedFabric: function(self) {
      if (!self.cache.$mtoProductItems.length) {
        return;
      }

      function waitForElement(selector, callback, self) {
        if (document.querySelector(selector) !== null) {
          callback();
        } else {
          setTimeout(function() {
            waitForElement(selector, callback, self);
          }, 100);
        }
      }

      if(window.location.href.indexOf('#fabricID') > -1){
        var fabricID = window.location.href.split('#fabricID=');      
        $(window).on('load',function(e){
          waitForElement('.mto-fabrics__option-button[data-variant-id="'+fabricID[1]+'"]', function(){
            var selectedFabric = $('.mto-fabrics__option-button[data-variant-id="'+fabricID[1]+'"]');
            setTimeout(function(){
              selectedFabric.trigger('click');
            },1);
            // waitForElement('.mto-fabric-detail__select-button[data-variant-id="'+fabricID[1]+'"]', function(){ 
            //   var selectThisFabric = $('.mto-fabric-detail__select-button[data-variant-id="'+fabricID[1]+'"]');
            //   selectThisFabric.trigger('click');
            // });
          });
        });
      }
    }, // END f. defaultSelectedFabric

    fabricsGridHeights: function() {
        if (!this.cache.$mtoProductItems.length) {
          return;
        }
        
        if(theme.cache.$window.width() > 768) {
          this.cache.$productGridMeta.css('height', 'auto').equalHeights();
        } else {
          this.cache.$productGridMeta.css('height', 'auto');
        }

        this.selectors.$mtoItems.isotope('layout');
    }, // END f. fabricsGridHeights

    toggleFabricsView: function(evt) {

      var val = $(evt.target).val();

      if (val == 'Shirt'){
        $('.mto-fabrics__option-button').addClass('show-shirt');
      } else {
        $('.mto-fabrics__option-button').removeClass('show-shirt');
      }
    },

    openFabricDetails: function(evt) {
        var self = this;
        
        const fabricTemplate = Handlebars.compile($("#mto-fabric-template").html());
      
        if (!this.cache.$fabricsButton.length) {
            return;
        }
   
        if ( $(evt.target).hasClass('active') ) {
            this.closeFabricDetails();
            return;
        }

        // Remove active class from any selected fabric button
        this.cache.$fabricsButton.not('.selected').removeClass('active').find('.mto-fabrics__product-status').html('View Details');

        var fabric_product_handle = $(evt.target).data('product-handle');
        var fabric_variant_id = $(evt.target).data('variant-id');
        var fabric_index_order = $(evt.target).data('order');

        var product_wear_for = $(evt.target).data('product-wear-for');
        var product_seasonality = $(evt.target).data('product-seasonality');
        var product_content = $(evt.target).data('product-content');
        var product_yarn_count = $(evt.target).data('product-yarn-count');
        var product_origin = $(evt.target).data('product-origin');
        var product_fabric_care = $(evt.target).data('product-fabric-care');
        var product_fabric_color = $(evt.target).data('product-fabric-color');
        var product_related_body_type = $(evt.target).data('product-related-body-type');

        var row_index_order = theme.calcFabricDetailPositionGrid(fabric_index_order);
        window.location.href = '#fabricID='+fabric_variant_id;
        jQuery.getJSON('/products/' + fabric_product_handle + '.js', function(product) {

            var $grid = self.selectors.$mtoItems.isotope();
          
            // Remove any previous instance of Fabric Details
            $grid.isotope('remove', $('.grid-fabric-details'));

            // Fabric Details Button Dom 
            var fabric_details_button_dom;
            if($(evt.target).hasClass('selected')){
                fabric_details_button_dom = '<button type="button" class="btn mto-fabric-detail__select-button selected" data-variant-id="' + product.variants[0].id + '" data-fabric-name="' + product.title + '" data-fabric-color="' + product_fabric_color + '" data-fabric-price="' + product.variants[0].price + '" data-body-collection="' + product_related_body_type + '">Selected fabric</button>';
            } else {
                fabric_details_button_dom = '<button type="button" class="btn mto-fabric-detail__select-button" data-variant-id="' + product.variants[0].id + '" data-fabric-name="' + product.title + '" data-fabric-color="' + product_fabric_color + '" data-fabric-price="' + product.variants[0].price + '" data-body-collection="' + product_related_body_type + '">Select fabric & Continue</button>';
            } 
            var fabric_details_dom = fabricTemplate({
              row_index_order: row_index_order,
              title: product.title,
              description: product.description,
              button: fabric_details_button_dom,
              first_image: product.images[0],
              second_image: product.images[1],
              third_image: product.images[2],
              wear_for: product_wear_for,
              seasonality: product_seasonality,
              content: product_content,
              yarn_count: product_yarn_count,
              origin: product_origin,
              fabric_care: product_fabric_care
            })


            // Insert fabric details DOM into isotope grid
            const fabricEl = $(fabric_details_dom);
            fabricEl.find('img').one('load',function(){
              $grid.isotope('layout');
            });

            $grid.isotope('insert', fabricEl);
          
            const zoomElOne = fabricEl.find('.mto-fabric-zoom-1');
            zoomElOne.zoom({
              url: zoomElOne.data('zoom')
            });

            const zoomElTwo = fabricEl.find('.mto-fabric-zoom-2');
            zoomElTwo.zoom({
              url: zoomElTwo.data('zoom')
            });

            $grid.isotope('layout');
          
            // Add active class from specific fabric button evt target  
            if($(evt.target).hasClass('selected')){
                $(evt.target).addClass('active');
            } else {
                $(evt.target).addClass('active').find('.mto-fabrics__product-status').html('Close Details');
            }

            
            // Scroll to fabric details position
            var offset = 0;
              if($(window).width() < 769) {
                offset = self.cache.$siteHeader.outerHeight() + self.selectors.$mtoOverviewInner.outerHeight();
              } else {
                offset = self.cache.$siteHeader.outerHeight();
              }

            setTimeout(function(e){
            $('html,body').animate({scrollTop: fabricEl.offset().top - offset },500);
            },500);
          
            // Fabric Details Bind Close Btn Click
            $(self.selectors.fabricDetailCloseButton, self.$container).on('click', self.closeFabricDetails.bind(self));

            // Fabric Detais Bind Select Btn Click
            $(self.selectors.fabricDetailSelectButton, self.$container).on('click', self.selectFabric.bind(self));
        });

    }, // END f. openFabricDetails

    startOver: function() {
      window.saver.clear();

      /*------ Fabric Tab Start ------*/
      this.cache.$fabricsButton.each(function(){
        // Remove active class from any selected fabric button
        $(this).removeClass('active selected').find('.mto-fabrics__product-status').html('View Details');
      });
      // this.selectors.$mtoItems.isotope('remove', $('.grid-fabric-details')).isotope('layout');
      $('#mto-os__fabric .val').addClass('incomplete').html('- not yet selected');

      // deactivateTabs();
      $(this.selectors.chooseFabricTab).removeClass('completed');
      $(this.selectors.chooseFabricTab).attr('aria-selected', 'true');
      $('#mtoMain__chooseFabric').removeAttr('hidden');

      if($(".mto-fabric-detail__close-button").length) {
        $(".mto-fabric-detail__close-button").click();
      }

      //enabling fabrics
      this.cache.$mtoProductItems.each(function() {
        $(this).removeClass('disabled');
        $(this).find('.mto-fabrics__option-button').prop('disabled', false);
      });
      /*------ Fabric Tab End ------*/

      /*------ Body Tab Start ------*/      
      // Clear body radio selection 
      $('.mto-choose-body__single-option input[type=radio]').prop('checked', false);
      $('.mto-choose-body__single-option input[type=radio]').parent('.mto-choose-body__single-option').removeClass('active');
      $(this.selectors.chooseBodyTab).removeClass('completed');
      $('.mto-choose-body__tabs').removeClass('completed');
      $(this.selectors.chooseBodyTab).attr('aria-selected', 'false');

      $('#mtoChooseBody__styleTab input[type="radio"]').prop('checked', false);

      $('#mto-os__style .val').addClass('incomplete').html('not yet selected');
      $('#mto-size__stock-size__options label').html('Dress / Shirt / Tunic Size');
      $('.mto-os__style__item .val').addClass('incomplete').html('not yet selected');

      //$('#mtoChooseBody__styleTab .empty-block').removeAttr('hidden');
      //$('#mtoChooseBody__styleTab .mto-choose-body__styles-option').attr('hidden','');
      
      this.cache.$bodyPrice.each(function(){
        // updating price to default price ragges
        var priceRange = $(this).attr('data-range');
        $(this).html(priceRange);
      });

      $('#mto-house-style .mto-card').removeAttr('data-handle data-fabric-id data-fabric-color data-body-id data-combined-id');

      //enabling bodyTypes
      var allBodies = $('.mto-card[data-body-type]');
      for(let j=0;j<allBodies.length;j++){
        $(allBodies[j]).removeClass('hide-bodytype').show();
      }
      /*------ Body Tab End ------*/

      /*------ Fit Tab Start --------*/
      $('#MTOSizeRadios,.single-option-radio__label-notes-mto').html('');
      $('#mtoMain__chooseFit input[type=radio]').prop('checked', false);
      $('#choose-fit_tab .mto-os__detail .val').addClass('incomplete').html('not yet selected');

      $(this.selectors.chooseFitTab).removeClass('completed');
      $(this.selectors.chooseFitTab).attr('aria-selected', 'false');

      $('#mtoMain__chooseFit .empty-block').removeAttr('hidden');
      $('#mtoMain__chooseFit #mto-size__stock-size-tab').attr('hidden','');
      /*------- Fit Tab End --------*/

      $('#AddToCart--MTO').attr('disabled','');
      $('#AddToCart--MTO .price').html('');

      $('#stock-size__btn').attr('disabled','');

      // Scroll to top
      var offset = this.cache.$siteHeader.outerHeight();
      theme.scrollTo(this.selectors.mtoMainContainer, offset);

      this.fabricsGridHeights();

      // Restart Sticky MTO Overview	
      this.initStickyMtoOverview();
    },

    closeFabricDetails: function() {

      this.cache.$fabricsButton.removeClass('active')
      this.cache.$fabricsButton.not('.selected').find('.mto-fabrics__product-status').html('View Details');

      this.selectors.$mtoItems.isotope('remove', $('.grid-fabric-details')).isotope('layout');
      // Restart Sticky MTO Overview	
      this.initStickyMtoOverview();
    }, // END f. closeFabricDetails

    selectFabric: function(evt) {
      if($(this.selectors.mtoOverviewContainer).find('.qty-error').length > 0){
        $(this.selectors.mtoOverviewContainer).find('.qty-error').remove();
      }
      var selected_variant_id = $(evt.target).data('variant-id');
        var grid_product = $('.mto-fabrics__option-button[data-variant-id='+selected_variant_id+']').closest('.grid-product');
        if(grid_product.hasClass('is-sold-out')){
          $(evt.target).html('Fabric Sold Out');
          $(evt.target).addClass('sold-out-fabric');
          $(evt.target).prop('disabled',true);
          var product_name = grid_product.find('.grid-product__title').text();
          if($(this.selectors.mtoOverviewContainer).find('.qty-error').length == 0){
            $(this.selectors.addToCart).after(
              '<div class="errors qty-error">So sorry, but the product ' + product_name + ' is already sold out.</div>'
            );
          }
        }else{
          $(evt.target).addClass('selected');

          window.location.href = '#fabricID='+selected_variant_id;
          // Update class from currently active selected fabric button
          this.cache.$fabricsButton.each(function(){
              if($(this).hasClass('active')){
                  $(this).removeClass('active').addClass('selected').find('.mto-fabrics__product-status').html('Selected Fabric');
              } else {
                  // Remove active class from any selected fabric button
                  $(this).removeClass('active selected').find('.mto-fabrics__product-status').html('View Details');
              }
          });

          this.selectors.$mtoItems.isotope('remove', $('.grid-fabric-details')).isotope('layout');

          // Update [name="id"] input with variant id and overview tab with fabric name
          var variant_id = $(evt.target).data('variant-id');
          this.selectors.$mtoFabricId.val(variant_id);
          var variant_name = $(evt.target).data('fabric-name');
          this.selectors.$mtoFabricSelected.val(variant_name);
          this.selectors.$mtoFabricSelectedId.val(variant_id);
          var fabricColor = $(evt.target).data('fabric-color');
          this.selectors.$mtoFabricSelectedColor.val(fabricColor);
          var finalsale = $(evt.target).data('final-sale');	
          this.selectors.$mtoFinalSale.val(finalsale);

          saver.save('fabric', variant_id);
          
          // Update fabric name in overview step
          var fabric_name = $(evt.target).data('fabric-name');

          if ( fabric_name == undefined) {
            $('#mto-os__fabric .val').addClass('incomplete').html('- not yet selected');
            $(this.selectors.chooseFabricTab).removeClass('completed');
            return;
          }

          $('#mto-os__fabric .val').removeClass('incomplete').html('- ' + fabric_name);
          $(this.selectors.chooseFabricTab).addClass('completed');
          this.validateOverviewSteps();

          // Update fabric price in Add to Cart button
          var fabric_price = $(evt.target).data('fabric-price');
          $('#AddToCart--MTO').data('price',fabric_price);

          // If active error message due to missing stock, hide it
          $('.errors.qty-error').remove();

          //Clear Body Selections
          //this.clearBodySizeSelection();

          // Get Body Types
          var fabric_collection = $(evt.target).data('body-collection');
          this.getBodyTypes(variant_id,fabric_collection,this);

          if($('.mto-card[data-body-id].active [name="properties[Body Type]"]').is(':checked')){	
            // Navigate to third step
            $('.mto-card.active[data-body-id]').find('.mto-style__select-button').trigger('click');
          }else{
            // Navigate to second step
            $(this.selectors.chooseBodyTab).trigger('click');
          }
        }
    }, // END f. selectFabric 

    clearBodySizeSelection: function(){     
      // Clear body radio selection 
      $('.mto-choose-body__single-option input[type=radio]').prop('checked', false);
      $('.mto-choose-body__single-option input[type=radio]').parent('.mto-choose-body__single-option').removeClass('active');
      $(this.selectors.chooseBodyTab).removeClass('completed');
      $('.mto-choose-body__tabs').removeClass('completed');
      $(this.selectors.chooseBodyTab).attr('aria-selected', 'false');

      $('#mtoChooseBody__styleTab input[type="radio"]').prop('checked', false);

      $('#mto-os__style').removeAttr('hidden');
      $('#mto-os__style .val').addClass('incomplete').html('not yet selected');
      $('#mto-size__stock-size__options label').html('Dress / Shirt / Tunic Size');
      $('.mto-os__style__item .val').addClass('incomplete').html('not yet selected');

      // $('#mtoChooseBody__styleTab .empty-block').removeAttr('hidden');
      // $('#mtoChooseBody__styleTab .mto-choose-body__styles-option').attr('hidden','');

      /*------ Fit Tab Start --------*/
      $('#mtoMain__chooseFit input[type=radio]').prop('checked', false);
      $('#choose-fit_tab .mto-os__detail .val').addClass('incomplete').html('not yet selected');

      $(this.selectors.chooseFitTab).removeClass('completed');
      $(this.selectors.chooseFitTab).attr('aria-selected', 'false');

      $('#mtoMain__chooseFit .empty-block').removeAttr('hidden');
      $('#mtoMain__chooseFit #mto-size__stock-size-tab').attr('hidden','');
      /*------- Fit Tab End --------*/

      $('#AddToCart--MTO').attr('disabled','');
      $('#AddToCart--MTO .price').html('');

      $('#stock-size__btn').attr('disabled','');

      this.fabricsGridHeights();

      // Restart Sticky MTO Overview	
      this.initStickyMtoOverview();
    },

    getBodyTypes: function(fabric_variant_id,product_related_body_type,self){
      //Get Body Types
      if(product_related_body_type != ''){
        fetch('/collections/' + product_related_body_type + '?view=collection-data')
        .then((response) => response.json())
        .then(function(collection){ 
            var productCount = parseInt(collection.products_count);
            if(productCount > 0){
              var bodyTypeProducts = collection.products;              
              var allBodies = $('.mto-card[data-body-type]');
              for(let j=0;j<allBodies.length;j++){
                $(allBodies[j]).addClass('hide-bodytype').hide();
              }
                allBodies.each(function(body){
                  var bodyType = $(this).attr('data-body-name');
                  for(let i=0;i<bodyTypeProducts.length;i++){
                    var handle = bodyTypeProducts[i].handle;
                    var name = bodyTypeProducts[i].name;
                    var id = 'fabric-' + fabric_variant_id + '-body-' + bodyTypeProducts[i].id;
                    var price_min = bodyTypeProducts[i].price_min;
                    var price_max = bodyTypeProducts[i].price_max;
                    var fabric_color = bodyTypeProducts[i].prodColor;
                    var final_sale = bodyTypeProducts[i].final_sale;	
                    if(name.indexOf(bodyType) > -1){
                        $(this).removeClass('hide-bodytype').show();
                        $(this).attr('data-handle',handle);
                        $(this).attr('data-combined-id',id);
                        $(this).attr('data-fabric-id',fabric_variant_id);
                        $(this).attr('data-body-id',bodyTypeProducts[i].id);
                        $(this).attr('data-fabric-color',fabric_color);
                        $(this).attr('data-final-sale',final_sale);	
                        if(price_min != price_max){
                          $(this).find('.mto-house-style__price').html(intlPrice(price_min) + ' - ' + intlPrice(price_max));
                        }else{
                          $(this).find('.mto-house-style__price').html(intlPrice(price_min));
                        }
                    }
                  };
                });

                function intlPrice(price) {
                  let intlPrice = price;
                  if (Shopify.currency.active === 'CAD' || Shopify.currency.active === 'AUD') {
                    intlPrice = price + ' ' + Shopify.currency.active
                  }
                  return intlPrice;
                }

                
                setTimeout(function(e){
                  if($('.mto-card').hasClass('hide-bodytype') && $('.mto-card').find('input[type=radio]').is(':checked')){
                    self.initChooseBody();
                    $(self.selectors.chooseBodyTab).trigger('click');
                    self.clearBodySizeSelection();
                  }
                },100);

              $('#mtoChooseBody__styleTab .empty-block').attr('hidden','');
              $('#mtoChooseBody__styleTab .mto-choose-body__styles-option').removeAttr('hidden');
            }else{
              // $('#mtoChooseBody__styleTab .empty-block .mto-main__section-intro').html('No Body Types are available. Please choose another Fabric.');
              // $('#mtoChooseBody__styleTab .empty-block').removeAttr('hidden');
              // $('#mtoChooseBody__styleTab .mto-choose-body__styles-option').attr('hidden','');
            }
            
            //get Body Sizes if Silhouette selected already
            if($('.mto-card[data-body-id].active:not(.hide-bodytype) [name="properties[Body Type]"]').is(':checked')){	
              // Navigate to third step
              $('.mto-card.active[data-body-id]:not(.hide-bodytype').find('.mto-style__select-button').trigger('click');
            }
        });
      }else{
        // $('#mtoChooseBody__styleTab .empty-block .mto-main__section-intro').html('No Body Types are available. Please choose another Fabric.');
        // $('#mtoChooseBody__styleTab .empty-block').removeAttr('hidden');
        // $('#mtoChooseBody__styleTab .mto-choose-body__styles-option').attr('hidden','');
      }
    }, // END f. getBodyTypes 

    initBodyTabs: function() {
        var self = this;
        /*
        *   This content is licensed according to the W3C Software License at
        *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
        */
        
        /* === View Model Button Trigger == */
        $('.view-model-trigger').on('click', function(){
          var getModalID = $(this).attr('href');
          $(getModalID).addClass('is-active');
          // View Model Slider	
          var $sliderContainer = $(getModalID).find('.mto-view-model-slider');
          var sectionId = $sliderContainer.attr('data-section-id');
          var ViewModelSlider = '#ViewModelSlider-' + sectionId;
          var prevArrowDesktop = '#slick__arrow--previous-' + sectionId;
          var nextArrowDesktop = '#slick__arrow--next-' + sectionId;
          var pagingInfo = '#slick__paging-info-' + sectionId;
          
          self.$ViewModelSlider = $(ViewModelSlider);
          self.$pagingInfo =$(pagingInfo);
          self.$sliderContainer = $sliderContainer;
      
          self.slickSettings = {
            accessibility: true,
            autoplay: false,
            arrows: true,
            prevArrow: prevArrowDesktop,
            nextArrow: nextArrowDesktop,
            infinite: false,
            dots: false,
            adaptiveHeight: false,
            slidesToShow: 1,
            slidesToScroll: 1
          };
          self.createViewModelSlider();
        });

        /* === View Model close click == */
        $('.mto-view-model-modal .close-mto-view-model-popup').on('click', function(){
          $('.mto-view-model-modal').removeClass('is-active');
        });

        // Restart Sticky MTO Overview	
        self.initStickyMtoOverview();

    }, // END f. initBodyTabs

    createViewModelSlider: function() {
      var self = this;
      this.$ViewModelSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        // no dots -> no slides
        if(!slick.$dots){
          return;
        }

        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var slidesToShow = Math.ceil( slick.slideCount/(slick.$dots[0].children.length) );
        var currentCustomSlide = currentSlide ? Math.ceil((currentSlide + 1)/slidesToShow) : 1;
        // use dots to get some count information
        self.$pagingInfo.text(currentCustomSlide + '/' + (slick.$dots[0].children.length));
        if((slick.$dots[0].children.length) == 1){
          self.$sliderContainer.find('.slick__controls').addClass('hide');
        }else{
          self.$sliderContainer.find('.slick__controls').removeClass('hide');
        }
      });
      
      this.$ViewModelSlider.slick(this.slickSettings);
    }, // END f. createViewModelSlider

    initChooseBody: function() {
      
      var self = this;

      /* === Style options == */
      $('input[name="properties[Body Type]"]').on('change', function(){

        // Clear body radio selection 
        $('.mto-choose-body__single-option input[type=radio]').prop('checked', false).trigger("change");
        $('.mto-os__style__item .val').addClass('incomplete').html('not yet selected');
        $('#mto-size__stock-size__options label').html('Dress / Shirt / Tunic Size');

        // Remove complete status from tab
        $(self.selectors.chooseBodyTab).removeClass('completed');
        $('.mto-choose-body__tabs').removeClass('completed');
        $('.mto-choose-body__styles-option__item .mto-card').removeClass('active');

        // TODO: Logic for start shirt from saved
        var selected_element_id = $(this).data('body-type');
        var selected_element_name = $(this).val();
        var selected_element = $('.mto-card[data-body-name="'+selected_element_name+'"]');
        selected_element.addClass('active');

        saver.save('body-type',  selected_element_name);
        saver.save('body-id',  selected_element.data('body-id'));
        saver.save('fabric-id',  selected_element.data('fabric-id'));
        saver.save('combined-id',  selected_element.data('combined-id'));

        // Update overview step details
        $('#mto-os__style, .mto-os__style__item').removeAttr('hidden');
        $('#mto-os__style .val').removeClass('incomplete').html(selected_element_name);
        $('#mto-size__stock-size__options label').html(selected_element_name);
        self.clearBodySizes();

        var selectedBodyHandle = $('.mto-card.active[data-body-id]').attr('data-handle');
        self.getBodySizes(selectedBodyHandle);
        self.validateBodyOptions();
        $('#choose-fit_tab .mto-os__detail .val').addClass('incomplete').html('not yet selected');
      });

      $('.mto-style__select-button, #fit-options_tab').on('click', function(){	
        self.clearBodySizes();
        $('#choose-fit_tab').trigger('click');	        
        var selectedBodyHandle = $('.mto-card.active[data-body-id]').attr('data-handle');
        self.getBodySizes(selectedBodyHandle);	

        var selectedBodyColor = $('.mto-card.active[data-body-id]').attr('data-fabric-color');
        self.selectors.$mtoFabricSelectedColor.val(selectedBodyColor);

        var selectedfinalsale = $('.mto-card.active[data-body-id]').attr('data-final-sale');	
        self.selectors.$mtoFinalSale.val(selectedfinalsale);

        $(self.selectors.chooseFitTab).attr('aria-selected', 'true');
        // Restart Sticky MTO Overview	
        self.initStickyMtoOverview();	
      });

      // Restart Sticky MTO Overview	
      self.initStickyMtoOverview();	

    }, // END f. initChooseStyle

    //Clear Body Sizes
    clearBodySizes:function(){
      /*------ Fit Tab Start --------*/
      $('#mtoMain__chooseFit input[type=radio]').prop('checked', false);
      $('#choose-fit_tab .mto-os__detail').removeAttr('hidden');

      $(this.selectors.chooseFitTab).removeClass('completed');
      $(this.selectors.chooseFitTab).attr('aria-selected', 'false');

      $('#mtoMain__chooseFit .empty-block').removeAttr('hidden');
      $('#mtoMain__chooseFit #mto-size__stock-size-tab').attr('hidden','');
      /*------- Fit Tab End --------*/

      $('#AddToCart--MTO').attr('disabled','');
      $('#AddToCart--MTO .price').html('');

      $('#stock-size__btn').attr('disabled','');
    },

    getBodySizes: function(selectedBodyHandle){
      if(selectedBodyHandle == undefined){
        $('#mtoMain__chooseFit .empty-block').removeAttr('hidden','');
        $('#mtoMain__chooseFit #mto-size__stock-size-tab').attr('hidden','');
      }else{
        $('#mtoMain__chooseFit .empty-block').attr('hidden','');
        $('#mtoMain__chooseFit #mto-size__stock-size-tab').removeAttr('hidden');
        fetch('/products/' + selectedBodyHandle + '.json')
        .then((response) => response.json())
        .then(function(product){ 
          var sizes = '<option value="" disabled="" selected="selected">Select Size</option>';
          var sizeRadios = '';
          var productOptions = product['product'].options;
          var hasSize = productOptions.includes(productOptions.find(el=>el.name ==='Size'));
          if(hasSize){
            let sizeNote = $('.mto-fabrics__option-button.selected').attr('data-product-size-note');
            var productSize = product['product'].variants;
            for(let i=0;i<productSize.length;i++){ 
              var variantPrice = Math.ceil(productSize[i].price * 100);
              sizes += '<option value="'+productSize[i].title+'" id="'+productSize[i].id+'" data-price="'+variantPrice+'">'+productSize[i].title+'</option>';
              sizeRadios += '<span class="input-wrap"><input type="radio" value="'+productSize[i].title+'" data-index="option'+i+'" id="'+productSize[i].id+'" name="optionSize" class="single-option-selector__radio" id="ProductSelect-option-size-'+productSize[i].title+'" aria-label="To make this website accessible to screen reader, Press combination of alt and 1 keys. To stop getting this message, press the combination of alt and 2 keys"><label for="ProductSelect-option-size-'+productSize[i].title+'">'+productSize[i].title+'</label></span>';
            }
            $('#mto-size__stock-size__dress-size').html(sizes);
            
            $('#MTOSizeRadios').html(sizeRadios);
            if(sizeNote != ''){
              $('.single-option-radio__label-notes-mto').html(sizeNote);
            }else{
              $('.single-option-radio__label-notes-mto').html('');
            }

            /* === Stock Size Radios == */
            $('#MTOSizeRadios input[type="radio"]').on('change', function(){
              var radioId = $(this).attr('id');
              var selectedOption = $('#mto-size__stock-size__dress-size option[id="'+radioId+'"]').val();
              $('#mto-size__stock-size__dress-size').val(selectedOption).trigger('change');
            });
          }
        });
      }
    },

    updateMetafieldsForm: function(id, value, parent = false){
      // console.log(id);
      $(`form#mto-body-meta-form input[name="${id.replaceAll('-','_')}"]`).val(value);

      if( parent ) {
        $(`form#mto-body-meta-form input[name="${id.replaceAll('-','_')}_detail"]`).val("");
      }
    },
    saveMetafields: function(formEl, key){
      function getFormData($form){
        var unindexed_array = $form.serializeArray();
        var indexed_array = {};
    
        $.map(unindexed_array, function(n, i){
            indexed_array[n['name']] = n['value'];
        });
    
        return indexed_array;
      }

      const customer_logged_in = $("#mto-customer-id").val();
      if( customer_logged_in != "") {
        const fdata = getFormData(formEl);
        let dataobj = {
          'customer[id]' : fdata.customer_id
        };
        
        dataobj[`metafield[${key}]`] = JSON.stringify(fdata);
          $.ajax({
            type: "POST",
            datatype: "json",
            data: $.param(dataobj),
            url: '/a/custmeta',
            success: function (data) {
                  var formValid = (data.status === 'OK');
                  if (formValid) {
                    var msgs = '';
                    for (var i=0;i<data.messages.length;i++) {
                      msgs += '-- ' + data.messages[i] + '\n';
                    }
                    if (msgs > '') {
                      console.log('SUCCESS WITH MESSAGES:\n\n' + msgs);
                    }
                    else {
                      console.log('SUCCESS!');
                    }
                  }
                  else {
                    console.log('Status: ' + data.status + '\nMessage: ' + data.message);
                  }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                  alert('AJAX or Server 500 error occurred');
                }
          });
      }
    },
    validateBodyOptions: function() {
      const self = this;
      // Validate if Body Options complete 
      var mto_os_styles_complete = true;

      if(mto_os_styles_complete) {
        self.saveMetafields($("#mto-body-meta-form"), 'ccmto.body');
        $(this.selectors.chooseBodyTab).addClass('completed');
        $('.mto-choose-body__tabs').addClass('completed');
        this.validateOverviewSteps();
      } else {
        $(this.selectors.chooseBodyTab).removeClass('completed');
        $('.mto-choose-body__tabs').removeClass('completed');
      }

    }, // END f. validateBodyOptions

    initChooseFit: function() {

      var self = this;

      $(".close-mto-login-popup").on('click',function(){
        $("#mto-login-popup").removeClass('is-active');
        // Restart Sticky MTO Overview	
        self.initStickyMtoOverview();
      });
      /* === Fit options == */
      $('input[name="properties[Fit]"]').on('change', function(){

        var property_val = $(this).val();
        // Update overview step details
        $('#mto-os__fit-title, #mto-os__fit').removeAttr('hidden');
        $('#mto-os__fit .val').removeClass('incomplete').html(property_val);
        saver.save('fit', property_val);
        self.validateFitOptions();
        // Restart Sticky MTO Overview	
        self.initStickyMtoOverview();
      });

      /* === Size options Navigation == */
      $('input[name="properties[Size Type]"]').on('change', function(){
        
        // Hide overview option details 
        $('.mto-size__option-details').attr('hidden','');
        // Disable all input/select elements in Size Type tab panels
        $('.mto-size__option-details').find('input, select').each((idx, el) => {
          $(el).prop('disabled', true);
        });

        var radio_val = $(this).val();
        if (radio_val == "From file") {
          if($(this).attr('data-logged-in') == "false") {
            saver.save('autoload', "yes");
            $("#mto-login-popup").addClass('is-active');
            // Restart Sticky MTO Overview	
            self.initStickyMtoOverview();
            return;
          }
          else {
            $('.mto-os__size__item').attr('hidden','');
            $('.mto-os__self-measure__item').removeAttr('hidden');

            $('.self-measurement__input').each(function(){
              var attr_name = $(this).attr('id').replace('self-measurement__','');
              var attr_val = $(this).val();
              $('#mto-os__' + attr_name + ' .val').removeClass('incomplete').html(attr_val);
            });
    
            $('.self-measurement__select').each(function(){
              var attr_name = $(this).attr('id').replace('self-measurement__','');
              var attr_val = $(this).val();
              $('#mto-os__' + attr_name + ' .val').removeClass('incomplete').html(attr_val);
            });
    
            self.validateFitOptions();
          }
        }

        saver.save('size_type', radio_val);
        // Show active size options
        var radio_id = $(this).attr('id');
        var aria_controls = $('label[for="' + radio_id + '"]').attr('aria-controls');
        $('#' + aria_controls).removeAttr('hidden');
        // Enable all input/select elements in current active tab panel
        $('#' + aria_controls).find('input, select').each((idx, el) => {
          $(el).prop('disabled', false);
        });
      
        // Update overview step details
        $('#mto-os__fit-title, #mto-os__size-type').removeAttr('hidden');
        $('#mto-os__size-type .val').removeClass('incomplete').html(radio_val);
        if (radio_val == 'Stock Size'){
          $('.mto-os__self-measure__item').attr('hidden','');
          $('.mto-os__size__item').removeAttr('hidden'); 
        } else if (radio_val == 'Self Measure'){
          $('.mto-os__size__item').attr('hidden','');
          $('.mto-os__self-measure__item').removeAttr('hidden');

          self.initSMYouTubeVideo();
        } else {
          if($(this).attr('data-logged-in') == "false") {
            $('.mto-os__size__item, .mto-os__self-measure__item').attr('hidden','');
          }
        }

        self.validateFitOptions();

        // Restart Sticky MTO Overview
        self.initStickyMtoOverview();
      });

      /* === Size options Header == */
      $('.mto-size__btn-close').on('click', function(){  

        // Hide option detail
        $('.mto-size__option-details').attr('hidden','');
        // Uncheck size type radio 
        $('input[name="properties[Size Type]"]').prop('checked', false);
        // Update overview step details
        $('#mto-os__size .val').addClass('incomplete').html('not yet selected'); 
        // Restart Sticky MTO Overview	
        self.initStickyMtoOverview();      
      });

      /* === Stock Size Options == */
      $('#mto-size__stock-size__dress-size').on('change', function(){
        if($(this).val() != ''){
          // Enable confirm size btn
          $('#stock-size__btn').removeAttr('disabled');
          var selectedSize = $(this).children("option:selected").attr('id');
          var selectedSizePrice = $(this).children("option:selected").attr('data-price');
          $('#mto-fabrics__input__id').val(selectedSize);
          //Add variant Size Price
          var moneyFormat = theme.strings.moneyFormat;
          $('#AddToCart--MTO').attr('data-price',selectedSizePrice);
          $('#AddToCart--MTO .price').html(' - ' + theme.Currency.formatMoney(selectedSizePrice, moneyFormat));
        }
      });

      $('#stock-size__btn').on('click', function(){
        $('#mto-os__size').removeAttr('hidden');
          //Add variant Size Price          
          var selectedSizePrice = $('#mto-size__stock-size__dress-size option:selected').attr('data-price');
          var moneyFormat = theme.strings.moneyFormat;
          $('#AddToCart--MTO').attr('data-price',selectedSizePrice);
          $('#AddToCart--MTO .price').html(' - ' + theme.Currency.formatMoney(selectedSizePrice, moneyFormat));

          var dress_shirt_size = $('#mto-size__stock-size__dress-size').val();
          if(dress_shirt_size != "" && dress_shirt_size !== null){
            $('#mto-os__size .val').removeClass('incomplete').html(' Your Size: '+dress_shirt_size);
          }
          self.validateFitOptions();
      });

      // Set Customer data to YOUR MEASUREMENTS form
      var mto_sm_input_complete = true;
      $('.self-measurement__input, .self-measurement__select').each(function(){
        const t = $(this);
        let prop = t.attr('name').replaceAll('properties[','').replaceAll(']','').replaceAll(' ','_').toLowerCase();

        if ($(this).attr("id") == "self-measurement__height") {
          if ($("#mto-body-meta-form input[name=height_ft]").val() && $("#mto-body-meta-form input[name=height_in]").val()) {
            $(this).val($("#mto-body-meta-form input[name=height_ft]").val() + " ft. " + $("#mto-body-meta-form input[name=height_in]").val() + " in.")
          }
        }
        else {
          $(this).val($("#mto-body-meta-form input[name='" + prop + "']").val());
        }
      })

      makeMetafields();
      
      $('.self-measurement__input').each(function(){
        if($(this).val() == '') { 
          mto_sm_input_complete = false;
        } 
      });

      if(mto_sm_input_complete) {
        $('#self-measurement__btn').removeAttr('disabled');
        this.validateOverviewSteps();
      }

      function makeMetafields(){
        const form = $("#mto-fit-meta-form");
        form.find('input.metafield-input').remove();

        $('.self-measurement__input, .self-measurement__select').each(function(){
          const t = $(this),
                v = t.val();

          let prop = t.attr('name').replaceAll('properties[','').replaceAll(']','');
          
          if( v != "" && v != null ) {
            if (t.attr("id") == "self-measurement__height") {
              let ft_value = $(this).val().match(/\d+/g)[0];
              let in_value = $(this).val().match(/\d+/g)[1];

              let input_ft = $(`<input type="hidden" name="metafield[ccmto.height_ft]" id="metafield_height_ft" class="metafield-input" />`).val(ft_value);
              let input_in = $(`<input type="hidden" name="metafield[ccmto.height_in]" id="metafield_height_in" class="metafield-input" />`).val(in_value);

              input_ft.appendTo(form);
              input_in.appendTo(form);
            }
            else {
              let input = $(`<input type="hidden" name="metafield[ccmto.${prop.replaceAll('-','_').replaceAll(' ','_').toLowerCase()}]"  class="metafield-input" />`).val(v);
              input.appendTo(form);
            }
          }
        })
      }
      /* === Self Measurement Size Options == */
      $('.self-measurement__input, .self-measurement__select').on('change', function() {

        makeMetafields();

        // Validate if self measurement complete 
        mto_sm_input_complete = true;
        $('.self-measurement__input').each(function(){
          if($(this).val() == '') { 
            mto_sm_input_complete = false;
          } 
        });

        $('.self-measurement__select').each(function(){
          if( $(this).val() == null) {
            mto_sm_input_complete = false;
          } 
        });

        if(mto_sm_input_complete) {
          const formEl = $("#mto-fit-meta-form");
          $.ajax({
            type: "POST",
            dataType: "json",
            data: formEl.serialize(),
            url: formEl.attr('action'),
            success: function (data) {
              var formValid = (data.status === 'OK');
              if (formValid) {
                var msgs = '';
                for (var i=0;i<data.messages.length;i++) {
                  msgs += '-- ' + data.messages[i] + '\n';
                }
                if (msgs > '') {
                  // alert('SUCCESS WITH MESSAGES:\n\n' + msgs);
                }
                else {
                  // alert('SUCCESS!');
                }
              }
              else {
                  // alert('Status: ' + data.status + '\nMessage: ' + data.message);
              }
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.log('AJAX or Server 500 error occurred');
            }
          });

          $('#self-measurement__btn').removeAttr('disabled');
        } else {
          $('#self-measurement__btn').attr('disabled','');
        }
      });

      // $('#self-measurement__btn').on('click', function(){

      //   document.getElementById('self-measurement__cross-shoulder').validity.rangeOverflow;
      //   document.getElementById('self-measurement__neck').validity.rangeOverflow;
      //   document.getElementById('self-measurement__chest').validity.rangeOverflow;
      //   document.getElementById('self-measurement__waist').validity.rangeOverflow;
      //   document.getElementById('self-measurement__hip').validity.rangeOverflow;
      //   document.getElementById('self-measurement__left-sleeve').validity.rangeOverflow;
      //   document.getElementById('self-measurement__left-wrist').validity.rangeOverflow;
      //   document.getElementById('self-measurement__right-sleeve').validity.rangeOverflow;
      //   document.getElementById('self-measurement__right-wrist').validity.rangeOverflow;
        
      //   // Adding validation on saving my measurements
      //   let valid = true;
      //   $('.sm__your-measurements__container').find('input, select').each((idx, el) => {
      //     if (el.checkValidity() == false) {
      //       valid = false;
      //     }
      //   })

      //   if (!valid) {
      //     if (self.cache.$addToCart.prop('disabled')) {
      //       self.cache.$addToCart.prop('disabled', false);
      //       self.cache.$addToCart.click();
      //       self.cache.$addToCart.prop('disabled', true);
      //     } else {
      //       self.cache.$addToCart.click();
      //     }
      //     return;
      //   }

      //   $('.self-measurement__input').each(function(){
      //     var attr_name = $(this).attr('id').replace('self-measurement__','');
      //     var attr_val = $(this).val();
      //     $('#mto-os__' + attr_name + ' .val').removeClass('incomplete').html(attr_val);
      //   });

      //   $('.self-measurement__select').each(function(){
      //     var attr_name = $(this).attr('id').replace('self-measurement__','');
      //     var attr_val = $(this).val();
      //     $('#mto-os__' + attr_name + ' .val').removeClass('incomplete').html(attr_val);
      //   });

      //   self.validateFitOptions();
      // });

    },

    validateFitOptions: function() {

      // Validate if Fit Options complete 
      var mto_os_fit_complete = true;
      if($('#mto-os__size .val').hasClass('incomplete')) {
          mto_os_fit_complete = false;
      }

      if(mto_os_fit_complete) {
        $(this.selectors.chooseFitTab).addClass('completed');
      } else {
        $(this.selectors.chooseFitTab).removeClass('completed');
      }

      this.validateOverviewSteps();
    }, // END f. validateFitOptions

    initYouTubeAPI: function() {
        // Init Youtube API
        var tag = document.createElement('script');
        tag.src = "//www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    }, // END f. initYouTubeAPI

    initSMYouTubeVideo: function() {
        var playerInfo = {
                id:'mto-size__self-measurement__ytplayer',
                height:'620px',
                width:'100%',
                videoId:'Ugc7RquA9rk', 
                playerVars: {
                    rel: 0, 
                    wmode: 'opaque', 
                    showinfo: 0 
                }
            };

            this.yt_player = new YT.Player(playerInfo.id, {
                height: playerInfo.height,
                width: playerInfo.width,
                videoId: playerInfo.videoId,
                playerVars: playerInfo.playerVars,
                color: "white"
            });
    }, // END f. initSMYouTubeVideo
    
    // Show Size Self-Measurement Attr Details
    showSizeAttrDetails: function(evt) {
       
        var v_seconds = $(evt.target).data('seconds');
        var attribute = $(evt.target).data('attr');

        this.yt_player.seekTo(v_seconds);

        // Scroll to top
        var offset = this.cache.$siteHeader.outerHeight();
        theme.scrollTo('#mto-size__self-measurement__ytplayer', offset);
        
        // Update Attr Details on the right
        $('.sm__item-info').attr('hidden','');
        $('#sm__detail-' + attribute).removeAttr('hidden');

    }, // END f. showSizeAttrDetails

    validateOverviewSteps: function() {

      if ($(this.selectors.chooseFabricTab).hasClass('completed') &&
          $(this.selectors.chooseBodyTab).hasClass('completed') &&
          $(this.selectors.chooseFitTab).hasClass('completed')) {
        var price = $('#AddToCart--MTO').attr('data-price');
        var moneyFormat = theme.strings.moneyFormat;
        $('#AddToCart--MTO .price').html(' - ' + theme.Currency.formatMoney(price, moneyFormat));
        $('#AddToCart--MTO').removeAttr('disabled');
        $('.mto-overview__footer').addClass('active');
      } else {
        $('#AddToCart--MTO .price').html('');
        $('#AddToCart--MTO').attr('disabled','');
        $('.mto-overview__footer').removeClass('active');
      }

    } // END f. validateOverviewSteps
  });

  return MTO;
})();

theme.variables = {
  productPageLoad     : false,
  productPageSticky   : true,

  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  mediaQuerySmall     : 'screen and (max-width: 590px)',
  mediaQueryMedium    : 'screen and (min-width: 591px) and (max-width: 768px)',
  mediaQueryMediumUp  : 'screen and (min-width: 591px)',
  mediaQueryLarge     : 'screen and (min-width: 769px)',
  bpSmall             : false
};

theme.initCache = function() {
  theme.cache = {
    $window                 : $(window),
    $html                   : $('html'),
    $body                   : $('body'),
    $drawerRight            : $('.drawer--right'),

    $hero                   : $('#Hero'),
    $customSelect           : $('.js-selector'),

    $collectionImage        : $('.collection-hero__image'),
    $heroImage              : $('.mtm-hero__image'),

    $siteHeader             : $('.site-header'),
    $siteNav                : $('.site-nav'),
    $siteNavOpen            : $('.site-nav--open'),
    $cartBuggle             : $('.cart-link__bubble'),
    $logoWrapper            : $('.site-header__logo'),
    $logo                   : $('.site-header__logo img'),
    $openSearchModal        : $('.js-open-search-modal'),
    $closeSearchModal       : $('.js-close-search-modal'),
    $searchBox              : $('.site-nav--search__bar'),

    $indentedRteImages      : $('.rte--indented-images'),

    $productGridRows        : $('.collage-grid__row'),
    $collectionProductItems : $('.grid-product'),

    // Equal height elements
    $productGridImages      : $('.grid-uniform .grid-product__image-wrapper'),

    $returnLink             : $('.return-link')
  };
};

theme.init = function() {
  theme.initCache();
  theme.setBreakpoints();
  theme.fitNav();
  theme.cartInit();
  theme.afterCartLoad();
  theme.checkoutIndicator();
  theme.returnLink();
  theme.styleTextLinks();
  theme.searchModal();
  if($('body').hasClass('template-collection')){}else{
    theme.Accordion();
  }
  theme.SelectEqualizer();
  theme.productCardImageLoadingAnimation();
  theme.smoothAnchorNav();

  theme.backToTopBtn();

  // Functions to run on load so image sizes can be calculated
  theme.cache.$window.on('load', theme.resizeLogo);
  theme.cache.$window.on('load', theme.articleImages);

  // Functions to re-run on resize
  theme.cache.$window.on('resize', theme.debounce(theme.resizeLogo, 150));
};

theme.returnLink = function() {
  if (!document.referrer || !theme.cache.$returnLink.length || !window.history.length) {
    return;
  }

  theme.cache.$returnLink.on('click', theme.backButton);
};

theme.backToTopBtn = function(){
  const backBtn = $("#scrollBackBtn");

  $(window).on('scroll', function(){
    if( $(window).scrollTop() > 200 ) {
      backBtn.addClass('is--visible');
    } else{
      backBtn.removeClass('is--visible');
    }
  });
}
theme.backButton = function() {
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain = urlDomain(document.url);

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain(url) {
    var    a      = document.createElement('a');
           a.href = url;
    return a.hostname;
  }
};

theme.setBreakpoints = function() {
    enquire.register(theme.variables.mediaQuerySmall, {
      match: function() {
        theme.variables.bpSmall = true;
      },
      unmatch: function() {
        theme.variables.bpSmall = false;
      }
    });
};

theme.fitNav = function() {
  // Measure children of site nav on load and resize.
  // If wider than parent, switch to mobile nav.
  controlNav();
  theme.cache.$window.on('load', controlNav);
  theme.cache.$window.on('resize', theme.debounce(controlNav, 150));

  function controlNav() {
    // Subtract 20 from width to account for inline-block spacing
    var navWidth = theme.cache.$siteNav.parent().outerWidth() - 20;
    var navItemWidth = 0;
    theme.cache.$siteNav.find('> li').each(function() {
      var $el = $(this);
      // Round up to be safe
      navItemWidth += Math.ceil($(this).width());
    });

    if (navItemWidth > navWidth) {
      theme.cache.$siteNav.addClass('site-nav--compress');
      theme.cache.$siteNavOpen.addClass('site-nav--open__display');
      theme.cache.$logoWrapper.removeClass('large--left').addClass('text-center');
      theme.cache.$searchBox.hide();
    } else {
      theme.cache.$siteNav.removeClass('site-nav--compress');
      theme.cache.$siteNavOpen.removeClass('site-nav--open__display');
      theme.cache.$searchBox.show();
    }

    theme.cache.$siteNav.addClass('site-nav--init');
    theme.cache.$siteNavOpen.addClass('site-nav--init');
  }
};

theme.Accordion = function() {
  
  /*
  *   This content is licensed according to the W3C Software License at
  *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
  *   https://www.w3.org/TR/wai-aria-practices/examples/accordion/accordion.html
  *
  *   Simple accordion pattern example
  */

  'use strict';
  
  Array.prototype.slice.call(document.querySelectorAll('.Accordion')).forEach(function (accordion) {

    // Allow for multiple accordion sections to be expanded at the same time
    var allowMultiple = accordion.hasAttribute('data-allow-multiple');
    // Allow for each toggle to both open and close individually
    var allowToggle = (allowMultiple) ? allowMultiple : accordion.hasAttribute('data-allow-toggle');

    // Create the array of toggle elements for the accordion group
    var triggers = Array.prototype.slice.call(accordion.querySelectorAll('.Accordion-trigger'));
    var panels = Array.prototype.slice.call(accordion.querySelectorAll('.Accordion-panel'));

    // Remove empty paragraphs from answers in FAQ page
    document.querySelectorAll('#frequently-asked-questions .Accordion-answer p:empty').forEach(item => item.remove())


    accordion.addEventListener('click', function (event) {
      var target = event.target;
      
      if (target.classList.contains('isFAQMain') && $(window).width() < 769) {
        
      } else {
      
        if (target.classList.contains('Accordion-trigger')) {
          // Check if the current toggle is expanded.
          var isExpanded = target.getAttribute('aria-expanded') == 'true';
          var active = accordion.querySelector('[aria-expanded="true"]');

          var isChildAccordion = $(target).hasClass('isChildAccordion');
          if(isChildAccordion){
            allowToggle = true;
          }

          // without allowMultiple, close the open accordion
          if (!allowMultiple && active && active !== target && !isChildAccordion) {
            // Set the expanded state on the triggering element
            active.setAttribute('aria-expanded', 'false');
            // Hide the accordion sections, using aria-controls to specify the desired section
            document.getElementById(active.getAttribute('aria-controls')).setAttribute('hidden', '');

            // When toggling is not allowed, clean up disabled state
            if (!allowToggle) {
              active.removeAttribute('aria-disabled');
            }
          }

          if (!isExpanded) {
            // Set the expanded state on the triggering element
            target.setAttribute('aria-expanded', 'true');
            $(target).find('.icon').removeClass('icon-chevron-down').addClass('icon-chevron-up');
            // Hide the accordion sections, using aria-controls to specify the desired section
            document.getElementById(target.getAttribute('aria-controls')).removeAttribute('hidden');
            // Triggering custom event for callbacks (theme.Collection)
            $(document).trigger('accordion-item-updated');

            // If toggling is not allowed, set disabled state on trigger
            if (!allowToggle) {
              target.setAttribute('aria-disabled', 'true');
            }
          }
          else if (allowToggle && isExpanded) {
            // Set the expanded state on the triggering element
            target.setAttribute('aria-expanded', 'false');
            $(target).find('.icon').removeClass('icon-chevron-up').addClass('icon-chevron-down');
            // Hide the accordion sections, using aria-controls to specify the desired section
            document.getElementById(target.getAttribute('aria-controls')).setAttribute('hidden', '');
            // Triggering custom event for callbacks (theme.Collection)
            $(document).trigger('accordion-item-updated');
          }

          event.preventDefault();
          event.stopPropagation();
        }
      }
    });

    // Bind keyboard behaviors on the main accordion container
    accordion.addEventListener('keydown', function (event) {
      
      if (event.target.classList.contains('isFAQMain') && $(window).width() < 769) {
        
      } else {
      
        var target = event.target;
        var key = event.which.toString();

        var isExpanded = target.getAttribute('aria-expanded') == 'true';
        var allowToggle = (allowMultiple) ? allowMultiple : accordion.hasAttribute('data-allow-toggle');

        // 33 = Page Up, 34 = Page Down
        var ctrlModifier = (event.ctrlKey && key.match(/33|34/));

        // Is this coming from an accordion header?
        if (target.classList.contains('Accordion-trigger')) {
          // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
          // 38 = Up, 40 = Down
          if (key.match(/38|40/) || ctrlModifier) {
            var index = triggers.indexOf(target);
            var direction = (key.match(/34|40/)) ? 1 : -1;
            var length = triggers.length;
            var newIndex = (index + length + direction) % length;

            triggers[newIndex].focus();

            event.preventDefault();
          }
          else if (key.match(/35|36/)) {
            // 35 = End, 36 = Home keyboard operations
            switch (key) {
              // Go to first accordion
              case '36':
                triggers[0].focus();
                break;
                // Go to last accordion
              case '35':
                triggers[triggers.length - 1].focus();
                break;
            }
            event.preventDefault();

          }

        }
        
      }
      
      
    });

    // These are used to style the accordion when one of the buttons has focus
    accordion.querySelectorAll('.Accordion-trigger').forEach(function (trigger) {

      trigger.addEventListener('focus', function (event) {
        accordion.classList.add('focus');
      });

      trigger.addEventListener('blur', function (event) {
        accordion.classList.remove('focus');
      });

    });

    // Minor setup: will set disabled state, via aria-disabled, to an
    // expanded/ active accordion which is not allowed to be toggled close
    if (!allowToggle) {
      // Get the first expanded/ active accordion
      var expanded = accordion.querySelector('[aria-expanded="true"]');

      // If an expanded/ active accordion is found, disable
      if (expanded) {
        expanded.setAttribute('aria-disabled', 'true');
      }
    }

  }); 
};

theme.SelectEqualizer = function(){
 
  /*
   * Adjust width of select element according to selected option's width
   * Taken from: https://stackoverflow.com/questions/28308103/adjust-width-of-select-element-according-to-selected-options-width
   */
  (function($, window){
    var arrowWidth = 10;

    $.fn.resizeselect = function(settings) {  
      return this.each(function() { 

        $(this).change(function(){
          var $this = $(this);

          // create test element
          var text = $this.find("option:selected").text();
          var $test = $("<span class='emulateSelectStyle'>").html(text);

          // add to body, get width, and get out
          $test.appendTo('body');
          var width = $test.width();
          $test.remove();

          // set select width
          $this.width(width + arrowWidth);

          // run on start
        }).change();

      });
    };

    // run by default
    $("select.resizeselect").resizeselect();                       

  })(jQuery, window);
  
}

theme.resizeLogo = function() {
  // Using .each() as there can be a reversed logo too
  theme.cache.$logo.each(function() {
    var $el = $(this),
        logoWidthOnScreen = $el.width(),
        containerWidth = $el.closest('.grid__item').width();
    // If image exceeds container, let's make it smaller
    if (logoWidthOnScreen > containerWidth) {
      $el.css('maxWidth', containerWidth);
    }
    else {
      $el.removeAttr('style');
    }
  });
  
  // Add container spacing when sticky announcement bar is enabled
  if($('body').hasClass('has-sticky-announcement-bar')){  
    var stickyHeaderHeight = $('#StickyBar').outerHeight();
    $('body #PageContainer').css('padding-top',stickyHeaderHeight);
    $('#product-sticky-bar.product-sticky-cta').css('top', stickyHeaderHeight - 3);
  }
};

theme.sizeCartDrawerFooter = function() {
  // Stop if our drawer doesn't have a fixed footer
  if (!theme.cache.$drawerRight.hasClass('drawer--has-fixed-footer')) {
    return;
  }

  // Elements are reprinted regularly so selectors are not cached
  var $cartFooter = $('.ajaxcart__footer').removeAttr('style');
  var $cartInner = $('.ajaxcart__inner').removeAttr('style');
  var cartFooterHeight = $cartFooter.outerHeight();
  var cartDrawerTitleHeight = $('.drawer--right .drawer__header').outerHeight();
  var cartDrawerAnnouncementHeight = $('.drawer--right .drawer__banner').outerHeight();
  var $cartDrawerInner = $('.drawer--right .drawer__inner');

  if(cartDrawerTitleHeight + cartDrawerAnnouncementHeight != 108) {
    $cartDrawerInner.css('top', cartDrawerTitleHeight + cartDrawerAnnouncementHeight);
  }

  $cartInner.css('bottom', cartFooterHeight);
};

theme.afterCartLoad = function() {
  theme.cache.$body.on('ajaxCart.afterCartLoad', function(evt, cart) {
    // Open cart drawer
    timber.RightDrawer.open();

    // Size the cart's fixed footer
    theme.sizeCartDrawerFooter();

    // Show cart bubble in nav if items exist
    if (cart.items.length > 0) {
      theme.cache.$cartBuggle.addClass('cart-link__bubble--visible');
    } else {
      theme.cache.$cartBuggle.removeClass('cart-link__bubble--visible');
    }
  });
};

theme.checkoutIndicator = function() {
  // Add a loading indicator on the cart checkout button (/cart and drawer)
  theme.cache.$body.on('click', '.cart__checkout', function() {
    $(this).addClass('btn--loading');
  });
};

theme.searchModal = function() {
  if (!theme.cache.$openSearchModal.length) {
    return;
  }

  var searchModalMagnificPopup = theme.cache.$openSearchModal.magnificPopup({
    type: 'inline',
    mainClass: 'mfp-search-modal',
    closeOnBgClick: true,
    closeBtnInside: false,
    showCloseBtn: false,
    closeOnContentClick: false,
    tClose: theme.strings.zoomClose,
    alignTop: true,
    removalDelay: 0,
    focus: '.search-bar > input',
    fixedContentPos: false,
    callbacks: {
      open: function() {
        var self = this;
        // Calculate modal position
        var pos_searchButton = theme.cache.$openSearchModal.offset();
        var width_searchButton = theme.cache.$openSearchModal.width();
        var posX = ($(window).width() - pos_searchButton.left) + 5;
        var posY = pos_searchButton.top - 5;
        if(theme.cache.$window.width() < 989) {
          var headerHeight = $('.drawer__header-container').outerHeight();
          var headerHeightX = headerHeight - 5;
          $('.mfp-search-modal.mfp-wrap').css({ top: headerHeightX, right: posX });
          $('.mfp-bg.mfp-search-modal').css({ top: headerHeightX });

          if($("#StickyBar").hasClass("sticky--active")){
            var stickyHeaderHeight = $('#StickyBar').outerHeight();
            var stickyHeaderHeightX = stickyHeaderHeight - 5;
            $('.mfp-search-modal.mfp-wrap').css({ top: stickyHeaderHeightX, position: 'fixed' });
            $('.mfp-bg.mfp-search-modal').css({ top: stickyHeaderHeightX, position: 'fixed' });
          }
        } else{
          $('.mfp-search-modal.mfp-wrap').css({ top: posY, right: posX });
        }
        theme.cache.$openSearchModal.addClass('search-open');
        theme.cache.$openSearchModal.hide();
        theme.cache.$closeSearchModal.show();
      },
      close: function() {
        theme.cache.$openSearchModal.removeClass('search-open');
        theme.cache.$closeSearchModal.hide();
        theme.cache.$openSearchModal.show();
      }
    }
  });

  theme.cache.$closeSearchModal.on('click', function(){
    $.magnificPopup.close();
  });

}

theme.articleImages = function() {
  if (!theme.cache.$indentedRteImages.length) {
    return;
  }

  theme.cache.$indentedRteImages.find('img').each(function() {
    var $el = $(this);
    var attr = $el.attr('style');

    // Check if undefined or float: none
    if (!attr || attr == 'float: none;') {
      // Remove grid-breaking styles if image isn't wider than parent
      if ($el.width() < theme.cache.$indentedRteImages.width()) {
        $el.addClass('rte__no-indent');
      }
    }
  });
};

theme.styleTextLinks = function() {
  $('.rte').find('a:not(:has(img)):not(.btn)').addClass('text-link');
};

theme.equalHeights = function(selector) {
  var self = this;
  theme.cache.$window.on('load', resizeElements());

  theme.cache.$window.on(
    'resize',
    afterResize(
      function() {
        resizeElements();
      },
      250,
      'equal-heights'
    )
  );

  function resizeElements() {
    if(selector !== undefined){
      $(selector).css('height', 'auto').equalHeights();
    } else {
      self.cache.$productGridImages.css('height', 'auto').equalHeights();
    }
  }
};

theme.cartInit = function() {
  if (!theme.cookiesEnabled()) {
    theme.cache.$body.addClass('cart--no-cookies');
  }
};

theme.cookiesEnabled = function() {
  var cookieEnabled = navigator.cookieEnabled;

  if (!cookieEnabled){
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
  }
  return cookieEnabled;
}

theme.productCardImageLoadingAnimation = function() {
  var selectors = {
    image: '[data-image]',
    imageLink: '[data-image-link]',
  };

  var classes = {
    loadingAnimation: 'grid-product__image-link--loading',
    lazyloaded: '.lazyloaded'
  }

  $(document).on('lazyloaded', function (e) {
    var $target = $(e.target);

    if (!$target.is(selectors.image)) {
      return;
    }

    $target
      .closest(selectors.imageLink)
      .removeClass(classes.loadingAnimation);
  });


  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  $(selectors.image + classes.lazyloaded)
    .closest(selectors.imageLink)
    .removeClass(classes.loadingAnimation);
}

theme.updateSlickSwipe = function(element, allowSwipe)
{
  if (!element.hasClass('slick-initialized')) {
    return;
  }

  var slickOptions = {
    accessibility: allowSwipe,
    draggable: allowSwipe,
    swipe: allowSwipe,
    touchMove: allowSwipe
  };
  element.slick('slickSetOption', slickOptions, false);
}

theme.smoothAnchorNav = function(){

  $('a[href*="#"]:not([href="#"])').click(function () {
    if($(this).hasClass('Accordion-trigger') && $(window).width() > 770){
      // Prevent smooth scroll to block accordion functionality for Desktop
    } else if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {

        var fixedHeaderHeight = theme.cache.$siteHeader.outerHeight();
        var headerStickyIsActive = theme.cache.$siteHeader.parent().hasClass('sticky--active');

        if(!headerStickyIsActive) {
          fixedHeaderHeight += fixedHeaderHeight;
        }

        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $('html,body').animate({
            scrollTop: target.offset().top - fixedHeaderHeight
          }, 600);
          return false;
        }

    }
  });
  
}

theme.scrollTo = function (selector, offset){
  var element = $(selector);
  $('html,body').animate({scrollTop: element.offset().top - offset },'slow');
}

theme.calcFabricDetailPositionGrid = function (fabric_index_order) {

  if(theme.cache.$window.width() > 960) {
      var row_index = 1 + Math.floor(fabric_index_order/4);
      var remainder = fabric_index_order % 4;
      if(remainder > 0){
          row_index_order =  row_index * 4;
      } else {
          row_index_order = fabric_index_order;
      }
  } else if(theme.cache.$window.width() > 768) {
      var row_index = 1 + Math.floor(fabric_index_order/3);
      var remainder = fabric_index_order % 3;
      if(remainder > 0){
          row_index_order =  row_index * 3;
      } else {
          row_index_order = fabric_index_order;
      }
  } else {
      var row_index = 1 + Math.floor(fabric_index_order/2);
      var remainder = fabric_index_order % 2;
      if(remainder > 0){
          row_index_order =  row_index * 2;
      } else {
          row_index_order = fabric_index_order;
      }
  }

  return row_index_order;
};


$(document).ready(function() {
  theme.init();
  var sections = new theme.Sections();

  sections.register('product-template', theme.Product);
  sections.register('collection-template', theme.Collection);
  sections.register('blog-landing-template', theme.BlogLanding);
  sections.register('article-template', theme.Article);
  sections.register('press-template', theme.Press);
  sections.register('ann-template', theme.Press);
  sections.register('sid-template', theme.Press);
  sections.register('article-visit-template', theme.VisitArticle);
  sections.register('featured-collection-template', theme.FeaturedCollection);
  sections.register('mtm-overview-offering-template', theme.MTMOverviewOffering);
  sections.register('appointments-template', theme.Appointments);
  sections.register('header-section', theme.HeaderSection);
  sections.register('visit-pop-up', theme.VisitPopUp);
  sections.register('collection-slider-section', theme.CollectionSliderSection);
  sections.register('collection-section', theme.CollectionSection);
  sections.register('featured-row-items-section', theme.FeaturedRowItemsSection);
  sections.register('featured-content-section', theme.FeaturedContentSection);
  sections.register('newsletter-section', theme.NewsletterSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('mtm-overview-offering-section', theme.MTMOverviewOffering);
  sections.register('password-header', theme.PasswordHeader);
  sections.register('password-content', theme.PasswordContent);
  sections.register('product-recommendations', theme.ProductRecommendations);
  sections.register('map', theme.Maps);
  sections.register('search', theme.Search);
  sections.register('footer-section', theme.FooterSection);
  sections.register('made-to-measurement-template', theme.MTM);
  sections.register('made-to-order-template', theme.MTO);

  initFAQ();
});

/*
 * Run function after window resize
 * http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed
 */
var afterResize = (function () {
  var t = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (t[uniqueId]) {
      clearTimeout(t[uniqueId]);
    }
    t[uniqueId] = setTimeout(callback, ms);
  };
})();


/* FAQ page initialization */
const initFAQ = () => {
  if (window.location.pathname.indexOf('/pages/') >= 0 && window.location.pathname.indexOf('frequently-asked-questions') >= 0 && window.location.hash != '') {
    let trigger = document.querySelector(`.Accordion [href="${window.location.hash}"]`)
    if (trigger) {
      trigger.click();
      setTimeout(function() {
        window.scrollTo(0, 0);
      }, 1);
      
    }
  }
}

// Gift Wrap Selection Check Cart Page

function updateGiftNoteText(checkbox) {
  var container = checkbox.closest('.gift-wrap__checkbox-compliment__container');
  var textarea = container.querySelector('textarea');

  if (checkbox.checked) {
    textarea.value = 'Add Complimentary Gift Wrapping';
  } else {
    textarea.value = 'Add Complimentary Gift Wrapping: No';
  }
}

function checkGiftWrap(el, event){
  event.preventDefault();
  let giftcheckbox = document.getElementsByClassName('gift-wrap__checkbox');
  let errorCheck = false;
  for(let i=0;i<giftcheckbox.length;i++){
      if(giftcheckbox[i].checked){
        let container = document.querySelectorAll('.gift-wrap__container')[i];
        let wrap_values = container.querySelectorAll('.gift-wrap__select');
        for(let j=0; j<wrap_values.length; j++){
          let vall = wrap_values[j];
          vall.classList.remove("giftwrap-not-valid");
          if(!vall.value || vall.value === ""){
            vall.classList.add("giftwrap-not-valid");
            document.getElementById('giftwrap-error').style.display = 'none';
            errorCheck = true;
          }
        }
    }
  }
  if(errorCheck) {
    setTimeout(() => {
      el.classList.remove('btn--loading');
    }, 500);
    return false;
  }
  el.removeAttribute('onclick');
  el.click();
}

function onLoadCheckGiftWrap(){
  let giftcheckbox = document.getElementsByClassName('gift-wrap__checkbox');
  for(let i=0;i<giftcheckbox.length;i++){
      if(giftcheckbox[i].checked){
        let container = document.querySelectorAll('.gift-wrap__container')[i];
        let wrap_values = container.querySelectorAll('.gift-wrap__select');
        for(let j=0; j<wrap_values.length; j++){
          let vall = wrap_values[j];
          vall.classList.remove("giftwrap-not-valid");
          if(!vall.value || vall.value === ""){
            vall.classList.add("giftwrap-not-valid");
            document.getElementById('giftwrap-error').style.display = 'none';
          }
        }
      }
    }
    setTimeout(() => {
      jQuery.getJSON('/cart.js', function(cart) {
        let cartItems = cart.items;
        for (let i = 0; i < cartItems.length; i++) {
          let properties = cartItems[i]['properties'];
    
          if (properties) {
            if (properties[`Gift Note ${i}`]) {
              document.getElementsByClassName('gift-wrap__textarea')[i].value = properties[`Gift Note ${i}`];
            }
            if (properties[`To ${i}`]) {
              document.getElementsByClassName('gift-wrap__to')[i].value = properties[`To ${i}`];
            }
            if (properties[`From ${i}`]) {
              document.getElementsByClassName('gift-wrap__from')[i].value = properties[`From ${i}`];
            }
          }
        }
      }).fail(function() {
        console.error('Failed to retrieve cart data.');
      });
    }, 1000);
}

if(document.getElementsByClassName('gift-wrap__checkbox').length > 0){
  onLoadCheckGiftWrap();
}
function jumpToProductImage(el){
    var container = document.querySelector('.product-single__media-group'); 
    document.getElementById(el.dataset.jump).scrollIntoView();
}
function switchZoomCursor(el){
  setTimeout(()=>{
    if(el.querySelector('.zoomImg').style.opacity == 1){
      el.querySelector('.zoomImg').style.cursor = 'zoom-out';
      return;
    }
    const zoomEls = document.getElementsByClassName('zoomImg');
    for(let i=0; i<zoomEls.length; i++){
      zoomEls[i].style.cursor = 'zoom-in';
    }
  }, 100);
}

//Product Page Nav Arrow Area Increase
if(document.querySelector('.product-single')){
  setTimeout(() => {
    document.querySelector('.product-single .slick-list')?.addEventListener('click', (e) => {
      const clickTarget = e.target;
      const clickTargetWidth = clickTarget.offsetWidth;
      const xCoordInClickTarget = e.clientX - clickTarget.getBoundingClientRect().left;
      if (clickTargetWidth * 0.3 > xCoordInClickTarget) {
        document.querySelector('.product-single .slick-prev').click();
      } 
      if (clickTargetWidth * 0.7 < xCoordInClickTarget) {
        document.querySelector('.product-single .slick-next').click();
      }
    });
  }, 500);
}

/***** Product Related Products Carousel ******/
const slidesToShow = $('#productRelatedProductsSlider .grid-product__wrapper').length === 1 ? 1 : 2;
$("#productRelatedProductsSlider").slick({
  accessibility: false,
  infinite: false,
  slidesToShow: slidesToShow,
  slidesToScroll: 1,
  adaptiveHeight: true,
  mobileFirst: false,
  prevArrow: '<button type="button" class="slick-prev icon-fallback-text" aria-label="Previous slide"><span class="icon icon-slide-prev-btn" aria-hidden="true"></span><span class="fallback-text">Previous</span></button>',
  nextArrow: '<button type="button" class="slick-next icon-fallback-text" aria-label="Next slide"><span class="icon icon-slide-next-btn" aria-hidden="true"></span><span class="fallback-text">Next</span></button>',
  arrows: true,
  responsive: [
    {
      breakpoint: 960,
      settings: {
        arrows: false
      }
    }
  ]
});

$("#yourShoppingBagSlider").on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  const pagingInfo = '#slick__paging-info-your-shopping-bag';
  const container = '.YourShoppingBagSlider';
  // no dots -> no slides
  if(!slick.$dots){
    return;
  }

  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  var i = (currentSlide ? currentSlide : 0) + 1;
  var slidesToShow = Math.ceil( slick.slideCount/(slick.$dots[0].children.length) );
  var currentCustomSlide = currentSlide ? Math.ceil((currentSlide + 1)/slidesToShow) : 1;
  // use dots to get some count information
  $(pagingInfo).text(currentCustomSlide + '/' + (slick.$dots[0].children.length));
  if((slick.$dots[0].children.length) <= 1){
    $(container).find('.slick__controls').addClass('hide');
  }else{
    $(container).find('.slick__controls').removeClass('hide');
  }

});

/***** Your Shopping Bag Carousel ******/
$("#yourShoppingBagSlider").slick({
  accessibility: false,
  infinite: false,
  slidesToShow: 4.1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  mobileFirst: false,
  dots: true,
  prevArrow: '.your-shopping-bag .slick__arrow--previous',
  nextArrow: '.your-shopping-bag .slick__arrow--next',
  arrows: true,
  responsive: [
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 1.17,
        arrows: false,
        dots: false
      }
    }
  ]
});

/***** Featured Collection List Carousel ******/
$(".featured-collection-list").slick({
  slidesToShow: 4,
  infinite: true,
  slidesToScroll: 1,
  accessibility: true,
  prevArrow: '<button type="button" class="slick-prev icon-fallback-text slick-arrow slick-disabled" aria-label="Previous slide" aria-disabled="true" style="display: block;"><span class="icon icon-slide-prev-btn" aria-hidden="true"></span><span class="fallback-text">Previous</span></button>',
  nextArrow: '<button type="button" class="slick-next icon-fallback-text slick-arrow" aria-label="Next slide" style="display: block;" aria-disabled="false"><span class="icon icon-slide-next-btn" aria-hidden="true"></span><span class="fallback-text">Next</span></button>',
  arrows: true,
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: false
      }
    }
  ]
});
/***** Featured Collection List Carousel ******/
/***** Mobile header search bar *****/
$(window).scroll(function(){
  if($('.mfp-bg.mfp-search-modal').length > 0){
    if($(window).width() < 989) {
      var scrollheaderHeight = $('.drawer__header-container').outerHeight();
      var scrollheaderHeightX = scrollheaderHeight - 5;
      $('.mfp-search-modal.mfp-wrap').css({ top: scrollheaderHeightX });
      $('.mfp-bg.mfp-search-modal').css({ top: scrollheaderHeightX });

      if($("#StickyBar").hasClass("sticky--active")){
        var scrollstickyHeaderHeight = $('#StickyBar').outerHeight();
        var scrollstickyHeaderHeightX = scrollstickyHeaderHeight - 5;
        $('.mfp-search-modal.mfp-wrap').css({ top: scrollstickyHeaderHeightX, position: 'fixed' });
        $('.mfp-bg.mfp-search-modal').css({ top: scrollstickyHeaderHeightX, position: 'fixed' });
      }
    }
  }
});
/***** Mobile header search bar *****/

/***** Article metafield products start *****/
var articleMetaProductAll = $('.article-meta-products .article-meta-products-wrapper').clone(true);
articleMetaProductAll.each(function(i){
  if(articleMetaProductAll[i] != null){
    var article_block_id = articleMetaProductAll[i].id;
    if($(".template-article-page .metafield-blog-products[data-blog-identifier='"+ article_block_id + "']").length > 0){
      $(".template-article-page .metafield-blog-products[data-blog-identifier='"+ article_block_id + "']").append(articleMetaProductAll[i]);

      $(".template-article-page .metafield-blog-products[data-blog-identifier='"+ article_block_id + "'] .article-meta-posts").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        accessibility: true,
        prevArrow: '<button type="button" class="slick-prev icon-fallback-text slick-arrow slick-disabled" aria-label="Previous slide" aria-disabled="true" style="display: block;"><span class="icon icon-slide-prev-btn" aria-hidden="true"></span><span class="fallback-text">Previous</span></button>',
        nextArrow: '<button type="button" class="slick-next icon-fallback-text slick-arrow" aria-label="Next slide" style="display: block;" aria-disabled="false"><span class="icon icon-slide-next-btn" aria-hidden="true"></span><span class="fallback-text">Next</span></button>',
        arrows: true,
        adaptiveHeight: true,
        dots: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 1
            }
          }
        ]
      });
    }
  }
});
/***** Article metafield products end *****/
/***** Product Dynamic Tooltip start *****/

function swatchesTooltip() {
  $(".single-product_nested-nav__item__list li").hover(
    function () {
      var tooltip = $(this).find(".swatch-tooltip");
      var tooltipRect = tooltip[0].getBoundingClientRect();
      if (tooltipRect.right > window.innerWidth) {
        tooltip.addClass("right");
        tooltip.css({
          left: "auto",
          right: "0px",
          transform: "translateX(10px)",
        });
      } else if (tooltipRect.left < 0) {
        tooltip.addClass("left");
        tooltip.css({
          left: "0px",
          right: "auto",
          transform: "translateX(-10px)",
        });
      }
    },
    function () {
      $(".single-product_nested-nav__item__list li .swatch-tooltip").removeAttr("style");
      $(".single-product_nested-nav__item__list li .swatch-tooltip").removeClass("left").removeClass("right");
    }
  );
}
$(window).on("load resize", function (e) {
  if($(window).width() > 591){
    swatchesTooltip();
  }
});

/***** Product Dynamic Tooltip end *****/
/***** Disable popup for email subscribers start *****/

if(window.location.href.indexOf('utm_medium=email') > -1){
  sessionStorage.setItem("utm_medium", "email");
}
var get_storage = sessionStorage.getItem("utm_medium");
if(get_storage === "email"){
  $('body').addClass('has-utm-email-medium');
}

/***** Disable popup for email subscribers end *****/

// Product Grid Item Swatch Hover Functionality
window.addEventListener('load', function() {
  // Get all swatch lists
  const swatchLists = document.querySelectorAll('.grid-product__swatches');

  swatchLists.forEach(function(swatchList) {
    // Get the parent grid product wrapper for this specific product card
    const gridProductWrapper = swatchList.closest('.grid-product__wrapper');
    if (!gridProductWrapper) return;
    
    // Get the default wrapper within THIS product card only
    const defaultWrapper = gridProductWrapper.querySelector('.grid-product__image-wrapper .product--wrapper:not(.hidden)');
    if (!defaultWrapper) return;
    
    // Get all swatch items in THIS product card
    const swatchItems = swatchList.querySelectorAll('li');
    
    swatchItems.forEach(function(swatch) {
      const img = swatch.querySelector('img[data-product-id]');
      if (!img) return;
      
      const productId = img.getAttribute('data-product-id');
      // Search for the product wrapper within THIS product card only
      const productWrapper = gridProductWrapper.querySelector('.grid-product__image-wrapper [id="' + productId + '"]');
      
      if (!productWrapper) return;
      
      // On hover, show the corresponding product image
      swatch.addEventListener('mouseenter', function() {
        // Hide the default wrapper
        defaultWrapper.classList.add('hidden');
        // Show the hovered product wrapper
        productWrapper.classList.remove('hidden');
      });
      
      // On mouse leave, restore the default image
      swatch.addEventListener('mouseleave', function() {
        // Hide the hovered product wrapper
        productWrapper.classList.add('hidden');
        // Show the default wrapper
        defaultWrapper.classList.remove('hidden');
      });
    });
  });
});
